

import React, { useEffect, useRef, useState } from "react";
import { LinearGauge, LinearGaugeProps } from '@progress/kendo-react-gauges';

import _ from "lodash";
import { Responsive, WidthProvider } from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import GaugeChart from "react-gauge-chart";
import { BrowserRouter, Route } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Draggable from "react-draggable";
import { connect } from "react-redux"
import { v4 as uuidv4, v4 } from 'uuid';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Resizable } from 're-resizable';
import { add_page_name, set_combine_trends, set_current_dyn_pageName, set_current_page_details, set_external_trend_info, set_pages, setCanvasBoyut } from "./Action/Action"
import Store from "./Store/Store"
import { elements } from "chart.js";
import GaugeComponent from 'react-gauge-component'
import "./Components/CSS/Raporlama.css"
import { Line } from 'react-chartjs-2';
import loading_ from "./Assets2/loading.gif";
import {
    Chart as ChartJS, LineElement, CategoryScale, LinearScale, PointElement,
    Title,
    Tooltip,
    Legend,
    Zoom
} from "chart.js"
import zoomPlugin from 'chartjs-plugin-zoom';
import 'chartjs-adapter-moment';
import moment from 'moment';
import 'moment-timezone';
import DashboardpngIcon from "./Assets/Icons/Dashboard.png";
import Misafir_Oda from "./Assets/Icons/pngwing.com.png";
import water_storage from "./Assets/Icons/tank.png";
import DigerSistemlerIcon from "./Assets/Icons/DigerSistemler.png";
import EnerjiIcon from "./Assets/Icons/Enerji.png";
import IsitmaSistemleriIcon from "./Assets/Icons/IsitmaSistemleri.png";
import KlimaSantIcon from "./Assets/Icons/KlimaSant.png";
import NotificationsIcon from "./Assets/Icons/Notifications.png";
import PompaVeHidroforIcon from "./Assets/Icons/PompaVeHidrofor.png";
import RooftopIcon from "./Assets/Icons/Rooftop.png";
import SogutmaSistemleriIcon from "./Assets/Icons/SogutmaSistemleri.png";
import SystemMonitoringIcon from "./Assets/Icons/SystemMonitoring.png";
import TuketimTakibiIcon from "./Assets/Icons/TuketimTakibi.png";
import VRFIcon from "./Assets/Icons/VRF.png";
import WorkOrdersIcon from "./Assets/Icons/WorkOrders.png";
import DevicesIcon from "./Assets/Icons/Devices.png";
import TagsIcon from "./Assets/Icons/Tags.png";

const ResponsiveReactGridLayout = WidthProvider(Responsive);

const availableHandles = ["s", "w", "e", "n", "sw", "nw", "se", "ne"];

const DynRead = (props) => {
    const history = useHistory();

    // Safe defaults for props to prevent undefined errors
    const tags = props.tags || [];
    const pages = props.pages || [];
    const alarms2 = props.alarms2 || [];
    const tag_values = props.tag_values || [];
    const totalizer_tags = props.totalizer_tags || [];
    const users_list = props.users_list || [];
    const widgets_library = props.widgets_library || [];

    const [screenWidthState, Set_screenWidthState] = useState(0);
    const [canvas_boyutu, Set_canvas_boyutu] = useState({ width: 0, height: 0 })
    const [canvas_boyutu_gecici, Set_canvas_boyutu_gecici] = useState({ width: 0, height: 0 })
    const [set_Raporlama, Set_set_raporlama] = useState(false)


    const [control_loading, Set_control_loading] = useState(true)

    const [alarm_okuma, Set_alarm_okuma] = useState(false)

    useEffect(() => {
        if (props.yetkilendirme && props.uid !== "") {
            let data = props.yetkilendirme;
            let newObj = data[props.uid];
            if (newObj !== undefined && newObj["Alarm"] !== undefined) {

                if (newObj["Alarm"]["O"] === "t") {

                    Set_alarm_okuma(true)
                } else {
                    Set_alarm_okuma(false);

                }
            }

        }
    }, [props.uid])

    useEffect(() => {
        if (localStorage.getItem("layouts")) {
            localStorage.removeItem("layouts")
        }
    }, [])




    const [min, Set_min] = useState(0)
    const [max, Set_max] = useState(0)

    const [sayfa_adi, Set_sayfa_adi] = useState("")
    const [sayfa_ikonu_son, Set_sayfa_ikonu_son] = useState("")

    const onChangePageName = (e) => {
        Set_sayfa_adi(e.target.value)
    }

    const dashBoard = TuketimTakibiIcon;
    const water = water_storage;
    const enerjiIcon = EnerjiIcon;
    const heat_system = IsitmaSistemleriIcon;
    const pumpicon = PompaVeHidroforIcon;
    const fansicon = "fa-solid fa-fan";
    const vrf_icon = VRFIcon;

    const [layouts2, Set_layouts2] = useState({})




    const [isOpencalisma, setIsOpencalisma] = useState(false);
    const [selectedOptioncalisma, setSelectedOptioncalisma] = useState("SOĞUTMA");

    const toggleDropdowncalisma = () => setIsOpencalisma(!isOpencalisma);

    const handleOptionClickcalisma = (option) => {
        setSelectedOptioncalisma(option);
        setIsOpencalisma(false);
    };

    const [isOpenfan, setIsOpenfan] = useState(false);
    const [selectedOptionfan, setSelectedOptionfan] = useState("DÜŞÜK");

    const toggleDropdownfan = () => setIsOpenfan(!isOpenfan);

    const handleOptionClickfan = (option) => {
        setSelectedOptionfan(option);
        setIsOpenfan(false);
    };

    const [isOpenİkon, setIsOpenİkon] = useState(false);
    const [selectedOptionİkon, setSelectedOptionİkon] = useState("");

    const toggleDropdownİkon = () => setIsOpenİkon(!isOpenİkon);

    const handleOptionClickİkon = (option) => {
        setSelectedOptionİkon(option);
        setIsOpenİkon(false);
    };

    const [yazma_control, Set_yazma_control] = useState(false)

    useEffect(() => {
        function normalizeURLPath(path) {
            const turkishMap = {
                'İ': 'I', 'ı': 'i', 'Ş': 'S', 'ş': 's',
                'Ğ': 'G', 'ğ': 'g', 'Ü': 'U', 'ü': 'u',
                'Ö': 'O', 'ö': 'o', 'Ç': 'C', 'ç': 'c'
            };

            return path.split('').map(char => turkishMap[char] || char).join('');
        }
        let pageName_ = window.location.pathname;
        let orjname;
        pageName_ = pageName_.substring(pageName_.lastIndexOf("/") + 1, pageName_.length);
        pages.forEach(s => {
            let pathName = normalizeURLPath(s.pageName);
            pathName = pathName.replaceAll(" ", "_")
            if (pageName_ === pathName) {
                orjname = s.pageName
            }

        })
        console.log(orjname, pageName_);
        if (users_list && props.uid !== "" && props.temp_com_id !== null) {
            users_list.forEach(a => {
                if (a.userId === props.uid) {

                    let data = a.yetkilendirme;
                    let newObj = JSON.parse(data);
                    console.log(newObj, orjname);
                    if (newObj !== undefined) {
                        if (newObj[props.temp_com_id < 3 ? 2 : props.temp_com_id]["Raporlama"]["Y"] === "t") {
                            Set_set_raporlama(true);
                        } else {
                            Set_set_raporlama(false);
                        }

                        if (orjname !== undefined && newObj[props.temp_com_id < 3 ? 2 : props.temp_com_id][orjname]["Y"] === "t") {
                            Set_yazma_control(true);
                        } else {
                            Set_yazma_control(false);
                        }
                    }
                }

            })



        }
    }, [users_list]);

    const [current_max_value, Set_current_max_value] = useState({})



    const [date1, SetDate1] = useState(null)
    const [date2, SetDate2] = useState(null)
    const [selected_tag, Set_selected_tag] = useState("")
    const [current_tag, Setcurrent_tag] = useState([])
    const [y_axis, Sety_axis] = useState({})

    const [real_datas, SetRealDatas] = useState({});

    const [fufg, forceUpdateforGauge] = useState(0);




    // useEffect(()=>{
    //   document.querySelector("body").style.width=String(document.querySelector("aside").getBoundingClientRect().width+canvas_boyutu.width)+"px"
    // },[canvas_boyutu])



    //SetValue

    const setValueFunc = async (list_) => {
        try {


            const req_ = await fetch(
                "https://app-rmmscmdapi.azurewebsites.net/api/cmd/SetValue",
                {
                    method: "POST",
                    headers: {
                        accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        ...list_,
                        companyId: props.temp_com_id
                    })
                }
            );

            const response = await req_.json();

            if (req_.status === 200 && response) { }


        } catch (err) {
            console.log(err);
        }
    }

    //For trends


    const [bigger_trend_active, Set_bigger_trend_active] = useState(false)
    const [bigger_trend_id, Set_bigger_trend_id] = useState(null)


    const chartRef = useRef(null);
    function createChartOptions(elemId) {
        return {
            scales: {
                x: {
                    type: 'time',
                    time: {
                        unit: 'day',
                        stepSize: 1,
                        displayFormats: {
                            day: 'MMM D'
                        }
                    },
                    ticks: {
                        maxTicksLimit: 24
                    }
                },
                y: {
                    min: Number(min),
                    max: max === 0 ? current_max_value[elemId] : Number(max),
                    beginAtZero: true,
                    ticks: {
                        callback: function (value) {
                            return Number(value.toFixed(2)); // Etiketlerdeki sıfırları engelle
                        }
                    }
                }
            },
            plugins: {
                legend: {
                    display: true,
                    labels: {
                        filter: function (item, chart) {
                            return item.text !== undefined;
                        },
                        generateLabels: function (chart) {
                            return [{
                                text: y_axis[elemId],
                                fillStyle: "crimson",
                                strokeStyle: chart.ctx.strokeStyle,
                                lineWidth: chart.ctx.lineWidth,
                                hidden: false,
                                index: 0,
                                datasetIndex: 0
                            }];
                        }
                    }
                },
                zoom: {
                    pan: {
                        enabled: true,
                        mode: 'xy',
                    },
                    zoom: {
                        wheel: {
                            enabled: true,
                        },
                        pinch: {
                            enabled: true,
                        },
                        mode: 'x',
                        onZoom: ({ chart }) => {
                            const xScale = chart.scales.x;
                            const min = xScale.min;
                            const max = xScale.max;
                            const diff = max - min;
                            let unit = 'second';

                            // Zoom leveline göre birim seçimi
                            if (diff > 1000 * 60 * 60 * 24 * 7) {
                                unit = 'day';
                            } else if (diff > 1000 * 60 * 60) {
                                unit = 'hour';
                            } else if (diff > 1000 * 60) {
                                unit = 'minute';
                            }

                            // Yeniden ayarlama
                            xScale.options.time.unit = unit;
                            xScale.options.time.tooltipFormat = unit === 'second' ? 'll HH:mm:ss' : 'll HH:mm';
                            xScale.options.ticks.callback = (value) => {
                                return moment(value).format(unit === 'second' ? 'll HH:mm:ss' : 'll HH:mm');
                            };

                            chart.update();
                        },
                    },
                },
            },
        };
    }

    useEffect(() => { console.log(real_datas) }, [real_datas])

    function createChartData(elemId) {
        const selectedData = real_datas[elemId];
        console.log(selectedData)

        const data = {
            labels: JSON.stringify(real_datas) !== "{}" ? selectedData.map(item => item.date) : [],
            datasets: [{
                data: JSON.stringify(real_datas) !== "{}" ? selectedData.map(item => item.value) : [],
                backgroundColor: "transparent",
                borderColor: "#f26c6d",
                pointBorderColor: "#f26c6d",
                pointBorderWidth: 1
            }]
        };

        return data;
    }




    const fetchTag = async (tagId, value, value2, elemId) => {


        console.log(value)

        const dateObj = new Date();
        const oneDay = 24 * 60 * 60 * 1000; // Bir günün milisaniye cinsinden değeri

        // Mevcut tarihi bir gün geri al
        const previousDay = new Date(dateObj.getTime() - oneDay);

        const pMonth = (previousDay.getUTCMonth() + 1).toString().padStart(2, "0"); // Ayları 01-12 arası yap
        const pDay = previousDay.getUTCDate().toString().padStart(2, "0"); // Günleri 01-31 arası yap
        const year = previousDay.getUTCFullYear();

        const newPaddedDate = `${year}-${pMonth}-${pDay}`;
        const date1_ = newPaddedDate + " " + "00:00:00.000";
        const date2_ = newPaddedDate + " " + "23:59:59.999";

        if (date1_ !== "" && date2_ !== "" && tagId !== "" && value !== null && value2 !== null) {
            Setcurrent_tag([]);
            const url = value === "1"
                ? "https://app-rmmsapi.azurewebsites.net/api/tags/GetTagTrendTotalizer"
                : "https://app-rmmsapi.azurewebsites.net/api/tags/GetTagTrend";

            try {
                const request = await fetch(url, {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json',
                        "Accept": "application/json"
                    },
                    body: JSON.stringify({ "TagId": tagId, "StartDate": date1_, "EndDate": date2_ })
                });

                const response = await request.json();

                var newdata_ = [];
                let control_data = new Map();

                var maksimumTagValue = response.reduce(function (previousValue, currentValue) {
                    previousValue.tagValue = previousValue.tagValue.replaceAll(",", "");
                    currentValue.tagValue = currentValue.tagValue.replaceAll(",", "");
                    return (Number(previousValue.tagValue) > Number(currentValue.tagValue)) ? previousValue : currentValue;
                });

                tags.forEach(i => {
                    if (i.tagId === tagId) {
                        Sety_axis((PrevState) => ({ ...PrevState, [elemId]: i.tagName }));

                    }
                });
                Set_current_max_value((PrevState) => ({ ...PrevState, [elemId]: Number(maksimumTagValue.tagValue) + (Number(maksimumTagValue.tagValue) / 10) }));


                const startDate = new Date(date1_);
                const endDate = new Date(date2_);
                const dateDifference = (endDate - startDate) / (1000 * 60 * 60 * 24) + 1; // Difference in days (inclusive)

                const maxItemsPerDay = Math.floor(3000 / dateDifference);

                response.forEach((item) => {
                    let value_int = Number(item.tagValue);
                    let obj__ = {
                        "date": item.valueDate,
                        "value": Number(value_int),
                    };



                    newdata_.push(obj__);
                });

                // if (value2 !== "1") {
                //   // Limit to 10 data points
                //   const interval = (endDate - startDate) / 10;
                //   newdata_ = newdata_.filter((item, index) => {
                //     const itemDate = new Date(item.date).getTime();
                //     return (itemDate >= startDate.getTime() + index * interval) && (itemDate < startDate.getTime() + (index + 1) * interval);
                //   }).slice(0, 10);
                // }

                SetRealDatas((prevState) => ({ ...prevState, [elemId]: newdata_ }))
            } catch (err) {
                console.log(err);
            }
        }
    };

    const [x_oran, Set_x_oran] = useState(null)
    const [y_oran, Set_y_oran] = useState(null)

    const [rotation, setRotation] = useState(0);

    const handleRotationChange = (e) => {
        let parent = e.target.parentElement;
        let id_ = parent.id;

        setLayouts(prevLayouts => {
            const updatedLayouts = { ...prevLayouts };
            updatedLayouts[currentBreakpoint] = (updatedLayouts[currentBreakpoint] || []).map(item => {
                if (String(item.id) === id_) {
                    return {
                        ...item,
                        elementDetails: {
                            ...item.elementDetails,
                            rotate_deg: e.target.value,
                        },
                    };
                }
                return item;
            });
            return updatedLayouts;
        });

        setRotation(e.target.value)
    };




    const getPages = async () => {
        try {
            const response = await fetch(
                `https://app-rmmsapi.azurewebsites.net/api/pages/GetPageList`,
                {
                    method: "POST",
                    body: JSON.stringify({
                        userId: props.uid,
                        companyId: props.com_id,
                    }),
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                    },
                }
            );
            const data = await response.json();
            var newlist = data;
            newlist.forEach(async (i) => {
                await Store.dispatch(add_page_name(i.pageName));
                if (i.details !== "") {
                    i.details = JSON.parse(i.details);
                }
            });


            await Store.dispatch(set_pages(newlist));
        } catch (err) {
            console.log(err);
        }
    }


    const [activePageName, Set_activePageName] = useState("")
    const [current_items_prop, Set_current_items_prop] = useState(null)
    // useEffect(() => {
    //     if (pages.length > 0) {


    //         setTimeout(() => {
    //             let pageName_ = window.location.pathname;
    //             pageName_ = pageName_.substring(pageName_.lastIndexOf("/") + 1, pageName_.length);
    //             console.log(pageName_)
    //             Set_activePageName(pageName_)
    //             let canvas_prop = pages.length > 0
    //                 ? pages.filter(x => normalizeURLPath(x.pageName).replaceAll(" ", "_") === pageName_).map(x => x.details.canvas_boyutu)[0]
    //                 : null;

    //             function normalizeURLPath(path) {
    //                 const turkishMap = {
    //                     'İ': 'I', 'ı': 'i', 'Ş': 'S', 'ş': 's',
    //                     'Ğ': 'G', 'ğ': 'g', 'Ü': 'U', 'ü': 'u',
    //                     'Ö': 'O', 'ö': 'o', 'Ç': 'C', 'ç': 'c'
    //                 };

    //                 return path.split('').map(char => turkishMap[char] || char).join('');
    //             }
    //             let main_sec = document.querySelector(".main_sec")
    //             let leftbar = document.querySelector("aside")
    //             console.log(document.querySelector("aside"));

    //             if (canvas_prop) {

    //                 let items_prop = pages.length > 0
    //                     ? pages.filter(x => x.pageName === pageName_).map(x => x.details)[0]
    //                     : null;

    //                     Store.dispatch(set_current_page_details(items_prop))

    //                 Set_current_items_prop(items_prop);
    //                 console.log({ width: Number(canvas_prop.width), height: Number(canvas_prop.height) });
    //                 Set_canvas_boyutu({ width: document.querySelector("aside")?window.innerWidth - document.querySelector("aside").getBoundingClientRect().width:window.innerWidth*0.86 - 12, height: document.querySelector("header")?window.innerHeight - document.querySelector("header").getBoundingClientRect().height:window.innerHeight - 86 - 26 })
    //                 Set_canvas_boyutu_gecici({ width: document.querySelector("aside")?window.innerWidth - document.querySelector("aside").getBoundingClientRect().width:window.innerWidth*0.86 - 12, height: document.querySelector("header")?window.innerHeight - document.querySelector("header").getBoundingClientRect().height:window.innerHeight - 86 - 26 })
    //                 Store.dispatch(setCanvasBoyut({ width: document.querySelector("aside")?window.innerWidth - document.querySelector("aside").getBoundingClientRect().width:window.innerWidth*0.86 - 12, height: document.querySelector("header")?window.innerHeight - document.querySelector("header").getBoundingClientRect().height:window.innerHeight - 86 - 6 }))
    //                 document.querySelector("aside").style.height = Number(window.innerHeight) - 38 + "px"
    //                 document.querySelector("aside").style.maxHeight = Number(window.innerHeight) - 38 + "px"



    //             }
    //         }, 800);
    //     }

    // }, [pages])

    useEffect(() => {
        if (pages.length > 0) {
            let pageName_ = window.location.pathname;
            pageName_ = pageName_.substring(pageName_.lastIndexOf("/") + 1, pageName_.length);

            function normalizeURLPath(path) {
                const turkishMap = {
                    'İ': 'I', 'ı': 'i', 'Ş': 'S', 'ş': 's',
                    'Ğ': 'G', 'ğ': 'g', 'Ü': 'U', 'ü': 'u',
                    'Ö': 'O', 'ö': 'o', 'Ç': 'C', 'ç': 'c'
                };

                return path.split('').map(char => turkishMap[char] || char).join('');
            }

            setTimeout(() => {
                let bgColor = pages.length > 0
                    ? pages
                        .filter(x => normalizeURLPath(x.pageName).replaceAll(" ", "_") === normalizeURLPath(pageName_).replaceAll(" ", "_"))
                        .map(x => x.bgColor)[0]
                    : null;

                console.warn(bgColor, pageName_)

                Set_page_bgColor(bgColor !== undefined ? bgColor : "")
            }, 250);
        }
    }, [pages])


    useEffect(() => {


        setTimeout(() => {
            let pageName_ = window.location.pathname;
            pageName_ = pageName_.substring(pageName_.lastIndexOf("/") + 1, pageName_.length);
            console.log(pageName_)
            Set_activePageName(pageName_)
            let canvas_prop = pages.length > 0
                ? pages.filter(x => normalizeURLPath(x.pageName).replaceAll(" ", "_") === pageName_).map(x => x.details.canvas_boyutu)[0]
                : null;


            function normalizeURLPath(path) {
                const turkishMap = {
                    'İ': 'I', 'ı': 'i', 'Ş': 'S', 'ş': 's',
                    'Ğ': 'G', 'ğ': 'g', 'Ü': 'U', 'ü': 'u',
                    'Ö': 'O', 'ö': 'o', 'Ç': 'C', 'ç': 'c'
                };

                return path.split('').map(char => turkishMap[char] || char).join('');
            }
            let main_sec = document.querySelector(".main_sec")
            let leftbar = document.querySelector("aside")
            console.log(document.querySelector("aside"));

            if (canvas_prop) {

                let items_prop = pages.length > 0
                    ? pages.filter(x => x.pageName === pageName_).map(x => x.details)[0]
                    : null;

                Store.dispatch(set_current_page_details(items_prop))


                Set_current_items_prop(items_prop);
                Set_canvas_boyutu({ width: window.innerWidth - leftbar.getBoundingClientRect().width, height: document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86 })
                Set_canvas_boyutu_gecici({ width: window.innerWidth - leftbar.getBoundingClientRect().width, height: document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86 })
                Store.dispatch(setCanvasBoyut({ width: window.innerWidth - leftbar.getBoundingClientRect().width, height: document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86 - 6 }))
                document.querySelector("aside").style.height = Number(window.innerHeight) + "px"
                document.querySelector("aside").style.maxHeight = Number(window.innerHeight) + "px"




            }
        }, 800);


    }, [pages, screenWidthState])




    useEffect(() => {




        const setWEidth = () => {

            setTimeout(() => {
                if (document.querySelector(".main_sec")) {
                    Set_screenWidthState((document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86));

                } else {
                    Set_screenWidthState(document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86);

                }

            }, 800);

        }
        // Add event listener to update okPopup on window resize
        window.addEventListener("resize", setWEidth);

        // Cleanup event listener on component unmount
        return () => {
            window.removeEventListener("resize", setWEidth);
            Store.dispatch(set_current_dyn_pageName(""))
        };
    }, []);


    const {
        className = "layout",
        rowHeight = 0.1,
        onLayoutChange = () => { },
        cols = { lg: document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86, md: document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86, sm: document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86, xs: document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86, xxs: document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86, },
    } = props;


    const [ok_popup, Set_ok_popup] = useState(null)
    const [elem_popup, Set_elem_popup] = useState(null)

    const [page_bgColor, Set_page_bgColor] = useState("")

    const [layouts, setLayouts] = useState({
        lg: [],
        md: [],
        sm: [],
        xs: [],
        xxs: [],
    });

    const [searchTerm, setSearchTerm] = useState('');

    const [zoomLevel, setZoomLevel] = useState(getZoomLevel());

    const [ws_items, Set_ws_items] = useState([])

    const [ws_active, Set_ws_active] = useState(false)

    useEffect(() => { setLayouts(layouts) }, [zoomLevel])

    // useEffect(() => {
    //     const handleResize = () => {
    //         setZoomLevel(getZoomLevel());
    //     };

    //     window.addEventListener('resize', handleResize);

    //     // Cleanup event listener on component unmount
    //     return () => {
    //         window.removeEventListener('resize', handleResize);
    //     };
    // }, []);

    function getZoomLevel() {
        return Math.round(window.devicePixelRatio * 100);
    }

    const handleSearch = (event) => {
        setSearchTerm(event.target.value.toLowerCase());
    };

    const filteredTags = tags.filter(tag =>
        tag.tagName.toLowerCase().includes(searchTerm)
    );


    const bgRef = useRef(null)

    const mainRef = useRef(null)

    const [bg_control, Set_bg_control] = useState(false)
    const [bg_item, Set_bg_item] = useState("");
    const [bg_key_current, Set_bg_key_current] = useState("")

    const [currentBreakpoint, setCurrentBreakpoint] = useState("lg");
    const [compactType, setCompactType] = useState(null);
    const [resizeHandles, setResizeHandles] = useState(["se"]);
    const [mounted, setMounted] = useState(false);

    const [render_items, Set_render_items] = useState({
        lg: [],
        md: [],
        sm: [],
        xs: [],
        xxs: [],
    });
    const [gauge_value, Set_gauge_value] = useState(72);

    const [temp_gauge_max, Set_temp_gauge_max] = useState(0);

    const [active_page_TagIds, Set_active_page_TagIds] = useState([])
    const [active_popup_id, Set_active_popup_id] = useState(null)
    const [active_popup_items, Set_active_popup_items] = useState([])

    const [get_value_timer, Set_get_value_timer] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            Set_get_value_timer(prevValue => prevValue + 1);
            console.log(get_value_timer + 1);
        }, 5000);

        return () => clearInterval(interval); // Temizleme işlemi
    }, []);

    const [current_pageDetails, Set_currentpageDetails] = useState(null);

    const [page_list, Set_page_list] = useState([])



    const getItemsFromDB = async () => {

        if (document.querySelector(".main_sec")) {
            try {
                let pageName_;
                let pageName__ = props.current_path;
                pageName__ = pageName__.substring(pageName__.indexOf("s/") + 2);

                pages.forEach(s => {
                    var pageN = s.pageName;
                    let pathName = normalizeURLPath(pageN);
                    pathName = pathName.replaceAll(" ", "_");
                    if (pathName === pageName__) pageName_ = pageN

                })

                let response;
                if (props.current_dyn_pageName !== "") {
                    response = await fetch(
                        `https://app-rmmsapi.azurewebsites.net/api/pages/GetPagetByName`,
                        {
                            method: "POST",
                            body: JSON.stringify({
                                pageName: pageName_,
                                companyId: props.com_id,
                            }),
                            headers: {
                                "Content-Type": "application/json",
                                Accept: "application/json",
                            },
                        }
                    );
                } else {
                    response = await fetch(
                        `https://app-rmmsapi.azurewebsites.net/api/pages/GetPageList`,
                        {
                            method: "POST",
                            body: JSON.stringify({
                                companyId: props.com_id,
                            }),
                            headers: {
                                "Content-Type": "application/json",
                                Accept: "application/json",
                            },
                        }
                    );
                }

                const data = await response.json();
                console.warn(data);
                var newlist = data;
                if (props.current_dyn_pageName === "") {
                    newlist.forEach(async (i) => {
                        await Store.dispatch(add_page_name(i.pageName));
                        if (i.details !== "") {
                            i.details = JSON.parse(i.details);
                        }
                    });

                    await Store.dispatch(set_pages(newlist));
                    Set_page_list(newlist)
                }




                let last_id_data = [];


                // let bgColor = newlist.length > 0
                //     ? newlist
                //         .filter(x => normalizeURLPath(x.pageName).replaceAll(" ", "_") === normalizeURLPath(pageName_).replaceAll(" ", "_"))
                //         .map(x => x.bgColor)[0]
                //     : null;

                // console.warn(bgColor, pageName_)

                // Set_page_bgColor(bgColor !== undefined ? bgColor : "")
                let items = null;
                if (newlist.length > 0) {
                    const filteredList = newlist.filter(x => {
                        const normalizedPageName = normalizeURLPath(x.pageName).replaceAll(" ", "_");
                        console.warn("Normalized x.pageName:", normalizedPageName, "pageName_:", pageName_);
                        return normalizedPageName === normalizeURLPath(pageName_).replaceAll(" ", "_");
                    });

                    items = filteredList.length > 0
                        ? filteredList.map(x => typeof x.details === 'string' ? JSON.parse(x.details) : x.details)[0]
                        : null;
                }









                function normalizeURLPath(path) {
                    const turkishMap = {
                        'İ': 'I', 'ı': 'i', 'Ş': 'S', 'ş': 's',
                        'Ğ': 'G', 'ğ': 'g', 'Ü': 'U', 'ü': 'u',
                        'Ö': 'O', 'ö': 'o', 'Ç': 'C', 'ç': 'c'
                    };

                    return path.split('').map(char => turkishMap[char] || char).join('');
                }
                console.log(items, pages);
                if (items !== null) {
                    setTimeout(() => {
                        const canvas_boyutu_ = current_pageDetails !== null ? current_pageDetails.canvas_boyutu : items.canvas_boyutu;
                        Set_currentpageDetails(items);

                        let df1_w = document.querySelector("aside") ? window.innerWidth - document.querySelector("aside").getBoundingClientRect().width : window.innerWidth * 0.86;
                        let df1_h = document.querySelector("header") ? window.innerHeight - document.querySelector("header").getBoundingClientRect().height : window.innerHeight - 86;

                        let guncel_ekran_boyutu = { w: df1_w, h: df1_h };

                        let json_items;
                        let currentWidth = guncel_ekran_boyutu.w;
                        let initalWidth = canvas_boyutu_.width;
                        let initalHeight = canvas_boyutu_.height;
                        let initalOran = initalWidth / initalHeight;
                        let currentHeight = guncel_ekran_boyutu.h;

                        let width_oran = currentWidth / initalWidth;
                        let height_oran = currentHeight / initalHeight;

                        if (items) {
                            json_items = items;
                            if (JSON.stringify(json_items) !== "{}") {
                                ["lg", "md", "sm", "xs", "xxs"].forEach(size => {
                                    if (json_items[size]) {
                                        let temp_data = [];
                                        json_items[size].forEach(item => {
                                            temp_data.push(item.type);

                                            if (item.type === "bg") {
                                                item.elementDetails.left *= width_oran;
                                                item.elementDetails.width *= width_oran;
                                                item.elementDetails.top *= height_oran;
                                                item.elementDetails.height *= height_oran;
                                            }

                                            if (item.elementDetails.tagId && item.elementDetails.tagId !== "" && last_id_data.indexOf(item.elementDetails.tagId) < 0) {
                                                last_id_data.push(item.elementDetails.tagId)
                                            }

                                            if (item.elementDetails.items && item.elementDetails.items.length > 0) {
                                                item.elementDetails.items.forEach(x => {
                                                    if (x.elementDetails.tagId && x.elementDetails.tagId !== "" && last_id_data.indexOf(x.elementDetails.tagId) < 0) {
                                                        last_id_data.push(x.elementDetails.tagId)
                                                    }
                                                    x.x = x.hasOwnProperty("x_percent") ? x.x_percent * currentWidth : x.x * width_oran;
                                                    x.w = x.hasOwnProperty("w_percent") ? x.w_percent * currentWidth : x.w * width_oran;
                                                    x.y = x.hasOwnProperty("y_percent") ? x.y_percent * currentHeight : x.y * height_oran;
                                                    x.h = x.hasOwnProperty("h_percent") ? x.h_percent * currentHeight : x.h * height_oran;

                                                    x.fontSize = Number(x.fontSize) * width_oran;
                                                })
                                            }

                                            if (item.elementDetails.tagId1 && item.elementDetails.tagId1 !== "" && last_id_data.indexOf(item.elementDetails.tagId1) < 0) {
                                                last_id_data.push(item.elementDetails.tagId1)
                                            }

                                            if (item.elementDetails.tagId2 && item.elementDetails.tagId2 !== "" && last_id_data.indexOf(item.elementDetails.tagId2) < 0) {
                                                last_id_data.push(item.elementDetails.tagId2)
                                            }

                                            if (item.elementDetails.tagId3 && item.elementDetails.tagId3 !== "" && last_id_data.indexOf(item.elementDetails.tagId3) < 0) {
                                                last_id_data.push(item.elementDetails.tagId3)
                                            }

                                            if (item.elementDetails.tagId4 && item.elementDetails.tagId4 !== "" && last_id_data.indexOf(item.elementDetails.tagId4) < 0) {
                                                last_id_data.push(item.elementDetails.tagId4)
                                            }

                                            item.x = item.x_percent * currentWidth;
                                            item.w = item.w_percent * currentWidth;
                                            item.y = item.y_percent * currentHeight;
                                            item.h = item.h_percent * currentHeight;
                                            item.fontSize = Number(item.fontSize) * width_oran;

                                            if (item.elementDetails.rad) {
                                                item.elementDetails.rad = item.elementDetails.rad * (width_oran + height_oran) / 2.9


                                            }
                                        });

                                        Set_render_items(prevLayouts => ({
                                            ...prevLayouts,
                                            [size]: temp_data,
                                        }));
                                    }
                                });
                            }
                        }

                        else {
                            json_items = { lg: [], md: [], sm: [], xs: [], xxs: [] };
                        }
                        let last_obje = []
                        console.warn(last_id_data);
                        last_id_data.forEach(s => {
                            last_obje.push({ tagId: s })
                        })

                        if (last_obje.length < 1) Set_control_loading(false)
                        Set_active_page_TagIds(last_obje)
                        console.log(json_items);
                        setLayouts(json_items);
                    }, 25)
                }

            } catch (err) {
                console.log(err);
            }
        }




    };


    const [tag_values_state, Set_tag_values_state] = useState([])

    const [select_set_box, Set_select_set_box] = useState("")
    const [select_set_box2, Set_select_set_box2] = useState("")


    useEffect(() => {
        if (active_page_TagIds.length > 0) {


            const fetchTagValues = async () => {
                try {
                    const request = await fetch(
                        "https://app-rmmsapi.azurewebsites.net/api/tags/GetTagValues",
                        {
                            headers: {
                                "Content-Type": "application/json",
                                accept: "application/json",
                            },
                            method: "POST",
                            body: JSON.stringify(active_page_TagIds),
                        }
                    );
                    const response = await request.json();

                    if (request.status === 200) { Set_tag_values_state(response); console.warn(response); }
                } catch (err) {
                    console.log(err);
                } finally {
                    Set_control_loading(false)
                }

            };

            fetchTagValues()
        }
    }, [get_value_timer, active_page_TagIds])

    //Unmount işlemleri

    useEffect(() => {
        // İlk render sonrası gauge'i tekrar çizdir

        const timer = setInterval(() => {
            if (fufg < 2) forceUpdateforGauge(prev => prev + 1);
        }, 100);


        // 50ms gecikme
        setTimeout(() => {
            if (pages.length > 0) {
                getItemsFromDB();

            }

            setMounted(true);
        }, 1500)


        return () => clearInterval(timer);








    }, [screenWidthState, tag_values, props.current_path]);




    useEffect(() => {

        setLayouts((prevLayouts) => {
            if (prevLayouts[currentBreakpoint]) {

                return {
                    ...prevLayouts,
                    [currentBreakpoint]: (prevLayouts[currentBreakpoint] || []).map(
                        (layoutItem) => {
                            // Mevcut layout'un her bir elemanının resizeHandles özelliğini güncelle
                            return { ...layoutItem, resizeHandles: resizeHandles };
                        }
                    ),
                };
            }
        });
    }, [resizeHandles]);

    //   function adjustFontSizeforWS(e) {
    //     var id_ = e.target.id;
    //     // Div'i seç
    //     var div = e.target;


    //     var pElements = div.querySelectorAll('.alt_white_space');
    //     var totalHeight = 0;

    //     for (var i = 0; i < pElements.length; i++) {
    //         // Yükseklik
    //         totalHeight += pElements[i].offsetHeight;

    //     }

    //     // Toplam yüksekliği div'in yeni yüksekliği olarak ayarla
    //     div.style.height = String((totalHeight/2 + 20)) + "px";
    // }



    function adjustFontSizeforWS(id) {
        var div; // divId, div'in gerçek id'siyle değiştirilmelidir
        document.querySelectorAll(".white_Space").forEach((a) => {
            if (a.id === id) {
                div = a;
            }
        });
        var elements = div.querySelectorAll(".alt_white_space");
        var minHeight = Number.MAX_SAFE_INTEGER; // Başlangıçta minimum yüksekliği en büyük olabilecek bir değerle başlat
        var maxHeight = Number.MIN_SAFE_INTEGER; // Başlangıçta maksimum yüksekliği en küçük olabilecek bir değerle başlat


        // Div içindeki her bir elementin pozisyonunu ve yüksekliğini hesapla
        elements.forEach(function (element) {
            var rect = element.getBoundingClientRect(); // Elementin pozisyonunu ve boyutunu al
            var elementTop = rect.top;
            var elementBottom = rect.bottom;

            // En üstteki elemanın başlangıcını, en alttaki elemanın bitişini ve en küçük yüksekliği bul
            if (elementTop < minHeight) {
                minHeight = elementTop;
            }
            if (elementBottom > maxHeight) {
                maxHeight = elementBottom;
            }
        });

        // En üstteki elemanın başlangıcından en alttaki elemanın bitişine kadar olan yüksekliği hesapla
        var totalHeight = maxHeight - minHeight;
        var divHeight = div.offsetHeight;

        if (totalHeight > divHeight) {
            div.style.height = String(totalHeight + 20) + "px";
            setLayouts((prevLayouts) => {
                return {
                    ...prevLayouts,
                    [currentBreakpoint]: (prevLayouts[currentBreakpoint] || []).map(
                        (layoutItem) => {
                            if (String(layoutItem.id) === id) {
                                return {
                                    ...layoutItem,
                                    h: Number(
                                        Number(Math.ceil((totalHeight + 20) / 40)).toFixed(0)
                                    ),
                                };
                            }
                            return { ...layoutItem };
                        }
                    ),
                };
            });
        }
    }

    const close_pop_up = (e) => {
        e.preventDefault();

        document
            .querySelector(".show_external_trend")
            .classList.toggle("show_external_trend_active");
    };

    const close_pop_up2 = (e) => {
        e.preventDefault();

        Set_combine_trend_tags([])


        document
            .querySelector(".show_external_combine_trend")
            .classList.toggle("show_external_combine_trend_active");
    };

    const close_pop_up3 = (e) => {
        e.preventDefault();



        document
            .querySelector(".show_external_detail")
            .classList.toggle("show_external_detail_active");
    };

    const [draggableActive, Set_dragggableActive] = useState(false)

    const [dragggableDetail, Set_dragggableDetail] = useState(null)

    const deleteElem = (id) => {
        console.log(id);
        setLayouts((prevLayouts) => {
            const updatedLayouts = { ...prevLayouts };
            if (Array.isArray(updatedLayouts[currentBreakpoint])) {
                updatedLayouts[currentBreakpoint] = (updatedLayouts[currentBreakpoint] || []).filter(
                    (item) => String(item.id) !== String(id)
                );
            }
            return updatedLayouts;
        });
    }



    const addPageFunc = async (item) => {

        try {
            const request = await fetch("https://app-rmmsapi.azurewebsites.net/api/pages/AddPage", {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                },
                method: "POST",
                body: item
            })

            if (request.status === 200) {
                const response = await request.json()
            }
        } catch (err) {
            console.log(err)
        } finally {
            localStorage.removeItem("layouts");
            localStorage.removeItem("canvas_properties");
            await getPages();
            history.push("/");
        }


    }

    const [combine_trend_tags, Set_combine_trend_tags] = useState([])

    const [alarms_state, Set_alarms_state] = useState(null)
    const API_BASE_URL_ALARM = "https://rmms-metis-engine.azurewebsites.net/api";


    const fetchAlarmValue = async () => {
        if (!props.temp_com_id) return 0;

        try {
            const request = await fetch(
                `${API_BASE_URL_ALARM}/Alarm/GetAlarmStats?companyId=${Number(props.temp_com_id)}`,
                {
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                }
            );

            if (request.status === 200) {
                const statsData = await request.json();
                // Set statistics based on returned data
                Set_alarms_state({
                    total: statsData?.total || 0,
                    unconfirmed: statsData?.unconfirmed || 0,
                    critical: statsData?.critical || 0,
                    warning: statsData?.warning || 0,
                    info: statsData?.info || 0,
                    high: statsData?.high || 0,
                    open: statsData?.open || 0,
                    inProgress: statsData?.inProgress || 0,
                    closed: statsData?.closed || 0,
                });
            } else {
                console.error(
                    "İstatistik verileri alınamadı:",
                    request.statusText
                );
            }
        } catch (err) {
            console.error("Alarm verileri alınırken hata oluştu:", err);
        }


    }

    useEffect(() => {

        fetchAlarmValue();

    }, [props.temp_com_id], props.alarms)

    const generateDOM = () => {
        if (currentBreakpoint === "md") {
            if (!layouts.md || !Array.isArray(layouts.md)) {
                return [];
            }
            return _.map(layouts.md, function (l, i) {
                if (l.type === "text") {

                    return (
                        <div
                            style={{
                                zIndex: "1",
                                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px",
                                borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px",
                                borderColor: l.borderColor ? l.borderColor : "black",
                                backgroundColor: l.bgColor ? l.bgColor : "white",
                                color: l.fontColor ? l.fontColor : "black",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                textAlign: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center",
                                fontSize: l.fontSize ? l.fontSize : `${(Number(l.w)) / 10}px`,
                                overflowWrap: "break-word",
                                wordBreak: "break-word",
                                whiteSpace: "normal",
                            }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: l.w,
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}
                            className={"text_widget" + " " + (l.special_type ? "special_type" : "")}
                        >
                            {l.elementDetails.text !== "" ? (
                                <span
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {l.elementDetails.text}
                                </span>
                            ) : (
                                <span
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    Bu alanda henüz metin yok.
                                </span>
                            )}
                        </div>
                    );

                } else if (l.type === "Alarm") {

                    let value;
                    let stats = alarms_state;

                    console.warn(stats); let seviye_ = l.elementDetails.seviye;
                    if (seviye_ === "1") {
                        value = stats?.high || 0
                    } else if (seviye_ === "2") {
                        value = stats?.warning || 0
                    } else {
                        value = stats?.critical || 0
                    }

                    return (
                        <div



                            style={{
                                zIndex: "1", border: "2px solid black", borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px",
                                borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor || "transparent"
                            }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: l.w,
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            data-id={l.special_type ? "l.special_type" : ""}
                            key={l.i}
                            className="alarm_widget"
                        >
                            <div className="main_alarm_widget">

                                <div style={{ display: "flex", justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center" }} className="showAlarmValueW">{value}</div>
                            </div>


                        </div>
                    );

                } else if (l.type === "gauge_linear") {

                    // tip kontrolü ile uygun tag değerini bul
                    let selectedTag;
                    if (l.elementDetails.tip === "Var") {
                        selectedTag = tag_values_state.find(
                            (item) => item.tip === "Var" && item.tagId === l.elementDetails.tagId
                        );
                    } else {
                        selectedTag = tag_values_state.find((item) => item.tagId === l.elementDetails.tagId);
                        // Sayısal değeri güvenli şekilde al
                        let value_tag = selectedTag ? selectedTag.tagValue : "";
                        console.warn("value_tag", value_tag)
                        const numericValue = parseFloat(value_tag);
                        console.warn(numericValue, "numericValue")
                        const isNumeric = !isNaN(numericValue);

                        // Eğer isNumeric false ise boşluktan sonrasını kes
                        value_tag = isNumeric ? value_tag : value_tag.split(' ')[0];

                        // startValue ve endValue güvenli şekilde belirle
                        const startValue =
                            l.elementDetails.startValue && isNumeric && l.elementDetails.startValue <= numericValue
                                ? l.elementDetails.startValue
                                : 0;

                        const endValue =
                            l.elementDetails.endValue && isNumeric && l.elementDetails.endValue >= numericValue
                                ? l.elementDetails.endValue
                                : isNumeric
                                    ? numericValue.toFixed(2)
                                    : 100;
                        // normalizedValue hesapla
                        const normalizedValue = isNumeric
                            ? ((value_tag - startValue) / (endValue - startValue)) * 100
                            : 0;



                        const linearOptions = {
                            pointer: {
                                value: isNumeric ? numericValue : 50, // Sayıysa kullan, değilse 50
                                shape: "arrow",
                                size: 20,
                                color: "rgb(20,20,20)"// Pointer büyüklüğü artırıldı
                            },
                            scale: {
                                min: startValue,
                                max: endValue,
                                majorUnit: (endValue - startValue) / 5,
                                minorUnit: 2,
                                line: {
                                    width: 5, // Ölçek çizgisi kalınlaştırıldı
                                    color: "black"
                                },
                                labels: {
                                    color: "black",
                                    visible: true,
                                    font: "14px Arial, sans-serif", // Yazı fontu büyütüldü
                                },
                                ranges: [
                                    { from: startValue, to: l.elementDetails.alarmValue ? l.elementDetails.alarmValue : (endValue - startValue) / 2, color: "red" },
                                    { from: l.elementDetails.alarmValue ? l.elementDetails.alarmValue : (endValue - startValue) / 2, to: endValue, color: "blue" },
                                ],
                            },
                        };

                        const alarmValue = l.elementDetails.alarmValue || 0


                        return (
                            <div
                                className="gauge_widgetParentDiv"
                                data-grid={{
                                    x: l.x,
                                    y: l.y,
                                    w: l.w,
                                    h: l.h,
                                    resizeHandles: l.resizeHandles,
                                }}


                                style={{
                                    border: "none",
                                    borderWidth: l.borderWidth ? `${l.borderWidth}px` : "2px",
                                    backgroundColor: "transparent",
                                    borderRadius: l.elementDetails.borderRadius ? `${l.elementDetails.borderRadius}px` : "8px",

                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    borderColor: l.borderColor ? l.borderColor : "rgb(100,100,100)",
                                    overflow: "hidden",
                                }}
                                key={l.i}
                                id={l.id}
                                data-id={l.special_type ? "l.special_type" : ""}

                                onContextMenu={(e) => {
                                    if (l.elementDetails.tagId && l.add_trend && l.add_trend === "YES") {
                                        var tagName = tags
                                            .filter((b) => b.tagId === l.elementDetails.tagId)
                                            .map((c) => c.tagName)[0];

                                        e.preventDefault();
                                        const { clientX, clientY } = e;
                                        let screen_width = window.innerWidth;
                                        console.log(clientX, clientY);
                                        document
                                            .querySelector(".show_external_trend")
                                            .classList.toggle(
                                                "show_external_trend_active"
                                            );
                                        document.querySelector(
                                            ".show_tagId"
                                        ).innerHTML = l.elementDetails.tagId;
                                        document.querySelector(
                                            ".show_tagName"
                                        ).innerHTML = tagName;
                                        var popup = document.querySelector(
                                            ".show_external_trend"
                                        );
                                        const popupRect =
                                            popup.getBoundingClientRect();
                                        const viewportWidth = window.innerWidth;
                                        const viewportHeight = window.innerHeight;

                                        // Calculate the new positions
                                        let newX = clientX;
                                        let newY = clientY;

                                        // Adjust if the popup would overflow the right edge of the viewport
                                        if (
                                            newX + popupRect.width >
                                            viewportWidth
                                        ) {
                                            newX = viewportWidth - popupRect.width;
                                        }

                                        // Adjust if the popup would overflow the bottom edge of the viewport
                                        if (
                                            newY + popupRect.height >
                                            viewportHeight
                                        ) {
                                            newY =
                                                viewportHeight - popupRect.height;
                                        }

                                        // Adjust if the popup would overflow the left edge of the viewport
                                        if (newX < 0) {
                                            newX = 0;
                                        }

                                        // Adjust if the popup would overflow the top edge of the viewport
                                        if (newY < 0) {
                                            newY = 0;
                                        }

                                        if (
                                            screen_width < 2301 &&
                                            screen_width > 1800
                                        ) {
                                            document.querySelector(
                                                ".show_external_trend"
                                            ).style.left = `${String(
                                                newX / 1.2
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_trend"
                                            ).style.top = `${String(newY / 1.2)}px`;
                                        } else if (
                                            screen_width < 2801 &&
                                            screen_width > 2300
                                        ) {
                                            document.querySelector(
                                                ".show_external_trend"
                                            ).style.left = `${String(
                                                newX / 1.5
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_trend"
                                            ).style.top = `${String(newY / 1.5)}px`;
                                        } else if (
                                            screen_width < 3501 &&
                                            screen_width > 2800
                                        ) {
                                            document.querySelector(
                                                ".show_external_trend"
                                            ).style.left = `${String(
                                                newX / 1.8
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_trend"
                                            ).style.top = `${String(newY / 1.8)}px`;
                                        } else if (
                                            screen_width < 5001 &&
                                            screen_width > 3500
                                        ) {
                                            document.querySelector(
                                                ".show_external_trend"
                                            ).style.left = `${String(
                                                newX / 2.5
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_trend"
                                            ).style.top = `${String(newY / 2.5)}px`;
                                        } else if (screen_width <= 1800) {
                                            document.querySelector(
                                                ".show_external_trend"
                                            ).style.left = `${String(newX)}px`;
                                            document.querySelector(
                                                ".show_external_trend"
                                            ).style.top = `${String(newY)}px`;
                                        }
                                    } else if (l.elementDetails.tagId && l.elementDetails.tagId !== "") {
                                        var tagName = tags
                                            .filter((b) => b.tagId === l.elementDetails.tagId)
                                            .map((c) => c.tagName)[0];

                                        e.preventDefault();
                                        const { clientX, clientY } = e;
                                        let screen_width = window.innerWidth;
                                        console.log(clientX, clientY);
                                        document
                                            .querySelector(".show_external_detail")
                                            .classList.toggle(
                                                "show_external_detail_active"
                                            );
                                        document.querySelector(
                                            ".show_tagId2"
                                        ).innerHTML = l.elementDetails.tagId;
                                        document.querySelector(
                                            ".show_tagName2"
                                        ).innerHTML = tagName;
                                        var popup = document.querySelector(
                                            ".show_external_detail"
                                        );
                                        const popupRect =
                                            popup.getBoundingClientRect();
                                        const viewportWidth = window.innerWidth;
                                        const viewportHeight = window.innerHeight;

                                        // Calculate the new positions
                                        let newX = clientX;
                                        let newY = clientY;

                                        // Adjust if the popup would overflow the right edge of the viewport
                                        if (
                                            newX + popupRect.width >
                                            viewportWidth
                                        ) {
                                            newX = viewportWidth - popupRect.width;
                                        }

                                        // Adjust if the popup would overflow the bottom edge of the viewport
                                        if (
                                            newY + popupRect.height >
                                            viewportHeight
                                        ) {
                                            newY =
                                                viewportHeight - popupRect.height;
                                        }

                                        // Adjust if the popup would overflow the left edge of the viewport
                                        if (newX < 0) {
                                            newX = 0;
                                        }

                                        // Adjust if the popup would overflow the top edge of the viewport
                                        if (newY < 0) {
                                            newY = 0;
                                        }

                                        if (
                                            screen_width < 2301 &&
                                            screen_width > 1800
                                        ) {
                                            document.querySelector(
                                                ".show_external_detail"
                                            ).style.left = `${String(
                                                newX / 1.2
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_detail"
                                            ).style.top = `${String(newY / 1.2)}px`;
                                        } else if (
                                            screen_width < 2801 &&
                                            screen_width > 2300
                                        ) {
                                            document.querySelector(
                                                ".show_external_detail"
                                            ).style.left = `${String(
                                                newX / 1.5
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_detail"
                                            ).style.top = `${String(newY / 1.5)}px`;
                                        } else if (
                                            screen_width < 3501 &&
                                            screen_width > 2800
                                        ) {
                                            document.querySelector(
                                                ".show_external_detail"
                                            ).style.left = `${String(
                                                newX / 1.8
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_detail"
                                            ).style.top = `${String(newY / 1.8)}px`;
                                        } else if (
                                            screen_width < 5001 &&
                                            screen_width > 3500
                                        ) {
                                            document.querySelector(
                                                ".show_external_detail"
                                            ).style.left = `${String(
                                                newX / 2.5
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_detail"
                                            ).style.top = `${String(newY / 2.5)}px`;
                                        } else if (screen_width <= 1800) {
                                            document.querySelector(
                                                ".show_external_detail"
                                            ).style.left = `${String(newX)}px`;
                                            document.querySelector(
                                                ".show_external_detail"
                                            ).style.top = `${String(newY)}px`;
                                        }
                                    }
                                }}
                            >
                                <div className="su_tanki_gauge_linear" style={{ borderColor: l.borderColor || "#000" }}>
                                    <div style={{ position: "relative", height: "100%", width: "100%", display: "flex", flexDirection: "column-reverse" }}>
                                        <div style={{ width: "100%", height: alarmValue >= numericValue ? "0%" : numericValue * 100 / endValue + "%", backgroundColor: "blue" }} className="water"></div>
                                        <div style={{ width: "100%", height: alarmValue >= numericValue ? numericValue * 100 / endValue + "%" : "0%", backgroundColor: "red" }} className="alarmWater"></div>

                                        <div
                                            style={{
                                                position: "absolute",
                                                top: "50%",
                                                left: "50%",
                                                transform: "translate(-50%, -50%)", // Bu, öğeyi tam olarak ortalar
                                                backgroundColor: "black", // Hafif şeffaf beyaz arka plan
                                                padding: "4px 8px",
                                                borderRadius: "6px",
                                                fontSize: "16px",
                                                fontWeight: "bold",
                                                zIndex: "3",
                                                color: "#ffffff", // Daha koyu siyah
                                                fontFamily: "'Poppins', sans-serif", // Daha modern ve seksi font
                                                boxShadow: "2px 2px 6px rgba(0, 0, 0, 0.15)", // Hafif gölge efekti
                                            }}
                                        >
                                            {value_tag ? l.elementDetails.pU && l.elementDetails.pU === "Percent" ? (numericValue * 100 / endValue).toFixed(2) + "%" : numericValue : 50}
                                        </div>
                                    </div>
                                </div>



                            </div>
                        );
                    }
                }
                else if (l.type === "lock") {
                    let value_ = tag_values_state.find(i =>
                        l.elementDetails.tip !== "Var"
                            ? String(i.tagId) === String(l.elementDetails.tagId)
                            : i.tip === "Var" && String(i.tagId) === String(l.elementDetails.tagId)
                    )?.tagValue;
                    if (value_ && isNaN(Number(value_))) {
                        value_ = value_.split(' ')[0]; // ilk boşluktan önceki kısmı al
                        value_ = value_.includes(" ") ? value_.trim() : value_
                    }
                    return (
                        <div


                            onClick={(e) => {
                                let tagValue;
                                (layouts[currentBreakpoint] || []).forEach(x => {
                                    if (String(x.id) === String(l.id)) {
                                        let tagId_ = l.elementDetails.tagId || "";

                                        tagValue = value_ === "1" ? "0" : "1";
                                        setValueFunc({ TagId: tagId_, TagValue: tagValue })
                                        document.querySelectorAll(".react-grid-item").forEach((item) => {
                                            if (item.classList.contains(`${l.elementDetails.tagIdEx}`)) {
                                                item.style.pointerEvents = tagValue === "1" ? "none" : "all";
                                                if (e.target.classList.contains("fa-lock")) {
                                                    item.style.opacity = "1"
                                                } else if (e.target.classList.contains("fa-unlock")) {
                                                    item.style.opacity = "0.55"
                                                }
                                            }
                                        })
                                        if (e.target.classList.contains("fa-lock")) {
                                            e.target.classList.replace("fa-lock", "fa-unlock");
                                        } else if (e.target.classList.contains("fa-unlock")) {
                                            e.target.classList.replace("fa-unlock", "fa-lock");
                                        }
                                    }
                                })
                            }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            data-id={l.special_type ? "l.special_type" : ""}
                            key={l.i}
                            className={`lock_widget`}
                        >
                            <i id="lock_i_dyn" style={{ color: l.fontColor || "gray", width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: `${l.w / 4}px` }} className={value_ === "0" ? "fa fa-lock" : "fa fa-unlock"}></i>



                        </div>
                    );
                } else if (l.type === "i_g") {
                    return (
                        <div

                            onClick={() => {
                                pages.forEach(async x => {
                                    if (Number(x.pageId) === Number(l.elementDetails.pageId)) {
                                        function normalizeURLPath(path) {
                                            const turkishMap = {
                                                'İ': 'I', 'ı': 'i', 'Ş': 'S', 'ş': 's',
                                                'Ğ': 'G', 'ğ': 'g', 'Ü': 'U', 'ü': 'u',
                                                'Ö': 'O', 'ö': 'o', 'Ç': 'C', 'ç': 'c'
                                            };

                                            return path.split('').map(char => turkishMap[char] || char).join('');
                                        }
                                        await Store.dispatch(set_current_dyn_pageName(x.pageName))
                                        history.push(`/pages/${normalizeURLPath(x.pageName).replaceAll(" ", "_")}`)

                                    }
                                })
                            }}

                            style={{
                                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px",
                                border: "2px solid rgb(60,60,60)", borderColor: l.borderColor ? l.borderColor : "black", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black",
                                borderRadius: "4px", zIndex: "1", cursor: "pointer"
                            }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            data-id={l.special_type ? "l.special_type" : ""}
                            key={l.i}
                            className="i_g_widget"
                        >

                            <div style={{ backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black", width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                                {l.elementDetails.text}

                            </div>

                        </div>
                    );
                } else if (l.type === "y_g") {

                    let value_ = tag_values_state.find(i =>
                        l.elementDetails.tip !== "Var"
                            ? String(i.tagId) === String(l.elementDetails.tagId)
                            : i.tip === "Var" && String(i.tagId) === String(l.elementDetails.tagId)
                    )?.tagValue;

                    // Eğer value_ sayısal değilse, boşluktan sonrasını sil
                    if (value_ && isNaN(Number(value_))) {
                        value_ = value_.split(' ')[0];

                    }
                    console.warn("value_", value_, typeof (value_));

                    value_ = value_ && value_.split('.')[0]; // Noktadan sonrasını almaz

                    console.warn("value_", value_, typeof (value_));

                    // 2. value_list oluştur (value1, value2, value3... varsa onları al)
                    let valueList = [];
                    let i = 1;
                    while (l.elementDetails[`value${i}`] !== undefined) {
                        valueList.push(l.elementDetails[`value${i}`]);
                        i++;
                    }


                    // 2. `value_.elementDetailslist` İçinde `valelementDetails.ue_` İndeksini Bul
                    let index_ = l.elementDetails.value_list && l.elementDetails.value_list.indexOf(
                        value_ !== undefined && value_.includes(" ") ? value_.trim() : value_
                    );

                    // 3. Varsayılan Atama
                    if (index_ === -1 || index_ === undefined) { // `indexOf` bulunamazsa -1 döner
                        index_ = 0;
                    }

                    return (
                        <div

                            onContextMenu={(e) => {
                                if (l.elementDetails.tagId && l.add_trend && l.add_trend === "YES") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_trend")
                                        .classList.toggle(
                                            "show_external_trend_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_trend"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                } else if (l.elementDetails.tagId && l.elementDetails.tagId !== "") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_detail")
                                        .classList.toggle(
                                            "show_external_detail_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId2"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName2"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_detail"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                }
                            }}
                            style={{
                                border: "2px solid rgb(60,60,60)",

                                width: l.elementDetails.rad ? l.elementDetails.rad + "px" : "10px", height: l.elementDetails.rad ? l.elementDetails.rad + "px" : "10px", borderRadius: l.elementDetails.rad ? (l.elementDetails.tur ? l.elementDetails.tur === "circle" ? l.elementDetails.rad + "px" : l.elementDetails.borderRadius + "px" : "10px") : "10px", zIndex: "1", borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px",
                                backgroundColor: l.elementDetails.bg_list && l.elementDetails.bg_list[index_] ? l.elementDetails.bg_list[index_] : "white", borderColor: l.elementDetails.border_list && l.elementDetails.border_list[index_] ? l.elementDetails.border_list[index_] : "black"
                            }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: l.elementDetails.rad ? l.elementDetails.rad : l.w,
                                h: l.elementDetails.rad ? l.elementDetails.rad : l.w,
                            }}
                            id={l.id}
                            data-id={l.special_type ? "l.special_type" : ""}
                            key={l.i}
                            className="yuvarlak_gosterge_widget"
                        >


                        </div>
                    );
                }
                else if (l.type === "go_page") {
                    return (
                        <div

                            onClick={() => {
                                if (l.elementDetails.text === "Alarm" && alarm_okuma) {
                                    history.push("/AlarmPanel")
                                } else {
                                    pages.forEach(async x => {
                                        if (Number(x.pageId) === Number(l.elementDetails.pageId)) {
                                            console.warn(l)

                                            function normalizeURLPath(path) {
                                                const turkishMap = {
                                                    'İ': 'I', 'ı': 'i', 'Ş': 'S', 'ş': 's',
                                                    'Ğ': 'G', 'ğ': 'g', 'Ü': 'U', 'ü': 'u',
                                                    'Ö': 'O', 'ö': 'o', 'Ç': 'C', 'ç': 'c'
                                                };

                                                return path.split('').map(char => turkishMap[char] || char).join('');
                                            }
                                            await Store.dispatch(set_current_dyn_pageName(x.pageName))
                                            history.push(`/pages/${normalizeURLPath(x.pageName).replaceAll(" ", "_")}`)

                                        }
                                    })
                                }
                            }
                            }

                            style={{
                                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px",
                                border: "2px solid rgb(60,60,60)", borderColor: l.borderColor ? l.borderColor : "black", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black",
                                borderRadius: "4px", zIndex: "1", cursor: "pointer"
                            }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            data-id={l.special_type ? "l.special_type" : ""}
                            key={l.i}
                            className="go_page_widget"
                        >

                            <div style={{ backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black", width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                                {l.elementDetails.text}

                            </div>

                        </div>
                    );
                }
                else if (l.type === "set") {

                    // 1. `value_` Değerini Bul
                    let value_ = tag_values_state.find(i =>
                        l.elementDetails.tip !== "Var"
                            ? String(i.tagId) === String(l.elementDetails.tagId)
                            : i.tip === "Var" && String(i.tagId) === String(l.elementDetails.tagId)
                    )?.tagValue;

                    // Eğer value_ sayısal değilse, boşluktan sonrasını sil
                    if (value_ && isNaN(Number(value_))) {
                        value_ = value_.split(' ')[0]; // ilk boşluktan önceki kısmı al
                    }

                    // 2. `value_list` İçinde `value_` İndeksini Bul
                    let index_ = l.elementDetails.value_list && l.elementDetails.value_list.indexOf(
                        value_ !== undefined && value_.includes(" ") ? value_.trim() : value_
                    );


                    // 3. Varsayılan Atama
                    if (index_ === -1 || index_ === undefined) { // `indexOf` bulunamazsa -1 döner
                        index_ = 0;
                    }


                    console.warn(value_, l, tag_values_state)

                    return (
                        <div
                            onContextMenu={(e) => {
                                if (l.elementDetails.tagId && l.add_trend && l.add_trend === "YES") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_trend")
                                        .classList.toggle(
                                            "show_external_trend_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_trend"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                } else if (l.elementDetails.tagId && l.elementDetails.tagId !== "") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_detail")
                                        .classList.toggle(
                                            "show_external_detail_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId2"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName2"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_detail"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                }
                            }}

                            onClick={(e) => {
                                if (l.elementDetails.tagId2 && l.elementDetails.tagId2 !== "" && l.elementDetails.tagId2 !== "None" && yazma_control) {
                                    console.log(e.target);
                                    e.preventDefault();
                                    e.stopPropagation();
                                    const { clientX, clientY } = e;
                                    document.querySelector(".Popup-selectbox2").classList.toggle("changeProperties_active")
                                    document.querySelector(".Popup-selectbox2").id = l.id

                                    var popup = document.querySelector(".Popup-selectbox2")
                                    const popupRect = popup.getBoundingClientRect();

                                    // Yeni pozisyonları hesapla
                                    let newX = clientX + window.scrollX;
                                    let newY = clientY + window.scrollY;

                                    console.log(newX, newY);

                                    // Sağ kenardan taşmayı önle
                                    if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                                        newX = window.innerWidth + window.scrollX - popupRect.width;
                                    }

                                    // Alt kenardan taşmayı önle
                                    if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                                        newY = window.innerHeight + window.scrollY - popupRect.height;
                                    }

                                    // Sol kenardan taşmayı önle
                                    if (newX < window.scrollX) {
                                        newX = window.scrollX;
                                    }

                                    // Üst kenardan taşmayı önle
                                    if (newY < window.scrollY) {
                                        newY = window.scrollY;
                                    }

                                    console.log(newX, newY);

                                    // Pop-up'ın pozisyonunu ayarla
                                    popup.style.left = `${newX}px`;
                                    popup.style.top = `${newY}px`;

                                    const parentElement = e.target.closest(".set_widget");
                                    const parentRect = parentElement.getBoundingClientRect();

                                    Set_elem_popup({
                                        width: l.w,
                                        height: l.h,
                                        left: l.x,
                                        top: l.y,

                                        value_list: l.elementDetails.value_list && l.elementDetails.value_list.length === 0 ? l.value_list : l.elementDetails.value_list,
                                        bg_list: l.elementDetails.bg_list && l.elementDetails.bg_list.length === 0 ? l.bg_list : l.elementDetails.bg_list,
                                        border_list: l.elementDetails.border_list && l.elementDetails.border_list.length === 0 ? l.border_list : l.elementDetails.border_list,
                                        font_list: l.elementDetails.font_list && l.elementDetails.font_list.length === 0 ? l.font_list : l.elementDetails.font_list,
                                        type: l.type,
                                        id: l.id,
                                        fontSize: l.fontSize ? l.fontSize : Number(l.w) / 10,
                                        value: l.elementDetails.text
                                    })
                                    setSelectedOptionselectbox(l.elementDetails.text)
                                }

                            }}
                            style={{
                                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px",
                                borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", backgroundColor: "white", border: "2px solid rgb(60,60,60)", borderColor: l.borderColor ? l.borderColor : "black", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black",
                                zIndex: "1",
                            }}

                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            data-id={l.special_type ? "l.special_type" : ""}
                            key={l.i}
                            className={`set_widget ${l.elementDetails.text} ${l.elementDetails.tagId}` + " " + (l.special_type ? "special_type" : "")}
                        >
                            <div style={{ backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black", width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                                {Number(value_).toLocaleString("tr-TR", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                }) || l.elementDetails.text}

                            </div>

                        </div>
                    );
                }
                else if (l.type === "selectbox") {




                    let value_ = tag_values_state.find(i =>
                        l.elementDetails.tip !== "Var"
                            ? String(i.tagId) === String(l.elementDetails.tagId)
                            : i.tip === "Var" && String(i.tagId) === String(l.elementDetails.tagId)
                    )?.tagValue;

                    // Eğer value_ sayısal değilse, boşluktan sonrasını sil
                    if (value_ && isNaN(Number(value_))) {
                        value_ = value_.split(' ')[0];

                    }
                    console.warn("value_", value_, typeof (value_));

                    value_ = value_ && value_.split('.')[0]; // Noktadan sonrasını almaz

                    console.warn("value_", value_, typeof (value_));

                    // 2. value_list oluştur (value1, value2, value3... varsa onları al)
                    let valueList = [];
                    let i = 1;
                    while (l.elementDetails[`value${i}`] !== undefined) {
                        valueList.push(l.elementDetails[`value${i}`]);
                        i++;
                    }


                    // 2. `value_list` İçinde `value_` İndeksini Bul
                    let index_ = l.elementDetails.value_list && l.elementDetails.value_list.indexOf(
                        value_ !== undefined && typeof value_ === "string" && value_.includes(" ")
                            ? value_.trim()
                            : value_
                    );

                    // 3. Varsayılan Atama
                    if (index_ === -1 || index_ === undefined) {
                        index_ = 0;
                    }

                   
                    let text_list_ = l.elementDetails.text_list;
                    let alarmClassName = "";
                    if (text_list_ && text_list_.length > 0 && text_list_[index_] === "ALARM") {
                        console.warn("ALARM", l, text_list_, index_)

                    }

                    if (text_list_ && text_list_.length > 0 && text_list_[index_] === "ALARM" && l.special_type) {
                        alarmClassName = "alarmactive_blackBorder";
                        (layouts[currentBreakpoint] || []).forEach((item) => {
                            if (item.id === l.id2 && !item.special_type) {
                                let id = item.id
                                document.querySelector(`#Popup${id}`).style.backgroundColor = "red"
                            }
                        });

                    }




                    return (
                        <div
                            onContextMenu={(e) => {
                                if (l.elementDetails.tagId && l.add_trend && l.add_trend === "YES") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_trend")
                                        .classList.toggle(
                                            "show_external_trend_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_trend"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                } else if (l.elementDetails.tagId && l.elementDetails.tagId !== "") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_detail")
                                        .classList.toggle(
                                            "show_external_detail_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId2"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName2"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_detail"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                }
                            }}
                            onClick={(e) => {
                                if (l.elementDetails.tagId2 && l.elementDetails.tagId2 !== "" && l.elementDetails.tagId2 !== "None" && yazma_control) {
                                    console.log(e.target);
                                    e.preventDefault();
                                    e.stopPropagation();
                                    const { clientX, clientY } = e;
                                    document.querySelector(".Popup-selectbox").classList.toggle("changeProperties_active")
                                    document.querySelector(".Popup-selectbox").id = l.id

                                    var popup = document.querySelector(".Popup-selectbox")
                                    const popupRect = popup.getBoundingClientRect();

                                    // Yeni pozisyonları hesapla
                                    let newX = clientX + window.scrollX;
                                    let newY = clientY + window.scrollY;

                                    console.log(newX, newY);

                                    // Sağ kenardan taşmayı önle
                                    if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                                        newX = window.innerWidth + window.scrollX - popupRect.width;
                                    }

                                    // Alt kenardan taşmayı önle
                                    if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                                        newY = window.innerHeight + window.scrollY - popupRect.height;
                                    }

                                    // Sol kenardan taşmayı önle
                                    if (newX < window.scrollX) {
                                        newX = window.scrollX;
                                    }

                                    // Üst kenardan taşmayı önle
                                    if (newY < window.scrollY) {
                                        newY = window.scrollY;
                                    }

                                    console.log(newX, newY);

                                    // Pop-up'ın pozisyonunu ayarla
                                    popup.style.left = `${newX}px`;
                                    popup.style.top = `${newY}px`;

                                    const parentElement = e.target.closest(".selectbox_widget");
                                    const parentRect = parentElement.getBoundingClientRect();

                                    Set_elem_popup({
                                        width: l.w,
                                        height: l.h,
                                        left: l.x,
                                        top: l.y,
                                        text_list: l.elementDetails.text_list.length === 0 ? l.text_list : l.elementDetails.text_list,
                                        value_list: l.elementDetails.value_list && l.elementDetails.value_list.length === 0 ? l.value_list : l.elementDetails.value_list,
                                        bg_list: l.elementDetails.bg_list && l.elementDetails.bg_list.length === 0 ? l.bg_list : l.elementDetails.bg_list,
                                        border_list: l.elementDetails.border_list && l.elementDetails.border_list.length === 0 ? l.border_list : l.elementDetails.border_list,
                                        font_list: l.elementDetails.font_list && l.elementDetails.font_list.length === 0 ? l.font_list : l.elementDetails.font_list,
                                        type: l.type,
                                        id: l.id,
                                        fontSize: l.fontSize ? l.fontSize : Number(l.w) / 10,
                                        value: l.elementDetails.text
                                    })
                                    setSelectedOptionselectbox(l.elementDetails.text)
                                }

                            }}
                            style={{
                                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px",
                                backgroundColor: "white", border: "2px solid rgb(60,60,60)", borderColor: l.elementDetails.border_list && l.elementDetails.border_list[index_] ? l.elementDetails.border_list[index_] : "black", backgroundColor: l.elementDetails.bg_list && l.elementDetails.bg_list[index_] ? l.elementDetails.bg_list[index_] : "white", color: l.elementDetails.font_list && l.elementDetails.font_list[index_] ? l.elementDetails.font_list[index_] : "black", zIndex: "1",
                            }}

                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            className={`selectbox_widget ${l.elementDetails.text}` + " " + (l.special_type ? ("special_type_ " + alarmClassName) : "")}
                        >
                            <div style={{ backgroundColor: "transparent", color: l.elementDetails.font_list && l.elementDetails.font_list[index_] ? l.elementDetails.font_list[index_] : "black", width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                                {l.elementDetails.text_list[index_]}

                            </div>

                        </div>
                    );
                }
                else if (l.type === "senaryoSelect") {
                    return (
                        <div


                            style={{
                                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px",
                                backgroundColor: "white", border: "2px solid rgb(60,60,60)", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black", borderRadius: "8px", zIndex: "1",
                            }}

                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            className={`senaryo_widget ${l.elementDetails.text}`}
                        >
                            <div style={{ backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black", width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                                {l.elementDetails.text}

                            </div>

                        </div>
                    );
                }
                else if (l.type === "trend") {
                    let data_ = {
                        labels: [],
                        datasets: [{
                            data: [],
                            backgroundColor: "transparent",
                            borderColor: "#f26c6d",
                            pointBorderColor: "#f26c6d",
                            pointBorderWidth: 1
                        }]

                    }
                    if (l.elementDetails.data) {
                        data_ = {
                            labels: (l.elementDetails.data || []).map((item, index) => {
                                return item.date

                            }),
                            datasets: [{
                                data: (l.elementDetails.data || []).map((item, index) => {
                                    return item.value
                                }),
                                backgroundColor: "transparent",
                                borderColor: "#f26c6d",
                                pointBorderColor: "#f26c6d",
                                pointBorderWidth: 1
                            }]

                        }
                    }

                    const datason = data_

                    const optionsSon = {
                        scales: {
                            x: {
                                type: 'time',
                                time: {
                                    unit: 'day',
                                    stepSize: 1,
                                    displayFormats: {
                                        day: 'MMM D'
                                    }
                                },
                                ticks: {
                                    maxTicksLimit: 24
                                }
                            },
                            y: {
                                min: Number(min),
                                max: 0,
                                beginAtZero: true,
                                ticks: {
                                    callback: function (value) {
                                        return Number(value.toFixed(2)); // Etiketlerdeki sıfırları engelle
                                    }
                                }
                            }
                        },
                        plugins: {
                            legend: {
                                display: true,
                                labels: {
                                    filter: function (item, chart) {
                                        return item.text !== undefined;
                                    },
                                    generateLabels: function (chart) {
                                        return [{
                                            text: "",
                                            fillStyle: "crimson",
                                            strokeStyle: chart.ctx.strokeStyle,
                                            lineWidth: chart.ctx.lineWidth,
                                            hidden: false,
                                            index: 0,
                                            datasetIndex: 0
                                        }];
                                    }
                                }
                            },
                            zoom: {
                                pan: {
                                    enabled: true,
                                    mode: 'xy',
                                },
                                zoom: {
                                    wheel: {
                                        enabled: true,
                                    },
                                    pinch: {
                                        enabled: true,
                                    },
                                    mode: 'x',
                                    onZoom: ({ chart }) => {
                                        const xScale = chart.scales.x;
                                        const min = xScale.min;
                                        const max = xScale.max;
                                        const diff = max - min;
                                        let unit = 'second';

                                        // Zoom leveline göre birim seçimi
                                        if (diff > 1000 * 60 * 60 * 24 * 7) {
                                            unit = 'day';
                                        } else if (diff > 1000 * 60 * 60) {
                                            unit = 'hour';
                                        } else if (diff > 1000 * 60) {
                                            unit = 'minute';
                                        }

                                        // Yeniden ayarlama
                                        xScale.options.time.unit = unit;
                                        xScale.options.time.tooltipFormat = unit === 'second' ? 'll HH:mm:ss' : 'll HH:mm';
                                        xScale.options.ticks.callback = (value) => {
                                            return moment(value).format(unit === 'second' ? 'll HH:mm:ss' : 'll HH:mm');
                                        };

                                        chart.update();
                                    },
                                },
                            },
                        },
                    };

                    return (
                        <div


                            style={{ zIndex: "1", marginTop: "-8px" }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            className="trend_widget"
                        >

                            <div style={{ width: "100%", height: "100%" }} className="bottom_sec trend_graph">
                                <Line options={JSON.stringify(real_datas) !== "{}" ? real_datas[String(l.id)] ? createChartOptions(String(l.id)) : optionsSon : optionsSon} data={JSON.stringify(real_datas) !== "{}" ? real_datas[String(l.id)] ? createChartData(String(l.id)) : datason : datason} />
                            </div>
                        </div>
                    )
                }
                else if (l.type === "empty_btn") {
                    return (
                        <div


                            style={{
                                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px",
                                backgroundColor: "white", border: "2px solid rgb(60,60,60)", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black", borderRadius: "8px", zIndex: "1",
                            }}

                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            className={`empty_btn_widget ${l.elementDetails.text}`}
                        >
                            <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                                <input disabled={true} style={{ backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black", backgroundColor: "transparent", width: "100%", outline: "none", appearance: "none", border: "none", textAlign: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w)) / 10}px` }} type="text" value={l.elementDetails.text} />


                            </div>

                        </div>
                    );
                }
                else if (l.type === "t_t") {

                    return (
                        <div

                            onContextMenu={(e) => {
                                if (l.elementDetails.tagId && l.add_trend && l.add_trend === "YES") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_trend")
                                        .classList.toggle(
                                            "show_external_trend_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_trend"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                } else if (l.elementDetails.tagId && l.elementDetails.tagId !== "") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_detail")
                                        .classList.toggle(
                                            "show_external_detail_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId2"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName2"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_detail"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                }
                            }}

                            style={{
                                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px",
                                zIndex: "1", borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", borderColor: l.borderColor ? l.borderColor : "black", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black",
                            }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: l.w,
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            data-id={l.special_type ? "l.special_type" : ""}
                            key={l.i}
                            className="text_tag_widget"
                        >

                            <input
                                type="text"
                                style={{
                                    width: "100%", textAlign: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w)) / 10}px`, position: "relative", backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black"
                                }}
                                disabled={true}

                                value={
                                    (l.elementDetails.text !== "" ? l.elementDetails.text : " ") +
                                    " : " +
                                    (
                                        l.elementDetails.tagId !== ""
                                            ? (() => {
                                                const matchedItem = tag_values_state.find(item =>
                                                    l.elementDetails.tip !== "Var"
                                                        ? item.tagId === l.elementDetails.tagId
                                                        : item.tip === "Var" && item.tagId === l.elementDetails.tagId
                                                );

                                                const tagValue = matchedItem?.tagValue;
                                                const formatted = tagValue != null
                                                    ? Number(tagValue).toLocaleString("tr-TR", {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2,
                                                    })
                                                    : "";

                                                return (
                                                    formatted +
                                                    (l.elementDetails.unit && l.elementDetails.unit !== "None"
                                                        ? " " + l.elementDetails.unit
                                                        : "")
                                                );
                                            })()
                                            : " "
                                    )

                                }


                            />
                            )
                        </div>
                    );
                }

                else if (l.type === "tag") {
                    const matchingTag = tag_values_state.find(item =>
                        l.elementDetails.tip !== "Var"
                            ? item.tagId === l.elementDetails.tagId
                            : item.tip === "Var" && item.tagId === l.elementDetails.tagId
                    );

                    const decimalPlaces = matchingTag && matchingTag.tagDecimal !== null ? Number(matchingTag.tagDecimal) : 2;
                    let formattedValue = "";

                    if (matchingTag) {
                        let value_tag = matchingTag.tagValue;
                        if (value_tag && isNaN(Number(value_tag))) {
                            value_tag = value_tag.split(" ")[0];
                        }

                        console.log(value_tag, 1)

                        if (value_tag && !isNaN(Number(value_tag))) {
                            let numericValue = Number(value_tag);

                            // Eğer birimi kW/h ise 1000'e böl
                            if (l.elementDetails.unit === "kW/h") {
                                numericValue = numericValue / 1000;
                            }

                            console.log(numericValue, 2)

                            formattedValue = numericValue.toLocaleString("tr-TR", {
                                minimumFractionDigits: decimalPlaces,
                                maximumFractionDigits: decimalPlaces,
                            }) + (l.elementDetails.unit && l.elementDetails.unit !== "None" ? " " + l.elementDetails.unit : "");
                        }
                    }




                    return (
                        <div

                            onContextMenu={(e) => {
                                if (l.elementDetails.tagId && l.add_trend && l.add_trend === "YES") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_trend")
                                        .classList.toggle(
                                            "show_external_trend_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_trend"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                } else if (l.elementDetails.tagId && l.elementDetails.tagId !== "") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_detail")
                                        .classList.toggle(
                                            "show_external_detail_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId2"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName2"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_detail"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                }
                            }}

                            style={{ borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", zIndex: "1", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black", }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            className={"tag_widget" + " " + (l.special_type ? "special_type" : "")}
                        >



                            <input
                                id={l.id + "cc"}
                                type="text"
                                disabled={true}
                                style={{
                                    backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black",
                                    fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, textAlign: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center",
                                    width: "100%", backgroundColor: "transparent", outline: "none", border: "none",

                                }}
                                value={
                                    l.elementDetails.tagId !== ""
                                        ? (() => {
                                            const source = tag_values_state.length > 0 ? tag_values_state : tag_values_state;

                                            const matchedItem = source.find(item =>
                                                l.elementDetails.tip !== "Var"
                                                    ? item.tagId === l.elementDetails.tagId
                                                    : item.tip === "Var" && item.tagId === l.elementDetails.tagId
                                            );

                                            let value_tag = matchedItem?.tagValue;

                                            // Sayı değilse boşluktan önceki kısmı al
                                            if (value_tag && isNaN(Number(value_tag))) {
                                                value_tag = value_tag.split(" ")[0];
                                            }

                                            // Formatla
                                            if (value_tag && !isNaN(Number(value_tag))) {
                                                let numericValue = Number(value_tag);

                                                // BURASI EKLENDİ: Eğer birimi kW/h ise 1000'e böl
                                                if (l.elementDetails.unit === "kW/h") {
                                                    numericValue = numericValue / 1000;
                                                }

                                                const decimalPlaces = l.elementDetails.decimal ?? 2;

                                                const formatted = numericValue.toLocaleString("tr-TR", {
                                                    minimumFractionDigits: decimalPlaces,
                                                    maximumFractionDigits: decimalPlaces,
                                                });

                                                const unit = l.elementDetails.unit;
                                                return formatted + (unit && unit !== "None" ? " " + unit : "");
                                            }

                                            return "";
                                        })()
                                        : ""
                                }



                            />

                        </div>
                    );
                }
                else if (l.type === "Popup") {
                    // 1. `value_` Değerini Bul
                    let value_ = tag_values_state.find(i =>
                        l.elementDetails.tip !== "Var"
                            ? String(i.tagId) === String(l.elementDetails.tagId)
                            : i.tip === "Var" && String(i.tagId) === String(l.elementDetails.tagId)
                    )?.tagValue;

                    // Eğer value_ sayısal değilse, boşluktan sonrasını sil
                    if (value_ && isNaN(Number(value_))) {
                        value_ = value_.split(' ')[0]; // ilk boşluktan önceki kısmı al
                    }

                    // 2. `value_list` İçinde `value_` İndeksini Bul
                    let index_ = l.elementDetails.value_list && l.elementDetails.value_list.indexOf(
                        value_ !== undefined && value_.includes(" ") ? value_.trim() : value_
                    );


                    // 3. Varsayılan Atama
                    if (index_ === -1 || index_ === undefined) { // `indexOf` bulunamazsa -1 döner
                        index_ = 0;
                    }

                    // 1. `value_` Değerini Bul
                    let value_2 = tag_values_state.find(i =>
                        l.elementDetails.tip2 !== "Var"
                            ? String(i.tagId) === String(l.elementDetails.tagId2)
                            : i.tip === "Var" && String(i.tagId) === String(l.elementDetails.tagId2)
                    )?.tagValue;

                    // Eğer value_ sayısal değilse, boşluktan sonrasını sil
                    if (value_2 && isNaN(Number(value_2))) {
                        value_2 = value_2.split(' ')[0]; // ilk boşluktan önceki kısmı al
                    }

                    // 2. `value_list` İçinde `value_` İndeksini Bul
                    let index_2 = l.elementDetails.value_list && l.elementDetails.value_list.indexOf(
                        value_2 !== undefined && value_2.includes(" ") ? value_2.trim() : value_2
                    );

                    // 3. Varsayılan Atama
                    if (index_2 === -1 || index_2 === undefined) { // `indexOf` bulunamazsa -1 döner
                        index_2 = 0;
                    }

                    // 1. `value_` Değerini Bul
                    let value_3 = tag_values_state.find(i =>
                        l.elementDetails.tip !== "Var"
                            ? String(i.tagId) === String(l.elementDetails.tagId3)
                            : i.tip === "Var" && String(i.tagId) === String(l.elementDetails.tagId3)
                    )?.tagValue;

                    // Eğer value_ sayısal değilse, boşluktan sonrasını sil
                    if (value_3 && isNaN(Number(value_3))) {
                        value_3 = value_3.split(' ')[0]; // ilk boşluktan önceki kısmı al
                    }

                    // 2. `value_list` İçinde `value_` İndeksini Bul
                    let index_3 = l.elementDetails.value_list && l.elementDetails.value_list.indexOf(
                        value_3 !== undefined && value_3.includes(" ") ? value_3.trim() : value_3
                    );

                    // 3. Varsayılan Atama
                    if (index_3 === -1 || index_3 === undefined) { // `indexOf` bulunamazsa -1 döner
                        index_3 = 0;
                    }

                    return (
                        <div

                            onClick={(e) => {
                                if (yazma_control) {
                                    let active_id = l.id;
                                    let active_items = l.elementDetails.items;
                                    Set_active_popup_id(active_id);
                                    Set_active_popup_items(active_items)
                                    // Hide other elements
                                    document.querySelector(".react-grid-layout").childNodes.forEach((x) => {
                                        x.style.opacity = "0";
                                        x.style.zIndex = "-1";
                                    });

                                    let w__, h__, x__, y__;

                                    setLayouts((prevLayouts) => {
                                        const updatedLayouts = { ...prevLayouts };

                                        if (Array.isArray(updatedLayouts[currentBreakpoint])) {
                                            (updatedLayouts[currentBreakpoint] || []).forEach((item) => {
                                                if (String(item.id) === String(active_id)) {
                                                    if (!item.elementDetails.items) {
                                                        item.elementDetails.items = [];
                                                    }

                                                    item.elementDetails.items.forEach((newItem) => {
                                                        if (newItem.type === "frame") {
                                                            w__ = newItem.w;
                                                            h__ = newItem.h;
                                                            x__ = newItem.x;
                                                            y__ = newItem.y;
                                                        }
                                                        newItem.isDraggable = false;
                                                        newItem.isResizable = false;
                                                        updatedLayouts[currentBreakpoint].push(newItem);
                                                    });
                                                }
                                            });
                                        }

                                        return updatedLayouts;
                                    });

                                    document.querySelector(".main_sec").classList.toggle("main_sec_bg_blur");

                                    setTimeout(() => {
                                        document.querySelector(".react-grid-layout").childNodes.forEach((x) => {
                                            if (window.getComputedStyle(x).zIndex !== "-1") {
                                                x.style.zIndex = "2";
                                            }
                                        });
                                    }, 50);

                                    setTimeout(() => {
                                        let diffX, diffY;
                                        const layoutItems = document.querySelector(".react-grid-layout")
                                            .childNodes;

                                        layoutItems.forEach((x) => {
                                            const id = x.getAttribute("data-id");

                                            if (x.classList.contains("frame_widget")) {

                                                x.style.width = `${w__}px`; // Grid birimlerini px'e çevir
                                                x.style.height = `${h__}px`;

                                                const initialRect = x.getBoundingClientRect();
                                                const mainSec = document.querySelector(".main_sec");
                                                const mainSecRect = mainSec.getBoundingClientRect();

                                                const centerX = (mainSecRect.width) / 2;
                                                const centerY = (mainSecRect.height) / 2 - mainSecRect.top / 10;

                                                console.warn(mainSecRect, "kdoejdıoejoejoe")

                                                const targetX = (centerX - w__ / 2) - mainSecRect.left / 5;
                                                const targetY = (centerY - h__ / 2);

                                                console.log("targetX", targetX)

                                                diffX = targetX;
                                                diffY = targetY;

                                                x.style.transform = `translate(${targetX}px, ${targetY}px)`;
                                            }
                                        });

                                        // Diğer öğeleri frame'e göre taşı
                                        layoutItems.forEach((x) => {
                                            const id = x.getAttribute("data-id");
                                            if (x.classList.contains("frame_widget")) return;


                                            if (!id?.includes("l.special_type")) return;



                                            if (typeof diffX !== "undefined" && typeof diffY !== "undefined") {
                                                const frameWidgetRect = document
                                                    .querySelector(".frame_widget")
                                                    .getBoundingClientRect();
                                                const elementRect = x.getBoundingClientRect();

                                                const relativeX = elementRect.left - frameWidgetRect.left;
                                                const relativeY = elementRect.top - frameWidgetRect.top;

                                                x.style.transform = `translate(${diffX + relativeX}px, ${diffY + relativeY
                                                    }px)`;
                                            }
                                        });
                                    }, 50);
                                }
                            }
                            }


                            style={{ borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", zIndex: "1", border: "2px solid rgb(70,70,70)", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black", borderRadius: "8px", display: "flex", alignItems: "center", borderColor: l.elementDetails.border_list && l.elementDetails.border_list[index_] ? l.elementDetails.border_list[index_] : "black", backgroundColor: l.elementDetails.bg_list && l.elementDetails.bg_list[index_] ? l.elementDetails.bg_list[index_] : "white", color: l.elementDetails.font_list && l.elementDetails.font_list[index_] ? l.elementDetails.font_list[index_] : "black" }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={"Popup" + l.id}
                            data-id={l.special_type ? "l.special_type" : ""}
                            key={l.i}
                            className="popupduz_widget"
                        >



                            <input
                                className="showRoomNumber_popupDYN"
                                placeholder="room number"

                                id={l.id + "cc"}
                                type="text"

                                value={l.elementDetails.text ? l.elementDetails.text : ""}
                                style={{
                                    fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, textAlign: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center",
                                    backgroundColor: "transparent",
                                    color: l.fontColor ? l.fontColor : "black",
                                    width: "100%", outline: "none", backgroundColor: "transparent", border: "none"

                                }}




                            />

                            <div className="dyn_popup_bottom_part">
                                <div><p style={{ fontSize: `${l.w / 17}px` }}>Oda:</p> <input style={{ color: l.elementDetails.font_list && l.elementDetails.font_list[index_] ? l.elementDetails.font_list[index_] : "black", fontSize: `${l.w / 20}px`, backgroundColor: "transparent" }} type="text" value={
                                    l.elementDetails.tagId3 !== ""
                                        ? (() => {
                                            let selectedTag;
                                            if (l.elementDetails.tip3 === "Var") {
                                                selectedTag = tag_values_state.find(
                                                    (item) => item.tip === "Var" && item.tagId === l.elementDetails.tagId3
                                                );
                                            } else {
                                                selectedTag = tag_values_state.find(
                                                    (item) => item.tagId === l.elementDetails.tagId3
                                                );
                                            }

                                            if (!selectedTag) return "";

                                            const numericValue = parseFloat(selectedTag.tagValue);
                                            const isNumeric = !isNaN(numericValue);

                                            return isNumeric
                                                ? numericValue.toFixed(l.elementDetails.decimal ? l.elementDetails.decimal : 2) +
                                                (l.elementDetails.unit && l.elementDetails.unit !== "None" ? " " + l.elementDetails.unit : "")
                                                : selectedTag.tagValue; // Sayıya çevrilemezse olduğu gibi bırak
                                        })()
                                        : ""
                                } className="dyn_popup_show_room_temp" /></div>
                                <div className="span_divPopupW"><span style={{ borderColor: l.elementDetails.border_list2 && l.elementDetails.border_list2[index_] ? l.elementDetails.border_list2[index_] : "black", backgroundColor: l.elementDetails.bg_list2 && l.elementDetails.bg_list2[index_] ? l.elementDetails.bg_list2[index_] : "white", }}></span></div>
                                <div><p style={{ fontSize: `${l.w / 17}px` }}>Set:</p> <input
                                    onClick={(e) => {
                                        if (l.elementDetails.tagId4 && l.elementDetails.tagId4 !== "" && l.elementDetails.tagId4 !== "None" && yazma_control) {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            const { clientX, clientY } = e;

                                            // Set elem_popup with tagId2 as tagId4 for modal to work
                                            Set_elem_popup({ ...l, elementDetails: { ...l.elementDetails, tagId2: l.elementDetails.tagId4 } });

                                            document.querySelector(".Popup-selectbox2").classList.toggle("changeProperties_active");
                                            document.querySelector(".Popup-selectbox2").id = l.id;

                                            var popup = document.querySelector(".Popup-selectbox2");
                                            const popupRect = popup.getBoundingClientRect();

                                            let newX = clientX + window.scrollX;
                                            let newY = clientY + window.scrollY;

                                            if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                                                newX = window.innerWidth + window.scrollX - popupRect.width;
                                            }
                                            if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                                                newY = window.innerHeight + window.scrollY - popupRect.height;
                                            }

                                            popup.style.left = `${newX}px`;
                                            popup.style.top = `${newY}px`;
                                        }
                                    }}
                                    style={{ color: l.elementDetails.font_list && l.elementDetails.font_list[index_] ? l.elementDetails.font_list[index_] : "black", fontSize: `${l.w / 20}px`, backgroundColor: "transparent", cursor: l.elementDetails.tagId4 && l.elementDetails.tagId4 !== "" && l.elementDetails.tagId4 !== "None" && yazma_control ? "pointer" : "default" }}
                                    type="text"
                                    value={
                                    l.elementDetails.tagId4 !== ""
                                        ? (() => {
                                            let selectedTag;
                                            if (l.elementDetails.tip4 === "Var") {
                                                selectedTag = tag_values_state.find(
                                                    (item) => item.tip === "Var" && item.tagId === l.elementDetails.tagId4
                                                );
                                            } else {
                                                selectedTag = tag_values_state.find(
                                                    (item) => item.tagId === l.elementDetails.tagId4
                                                );
                                            }

                                            if (!selectedTag) return "";

                                            const numericValue = parseFloat(selectedTag.tagValue);
                                            const isNumeric = !isNaN(numericValue);

                                            return isNumeric
                                                ? numericValue.toFixed(l.elementDetails.decimal ? l.elementDetails.decimal : 2) +
                                                (l.elementDetails.unit && l.elementDetails.unit !== "None" ? " " + l.elementDetails.unit : "")
                                                : selectedTag.tagValue; // Sayıya çevrilemezse olduğu gibi bırak
                                        })()
                                        : ""
                                } className="dyn_popup_show_room_set_temp" /></div>
                            </div>

                        </div>
                    );
                }
                else if (l.type === "frame") {
                    if (!l.special_type) {
                        return (
                            <div

                                onContextMenu={(e) => {
                                    console.log(l);
                                    if (l.combine_trend && l.combine_trend === true) {
                                        let group_id = l.group_t_id ? l.group_t_id : undefined

                                        let newData = combine_trend_tags;

                                        (layouts[currentBreakpoint] || []).forEach(x => {
                                            if (group_id !== undefined && x.group_t_id && Number(x.group_t_id) === Number(group_id) && l.elementDetails.tagId) {
                                                var tagName = tags
                                                    .filter((b) => b.tagId === l.elementDetails.tagId)
                                                    .map((c) => c.tagName)[0];
                                                newData.push({ tagId: l.elementDetails.tagId, tagName: tagName })
                                            }
                                        })

                                        Set_combine_trend_tags(newData)

                                        e.preventDefault();
                                        const { clientX, clientY } = e;
                                        let screen_width = window.innerWidth;
                                        console.log(clientX, clientY);
                                        document
                                            .querySelector(".show_external_combine_trend")
                                            .classList.toggle(
                                                "show_external_combine_trend_active"
                                            );

                                        var popup = document.querySelector(
                                            ".show_external_combine_trend"
                                        );
                                        const popupRect =
                                            popup.getBoundingClientRect();
                                        const viewportWidth = window.innerWidth;
                                        const viewportHeight = window.innerHeight;

                                        // Calculate the new positions
                                        let newX = clientX;
                                        let newY = clientY;

                                        // Adjust if the popup would overflow the right edge of the viewport
                                        if (
                                            newX + popupRect.width >
                                            viewportWidth
                                        ) {
                                            newX = viewportWidth - popupRect.width;
                                        }

                                        // Adjust if the popup would overflow the bottom edge of the viewport
                                        if (
                                            newY + popupRect.height >
                                            viewportHeight
                                        ) {
                                            newY =
                                                viewportHeight - popupRect.height;
                                        }

                                        // Adjust if the popup would overflow the left edge of the viewport
                                        if (newX < 0) {
                                            newX = 0;
                                        }

                                        // Adjust if the popup would overflow the top edge of the viewport
                                        if (newY < 0) {
                                            newY = 0;
                                        }

                                        if (
                                            screen_width < 2301 &&
                                            screen_width > 1800
                                        ) {
                                            document.querySelector(
                                                ".show_external_combine_trend"
                                            ).style.left = `${String(
                                                newX / 1.2
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_combine_trend"
                                            ).style.top = `${String(newY / 1.2)}px`;
                                        } else if (
                                            screen_width < 2801 &&
                                            screen_width > 2300
                                        ) {
                                            document.querySelector(
                                                ".show_external_combine_trend"
                                            ).style.left = `${String(
                                                newX / 1.5
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_combine_trend"
                                            ).style.top = `${String(newY / 1.5)}px`;
                                        } else if (
                                            screen_width < 3501 &&
                                            screen_width > 2800
                                        ) {
                                            document.querySelector(
                                                ".show_external_combine_trend"
                                            ).style.left = `${String(
                                                newX / 1.8
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_combine_trend"
                                            ).style.top = `${String(newY / 1.8)}px`;
                                        } else if (
                                            screen_width < 5001 &&
                                            screen_width > 3500
                                        ) {
                                            document.querySelector(
                                                ".show_external_combine_trend"
                                            ).style.left = `${String(
                                                newX / 2.5
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_combine_trend"
                                            ).style.top = `${String(newY / 2.5)}px`;
                                        } else if (screen_width <= 1800) {
                                            document.querySelector(
                                                ".show_external_combine_trend"
                                            ).style.left = `${String(newX)}px`;
                                            document.querySelector(
                                                ".show_external_combine_trend"
                                            ).style.top = `${String(newY)}px`;
                                        }
                                    }
                                }}

                                style={{ borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", backgroundColor: "white", borderRadius: l.elementDetails.borderRadius + "px", border: "3px solid rgb(65,65,65)", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black", zIndex: "0" }}
                                data-grid={{
                                    x: l.x,
                                    y: l.y,
                                    w: (l.w),
                                    h: l.h,
                                    resizeHandles: l.resizeHandles,
                                }}
                                id={l.id}
                                data-id={l.special_type ? "l.special_type" : ""}
                                key={l.i}
                                className="frame_widget"
                            >




                            </div>
                        );
                    } else {
                        return (
                            <div


                                style={{ borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", backgroundColor: "white", borderRadius: l.elementDetails.borderRadius + "px", border: "3px solid rgb(65,65,65)", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black", zIndex: "0" }}
                                data-grid={{
                                    x: l.x,
                                    y: l.y,
                                    w: (l.w),
                                    h: l.h,
                                    resizeHandles: l.resizeHandles,
                                }}
                                id={l.id}
                                data-id={l.special_type ? "l.special_type" : ""}
                                key={l.i}
                                className="frame_widget"
                            >
                                <i onClick={(e) => {
                                    if (document.querySelector(".main_sec").classList.contains("main_sec_bg_blur")) {


                                        setLayouts((prevLayouts) => {
                                            const updatedLayouts = { ...prevLayouts };


                                            if (Array.isArray(updatedLayouts[currentBreakpoint])) {
                                                // Filter out items with matching special_type and id2
                                                updatedLayouts[currentBreakpoint] = (updatedLayouts[currentBreakpoint] || []).filter(
                                                    (item) => !(item.special_type && String(item.id2) === String(active_popup_id))
                                                );
                                            }

                                            return updatedLayouts;
                                        });
                                        Set_active_popup_id(null)
                                        Set_active_popup_items([])
                                        document.querySelector(".main_sec").classList.toggle("main_sec_bg_blur");
                                        setTimeout(() => {
                                            document.querySelector(".react-grid-layout").childNodes.forEach(x => {
                                                x.style.opacity = "1"
                                                x.style.zIndex = "1"
                                            })
                                        }, 50)
                                    }

                                }} style={{ position: "relative", left: "95%", top: "-30px", cursor: "pointer", backgroundColor: "red", width: "40px", height: "40px", display: "flex", alignItems: "center", justifyContent: "center", color: "white", borderRadius: "40px", border: "none" }} className="fa fa-times"></i>




                            </div>
                        );
                    }

                }
                else if (l.type === "fan_modu") {
                    return (
                        <div

                            onContextMenu={(e) => {
                                if (l.elementDetails.tagId && l.add_trend && l.add_trend === "YES") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_trend")
                                        .classList.toggle(
                                            "show_external_trend_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_trend"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                } else if (l.elementDetails.tagId && l.elementDetails.tagId !== "") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_detail")
                                        .classList.toggle(
                                            "show_external_detail_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId2"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName2"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_detail"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                }
                            }}

                            onClick={(e) => {
                                if (yazma_control) {
                                    console.log(e.target);
                                    e.preventDefault();
                                    e.stopPropagation();
                                    const { clientX, clientY } = e;
                                    document.querySelector(".Popup-fan").classList.toggle("changeProperties_active")
                                    document.querySelector(".Popup-fan").id = l.id

                                    var popup = document.querySelector(".Popup-fan")
                                    const popupRect = popup.getBoundingClientRect();

                                    // Yeni pozisyonları hesapla
                                    let newX = clientX + window.scrollX;
                                    let newY = clientY + window.scrollY;

                                    console.log(newX, newY);

                                    // Sağ kenardan taşmayı önle
                                    if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                                        newX = window.innerWidth + window.scrollX - popupRect.width;
                                    }

                                    // Alt kenardan taşmayı önle
                                    if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                                        newY = window.innerHeight + window.scrollY - popupRect.height;
                                    }

                                    // Sol kenardan taşmayı önle
                                    if (newX < window.scrollX) {
                                        newX = window.scrollX;
                                    }

                                    // Üst kenardan taşmayı önle
                                    if (newY < window.scrollY) {
                                        newY = window.scrollY;
                                    }

                                    console.log(newX, newY);

                                    // Pop-up'ın pozisyonunu ayarla
                                    popup.style.left = `${newX}px`;
                                    popup.style.top = `${newY}px`;

                                    const parentElement = e.target.closest(".fan_modu_widget");
                                    const parentRect = parentElement.getBoundingClientRect();

                                    Set_elem_popup({
                                        width: l.w,
                                        height: l.h * 10,
                                        left: l.x,
                                        top: l.y,

                                        type: l.type,
                                        id: l.id,
                                        fontSize: l.fontSize ? l.fontSize : Number(l.w) / 10
                                    })

                                    setSelectedOptionfan(l.elementDetails.text)
                                }
                            }
                            }
                            style={{ borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", border: "2px solid rgb(60,60,60)", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black", borderRadius: "4px", zIndex: "1" }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            className={"fan_modu_widget" + " " + (l.special_type ? "special_type" : "")}
                        >

                            <div style={{ backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black", width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                                {l.elementDetails.text}

                            </div>

                        </div>
                    );
                }
                else if (l.type === "calisma_modu") {
                    return (
                        <div
                            onContextMenu={(e) => {
                                if (l.elementDetails.tagId && l.add_trend && l.add_trend === "YES") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_trend")
                                        .classList.toggle(
                                            "show_external_trend_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_trend"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                } else if (l.elementDetails.tagId && l.elementDetails.tagId !== "") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_detail")
                                        .classList.toggle(
                                            "show_external_detail_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId2"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName2"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_detail"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                }
                            }}
                            onClick={(e) => {
                                if (yazma_control) {
                                    console.log(e.target);
                                    e.preventDefault();
                                    e.stopPropagation();
                                    const { clientX, clientY } = e;
                                    document.querySelector(".Popup-calisma").classList.toggle("changeProperties_active")
                                    document.querySelector(".Popup-calisma").id = l.id

                                    var popup = document.querySelector(".Popup-calisma")
                                    const popupRect = popup.getBoundingClientRect();

                                    // Yeni pozisyonları hesapla
                                    let newX = clientX + window.scrollX;
                                    let newY = clientY + window.scrollY;

                                    console.log(newX, newY);

                                    // Sağ kenardan taşmayı önle
                                    if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                                        newX = window.innerWidth + window.scrollX - popupRect.width;
                                    }

                                    // Alt kenardan taşmayı önle
                                    if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                                        newY = window.innerHeight + window.scrollY - popupRect.height;
                                    }

                                    // Sol kenardan taşmayı önle
                                    if (newX < window.scrollX) {
                                        newX = window.scrollX;
                                    }

                                    // Üst kenardan taşmayı önle
                                    if (newY < window.scrollY) {
                                        newY = window.scrollY;
                                    }

                                    console.log(newX, newY);

                                    // Pop-up'ın pozisyonunu ayarla
                                    popup.style.left = `${newX}px`;
                                    popup.style.top = `${newY}px`;

                                    const parentElement = e.target.closest(".calisma_modu_widget");
                                    const parentRect = parentElement.getBoundingClientRect();

                                    Set_elem_popup({
                                        width: l.w,
                                        height: l.h * 10,
                                        left: l.x,
                                        top: l.y,

                                        type: l.type,
                                        id: l.id,
                                        fontSize: l.fontSize ? l.fontSize : Number(l.w) / 10
                                    })

                                    setSelectedOptioncalisma(l.elementDetails.text)
                                }
                            }
                            }
                            style={{ borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", border: "2px solid rgb(60,60,60)", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black", borderRadius: "4px", zIndex: "1" }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}

                            id={l.id}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            className={"calisma_modu_widget" + ` ${l.elementDetails.tagId}` + " " + (l.special_type ? "special_type" : "")}
                        >


                            <div style={{ backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black", width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                                {l.elementDetails.text}

                            </div>



                        </div>
                    );
                }
                else if (l.type === "on/off") {
                    let value_ = tag_values_state.find(i =>
                        l.elementDetails.tip !== "Var"
                            ? String(i.tagId) === String(l.elementDetails.tagId)
                            : i.tip === "Var" && String(i.tagId) === String(l.elementDetails.tagId)
                    )?.tagValue;

                    // Eğer value_ sayısal değilse, boşluktan sonrasını sil
                    if (value_ && isNaN(Number(value_))) {
                        value_ = value_.split(' ')[0];

                    }
                    console.warn("value_", value_, typeof (value_));

                    value_ = value_ && value_.split('.')[0]; // Noktadan sonrasını almaz

                    console.warn("value_", value_, typeof (value_));

                    // 2. value_list oluştur (value1, value2, value3... varsa onları al)
                    let valueList = [];
                    let i = 1;
                    while (l.elementDetails[`value${i}`] !== undefined) {
                        valueList.push(l.elementDetails[`value${i}`]);
                        i++;
                    }

                    // 3. value_ değeri valueList içinde kaçıncı sıradaysa onu al
                    let index_ = valueList.indexOf(
                        value_ !== undefined && value_.includes(" ") ? value_.trim() : value_
                    );

                    // 4. Varsayılan atama
                    if (index_ === -1 || index_ === undefined) {
                        index_ = 0;
                    }

                    return (
                        <div

                            onContextMenu={(e) => {
                                const { clientX, clientY } = e;
                                let screen_width = window.innerWidth;
                                console.log(l);

                                if (l.elementDetails.tagId && l.add_trend && l.add_trend === "YES") {
                                    if (l.elementDetails.text === "ON") {
                                        var tagName = tags
                                            .filter((b) => b.tagId === l.elementDetails.tagId)
                                            .map((c) => c.tagName)[0];

                                        e.preventDefault();

                                        let screen_width = window.innerWidth;
                                        console.log(clientX, clientY);
                                        document
                                            .querySelector(".show_external_trend")
                                            .classList.toggle(
                                                "show_external_trend_active"
                                            );
                                        document.querySelector(
                                            ".show_tagId"
                                        ).innerHTML = l.elementDetails.tagId;
                                        document.querySelector(
                                            ".show_tagName"
                                        ).innerHTML = tagName;
                                        var popup = document.querySelector(
                                            ".show_external_trend"
                                        );
                                    } else {
                                        var tagName = tags
                                            .filter((b) => b.tagId === l.elementDetails.tagId)
                                            .map((c) => c.tagName)[0];

                                        e.preventDefault();

                                        let screen_width = window.innerWidth;
                                        console.log(clientX, clientY);
                                        document
                                            .querySelector(".show_external_trend")
                                            .classList.toggle(
                                                "show_external_trend_active"
                                            );
                                        document.querySelector(
                                            ".show_tagId"
                                        ).innerHTML = l.elementDetails.tagId;
                                        document.querySelector(
                                            ".show_tagName"
                                        ).innerHTML = tagName;
                                        var popup = document.querySelector(
                                            ".show_external_trend"
                                        );
                                    }

                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                } else if (l.elementDetails.tagId && l.elementDetails.tagId !== "") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_detail")
                                        .classList.toggle(
                                            "show_external_detail_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId2"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName2"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_detail"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                }
                            }}

                            onClick={(e) => {
                                if (yazma_control) {


                                    console.log(e.target);
                                    e.preventDefault();
                                    e.stopPropagation();
                                    const { clientX, clientY } = e;
                                    document.querySelector(".Popup-onOff").classList.toggle("changeProperties_active")
                                    document.querySelector(".Popup-onOff").id = l.id

                                    var popup = document.querySelector(".Popup-onOff")
                                    const popupRect = popup.getBoundingClientRect();

                                    // Yeni pozisyonları hesapla
                                    let newX = clientX + window.scrollX;
                                    let newY = clientY + window.scrollY;

                                    console.log(newX, newY);

                                    // Sağ kenardan taşmayı önle
                                    if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                                        newX = window.innerWidth + window.scrollX - popupRect.width;
                                    }

                                    // Alt kenardan taşmayı önle
                                    if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                                        newY = window.innerHeight + window.scrollY - popupRect.height;
                                    }

                                    // Sol kenardan taşmayı önle
                                    if (newX < window.scrollX) {
                                        newX = window.scrollX;
                                    }

                                    // Üst kenardan taşmayı önle
                                    if (newY < window.scrollY) {
                                        newY = window.scrollY;
                                    }

                                    console.log(newX, newY);

                                    // Pop-up'ın pozisyonunu ayarla
                                    popup.style.left = `${newX}px`;
                                    popup.style.top = `${newY}px`;

                                    const parentElement = e.target.closest(".on-off_widget");
                                    const parentRect = parentElement.getBoundingClientRect();

                                    Set_elem_popup({
                                        width: l.w,
                                        height: l.h * 10,
                                        left: l.x,
                                        top: l.y,

                                        type: l.type,
                                        id: l.id,
                                        fontSize: l.fontSize ? l.fontSize : Number(l.w) / 10,
                                        value: value_ !== undefined && value_ === "1" ? "ON" : "OFF"
                                    })
                                }
                            }
                            }
                            style={{
                                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", backgroundColor: "white", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "white", borderRadius: "8px", zIndex: "1",
                            }}

                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            className={`on-off_widget ${value_ !== undefined && value_ === "1" ? "ON" : "OFF"} ${l.elementDetails.tagId}` + " " + (l.special_type ? "special_type" : "")}
                        >
                            <div style={{ backgroundColor: "transparent", color: "white", width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                                {value_ !== undefined && value_ === "1" ? "ON" : "OFF"}

                            </div>

                        </div>
                    );
                }
                else if (l.type === "image") {
                    return (
                        <div


                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: l.w,
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            className="image_widgetParentDiv"
                            style={{ borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", borderColor: "rgb(100,100,100)", zIndex: "1" }}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            id={l.id}
                        >

                            <img
                                style={{ width: "100%", height: "100%" }}
                                className="image_widget"
                                src={l.elementDetails.src !== "" ? l.elementDetails.src : ""}
                                alt=""
                            />
                        </div>
                    );
                } else if (l.type === "bg") {

                    let diffWidth = document.querySelector(".link-group-data-links").getBoundingClientRect().width * 1.05
                    let diffHeigth = document.querySelector("nav").getBoundingClientRect().height * 1.25
                    console.log(diffHeigth)


                    setTimeout(() => {
                        if (document.querySelector(".main_sec")) {
                            document.querySelector(
                                ".main_sec"
                            ).style.backgroundImage = `url("${l.elementDetails.src}")`;
                            document.querySelector(".main_sec").style.backgroundPosition =
                                `${l.elementDetails.left}px ${l.elementDetails.top}px`;
                            document.querySelector(".main_sec").style.backgroundSize = `${l.elementDetails.width}px ${l.elementDetails.height}px`;
                            document.querySelector(".main_sec").style.backgroundRepeat = "no-repeat"
                        }

                    }, 1000)



                } else if (l.type === "gauge") {
                    let value_max = Number(l.elementDetails.maxValue);

                    // tip kontrolü ile uygun tag değerini bul
                    let selectedTag;
                    if (l.elementDetails.tip === "Var") {
                        selectedTag = tag_values_state.find(
                            (item) => item.tip === "Var" && item.tagId === l.elementDetails.tagId
                        );
                    } else {
                        selectedTag = tag_values_state.find((item) => item.tagId === l.elementDetails.tagId);
                    }

                    // Sayısal değeri güvenli şekilde al
                    let value_tag = selectedTag ? selectedTag.tagValue : "";
                    const numericValue = parseFloat(value_tag);
                    const isNumeric = !isNaN(numericValue);

                    // Eğer isNumeric false ise boşluktan sonrasını kes
                    value_tag = isNumeric ? value_tag : value_tag.split(' ')[0];



                    // last_deger hesaplamasını güvenli hale getir
                    let last_deger = isNumeric
                        ? (numericValue / (l.elementDetails.endValue ? l.elementDetails.endValue : value_max).toFixed(2)) * 100
                        : 0;

                    // startValue ve endValue güvenli şekilde belirle
                    const startValue =
                        l.elementDetails.startValue && isNumeric && l.elementDetails.startValue <= numericValue
                            ? l.elementDetails.startValue
                            : 0;

                    const endValue = l.elementDetails.endValue && isNumeric
                        ? l.elementDetails.limitValues && l.elementDetails.limitValues.length > 0 && Number([...l.elementDetails.limitValues]
                            .sort((a, b) => a.value - b.value)
                            .at(-1).value) >= l.elementDetails.endValue
                            ? Math.max(l.elementDetails.endValue, numericValue) +
                            Number([...l.elementDetails.limitValues]
                                .sort((a, b) => a.value - b.value)
                                .at(-1).value)
                            : Math.max(l.elementDetails.endValue, numericValue)
                        : isNumeric
                            ? numericValue.toFixed(2)
                            : 100;
                    // normalizedValue hesapla
                    const normalizedValue = isNumeric
                        ? ((value_tag - startValue) / (endValue - startValue)) * 100
                        : 0;

                    // Arc limitlerini tanımla
                    const arcLimits = l.elementDetails.pU && l.elementDetails.limitValues
                        ? (() => {
                            if (l.elementDetails.pU === "Unit") {
                                // Unit modu için özel mantık
                                const sortedLimits = [...l.elementDetails.limitValues].sort((a, b) => a.value - b.value);
                                const colorLimits = sortedLimits.filter(i => i.color);

                                let lastLimit = startValue;
                                let result = [];

                                colorLimits.forEach(({ value, color }) => {
                                    let newColor = color;
                                    if (l.elementDetails.scaleX === "-1" && color === "#008000") {
                                        newColor = "#ff0000";
                                    } else if (l.elementDetails.scaleX === "-1" && color === "#ff0000") {
                                        newColor = "#008000";
                                    }
                                    result.push({
                                        limit: value,
                                        color: newColor,
                                    });
                                    lastLimit = value;
                                });

                                // Son rengi endValue'ya kadar devam ettir
                                if (colorLimits.length > 2) {
                                    result.push({
                                        limit: endValue,
                                        color: l.elementDetails.scaleX === "-1" ? colorLimits[0].color : colorLimits[colorLimits.length - 1].color,
                                    });
                                } else {
                                    result = [
                                        {
                                            limit: ((20 / 100) * (endValue - startValue)) + startValue,
                                            color: l.elementDetails.scaleX === "-1" ? "#5BE12C" : "#EA4228",
                                        },
                                        {
                                            limit: ((40 / 100) * (endValue - startValue)) + startValue,
                                            color: l.elementDetails.scaleX === "-1" ? "#F5CD19" : "#F58B19",
                                        },
                                        {
                                            limit: ((60 / 100) * (endValue - startValue)) + startValue,
                                            color: l.elementDetails.scaleX === "-1" ? "#F58B19" : "#F5CD19",
                                        },
                                        {
                                            limit: ((80 / 100) * (endValue - startValue)) + startValue,
                                            color: l.elementDetails.scaleX === "-1" ? "#FF5733" : "#33FFCE",
                                        },
                                        {
                                            limit: ((100 / 100) * (endValue - startValue)) + startValue,
                                            color: l.elementDetails.scaleX === "-1" ? "#EA4228" : "#5BE12C",
                                        },
                                    ];
                                }

                                return result;
                            } else if (l.elementDetails.pU === "Percent") {
                                // Percent modu için 5 renkli dizi
                                return [
                                    {
                                        limit: ((20 / 100) * (endValue - startValue)) + startValue,
                                        color: l.elementDetails.scaleX === "-1" ? "#5BE12C" : "#EA4228",
                                    },
                                    {
                                        limit: ((40 / 100) * (endValue - startValue)) + startValue,
                                        color: l.elementDetails.scaleX === "-1" ? "#F5CD19" : "#F58B19",
                                    },
                                    {
                                        limit: ((60 / 100) * (endValue - startValue)) + startValue,
                                        color: l.elementDetails.scaleX === "-1" ? "#F58B19" : "#F5CD19",
                                    },
                                    {
                                        limit: ((80 / 100) * (endValue - startValue)) + startValue,
                                        color: l.elementDetails.scaleX === "-1" ? "#FF5733" : "#33FFCE",
                                    },
                                    {
                                        limit: ((100 / 100) * (endValue - startValue)) + startValue,
                                        color: l.elementDetails.scaleX === "-1" ? "#EA4228" : "#5BE12C",
                                    },
                                ];
                            } else {
                                // Diğer durumlar için varsayılan dizi
                                return [
                                    {
                                        limit: ((20 / 100) * (endValue - startValue)) + startValue,
                                        color: l.elementDetails.scaleX === "-1" ? "#5BE12C" : "#EA4228",
                                    },
                                    {
                                        limit: ((40 / 100) * (endValue - startValue)) + startValue,
                                        color: l.elementDetails.scaleX === "-1" ? "#F5CD19" : "#F58B19",
                                    },
                                    {
                                        limit: ((60 / 100) * (endValue - startValue)) + startValue,
                                        color: l.elementDetails.scaleX === "-1" ? "#F58B19" : "#F5CD19",
                                    },
                                    {
                                        limit: ((80 / 100) * (endValue - startValue)) + startValue,
                                        color: l.elementDetails.scaleX === "-1" ? "#FF5733" : "#33FFCE",
                                    },
                                    {
                                        limit: ((100 / 100) * (endValue - startValue)) + startValue,
                                        color: l.elementDetails.scaleX === "-1" ? "#EA4228" : "#5BE12C",
                                    },
                                ];
                            }
                        })()
                        : [
                            {
                                limit: ((20 / 100) * (endValue - startValue)) + startValue,
                                color: l.elementDetails.scaleX === "-1" ? "#5BE12C" : "#EA4228",
                            },
                            {
                                limit: ((40 / 100) * (endValue - startValue)) + startValue,
                                color: l.elementDetails.scaleX === "-1" ? "#F5CD19" : "#F58B19",
                            },
                            {
                                limit: ((60 / 100) * (endValue - startValue)) + startValue,
                                color: l.elementDetails.scaleX === "-1" ? "#F58B19" : "#F5CD19",
                            },
                            {
                                limit: ((80 / 100) * (endValue - startValue)) + startValue,
                                color: l.elementDetails.scaleX === "-1" ? "#FF5733" : "#33FFCE",
                            },
                            {
                                limit: ((100 / 100) * (endValue - startValue)) + startValue,
                                color: l.elementDetails.scaleX === "-1" ? "#EA4228" : "#5BE12C",
                            },
                        ];
                    ;

                    const textElement = document.querySelector(`.gauge_widgetParentDiv${l.id} .value-text text`);

                    if (textElement && l.fontColor) textElement.style.fill = l.fontColor

                    document.querySelectorAll(`.gauge_widgetParentDiv${l.id} .tick-value text`).forEach(x => {
                        if (l.fontColor) x.style.fill = l.fontColor
                    })

                    // pU kontrolü ile text içeriğini güncelle
                    if (l.elementDetails.pU) {
                        const textElement = document.querySelector(`.gauge_widgetParentDiv${l.id} .value-text text`);
                        if (textElement) {
                            if (l.elementDetails.pU === "Unit") {
                                if (textElement.textContent.includes("%")) {
                                    textElement.textContent = textElement.textContent.slice(0, -1); // "%" karakterini kaldır
                                }
                                textElement.textContent = value_tag;
                            } else {
                                if (!textElement.textContent.includes("%")) {
                                    textElement.textContent = normalizedValue.toFixed(2) + "%";
                                }
                            }
                        }
                    }

                    // Min ve Max değerlerini ayarla
                    const min = l.elementDetails.pU === "Unit" && l.elementDetails.startValue ? startValue : 0;
                    const max = l.elementDetails.pU === "Unit" && l.elementDetails.endValue ? endValue : 100;





                    return (
                        <div
                            className={"gauge_widgetParentDiv" + " gauge_widgetParentDiv" + l.id}

                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: l.w,
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            onContextMenu={(e) => {
                                if (l.elementDetails.tagId && l.add_trend && l.add_trend === "YES") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_trend")
                                        .classList.toggle(
                                            "show_external_trend_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_trend"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                } else if (l.elementDetails.tagId && l.elementDetails.tagId !== "") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_detail")
                                        .classList.toggle(
                                            "show_external_detail_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId2"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName2"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_detail"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                }
                            }}

                            style={{
                                border: "1px solid rgb(100,100,100)",
                                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px",
                                backgroundColor: l.bgColor ? l.bgColor : "transparent",
                                borderRadius: l.elementDetails.borderRadius ? l.elementDetails.borderRadius + "px" : "8px",
                                minWidth: "100px", minHeight: "100px",
                                zIndex: "1",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                borderColor: l.borderColor ? l.borderColor : "rgb(100,100,100)",
                                overflow: "hidden", // Ebeveyn div taşmasını önler
                            }}
                            key={`${l.id} gauge-${fufg}`}

                            data-id={l.special_type ? "l.special_type" : ""}

                            id={l.id}

                        >

                            <GaugeComponent

                                maxValue={max}
                                minValue={min}
                                className="gauge_widget"
                                arc={{
                                    subArcs:
                                        l.elementDetails.pU ? l.elementDetails.pU === "Percent"
                                            ? arcLimits.map((arc) => ({
                                                limit: ((arc.limit - startValue) / (endValue - startValue)) * 100, // Normalize edilen yüzdelik limitler
                                                color: arc.color,
                                                showTick: true,
                                            }))
                                            : // Eğer "Unit" modundaysa, startValue ve endValue arasında 5 eşit dilim oluştur
                                            arcLimits.map((arc) => {
                                                // Eğer arc.limit startValue'dan küçükse startValue'ya ayarla
                                                let adjustedLimit = arc.limit < startValue ? startValue
                                                    // Eğer arc.limit endValue'dan büyükse endValue'ya ayarla
                                                    : arc.limit > endValue ? endValue
                                                        : arc.limit;

                                                return {
                                                    limit: adjustedLimit, // Normalize edilmiş limit
                                                    color: arc.color,
                                                    showTick: true,
                                                };
                                            }) : arcLimits.map((arc) => ({
                                                limit: ((arc.limit - startValue) / (endValue - startValue)) * 100, // Normalize edilen yüzdelik limitler
                                                color: arc.color,
                                                showTick: true,
                                            })),
                                }}
                                value={
                                    l.elementDetails.pU && l.elementDetails.pU === "Unit"
                                        ? isNumeric ? numericValue.toFixed(2) : "50" // value_tag geçerli sayı mı?
                                        : isNumeric ? (normalizedValue * max) / 100 : 50 // normalizedValue geçerli sayı mı?
                                }
                                style={{
                                    width: "80%",  // Tam genişlik kaplama
                                    height: "80%",
                                    marginLeft: "0%",// Tam yükseklik kaplama,
                                    opacity: "1",

                                }}
                            />
                        </div>
                    );
                }

                else if (l.type === "left_ok") {
                    let rotate_deg = 0;
                    if (l.elementDetails.rotate_deg) {
                        rotate_deg = l.elementDetails.rotate_deg
                    }

                    return (
                        <div

                            style={{ maxHeight: "50px", display: "flex", alignItems: "center", zIndex: "1" }}


                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: l.w,
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            id={l.id}
                            className="left_ok_arrow"
                        >

                            <svg style={l.elementDetails.rotate_deg && { transform: `rotate(${l.elementDetails.rotate_deg}deg)`, transformOrigin: "center" }} width={"100%"} className="sebeke-giris-cizgi">
                                <line
                                    x1="0"
                                    y1="25"
                                    x2="200%"
                                    y2="25"
                                    stroke={l.elementDetails.color}
                                    strokeWidth="8"
                                />
                                <polygon
                                    points="0,25 20,10 20,40"
                                    fill={l.elementDetails.color}
                                />
                                <line

                                    stroke="black"
                                    strokeWidth="14"
                                    markerEnd="url(#arrowhead)"
                                />
                            </svg>

                        </div>
                    )


                } else if (l.type === "right_ok") {

                    let rotate_deg = 0;
                    if (l.elementDetails.rotate_deg) {
                        rotate_deg = l.elementDetails.rotate_deg
                    }

                    return (
                        <div

                            style={{ maxHeight: "50px", display: "flex", alignItems: "center", color: `${l.elementDetails.color}`, zIndex: "1" }}

                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: l.w,
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            id={l.id}
                            className="right_arrow"
                        >

                            <svg width="100%" style={l.elementDetails.rotate_deg && { transform: `rotate(${l.elementDetails.rotate_deg}deg)`, transformOrigin: "center" }} height="50" className="sebeke-giris-cizgi">
                                <defs>
                                    <marker id={`arrowhead${l.id}`} orient="auto" markerWidth="5" markerHeight="5" refX="5" refY="2.5">
                                        <path d="M 0,0 L 5,2.5 L 0,5 Z" fill={`${l.elementDetails.color}`} />
                                    </marker>
                                </defs>

                                <line
                                    x1="0"
                                    y1="25"
                                    x2="calc(100% - 10px)"
                                    y2="25"
                                    stroke={l.elementDetails.color}
                                    strokeWidth="8"
                                />

                                <line
                                    x1="0"
                                    y1="25"
                                    x2="100%"
                                    y2="25"
                                    stroke={l.elementDetails.color}
                                    strokeWidth="8"
                                    marker-end={`url(#arrowhead${l.id})`}
                                />
                            </svg>









                        </div>
                    )

                }
                // return (
                //   <div id='selam34' style={{ display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "rgb(170,170,170)", color: "wheat", fontSize: "35px" }} key={i} className={l.static ? 'static' : ''}>
                //     {l.static ? (
                //       <span className="text" title="This item is static and cannot be removed or resized.">
                //         Static - {i}
                //       </span>
                //     ) : (
                //       <span style={{ padding: "10%", display: "flex", alignItems: "center", justifyContent: "center", width: "90%", height: "90%" }} className="text"><div id='test1' style={{ width: "100%", fontSize: `${Number(l.w) * 15}px`, height: "100%", backgroundColor: "black", display: "flex", alignItems: "center", justifyContent: "center" }}>{i}</div></span>
                //     )}
                //   </div>
                // );
            });

        } else if (currentBreakpoint === "lg") {
            if (!layouts.lg || !Array.isArray(layouts.lg)) {
                return [];
            }
            return _.map(layouts.lg, function (l, i) {
                if (l.type === "text") {

                    return (
                        <div
                            style={{
                                zIndex: "1",
                                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px",
                                borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px",
                                borderColor: l.borderColor ? l.borderColor : "black",
                                backgroundColor: l.bgColor ? l.bgColor : "white",
                                color: l.fontColor ? l.fontColor : "black",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                textAlign: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center",
                                fontSize: l.fontSize ? l.fontSize : `${(Number(l.w)) / 10}px`,
                                overflowWrap: "break-word",
                                wordBreak: "break-word",
                                whiteSpace: "normal",
                            }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: l.w,
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}
                            className={"text_widget" + " " + (l.special_type ? "special_type" : "")}
                        >
                            {l.elementDetails.text !== "" ? (
                                <span
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {l.elementDetails.text}
                                </span>
                            ) : (
                                <span
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    Bu alanda henüz metin yok.
                                </span>
                            )}
                        </div>
                    );

                } else if (l.type === "Alarm") {

                    let value;
                    let stats = alarms_state;

                    console.warn(stats); let seviye_ = l.elementDetails.seviye;
                    if (seviye_ === "1") {
                        value = stats?.high || 0
                    } else if (seviye_ === "2") {
                        value = stats?.warning || 0
                    } else {
                        value = stats?.critical || 0
                    }

                    return (
                        <div



                            style={{
                                zIndex: "1", border: "2px solid black", borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px",
                                borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor || "transparent"
                            }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: l.w,
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            data-id={l.special_type ? "l.special_type" : ""}
                            key={l.i}
                            className="alarm_widget"
                        >
                            <div className="main_alarm_widget">

                                <div style={{ display: "flex", justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center" }} className="showAlarmValueW">{value}</div>
                            </div>


                        </div>
                    );

                } else if (l.type === "gauge_linear") {

                    // tip kontrolü ile uygun tag değerini bul
                    let selectedTag;
                    if (l.elementDetails.tip === "Var") {
                        selectedTag = tag_values_state.find(
                            (item) => item.tip === "Var" && item.tagId === l.elementDetails.tagId
                        );
                    } else {
                        selectedTag = tag_values_state.find((item) => item.tagId === l.elementDetails.tagId);
                        console.warn("selected",selectedTag,tag_values_state,l)
                        // Sayısal değeri güvenli şekilde al
                        let value_tag = selectedTag ? selectedTag.tagValue : "";
                        console.warn("value_tag", value_tag)
                        const numericValue = parseFloat(value_tag);
                        console.warn(numericValue, "numericValue")
                        const isNumeric = !isNaN(numericValue);

                        // Eğer isNumeric false ise boşluktan sonrasını kes
                        value_tag = isNumeric ? value_tag : value_tag.split(' ')[0];

                        // startValue ve endValue güvenli şekilde belirle
                        const startValue =
                            l.elementDetails.startValue && isNumeric && l.elementDetails.startValue <= numericValue
                                ? l.elementDetails.startValue
                                : 0;

                        const endValue =
                            l.elementDetails.endValue && isNumeric && l.elementDetails.endValue >= numericValue
                                ? l.elementDetails.endValue
                                : isNumeric
                                    ? numericValue.toFixed(2)
                                    : 100;
                        // normalizedValue hesapla
                        const normalizedValue = isNumeric
                            ? ((value_tag - startValue) / (endValue - startValue)) * 100
                            : 0;



                        const linearOptions = {
                            pointer: {
                                value: isNumeric ? numericValue : 50, // Sayıysa kullan, değilse 50
                                shape: "arrow",
                                size: 20,
                                color: "rgb(20,20,20)"// Pointer büyüklüğü artırıldı
                            },
                            scale: {
                                min: startValue,
                                max: endValue,
                                majorUnit: (endValue - startValue) / 5,
                                minorUnit: 2,
                                line: {
                                    width: 5, // Ölçek çizgisi kalınlaştırıldı
                                    color: "black"
                                },
                                labels: {
                                    color: "black",
                                    visible: true,
                                    font: "14px Arial, sans-serif", // Yazı fontu büyütüldü
                                },
                                ranges: [
                                    { from: startValue, to: l.elementDetails.alarmValue ? l.elementDetails.alarmValue : (endValue - startValue) / 2, color: "red" },
                                    { from: l.elementDetails.alarmValue ? l.elementDetails.alarmValue : (endValue - startValue) / 2, to: endValue, color: "blue" },
                                ],
                            },
                        };

                        const alarmValue = l.elementDetails.alarmValue || 0


                        return (
                            <div
                                className="gauge_widgetParentDiv"
                                data-grid={{
                                    x: l.x,
                                    y: l.y,
                                    w: l.w,
                                    h: l.h,
                                    resizeHandles: l.resizeHandles,
                                }}


                                style={{
                                    border: "none",
                                    borderWidth: l.borderWidth ? `${l.borderWidth}px` : "2px",
                                    backgroundColor: "transparent",
                                    borderRadius: l.elementDetails.borderRadius ? `${l.elementDetails.borderRadius}px` : "8px",

                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    borderColor: l.borderColor ? l.borderColor : "rgb(100,100,100)",
                                    overflow: "hidden",
                                }}
                                key={l.i}
                                id={l.id}
                                data-id={l.special_type ? "l.special_type" : ""}

                                onContextMenu={(e) => {
                                    if (l.elementDetails.tagId && l.add_trend && l.add_trend === "YES") {
                                        var tagName = tags
                                            .filter((b) => b.tagId === l.elementDetails.tagId)
                                            .map((c) => c.tagName)[0];

                                        e.preventDefault();
                                        const { clientX, clientY } = e;
                                        let screen_width = window.innerWidth;
                                        console.log(clientX, clientY);
                                        document
                                            .querySelector(".show_external_trend")
                                            .classList.toggle(
                                                "show_external_trend_active"
                                            );
                                        document.querySelector(
                                            ".show_tagId"
                                        ).innerHTML = l.elementDetails.tagId;
                                        document.querySelector(
                                            ".show_tagName"
                                        ).innerHTML = tagName;
                                        var popup = document.querySelector(
                                            ".show_external_trend"
                                        );
                                        const popupRect =
                                            popup.getBoundingClientRect();
                                        const viewportWidth = window.innerWidth;
                                        const viewportHeight = window.innerHeight;

                                        // Calculate the new positions
                                        let newX = clientX;
                                        let newY = clientY;

                                        // Adjust if the popup would overflow the right edge of the viewport
                                        if (
                                            newX + popupRect.width >
                                            viewportWidth
                                        ) {
                                            newX = viewportWidth - popupRect.width;
                                        }

                                        // Adjust if the popup would overflow the bottom edge of the viewport
                                        if (
                                            newY + popupRect.height >
                                            viewportHeight
                                        ) {
                                            newY =
                                                viewportHeight - popupRect.height;
                                        }

                                        // Adjust if the popup would overflow the left edge of the viewport
                                        if (newX < 0) {
                                            newX = 0;
                                        }

                                        // Adjust if the popup would overflow the top edge of the viewport
                                        if (newY < 0) {
                                            newY = 0;
                                        }

                                        if (
                                            screen_width < 2301 &&
                                            screen_width > 1800
                                        ) {
                                            document.querySelector(
                                                ".show_external_trend"
                                            ).style.left = `${String(
                                                newX / 1.2
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_trend"
                                            ).style.top = `${String(newY / 1.2)}px`;
                                        } else if (
                                            screen_width < 2801 &&
                                            screen_width > 2300
                                        ) {
                                            document.querySelector(
                                                ".show_external_trend"
                                            ).style.left = `${String(
                                                newX / 1.5
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_trend"
                                            ).style.top = `${String(newY / 1.5)}px`;
                                        } else if (
                                            screen_width < 3501 &&
                                            screen_width > 2800
                                        ) {
                                            document.querySelector(
                                                ".show_external_trend"
                                            ).style.left = `${String(
                                                newX / 1.8
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_trend"
                                            ).style.top = `${String(newY / 1.8)}px`;
                                        } else if (
                                            screen_width < 5001 &&
                                            screen_width > 3500
                                        ) {
                                            document.querySelector(
                                                ".show_external_trend"
                                            ).style.left = `${String(
                                                newX / 2.5
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_trend"
                                            ).style.top = `${String(newY / 2.5)}px`;
                                        } else if (screen_width <= 1800) {
                                            document.querySelector(
                                                ".show_external_trend"
                                            ).style.left = `${String(newX)}px`;
                                            document.querySelector(
                                                ".show_external_trend"
                                            ).style.top = `${String(newY)}px`;
                                        }
                                    } else if (l.elementDetails.tagId && l.elementDetails.tagId !== "") {
                                        var tagName = tags
                                            .filter((b) => b.tagId === l.elementDetails.tagId)
                                            .map((c) => c.tagName)[0];

                                        e.preventDefault();
                                        const { clientX, clientY } = e;
                                        let screen_width = window.innerWidth;
                                        console.log(clientX, clientY);
                                        document
                                            .querySelector(".show_external_detail")
                                            .classList.toggle(
                                                "show_external_detail_active"
                                            );
                                        document.querySelector(
                                            ".show_tagId2"
                                        ).innerHTML = l.elementDetails.tagId;
                                        document.querySelector(
                                            ".show_tagName2"
                                        ).innerHTML = tagName;
                                        var popup = document.querySelector(
                                            ".show_external_detail"
                                        );
                                        const popupRect =
                                            popup.getBoundingClientRect();
                                        const viewportWidth = window.innerWidth;
                                        const viewportHeight = window.innerHeight;

                                        // Calculate the new positions
                                        let newX = clientX;
                                        let newY = clientY;

                                        // Adjust if the popup would overflow the right edge of the viewport
                                        if (
                                            newX + popupRect.width >
                                            viewportWidth
                                        ) {
                                            newX = viewportWidth - popupRect.width;
                                        }

                                        // Adjust if the popup would overflow the bottom edge of the viewport
                                        if (
                                            newY + popupRect.height >
                                            viewportHeight
                                        ) {
                                            newY =
                                                viewportHeight - popupRect.height;
                                        }

                                        // Adjust if the popup would overflow the left edge of the viewport
                                        if (newX < 0) {
                                            newX = 0;
                                        }

                                        // Adjust if the popup would overflow the top edge of the viewport
                                        if (newY < 0) {
                                            newY = 0;
                                        }

                                        if (
                                            screen_width < 2301 &&
                                            screen_width > 1800
                                        ) {
                                            document.querySelector(
                                                ".show_external_detail"
                                            ).style.left = `${String(
                                                newX / 1.2
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_detail"
                                            ).style.top = `${String(newY / 1.2)}px`;
                                        } else if (
                                            screen_width < 2801 &&
                                            screen_width > 2300
                                        ) {
                                            document.querySelector(
                                                ".show_external_detail"
                                            ).style.left = `${String(
                                                newX / 1.5
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_detail"
                                            ).style.top = `${String(newY / 1.5)}px`;
                                        } else if (
                                            screen_width < 3501 &&
                                            screen_width > 2800
                                        ) {
                                            document.querySelector(
                                                ".show_external_detail"
                                            ).style.left = `${String(
                                                newX / 1.8
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_detail"
                                            ).style.top = `${String(newY / 1.8)}px`;
                                        } else if (
                                            screen_width < 5001 &&
                                            screen_width > 3500
                                        ) {
                                            document.querySelector(
                                                ".show_external_detail"
                                            ).style.left = `${String(
                                                newX / 2.5
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_detail"
                                            ).style.top = `${String(newY / 2.5)}px`;
                                        } else if (screen_width <= 1800) {
                                            document.querySelector(
                                                ".show_external_detail"
                                            ).style.left = `${String(newX)}px`;
                                            document.querySelector(
                                                ".show_external_detail"
                                            ).style.top = `${String(newY)}px`;
                                        }
                                    }
                                }}
                            >
                                <div className="su_tanki_gauge_linear" style={{ borderColor: l.borderColor || "#000" }}>
                                    <div style={{ position: "relative", height: "100%", width: "100%", display: "flex", flexDirection: "column-reverse" }}>
                                        <div style={{ width: "100%", height: alarmValue >= numericValue ? "0%" : numericValue * 100 / endValue + "%", backgroundColor: "blue" }} className="water"></div>
                                        <div style={{ width: "100%", height: alarmValue >= numericValue ? numericValue * 100 / endValue + "%" : "0%", backgroundColor: "red" }} className="alarmWater"></div>

                                        <div
                                            style={{
                                                position: "absolute",
                                                top: "50%",
                                                left: "50%",
                                                transform: "translate(-50%, -50%)", // Bu, öğeyi tam olarak ortalar
                                                backgroundColor: "black", // Hafif şeffaf beyaz arka plan
                                                padding: "4px 8px",
                                                borderRadius: "6px",
                                                fontSize: "16px",
                                                fontWeight: "bold",
                                                zIndex: "3",
                                                color: "#ffffff", // Daha koyu siyah
                                                fontFamily: "'Poppins', sans-serif", // Daha modern ve seksi font
                                                boxShadow: "2px 2px 6px rgba(0, 0, 0, 0.15)", // Hafif gölge efekti
                                            }}
                                        >
                                            {value_tag ? l.elementDetails.pU && l.elementDetails.pU === "Percent" ? (numericValue * 100 / endValue).toFixed(2) + "%" : numericValue : 50}
                                        </div>
                                    </div>
                                </div>



                            </div>
                        );
                    }
                }
                else if (l.type === "lock") {
                    let value_ = tag_values_state.find(i =>
                        l.elementDetails.tip !== "Var"
                            ? String(i.tagId) === String(l.elementDetails.tagId)
                            : i.tip === "Var" && String(i.tagId) === String(l.elementDetails.tagId)
                    )?.tagValue;
                    if (value_ && isNaN(Number(value_))) {
                        value_ = value_.split(' ')[0]; // ilk boşluktan önceki kısmı al
                        value_ = value_.includes(" ") ? value_.trim() : value_
                    }
                    return (
                        <div


                            onClick={(e) => {
                                let tagValue;
                                (layouts[currentBreakpoint] || []).forEach(x => {
                                    if (String(x.id) === String(l.id)) {
                                        let tagId_ = l.elementDetails.tagId || "";

                                        tagValue = value_ === "1" ? "0" : "1";
                                        setValueFunc({ TagId: tagId_, TagValue: tagValue })
                                        document.querySelectorAll(".react-grid-item").forEach((item) => {
                                            if (item.classList.contains(`${l.elementDetails.tagIdEx}`)) {
                                                item.style.pointerEvents = tagValue === "1" ? "none" : "all";
                                                if (e.target.classList.contains("fa-lock")) {
                                                    item.style.opacity = "1"
                                                } else if (e.target.classList.contains("fa-unlock")) {
                                                    item.style.opacity = "0.55"
                                                }
                                            }
                                        })
                                        if (e.target.classList.contains("fa-lock")) {
                                            e.target.classList.replace("fa-lock", "fa-unlock");
                                        } else if (e.target.classList.contains("fa-unlock")) {
                                            e.target.classList.replace("fa-unlock", "fa-lock");
                                        }
                                    }
                                })
                            }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            data-id={l.special_type ? "l.special_type" : ""}
                            key={l.i}
                            className={`lock_widget`}
                        >
                            <i id="lock_i_dyn" style={{ color: l.fontColor || "gray", width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: `${l.w / 4}px` }} className={value_ === "0" ? "fa fa-lock" : "fa fa-unlock"}></i>



                        </div>
                    );
                } else if (l.type === "i_g") {
                    return (
                        <div

                            onClick={() => {
                                pages.forEach(async x => {
                                    if (Number(x.pageId) === Number(l.elementDetails.pageId)) {
                                        function normalizeURLPath(path) {
                                            const turkishMap = {
                                                'İ': 'I', 'ı': 'i', 'Ş': 'S', 'ş': 's',
                                                'Ğ': 'G', 'ğ': 'g', 'Ü': 'U', 'ü': 'u',
                                                'Ö': 'O', 'ö': 'o', 'Ç': 'C', 'ç': 'c'
                                            };

                                            return path.split('').map(char => turkishMap[char] || char).join('');
                                        }
                                        await Store.dispatch(set_current_dyn_pageName(x.pageName))
                                        history.push(`/pages/${normalizeURLPath(x.pageName).replaceAll(" ", "_")}`)

                                    }
                                })
                            }}

                            style={{
                                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px",
                                border: "2px solid rgb(60,60,60)", borderColor: l.borderColor ? l.borderColor : "black", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black",
                                borderRadius: "4px", zIndex: "1", cursor: "pointer"
                            }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            data-id={l.special_type ? "l.special_type" : ""}
                            key={l.i}
                            className="i_g_widget"
                        >

                            <div style={{ backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black", width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                                {l.elementDetails.text}

                            </div>

                        </div>
                    );
                } else if (l.type === "y_g") {

                    let value_ = tag_values_state.find(i =>
                        l.elementDetails.tip !== "Var"
                            ? String(i.tagId) === String(l.elementDetails.tagId)
                            : i.tip === "Var" && String(i.tagId) === String(l.elementDetails.tagId)
                    )?.tagValue;

                    // Eğer value_ sayısal değilse, boşluktan sonrasını sil
                    if (value_ && isNaN(Number(value_))) {
                        value_ = value_.split(' ')[0];

                    }

                    value_ = value_ && value_.split('.')[0]; // Noktadan sonrasını almaz

                    console.warn("value_", value_, typeof (value_), l.elementDetails.value_list);

                    // 2. value_list oluştur (value1, value2, value3... varsa onları al)
                    let valueList = [];
                    let i = 1;
                    while (l.elementDetails[`value${i}`] !== undefined) {
                        valueList.push(l.elementDetails[`value${i}`]);
                        i++;
                    }


                    // 2. `value_.elementDetailslist` İçinde `valelementDetails.ue_` İndeksini Bul
                    let index_ = l.elementDetails.value_list && l.elementDetails.value_list.indexOf(
                        value_ !== undefined && value_.includes(" ") ? value_.trim() : value_
                    );

                    // 3. Varsayılan Atama
                    if (index_ === -1 || index_ === undefined) { // `indexOf` bulunamazsa -1 döner
                        index_ = 0;
                    }

                    return (
                        <div

                            onContextMenu={(e) => {
                                if (l.elementDetails.tagId && l.add_trend && l.add_trend === "YES") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_trend")
                                        .classList.toggle(
                                            "show_external_trend_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_trend"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                } else if (l.elementDetails.tagId && l.elementDetails.tagId !== "") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_detail")
                                        .classList.toggle(
                                            "show_external_detail_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId2"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName2"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_detail"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                }
                            }}
                            style={{
                                border: "2px solid rgb(60,60,60)",

                                width: l.elementDetails.rad ? l.elementDetails.rad + "px" : "10px", height: l.elementDetails.rad ? l.elementDetails.rad + "px" : "10px", borderRadius: l.elementDetails.rad ? (l.elementDetails.tur ? l.elementDetails.tur === "circle" ? l.elementDetails.rad + "px" : l.elementDetails.borderRadius + "px" : "10px") : "10px", zIndex: "1", borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px",
                                backgroundColor: l.elementDetails.bg_list && l.elementDetails.bg_list[index_] ? l.elementDetails.bg_list[index_] : "white", borderColor: l.elementDetails.border_list && l.elementDetails.border_list[index_] ? l.elementDetails.border_list[index_] : "black"
                            }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: l.elementDetails.rad ? l.elementDetails.rad : l.w,
                                h: l.elementDetails.rad ? l.elementDetails.rad : l.w,
                            }}
                            id={l.id}
                            data-id={l.special_type ? "l.special_type" : ""}
                            key={l.i}
                            className="yuvarlak_gosterge_widget"
                        >


                        </div>
                    );
                }
                else if (l.type === "go_page") {
                    return (
                        <div

                            onClick={() => {
                                if (l.elementDetails.text === "Alarm" && alarm_okuma) {
                                    history.push("/AlarmPanel")
                                } else {
                                    pages.forEach(async x => {
                                        if (Number(x.pageId) === Number(l.elementDetails.pageId)) {
                                            console.warn(l)

                                            function normalizeURLPath(path) {
                                                const turkishMap = {
                                                    'İ': 'I', 'ı': 'i', 'Ş': 'S', 'ş': 's',
                                                    'Ğ': 'G', 'ğ': 'g', 'Ü': 'U', 'ü': 'u',
                                                    'Ö': 'O', 'ö': 'o', 'Ç': 'C', 'ç': 'c'
                                                };

                                                return path.split('').map(char => turkishMap[char] || char).join('');
                                            }
                                            await Store.dispatch(set_current_dyn_pageName(x.pageName))
                                            history.push(`/pages/${normalizeURLPath(x.pageName).replaceAll(" ", "_")}`)

                                        }
                                    })
                                }
                            }
                            }

                            style={{
                                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px",
                                border: "2px solid rgb(60,60,60)", borderColor: l.borderColor ? l.borderColor : "black", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black",
                                borderRadius: "4px", zIndex: "1", cursor: "pointer"
                            }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            data-id={l.special_type ? "l.special_type" : ""}
                            key={l.i}
                            className="go_page_widget"
                        >

                            <div style={{ backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black", width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                                {l.elementDetails.text}

                            </div>

                        </div>
                    );
                }
                else if (l.type === "set") {

                    // 1. `value_` Değerini Bul
                    let value_ = tag_values_state.find(i =>
                        l.elementDetails.tip !== "Var"
                            ? String(i.tagId) === String(l.elementDetails.tagId)
                            : i.tip === "Var" && String(i.tagId) === String(l.elementDetails.tagId)
                    )?.tagValue;

                    // Eğer value_ sayısal değilse, boşluktan sonrasını sil
                    if (value_ && isNaN(Number(value_))) {
                        value_ = value_.split(' ')[0]; // ilk boşluktan önceki kısmı al
                    }

                    // 2. `value_list` İçinde `value_` İndeksini Bul
                    let index_ = l.elementDetails.value_list && l.elementDetails.value_list.indexOf(
                        value_ !== undefined && value_.includes(" ") ? value_.trim() : value_
                    );


                    // 3. Varsayılan Atama
                    if (index_ === -1 || index_ === undefined) { // `indexOf` bulunamazsa -1 döner
                        index_ = 0;
                    }


                    console.warn(value_, l, tag_values_state)

                    return (
                        <div
                            onContextMenu={(e) => {
                                if (l.elementDetails.tagId && l.add_trend && l.add_trend === "YES") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_trend")
                                        .classList.toggle(
                                            "show_external_trend_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_trend"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                } else if (l.elementDetails.tagId && l.elementDetails.tagId !== "") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_detail")
                                        .classList.toggle(
                                            "show_external_detail_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId2"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName2"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_detail"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                }
                            }}

                            onClick={(e) => {
                                if (l.elementDetails.tagId2 && l.elementDetails.tagId2 !== "" && l.elementDetails.tagId2 !== "None" && yazma_control) {
                                    console.log(e.target);
                                    e.preventDefault();
                                    e.stopPropagation();
                                    const { clientX, clientY } = e;
                                    document.querySelector(".Popup-selectbox2").classList.toggle("changeProperties_active")
                                    document.querySelector(".Popup-selectbox2").id = l.id

                                    var popup = document.querySelector(".Popup-selectbox2")
                                    const popupRect = popup.getBoundingClientRect();

                                    // Yeni pozisyonları hesapla
                                    let newX = clientX + window.scrollX;
                                    let newY = clientY + window.scrollY;

                                    console.log(newX, newY);

                                    // Sağ kenardan taşmayı önle
                                    if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                                        newX = window.innerWidth + window.scrollX - popupRect.width;
                                    }

                                    // Alt kenardan taşmayı önle
                                    if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                                        newY = window.innerHeight + window.scrollY - popupRect.height;
                                    }

                                    // Sol kenardan taşmayı önle
                                    if (newX < window.scrollX) {
                                        newX = window.scrollX;
                                    }

                                    // Üst kenardan taşmayı önle
                                    if (newY < window.scrollY) {
                                        newY = window.scrollY;
                                    }

                                    console.log(newX, newY);

                                    // Pop-up'ın pozisyonunu ayarla
                                    popup.style.left = `${newX}px`;
                                    popup.style.top = `${newY}px`;

                                    const parentElement = e.target.closest(".set_widget");
                                    const parentRect = parentElement.getBoundingClientRect();

                                    Set_elem_popup({
                                        width: l.w,
                                        height: l.h,
                                        left: l.x,
                                        top: l.y,

                                        value_list: l.elementDetails.value_list && l.elementDetails.value_list.length === 0 ? l.value_list : l.elementDetails.value_list,
                                        bg_list: l.elementDetails.bg_list && l.elementDetails.bg_list.length === 0 ? l.bg_list : l.elementDetails.bg_list,
                                        border_list: l.elementDetails.border_list && l.elementDetails.border_list.length === 0 ? l.border_list : l.elementDetails.border_list,
                                        font_list: l.elementDetails.font_list && l.elementDetails.font_list.length === 0 ? l.font_list : l.elementDetails.font_list,
                                        type: l.type,
                                        id: l.id,
                                        fontSize: l.fontSize ? l.fontSize : Number(l.w) / 10,
                                        value: l.elementDetails.text
                                    })
                                    setSelectedOptionselectbox(l.elementDetails.text)
                                }

                            }}
                            style={{
                                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px",
                                borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", backgroundColor: "white", border: "2px solid rgb(60,60,60)", borderColor: l.borderColor ? l.borderColor : "black", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black",
                                zIndex: "1",
                            }}

                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            data-id={l.special_type ? "l.special_type" : ""}
                            key={l.i}
                            className={`set_widget ${l.elementDetails.text} ${l.elementDetails.tagId}` + " " + (l.special_type ? "special_type" : "")}
                        >
                            <div style={{ backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black", width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                                {Number(value_).toLocaleString("tr-TR", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                }) || l.elementDetails.text}

                            </div>

                        </div>
                    );
                }
                else if (l.type === "selectbox") {

                    let value_ = tag_values_state.find(i =>
                        l.elementDetails.tip !== "Var"
                            ? String(i.tagId) === String(l.elementDetails.tagId)
                            : i.tip === "Var" && String(i.tagId) === String(l.elementDetails.tagId)
                    )?.tagValue;

                    // Eğer value_ sayısal değilse, boşluktan sonrasını sil
                    if (value_ && isNaN(Number(value_))) {
                        value_ = value_.split(' ')[0];

                    }
                    console.warn("value_", value_, typeof (value_));

                    value_ = value_ && value_.split('.')[0]; // Noktadan sonrasını almaz

                    console.warn("value_", value_, typeof (value_), l);

                    // 2. value_list oluştur (value1, value2, value3... varsa onları al)
                    let valueList = [];
                    let i = 1;
                    while (l.elementDetails[`value${i}`] !== undefined) {
                        valueList.push(l.elementDetails[`value${i}`]);
                        i++;
                    }


                    // 2. `value_list` İçinde `value_` İndeksini Bul
                    let index_ = l.elementDetails.value_list && l.elementDetails.value_list.indexOf(
                        value_ !== undefined && typeof value_ === "string" && value_.includes(" ")
                            ? value_.trim()
                            : value_
                    );

                    // 3. Varsayılan Atama
                    if (index_ === -1 || index_ === undefined) {
                        index_ = 0;
                    }

                    console.warn(value_, l, tag_values_state)
                    let text_list_ = l.elementDetails.text_list;
                    let alarmClassName = "";

                    if (text_list_ && text_list_.length > 0 && text_list_[index_] === "ALARM" && l.special_type) {
                        alarmClassName = "alarmactive_blackBorder";
                        (layouts[currentBreakpoint] || []).forEach((item) => {
                            if (item.id === l.id2 && !item.special_type) {
                                let id = item.id
                                document.querySelector(`#Popup${id}`).style.backgroundColor = "red"
                            }
                        });

                    }




                    return (
                        <div
                            onContextMenu={(e) => {
                                if (l.elementDetails.tagId && l.add_trend && l.add_trend === "YES") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_trend")
                                        .classList.toggle(
                                            "show_external_trend_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_trend"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                } else if (l.elementDetails.tagId && l.elementDetails.tagId !== "") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_detail")
                                        .classList.toggle(
                                            "show_external_detail_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId2"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName2"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_detail"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                }
                            }}
                            onClick={(e) => {
                                if (l.elementDetails.tagId2 && l.elementDetails.tagId2 !== "" && l.elementDetails.tagId2 !== "None" && yazma_control) {
                                    console.log(e.target);
                                    e.preventDefault();
                                    e.stopPropagation();
                                    const { clientX, clientY } = e;
                                    document.querySelector(".Popup-selectbox").classList.toggle("changeProperties_active")
                                    document.querySelector(".Popup-selectbox").id = l.id

                                    var popup = document.querySelector(".Popup-selectbox")
                                    const popupRect = popup.getBoundingClientRect();

                                    // Yeni pozisyonları hesapla
                                    let newX = clientX + window.scrollX;
                                    let newY = clientY + window.scrollY;

                                    console.log(newX, newY);

                                    // Sağ kenardan taşmayı önle
                                    if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                                        newX = window.innerWidth + window.scrollX - popupRect.width;
                                    }

                                    // Alt kenardan taşmayı önle
                                    if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                                        newY = window.innerHeight + window.scrollY - popupRect.height;
                                    }

                                    // Sol kenardan taşmayı önle
                                    if (newX < window.scrollX) {
                                        newX = window.scrollX;
                                    }

                                    // Üst kenardan taşmayı önle
                                    if (newY < window.scrollY) {
                                        newY = window.scrollY;
                                    }

                                    console.log(newX, newY);

                                    // Pop-up'ın pozisyonunu ayarla
                                    popup.style.left = `${newX}px`;
                                    popup.style.top = `${newY}px`;

                                    const parentElement = e.target.closest(".selectbox_widget");
                                    const parentRect = parentElement.getBoundingClientRect();

                                    Set_elem_popup({
                                        width: l.w,
                                        height: l.h,
                                        left: l.x,
                                        top: l.y,
                                        text_list: l.elementDetails.text_list.length === 0 ? l.text_list : l.elementDetails.text_list,
                                        value_list: l.elementDetails.value_list && l.elementDetails.value_list.length === 0 ? l.value_list : l.elementDetails.value_list,
                                        bg_list: l.elementDetails.bg_list && l.elementDetails.bg_list.length === 0 ? l.bg_list : l.elementDetails.bg_list,
                                        border_list: l.elementDetails.border_list && l.elementDetails.border_list.length === 0 ? l.border_list : l.elementDetails.border_list,
                                        font_list: l.elementDetails.font_list && l.elementDetails.font_list.length === 0 ? l.font_list : l.elementDetails.font_list,
                                        type: l.type,
                                        id: l.id,
                                        fontSize: l.fontSize ? l.fontSize : Number(l.w) / 10,
                                        value: l.elementDetails.text
                                    })
                                    setSelectedOptionselectbox(l.elementDetails.text)
                                }

                            }}
                            style={{
                                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px",
                                backgroundColor: "white", border: "2px solid rgb(60,60,60)", borderColor: l.elementDetails.border_list && l.elementDetails.border_list[index_] ? l.elementDetails.border_list[index_] : "black", backgroundColor: l.elementDetails.bg_list && l.elementDetails.bg_list[index_] ? l.elementDetails.bg_list[index_] : "white", color: l.elementDetails.font_list && l.elementDetails.font_list[index_] ? l.elementDetails.font_list[index_] : "black", zIndex: "1",
                            }}

                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            className={`selectbox_widget ${l.elementDetails.text}` + " " + (l.special_type ? ("special_type_ " + alarmClassName) : "")}
                        >
                            <div style={{ backgroundColor: "transparent", color: l.elementDetails.font_list && l.elementDetails.font_list[index_] ? l.elementDetails.font_list[index_] : "black", width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                                {l.elementDetails.text_list[index_]}

                            </div>

                        </div>
                    );
                }
                else if (l.type === "senaryoSelect") {
                    return (
                        <div


                            style={{
                                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px",
                                backgroundColor: "white", border: "2px solid rgb(60,60,60)", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black", borderRadius: "8px", zIndex: "1",
                            }}

                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            className={`senaryo_widget ${l.elementDetails.text}`}
                        >
                            <div style={{ backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black", width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                                {l.elementDetails.text}

                            </div>

                        </div>
                    );
                }
                else if (l.type === "trend") {
                    let data_ = {
                        labels: [],
                        datasets: [{
                            data: [],
                            backgroundColor: "transparent",
                            borderColor: "#f26c6d",
                            pointBorderColor: "#f26c6d",
                            pointBorderWidth: 1
                        }]

                    }
                    if (l.elementDetails.data) {
                        data_ = {
                            labels: (l.elementDetails.data || []).map((item, index) => {
                                return item.date

                            }),
                            datasets: [{
                                data: (l.elementDetails.data || []).map((item, index) => {
                                    return item.value
                                }),
                                backgroundColor: "transparent",
                                borderColor: "#f26c6d",
                                pointBorderColor: "#f26c6d",
                                pointBorderWidth: 1
                            }]

                        }
                    }

                    const datason = data_

                    const optionsSon = {
                        scales: {
                            x: {
                                type: 'time',
                                time: {
                                    unit: 'day',
                                    stepSize: 1,
                                    displayFormats: {
                                        day: 'MMM D'
                                    }
                                },
                                ticks: {
                                    maxTicksLimit: 24
                                }
                            },
                            y: {
                                min: Number(min),
                                max: 0,
                                beginAtZero: true,
                                ticks: {
                                    callback: function (value) {
                                        return Number(value.toFixed(2)); // Etiketlerdeki sıfırları engelle
                                    }
                                }
                            }
                        },
                        plugins: {
                            legend: {
                                display: true,
                                labels: {
                                    filter: function (item, chart) {
                                        return item.text !== undefined;
                                    },
                                    generateLabels: function (chart) {
                                        return [{
                                            text: "",
                                            fillStyle: "crimson",
                                            strokeStyle: chart.ctx.strokeStyle,
                                            lineWidth: chart.ctx.lineWidth,
                                            hidden: false,
                                            index: 0,
                                            datasetIndex: 0
                                        }];
                                    }
                                }
                            },
                            zoom: {
                                pan: {
                                    enabled: true,
                                    mode: 'xy',
                                },
                                zoom: {
                                    wheel: {
                                        enabled: true,
                                    },
                                    pinch: {
                                        enabled: true,
                                    },
                                    mode: 'x',
                                    onZoom: ({ chart }) => {
                                        const xScale = chart.scales.x;
                                        const min = xScale.min;
                                        const max = xScale.max;
                                        const diff = max - min;
                                        let unit = 'second';

                                        // Zoom leveline göre birim seçimi
                                        if (diff > 1000 * 60 * 60 * 24 * 7) {
                                            unit = 'day';
                                        } else if (diff > 1000 * 60 * 60) {
                                            unit = 'hour';
                                        } else if (diff > 1000 * 60) {
                                            unit = 'minute';
                                        }

                                        // Yeniden ayarlama
                                        xScale.options.time.unit = unit;
                                        xScale.options.time.tooltipFormat = unit === 'second' ? 'll HH:mm:ss' : 'll HH:mm';
                                        xScale.options.ticks.callback = (value) => {
                                            return moment(value).format(unit === 'second' ? 'll HH:mm:ss' : 'll HH:mm');
                                        };

                                        chart.update();
                                    },
                                },
                            },
                        },
                    };

                    return (
                        <div


                            style={{ zIndex: "1", marginTop: "-8px" }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            className="trend_widget"
                        >

                            <div style={{ width: "100%", height: "100%" }} className="bottom_sec trend_graph">
                                <Line options={JSON.stringify(real_datas) !== "{}" ? real_datas[String(l.id)] ? createChartOptions(String(l.id)) : optionsSon : optionsSon} data={JSON.stringify(real_datas) !== "{}" ? real_datas[String(l.id)] ? createChartData(String(l.id)) : datason : datason} />
                            </div>
                        </div>
                    )
                }
                else if (l.type === "empty_btn") {
                    return (
                        <div


                            style={{
                                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px",
                                backgroundColor: "white", border: "2px solid rgb(60,60,60)", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black", borderRadius: "8px", zIndex: "1",
                            }}

                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            className={`empty_btn_widget ${l.elementDetails.text}`}
                        >
                            <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                                <input disabled={true} style={{ backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black", backgroundColor: "transparent", width: "100%", outline: "none", appearance: "none", border: "none", textAlign: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w)) / 10}px` }} type="text" value={l.elementDetails.text} />


                            </div>

                        </div>
                    );
                }
                else if (l.type === "t_t") {

                    return (
                        <div

                            onContextMenu={(e) => {
                                if (l.elementDetails.tagId && l.add_trend && l.add_trend === "YES") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_trend")
                                        .classList.toggle(
                                            "show_external_trend_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_trend"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                } else if (l.elementDetails.tagId && l.elementDetails.tagId !== "") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_detail")
                                        .classList.toggle(
                                            "show_external_detail_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId2"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName2"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_detail"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                }
                            }}

                            style={{
                                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px",
                                zIndex: "1", borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", borderColor: l.borderColor ? l.borderColor : "black", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black",
                            }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: l.w,
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            data-id={l.special_type ? "l.special_type" : ""}
                            key={l.i}
                            className="text_tag_widget"
                        >

                            <input
                                type="text"
                                style={{
                                    width: "100%", textAlign: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w)) / 10}px`, position: "relative", backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black"
                                }}
                                disabled={true}

                                value={
                                    (l.elementDetails.text !== "" ? l.elementDetails.text : " ") +
                                    " : " +
                                    (
                                        l.elementDetails.tagId !== ""
                                            ? (() => {
                                                const matchedItem = tag_values_state.find(item =>
                                                    l.elementDetails.tip !== "Var"
                                                        ? item.tagId === l.elementDetails.tagId
                                                        : item.tip === "Var" && item.tagId === l.elementDetails.tagId
                                                );

                                                const tagValue = matchedItem?.tagValue;
                                                const formatted = tagValue != null
                                                    ? Number(tagValue).toLocaleString("tr-TR", {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2,
                                                    })
                                                    : "";

                                                return (
                                                    formatted +
                                                    (l.elementDetails.unit && l.elementDetails.unit !== "None"
                                                        ? " " + l.elementDetails.unit
                                                        : "")
                                                );
                                            })()
                                            : " "
                                    )

                                }


                            />
                            )
                        </div>
                    );
                }

                else if (l.type === "tag") {
                    const matchingTag = tag_values_state.find(item =>
                        l.elementDetails.tip !== "Var"
                            ? item.tagId === l.elementDetails.tagId
                            : item.tip === "Var" && item.tagId === l.elementDetails.tagId
                    );

                    const decimalPlaces = matchingTag && matchingTag.tagDecimal !== null ? Number(matchingTag.tagDecimal) : 2;
                    let formattedValue = "";

                    if (matchingTag) {
                        let value_tag = matchingTag.tagValue;
                        if (value_tag && isNaN(Number(value_tag))) {
                            value_tag = value_tag.split(" ")[0];
                        }

                        console.log(value_tag, 1)

                        if (value_tag && !isNaN(Number(value_tag))) {
                            let numericValue = Number(value_tag);

                            // Eğer birimi kW/h ise 1000'e böl
                            if (l.elementDetails.unit === "kW/h") {
                                numericValue = numericValue / 1000;
                            }

                            console.log(numericValue, 2)

                            formattedValue = numericValue.toLocaleString("tr-TR", {
                                minimumFractionDigits: decimalPlaces,
                                maximumFractionDigits: decimalPlaces,
                            }) + (l.elementDetails.unit && l.elementDetails.unit !== "None" ? " " + l.elementDetails.unit : "");
                        }
                    }




                    return (
                        <div

                            onContextMenu={(e) => {
                                if (l.elementDetails.tagId && l.add_trend && l.add_trend === "YES") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_trend")
                                        .classList.toggle(
                                            "show_external_trend_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_trend"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                } else if (l.elementDetails.tagId && l.elementDetails.tagId !== "") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_detail")
                                        .classList.toggle(
                                            "show_external_detail_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId2"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName2"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_detail"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                }
                            }}

                            style={{ borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", zIndex: "1", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black", }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            className={"tag_widget" + " " + (l.special_type ? "special_type" : "")}
                        >



                            <input
                                id={l.id + "cc"}
                                type="text"
                                disabled={true}
                                style={{
                                    backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black",
                                    fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, textAlign: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center",
                                    width: "100%", backgroundColor: "transparent", outline: "none", border: "none",

                                }}
                                value={
                                    l.elementDetails.tagId !== ""
                                        ? (() => {
                                            const source = tag_values_state.length > 0 ? tag_values_state : tag_values_state;

                                            const matchedItem = source.find(item =>
                                                l.elementDetails.tip !== "Var"
                                                    ? item.tagId === l.elementDetails.tagId
                                                    : item.tip === "Var" && item.tagId === l.elementDetails.tagId
                                            );

                                            let value_tag = matchedItem?.tagValue;

                                            // Sayı değilse boşluktan önceki kısmı al
                                            if (value_tag && isNaN(Number(value_tag))) {
                                                value_tag = value_tag.split(" ")[0];
                                            }

                                            // Formatla
                                            if (value_tag && !isNaN(Number(value_tag))) {
                                                let numericValue = Number(value_tag);

                                                // BURASI EKLENDİ: Eğer birimi kW/h ise 1000'e böl
                                                if (l.elementDetails.unit === "kW/h") {
                                                    numericValue = numericValue / 1000;
                                                }

                                                const decimalPlaces = l.elementDetails.decimal ?? 2;

                                                const formatted = numericValue.toLocaleString("tr-TR", {
                                                    minimumFractionDigits: decimalPlaces,
                                                    maximumFractionDigits: decimalPlaces,
                                                });

                                                const unit = l.elementDetails.unit;
                                                return formatted + (unit && unit !== "None" ? " " + unit : "");
                                            }

                                            return "";
                                        })()
                                        : ""
                                }



                            />

                        </div>
                    );
                }
                else if (l.type === "Popup") {
                    // 1. `value_` Değerini Bul
                    let value_ = tag_values_state.find(i =>
                        l.elementDetails.tip !== "Var"
                            ? String(i.tagId) === String(l.elementDetails.tagId)
                            : i.tip === "Var" && String(i.tagId) === String(l.elementDetails.tagId)
                    )?.tagValue;

                    // Eğer value_ sayısal değilse, boşluktan sonrasını sil
                    if (value_ && isNaN(Number(value_))) {
                        value_ = value_.split(' ')[0]; // ilk boşluktan önceki kısmı al
                    }

                    // 2. `value_list` İçinde `value_` İndeksini Bul
                    let index_ = l.elementDetails.value_list && l.elementDetails.value_list.indexOf(
                        value_ !== undefined && value_.includes(" ") ? value_.trim() : value_
                    );


                    // 3. Varsayılan Atama
                    if (index_ === -1 || index_ === undefined) { // `indexOf` bulunamazsa -1 döner
                        index_ = 0;
                    }

                    // 1. `value_` Değerini Bul
                    let value_2 = tag_values_state.find(i =>
                        l.elementDetails.tip2 !== "Var"
                            ? String(i.tagId) === String(l.elementDetails.tagId2)
                            : i.tip === "Var" && String(i.tagId) === String(l.elementDetails.tagId2)
                    )?.tagValue;

                    // Eğer value_ sayısal değilse, boşluktan sonrasını sil
                    if (value_2 && isNaN(Number(value_2))) {
                        value_2 = value_2.split(' ')[0]; // ilk boşluktan önceki kısmı al
                    }

                    // 2. `value_list` İçinde `value_` İndeksini Bul
                    let index_2 = l.elementDetails.value_list && l.elementDetails.value_list.indexOf(
                        value_2 !== undefined && value_2.includes(" ") ? value_2.trim() : value_2
                    );

                    // 3. Varsayılan Atama
                    if (index_2 === -1 || index_2 === undefined) { // `indexOf` bulunamazsa -1 döner
                        index_2 = 0;
                    }

                    // 1. `value_` Değerini Bul
                    let value_3 = tag_values_state.find(i =>
                        l.elementDetails.tip !== "Var"
                            ? String(i.tagId) === String(l.elementDetails.tagId3)
                            : i.tip === "Var" && String(i.tagId) === String(l.elementDetails.tagId3)
                    )?.tagValue;

                    // Eğer value_ sayısal değilse, boşluktan sonrasını sil
                    if (value_3 && isNaN(Number(value_3))) {
                        value_3 = value_3.split(' ')[0]; // ilk boşluktan önceki kısmı al
                    }

                    // 2. `value_list` İçinde `value_` İndeksini Bul
                    let index_3 = l.elementDetails.value_list && l.elementDetails.value_list.indexOf(
                        value_3 !== undefined && value_3.includes(" ") ? value_3.trim() : value_3
                    );

                    // 3. Varsayılan Atama
                    if (index_3 === -1 || index_3 === undefined) { // `indexOf` bulunamazsa -1 döner
                        index_3 = 0;
                    }

                    return (
                        <div

                            onClick={(e) => {
                                if (yazma_control) {
                                    let active_id = l.id;
                                    let active_items = l.elementDetails.items;
                                    Set_active_popup_id(active_id);
                                    Set_active_popup_items(active_items)
                                    // Hide other elements
                                    document.querySelector(".react-grid-layout").childNodes.forEach((x) => {
                                        x.style.opacity = "0";
                                        x.style.zIndex = "-1";
                                    });

                                    let w__, h__, x__, y__;

                                    setLayouts((prevLayouts) => {
                                        const updatedLayouts = { ...prevLayouts };

                                        if (Array.isArray(updatedLayouts[currentBreakpoint])) {
                                            (updatedLayouts[currentBreakpoint] || []).forEach((item) => {
                                                if (String(item.id) === String(active_id)) {
                                                    if (!item.elementDetails.items) {
                                                        item.elementDetails.items = [];
                                                    }

                                                    item.elementDetails.items.forEach((newItem) => {
                                                        if (newItem.type === "frame") {
                                                            w__ = newItem.w;
                                                            h__ = newItem.h;
                                                            x__ = newItem.x;
                                                            y__ = newItem.y;
                                                        }
                                                        newItem.isDraggable = false;
                                                        newItem.isResizable = false;
                                                        updatedLayouts[currentBreakpoint].push(newItem);
                                                    });
                                                }
                                            });
                                        }

                                        return updatedLayouts;
                                    });

                                    document.querySelector(".main_sec").classList.toggle("main_sec_bg_blur");

                                    setTimeout(() => {
                                        document.querySelector(".react-grid-layout").childNodes.forEach((x) => {
                                            if (window.getComputedStyle(x).zIndex !== "-1") {
                                                x.style.zIndex = "2";
                                            }
                                        });
                                    }, 50);

                                    setTimeout(() => {
                                        let diffX, diffY;
                                        const layoutItems = document.querySelector(".react-grid-layout")
                                            .childNodes;

                                        layoutItems.forEach((x) => {
                                            const id = x.getAttribute("data-id");

                                            if (x.classList.contains("frame_widget")) {

                                                x.style.width = `${w__}px`; // Grid birimlerini px'e çevir
                                                x.style.height = `${h__}px`;

                                                const initialRect = x.getBoundingClientRect();
                                                const mainSec = document.querySelector(".main_sec");
                                                const mainSecRect = mainSec.getBoundingClientRect();

                                                const centerX = (mainSecRect.width) / 2;
                                                const centerY = (mainSecRect.height) / 2 - mainSecRect.top / 10;

                                                console.warn(mainSecRect, "kdoejdıoejoejoe")

                                                const targetX = (centerX - w__ / 2) - mainSecRect.left / 5;
                                                const targetY = (centerY - h__ / 2);

                                                console.log("targetX", targetX)

                                                diffX = targetX;
                                                diffY = targetY;

                                                x.style.transform = `translate(${targetX}px, ${targetY}px)`;
                                            }
                                        });

                                        // Diğer öğeleri frame'e göre taşı
                                        layoutItems.forEach((x) => {
                                            const id = x.getAttribute("data-id");
                                            if (x.classList.contains("frame_widget")) return;


                                            if (!id?.includes("l.special_type")) return;



                                            if (typeof diffX !== "undefined" && typeof diffY !== "undefined") {
                                                const frameWidgetRect = document
                                                    .querySelector(".frame_widget")
                                                    .getBoundingClientRect();
                                                const elementRect = x.getBoundingClientRect();

                                                const relativeX = elementRect.left - frameWidgetRect.left;
                                                const relativeY = elementRect.top - frameWidgetRect.top;

                                                x.style.transform = `translate(${diffX + relativeX}px, ${diffY + relativeY
                                                    }px)`;
                                            }
                                        });
                                    }, 50);
                                }
                            }
                            }


                            style={{ borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", zIndex: "1", border: "2px solid rgb(70,70,70)", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black", borderRadius: "8px", display: "flex", alignItems: "center", borderColor: l.elementDetails.border_list && l.elementDetails.border_list[index_] ? l.elementDetails.border_list[index_] : "black", backgroundColor: l.elementDetails.bg_list && l.elementDetails.bg_list[index_] ? l.elementDetails.bg_list[index_] : "white", color: l.elementDetails.font_list && l.elementDetails.font_list[index_] ? l.elementDetails.font_list[index_] : "black" }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={"Popup" + l.id}
                            data-id={l.special_type ? "l.special_type" : ""}
                            key={l.i}
                            className="popupduz_widget"
                        >



                            <input
                                className="showRoomNumber_popupDYN"
                                placeholder="room number"

                                id={l.id + "cc"}
                                type="text"

                                value={l.elementDetails.text ? l.elementDetails.text : ""}
                                style={{
                                    fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, textAlign: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center",
                                    backgroundColor: "transparent",
                                    color: l.fontColor ? l.fontColor : "black",
                                    width: "100%", outline: "none", backgroundColor: "transparent", border: "none"

                                }}




                            />

                            <div className="dyn_popup_bottom_part">
                                <div><p style={{ fontSize: `${l.w / 17}px` }}>Oda:</p> <input style={{ color: l.elementDetails.font_list && l.elementDetails.font_list[index_] ? l.elementDetails.font_list[index_] : "black", fontSize: `${l.w / 20}px`, backgroundColor: "transparent" }} type="text" value={
                                    l.elementDetails.tagId3 !== ""
                                        ? (() => {
                                            let selectedTag;
                                            if (l.elementDetails.tip3 === "Var") {
                                                selectedTag = tag_values_state.find(
                                                    (item) => item.tip === "Var" && item.tagId === l.elementDetails.tagId3
                                                );
                                            } else {
                                                selectedTag = tag_values_state.find(
                                                    (item) => item.tagId === l.elementDetails.tagId3
                                                );
                                            }

                                            if (!selectedTag) return "";

                                            const numericValue = parseFloat(selectedTag.tagValue);
                                            const isNumeric = !isNaN(numericValue);

                                            return isNumeric
                                                ? numericValue.toFixed(l.elementDetails.decimal ? l.elementDetails.decimal : 2) +
                                                (l.elementDetails.unit && l.elementDetails.unit !== "None" ? " " + l.elementDetails.unit : "")
                                                : selectedTag.tagValue; // Sayıya çevrilemezse olduğu gibi bırak
                                        })()
                                        : ""
                                } className="dyn_popup_show_room_temp" /></div>
                                <div className="span_divPopupW"><span style={{ borderColor: l.elementDetails.border_list2 && l.elementDetails.border_list2[index_] ? l.elementDetails.border_list2[index_] : "black", backgroundColor: l.elementDetails.bg_list2 && l.elementDetails.bg_list2[index_] ? l.elementDetails.bg_list2[index_] : "white", }}></span></div>
                                <div><p style={{ fontSize: `${l.w / 17}px` }}>Set:</p> <input
                                    onClick={(e) => {
                                        if (l.elementDetails.tagId4 && l.elementDetails.tagId4 !== "" && l.elementDetails.tagId4 !== "None" && yazma_control) {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            const { clientX, clientY } = e;

                                            // Set elem_popup with tagId2 as tagId4 for modal to work
                                            Set_elem_popup({ ...l, elementDetails: { ...l.elementDetails, tagId2: l.elementDetails.tagId4 } });

                                            document.querySelector(".Popup-selectbox2").classList.toggle("changeProperties_active");
                                            document.querySelector(".Popup-selectbox2").id = l.id;

                                            var popup = document.querySelector(".Popup-selectbox2");
                                            const popupRect = popup.getBoundingClientRect();

                                            let newX = clientX + window.scrollX;
                                            let newY = clientY + window.scrollY;

                                            if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                                                newX = window.innerWidth + window.scrollX - popupRect.width;
                                            }
                                            if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                                                newY = window.innerHeight + window.scrollY - popupRect.height;
                                            }

                                            popup.style.left = `${newX}px`;
                                            popup.style.top = `${newY}px`;
                                        }
                                    }}
                                    style={{ color: l.elementDetails.font_list && l.elementDetails.font_list[index_] ? l.elementDetails.font_list[index_] : "black", fontSize: `${l.w / 20}px`, backgroundColor: "transparent", cursor: l.elementDetails.tagId4 && l.elementDetails.tagId4 !== "" && l.elementDetails.tagId4 !== "None" && yazma_control ? "pointer" : "default" }}
                                    type="text"
                                    value={
                                    l.elementDetails.tagId4 !== ""
                                        ? (() => {
                                            let selectedTag;
                                            if (l.elementDetails.tip4 === "Var") {
                                                selectedTag = tag_values_state.find(
                                                    (item) => item.tip === "Var" && item.tagId === l.elementDetails.tagId4
                                                );
                                            } else {
                                                selectedTag = tag_values_state.find(
                                                    (item) => item.tagId === l.elementDetails.tagId4
                                                );
                                            }

                                            if (!selectedTag) return "";

                                            const numericValue = parseFloat(selectedTag.tagValue);
                                            const isNumeric = !isNaN(numericValue);

                                            return isNumeric
                                                ? numericValue.toFixed(l.elementDetails.decimal ? l.elementDetails.decimal : 2) +
                                                (l.elementDetails.unit && l.elementDetails.unit !== "None" ? " " + l.elementDetails.unit : "")
                                                : selectedTag.tagValue; // Sayıya çevrilemezse olduğu gibi bırak
                                        })()
                                        : ""
                                } className="dyn_popup_show_room_set_temp" /></div>
                            </div>

                        </div>
                    );
                }
                else if (l.type === "frame") {
                    if (!l.special_type) {
                        return (
                            <div

                                onContextMenu={(e) => {
                                    console.log(l);
                                    if (l.combine_trend && l.combine_trend === true) {
                                        let group_id = l.group_t_id ? l.group_t_id : undefined

                                        let newData = combine_trend_tags;

                                        (layouts[currentBreakpoint] || []).forEach(x => {
                                            if (group_id !== undefined && x.group_t_id && Number(x.group_t_id) === Number(group_id) && l.elementDetails.tagId) {
                                                var tagName = tags
                                                    .filter((b) => b.tagId === l.elementDetails.tagId)
                                                    .map((c) => c.tagName)[0];
                                                newData.push({ tagId: l.elementDetails.tagId, tagName: tagName })
                                            }
                                        })

                                        Set_combine_trend_tags(newData)

                                        e.preventDefault();
                                        const { clientX, clientY } = e;
                                        let screen_width = window.innerWidth;
                                        console.log(clientX, clientY);
                                        document
                                            .querySelector(".show_external_combine_trend")
                                            .classList.toggle(
                                                "show_external_combine_trend_active"
                                            );

                                        var popup = document.querySelector(
                                            ".show_external_combine_trend"
                                        );
                                        const popupRect =
                                            popup.getBoundingClientRect();
                                        const viewportWidth = window.innerWidth;
                                        const viewportHeight = window.innerHeight;

                                        // Calculate the new positions
                                        let newX = clientX;
                                        let newY = clientY;

                                        // Adjust if the popup would overflow the right edge of the viewport
                                        if (
                                            newX + popupRect.width >
                                            viewportWidth
                                        ) {
                                            newX = viewportWidth - popupRect.width;
                                        }

                                        // Adjust if the popup would overflow the bottom edge of the viewport
                                        if (
                                            newY + popupRect.height >
                                            viewportHeight
                                        ) {
                                            newY =
                                                viewportHeight - popupRect.height;
                                        }

                                        // Adjust if the popup would overflow the left edge of the viewport
                                        if (newX < 0) {
                                            newX = 0;
                                        }

                                        // Adjust if the popup would overflow the top edge of the viewport
                                        if (newY < 0) {
                                            newY = 0;
                                        }

                                        if (
                                            screen_width < 2301 &&
                                            screen_width > 1800
                                        ) {
                                            document.querySelector(
                                                ".show_external_combine_trend"
                                            ).style.left = `${String(
                                                newX / 1.2
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_combine_trend"
                                            ).style.top = `${String(newY / 1.2)}px`;
                                        } else if (
                                            screen_width < 2801 &&
                                            screen_width > 2300
                                        ) {
                                            document.querySelector(
                                                ".show_external_combine_trend"
                                            ).style.left = `${String(
                                                newX / 1.5
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_combine_trend"
                                            ).style.top = `${String(newY / 1.5)}px`;
                                        } else if (
                                            screen_width < 3501 &&
                                            screen_width > 2800
                                        ) {
                                            document.querySelector(
                                                ".show_external_combine_trend"
                                            ).style.left = `${String(
                                                newX / 1.8
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_combine_trend"
                                            ).style.top = `${String(newY / 1.8)}px`;
                                        } else if (
                                            screen_width < 5001 &&
                                            screen_width > 3500
                                        ) {
                                            document.querySelector(
                                                ".show_external_combine_trend"
                                            ).style.left = `${String(
                                                newX / 2.5
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_combine_trend"
                                            ).style.top = `${String(newY / 2.5)}px`;
                                        } else if (screen_width <= 1800) {
                                            document.querySelector(
                                                ".show_external_combine_trend"
                                            ).style.left = `${String(newX)}px`;
                                            document.querySelector(
                                                ".show_external_combine_trend"
                                            ).style.top = `${String(newY)}px`;
                                        }
                                    }
                                }}

                                style={{ borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", backgroundColor: "white", borderRadius: l.elementDetails.borderRadius + "px", border: "3px solid rgb(65,65,65)", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black", zIndex: "0" }}
                                data-grid={{
                                    x: l.x,
                                    y: l.y,
                                    w: (l.w),
                                    h: l.h,
                                    resizeHandles: l.resizeHandles,
                                }}
                                id={l.id}
                                data-id={l.special_type ? "l.special_type" : ""}
                                key={l.i}
                                className="frame_widget"
                            >




                            </div>
                        );
                    } else {
                        return (
                            <div


                                style={{ borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", backgroundColor: "white", borderRadius: l.elementDetails.borderRadius + "px", border: "3px solid rgb(65,65,65)", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black", zIndex: "0" }}
                                data-grid={{
                                    x: l.x,
                                    y: l.y,
                                    w: (l.w),
                                    h: l.h,
                                    resizeHandles: l.resizeHandles,
                                }}
                                id={l.id}
                                data-id={l.special_type ? "l.special_type" : ""}
                                key={l.i}
                                className="frame_widget"
                            >
                                <i onClick={(e) => {
                                    if (document.querySelector(".main_sec").classList.contains("main_sec_bg_blur")) {


                                        setLayouts((prevLayouts) => {
                                            const updatedLayouts = { ...prevLayouts };


                                            if (Array.isArray(updatedLayouts[currentBreakpoint])) {
                                                // Filter out items with matching special_type and id2
                                                updatedLayouts[currentBreakpoint] = (updatedLayouts[currentBreakpoint] || []).filter(
                                                    (item) => !(item.special_type && String(item.id2) === String(active_popup_id))
                                                );
                                            }

                                            return updatedLayouts;
                                        });
                                        Set_active_popup_id(null)
                                        Set_active_popup_items([])
                                        document.querySelector(".main_sec").classList.toggle("main_sec_bg_blur");
                                        setTimeout(() => {
                                            document.querySelector(".react-grid-layout").childNodes.forEach(x => {
                                                x.style.opacity = "1"
                                                x.style.zIndex = "1"
                                            })
                                        }, 50)
                                    }

                                }} style={{ position: "relative", left: "95%", top: "-30px", cursor: "pointer", backgroundColor: "red", width: "40px", height: "40px", display: "flex", alignItems: "center", justifyContent: "center", color: "white", borderRadius: "40px", border: "none" }} className="fa fa-times"></i>




                            </div>
                        );
                    }

                }
                else if (l.type === "fan_modu") {
                    return (
                        <div

                            onContextMenu={(e) => {
                                if (l.elementDetails.tagId && l.add_trend && l.add_trend === "YES") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_trend")
                                        .classList.toggle(
                                            "show_external_trend_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_trend"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                } else if (l.elementDetails.tagId && l.elementDetails.tagId !== "") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_detail")
                                        .classList.toggle(
                                            "show_external_detail_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId2"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName2"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_detail"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                }
                            }}

                            onClick={(e) => {
                                if (yazma_control) {
                                    console.log(e.target);
                                    e.preventDefault();
                                    e.stopPropagation();
                                    const { clientX, clientY } = e;
                                    document.querySelector(".Popup-fan").classList.toggle("changeProperties_active")
                                    document.querySelector(".Popup-fan").id = l.id

                                    var popup = document.querySelector(".Popup-fan")
                                    const popupRect = popup.getBoundingClientRect();

                                    // Yeni pozisyonları hesapla
                                    let newX = clientX + window.scrollX;
                                    let newY = clientY + window.scrollY;

                                    console.log(newX, newY);

                                    // Sağ kenardan taşmayı önle
                                    if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                                        newX = window.innerWidth + window.scrollX - popupRect.width;
                                    }

                                    // Alt kenardan taşmayı önle
                                    if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                                        newY = window.innerHeight + window.scrollY - popupRect.height;
                                    }

                                    // Sol kenardan taşmayı önle
                                    if (newX < window.scrollX) {
                                        newX = window.scrollX;
                                    }

                                    // Üst kenardan taşmayı önle
                                    if (newY < window.scrollY) {
                                        newY = window.scrollY;
                                    }

                                    console.log(newX, newY);

                                    // Pop-up'ın pozisyonunu ayarla
                                    popup.style.left = `${newX}px`;
                                    popup.style.top = `${newY}px`;

                                    const parentElement = e.target.closest(".fan_modu_widget");
                                    const parentRect = parentElement.getBoundingClientRect();

                                    Set_elem_popup({
                                        width: l.w,
                                        height: l.h * 10,
                                        left: l.x,
                                        top: l.y,

                                        type: l.type,
                                        id: l.id,
                                        fontSize: l.fontSize ? l.fontSize : Number(l.w) / 10
                                    })

                                    setSelectedOptionfan(l.elementDetails.text)
                                }
                            }
                            }
                            style={{ borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", border: "2px solid rgb(60,60,60)", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black", borderRadius: "4px", zIndex: "1" }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            className={"fan_modu_widget" + " " + (l.special_type ? "special_type" : "")}
                        >

                            <div style={{ backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black", width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                                {l.elementDetails.text}

                            </div>

                        </div>
                    );
                }
                else if (l.type === "calisma_modu") {
                    return (
                        <div
                            onContextMenu={(e) => {
                                if (l.elementDetails.tagId && l.add_trend && l.add_trend === "YES") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_trend")
                                        .classList.toggle(
                                            "show_external_trend_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_trend"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                } else if (l.elementDetails.tagId && l.elementDetails.tagId !== "") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_detail")
                                        .classList.toggle(
                                            "show_external_detail_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId2"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName2"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_detail"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                }
                            }}
                            onClick={(e) => {
                                if (yazma_control) {
                                    console.log(e.target);
                                    e.preventDefault();
                                    e.stopPropagation();
                                    const { clientX, clientY } = e;
                                    document.querySelector(".Popup-calisma").classList.toggle("changeProperties_active")
                                    document.querySelector(".Popup-calisma").id = l.id

                                    var popup = document.querySelector(".Popup-calisma")
                                    const popupRect = popup.getBoundingClientRect();

                                    // Yeni pozisyonları hesapla
                                    let newX = clientX + window.scrollX;
                                    let newY = clientY + window.scrollY;

                                    console.log(newX, newY);

                                    // Sağ kenardan taşmayı önle
                                    if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                                        newX = window.innerWidth + window.scrollX - popupRect.width;
                                    }

                                    // Alt kenardan taşmayı önle
                                    if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                                        newY = window.innerHeight + window.scrollY - popupRect.height;
                                    }

                                    // Sol kenardan taşmayı önle
                                    if (newX < window.scrollX) {
                                        newX = window.scrollX;
                                    }

                                    // Üst kenardan taşmayı önle
                                    if (newY < window.scrollY) {
                                        newY = window.scrollY;
                                    }

                                    console.log(newX, newY);

                                    // Pop-up'ın pozisyonunu ayarla
                                    popup.style.left = `${newX}px`;
                                    popup.style.top = `${newY}px`;

                                    const parentElement = e.target.closest(".calisma_modu_widget");
                                    const parentRect = parentElement.getBoundingClientRect();

                                    Set_elem_popup({
                                        width: l.w,
                                        height: l.h * 10,
                                        left: l.x,
                                        top: l.y,

                                        type: l.type,
                                        id: l.id,
                                        fontSize: l.fontSize ? l.fontSize : Number(l.w) / 10
                                    })

                                    setSelectedOptioncalisma(l.elementDetails.text)
                                }
                            }
                            }
                            style={{ borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", border: "2px solid rgb(60,60,60)", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black", borderRadius: "4px", zIndex: "1" }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}

                            id={l.id}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            className={"calisma_modu_widget" + ` ${l.elementDetails.tagId}` + " " + (l.special_type ? "special_type" : "")}
                        >


                            <div style={{ backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black", width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                                {l.elementDetails.text}

                            </div>



                        </div>
                    );
                }
                else if (l.type === "on/off") {
                    let value_ = tag_values_state.find(i =>
                        l.elementDetails.tip !== "Var"
                            ? String(i.tagId) === String(l.elementDetails.tagId)
                            : i.tip === "Var" && String(i.tagId) === String(l.elementDetails.tagId)
                    )?.tagValue;

                    // Eğer value_ sayısal değilse, boşluktan sonrasını sil
                    if (value_ && isNaN(Number(value_))) {
                        value_ = value_.split(' ')[0];

                    }
                    console.warn("value_", value_, typeof (value_));

                    value_ = value_ && value_.split('.')[0]; // Noktadan sonrasını almaz

                    console.warn("value_", value_, typeof (value_));

                    // 2. value_list oluştur (value1, value2, value3... varsa onları al)
                    let valueList = [];
                    let i = 1;
                    while (l.elementDetails[`value${i}`] !== undefined) {
                        valueList.push(l.elementDetails[`value${i}`]);
                        i++;
                    }

                    // 3. value_ değeri valueList içinde kaçıncı sıradaysa onu al
                    let index_ = valueList.indexOf(
                        value_ !== undefined && value_.includes(" ") ? value_.trim() : value_
                    );

                    // 4. Varsayılan atama
                    if (index_ === -1 || index_ === undefined) {
                        index_ = 0;
                    }
                    return (
                        <div

                            onContextMenu={(e) => {
                                const { clientX, clientY } = e;
                                let screen_width = window.innerWidth;
                                console.log(l);

                                if (l.elementDetails.tagId && l.add_trend && l.add_trend === "YES") {
                                    if (l.elementDetails.text === "ON") {
                                        var tagName = tags
                                            .filter((b) => b.tagId === l.elementDetails.tagId)
                                            .map((c) => c.tagName)[0];

                                        e.preventDefault();

                                        let screen_width = window.innerWidth;
                                        console.log(clientX, clientY);
                                        document
                                            .querySelector(".show_external_trend")
                                            .classList.toggle(
                                                "show_external_trend_active"
                                            );
                                        document.querySelector(
                                            ".show_tagId"
                                        ).innerHTML = l.elementDetails.tagId;
                                        document.querySelector(
                                            ".show_tagName"
                                        ).innerHTML = tagName;
                                        var popup = document.querySelector(
                                            ".show_external_trend"
                                        );
                                    } else {
                                        var tagName = tags
                                            .filter((b) => b.tagId === l.elementDetails.tagId)
                                            .map((c) => c.tagName)[0];

                                        e.preventDefault();

                                        let screen_width = window.innerWidth;
                                        console.log(clientX, clientY);
                                        document
                                            .querySelector(".show_external_trend")
                                            .classList.toggle(
                                                "show_external_trend_active"
                                            );
                                        document.querySelector(
                                            ".show_tagId"
                                        ).innerHTML = l.elementDetails.tagId;
                                        document.querySelector(
                                            ".show_tagName"
                                        ).innerHTML = tagName;
                                        var popup = document.querySelector(
                                            ".show_external_trend"
                                        );
                                    }

                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                } else if (l.elementDetails.tagId && l.elementDetails.tagId !== "") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_detail")
                                        .classList.toggle(
                                            "show_external_detail_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId2"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName2"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_detail"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                }
                            }}

                            onClick={(e) => {
                                if (yazma_control) {


                                    console.log(e.target);
                                    e.preventDefault();
                                    e.stopPropagation();
                                    const { clientX, clientY } = e;
                                    document.querySelector(".Popup-onOff").classList.toggle("changeProperties_active")
                                    document.querySelector(".Popup-onOff").id = l.id

                                    var popup = document.querySelector(".Popup-onOff")
                                    const popupRect = popup.getBoundingClientRect();

                                    // Yeni pozisyonları hesapla
                                    let newX = clientX + window.scrollX;
                                    let newY = clientY + window.scrollY;

                                    console.log(newX, newY);

                                    // Sağ kenardan taşmayı önle
                                    if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                                        newX = window.innerWidth + window.scrollX - popupRect.width;
                                    }

                                    // Alt kenardan taşmayı önle
                                    if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                                        newY = window.innerHeight + window.scrollY - popupRect.height;
                                    }

                                    // Sol kenardan taşmayı önle
                                    if (newX < window.scrollX) {
                                        newX = window.scrollX;
                                    }

                                    // Üst kenardan taşmayı önle
                                    if (newY < window.scrollY) {
                                        newY = window.scrollY;
                                    }

                                    console.log(newX, newY);

                                    // Pop-up'ın pozisyonunu ayarla
                                    popup.style.left = `${newX}px`;
                                    popup.style.top = `${newY}px`;

                                    const parentElement = e.target.closest(".on-off_widget");
                                    const parentRect = parentElement.getBoundingClientRect();

                                    Set_elem_popup({
                                        width: l.w,
                                        height: l.h * 10,
                                        left: l.x,
                                        top: l.y,

                                        type: l.type,
                                        id: l.id,
                                        fontSize: l.fontSize ? l.fontSize : Number(l.w) / 10,
                                        value: value_ !== undefined && value_ === "1" ? "ON" : "OFF"
                                    })
                                }
                            }
                            }
                            style={{
                                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", backgroundColor: "white", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "white", borderRadius: "8px", zIndex: "1",
                            }}

                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            className={`on-off_widget ${value_ !== undefined && value_ === "1" ? "ON" : "OFF"} ${l.elementDetails.tagId}` + " " + (l.special_type ? "special_type" : "")}
                        >
                            <div style={{ backgroundColor: "transparent", color: "white", width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                                {value_ !== undefined && value_ === "1" ? "ON" : "OFF"}

                            </div>

                        </div>
                    );
                }
                else if (l.type === "image") {
                    return (
                        <div


                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: l.w,
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            className="image_widgetParentDiv"
                            style={{ borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", borderColor: "rgb(100,100,100)", zIndex: "1" }}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            id={l.id}
                        >

                            <img
                                style={{ width: "100%", height: "100%" }}
                                className="image_widget"
                                src={l.elementDetails.src !== "" ? l.elementDetails.src : ""}
                                alt=""
                            />
                        </div>
                    );
                } else if (l.type === "bg") {

                    let diffWidth = document.querySelector(".link-group-data-links").getBoundingClientRect().width * 1.05
                    let diffHeigth = document.querySelector("nav").getBoundingClientRect().height * 1.25
                    console.log(diffHeigth)


                    setTimeout(() => {
                        if (document.querySelector(".main_sec")) {
                            document.querySelector(
                                ".main_sec"
                            ).style.backgroundImage = `url("${l.elementDetails.src}")`;
                            document.querySelector(".main_sec").style.backgroundPosition =
                                `${l.elementDetails.left}px ${l.elementDetails.top}px`;
                            document.querySelector(".main_sec").style.backgroundSize = `${l.elementDetails.width}px ${l.elementDetails.height}px`;
                            document.querySelector(".main_sec").style.backgroundRepeat = "no-repeat"
                        }

                    }, 1000)



                } else if (l.type === "gauge") {
                    let value_max = Number(l.elementDetails.maxValue);

                    // tip kontrolü ile uygun tag değerini bul
                    let selectedTag;
                    if (l.elementDetails.tip === "Var") {
                        selectedTag = tag_values_state.find(
                            (item) => item.tip === "Var" && item.tagId === l.elementDetails.tagId
                        );
                    } else {
                        selectedTag = tag_values_state.find((item) => item.tagId === l.elementDetails.tagId);
                    }

                    // Sayısal değeri güvenli şekilde al
                    let value_tag = selectedTag ? selectedTag.tagValue : "";
                    const numericValue = parseFloat(value_tag);
                    const isNumeric = !isNaN(numericValue);

                    // Eğer isNumeric false ise boşluktan sonrasını kes
                    value_tag = isNumeric ? value_tag : value_tag.split(' ')[0];



                    // last_deger hesaplamasını güvenli hale getir
                    let last_deger = isNumeric
                        ? (numericValue / (l.elementDetails.endValue ? l.elementDetails.endValue : value_max).toFixed(2)) * 100
                        : 0;

                    // startValue ve endValue güvenli şekilde belirle
                    const startValue =
                        l.elementDetails.startValue && isNumeric && l.elementDetails.startValue <= numericValue
                            ? l.elementDetails.startValue
                            : 0;

                    const endValue = l.elementDetails.endValue && isNumeric
                        ? l.elementDetails.limitValues && l.elementDetails.limitValues.length > 0 && Number([...l.elementDetails.limitValues]
                            .sort((a, b) => a.value - b.value)
                            .at(-1).value) >= l.elementDetails.endValue
                            ? Math.max(l.elementDetails.endValue, numericValue) +
                            Number([...l.elementDetails.limitValues]
                                .sort((a, b) => a.value - b.value)
                                .at(-1).value)
                            : Math.max(l.elementDetails.endValue, numericValue)
                        : isNumeric
                            ? numericValue.toFixed(2)
                            : 100;
                    // normalizedValue hesapla
                    const normalizedValue = isNumeric
                        ? ((value_tag - startValue) / (endValue - startValue)) * 100
                        : 0;

                    // Arc limitlerini tanımla
                    const arcLimits = l.elementDetails.pU && l.elementDetails.limitValues
                        ? (() => {
                            if (l.elementDetails.pU === "Unit") {
                                // Unit modu için özel mantık
                                const sortedLimits = [...l.elementDetails.limitValues].sort((a, b) => a.value - b.value);
                                const colorLimits = sortedLimits.filter(i => i.color);

                                let lastLimit = startValue;
                                let result = [];

                                colorLimits.forEach(({ value, color }) => {
                                    let newColor = color;
                                    if (l.elementDetails.scaleX === "-1" && color === "#008000") {
                                        newColor = "#ff0000";
                                    } else if (l.elementDetails.scaleX === "-1" && color === "#ff0000") {
                                        newColor = "#008000";
                                    }
                                    result.push({
                                        limit: value,
                                        color: newColor,
                                    });
                                    lastLimit = value;
                                });

                                // Son rengi endValue'ya kadar devam ettir
                                if (colorLimits.length > 2) {
                                    result.push({
                                        limit: endValue,
                                        color: l.elementDetails.scaleX === "-1" ? colorLimits[0].color : colorLimits[colorLimits.length - 1].color,
                                    });
                                } else {
                                    result = [
                                        {
                                            limit: ((20 / 100) * (endValue - startValue)) + startValue,
                                            color: l.elementDetails.scaleX === "-1" ? "#5BE12C" : "#EA4228",
                                        },
                                        {
                                            limit: ((40 / 100) * (endValue - startValue)) + startValue,
                                            color: l.elementDetails.scaleX === "-1" ? "#F5CD19" : "#F58B19",
                                        },
                                        {
                                            limit: ((60 / 100) * (endValue - startValue)) + startValue,
                                            color: l.elementDetails.scaleX === "-1" ? "#F58B19" : "#F5CD19",
                                        },
                                        {
                                            limit: ((80 / 100) * (endValue - startValue)) + startValue,
                                            color: l.elementDetails.scaleX === "-1" ? "#FF5733" : "#33FFCE",
                                        },
                                        {
                                            limit: ((100 / 100) * (endValue - startValue)) + startValue,
                                            color: l.elementDetails.scaleX === "-1" ? "#EA4228" : "#5BE12C",
                                        },
                                    ];
                                }

                                return result;
                            } else if (l.elementDetails.pU === "Percent") {
                                // Percent modu için 5 renkli dizi
                                return [
                                    {
                                        limit: ((20 / 100) * (endValue - startValue)) + startValue,
                                        color: l.elementDetails.scaleX === "-1" ? "#5BE12C" : "#EA4228",
                                    },
                                    {
                                        limit: ((40 / 100) * (endValue - startValue)) + startValue,
                                        color: l.elementDetails.scaleX === "-1" ? "#F5CD19" : "#F58B19",
                                    },
                                    {
                                        limit: ((60 / 100) * (endValue - startValue)) + startValue,
                                        color: l.elementDetails.scaleX === "-1" ? "#F58B19" : "#F5CD19",
                                    },
                                    {
                                        limit: ((80 / 100) * (endValue - startValue)) + startValue,
                                        color: l.elementDetails.scaleX === "-1" ? "#FF5733" : "#33FFCE",
                                    },
                                    {
                                        limit: ((100 / 100) * (endValue - startValue)) + startValue,
                                        color: l.elementDetails.scaleX === "-1" ? "#EA4228" : "#5BE12C",
                                    },
                                ];
                            } else {
                                // Diğer durumlar için varsayılan dizi
                                return [
                                    {
                                        limit: ((20 / 100) * (endValue - startValue)) + startValue,
                                        color: l.elementDetails.scaleX === "-1" ? "#5BE12C" : "#EA4228",
                                    },
                                    {
                                        limit: ((40 / 100) * (endValue - startValue)) + startValue,
                                        color: l.elementDetails.scaleX === "-1" ? "#F5CD19" : "#F58B19",
                                    },
                                    {
                                        limit: ((60 / 100) * (endValue - startValue)) + startValue,
                                        color: l.elementDetails.scaleX === "-1" ? "#F58B19" : "#F5CD19",
                                    },
                                    {
                                        limit: ((80 / 100) * (endValue - startValue)) + startValue,
                                        color: l.elementDetails.scaleX === "-1" ? "#FF5733" : "#33FFCE",
                                    },
                                    {
                                        limit: ((100 / 100) * (endValue - startValue)) + startValue,
                                        color: l.elementDetails.scaleX === "-1" ? "#EA4228" : "#5BE12C",
                                    },
                                ];
                            }
                        })()
                        : [
                            {
                                limit: ((20 / 100) * (endValue - startValue)) + startValue,
                                color: l.elementDetails.scaleX === "-1" ? "#5BE12C" : "#EA4228",
                            },
                            {
                                limit: ((40 / 100) * (endValue - startValue)) + startValue,
                                color: l.elementDetails.scaleX === "-1" ? "#F5CD19" : "#F58B19",
                            },
                            {
                                limit: ((60 / 100) * (endValue - startValue)) + startValue,
                                color: l.elementDetails.scaleX === "-1" ? "#F58B19" : "#F5CD19",
                            },
                            {
                                limit: ((80 / 100) * (endValue - startValue)) + startValue,
                                color: l.elementDetails.scaleX === "-1" ? "#FF5733" : "#33FFCE",
                            },
                            {
                                limit: ((100 / 100) * (endValue - startValue)) + startValue,
                                color: l.elementDetails.scaleX === "-1" ? "#EA4228" : "#5BE12C",
                            },
                        ];
                    ;

                    const textElement = document.querySelector(`.gauge_widgetParentDiv${l.id} .value-text text`);

                    if (textElement && l.fontColor) textElement.style.fill = l.fontColor

                    document.querySelectorAll(`.gauge_widgetParentDiv${l.id} .tick-value text`).forEach(x => {
                        if (l.fontColor) x.style.fill = l.fontColor
                    })

                    // pU kontrolü ile text içeriğini güncelle
                    if (l.elementDetails.pU) {
                        const textElement = document.querySelector(`.gauge_widgetParentDiv${l.id} .value-text text`);
                        if (textElement) {
                            if (l.elementDetails.pU === "Unit") {
                                if (textElement.textContent.includes("%")) {
                                    textElement.textContent = textElement.textContent.slice(0, -1); // "%" karakterini kaldır
                                }
                                textElement.textContent = value_tag;
                            } else {
                                if (!textElement.textContent.includes("%")) {
                                    textElement.textContent = normalizedValue.toFixed(2) + "%";
                                }
                            }
                        }
                    }

                    // Min ve Max değerlerini ayarla
                    const min = l.elementDetails.pU === "Unit" && l.elementDetails.startValue ? startValue : 0;
                    const max = l.elementDetails.pU === "Unit" && l.elementDetails.endValue ? endValue : 100;





                    return (
                        <div
                            className={"gauge_widgetParentDiv" + " gauge_widgetParentDiv" + l.id}

                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: l.w,
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            onContextMenu={(e) => {
                                if (l.elementDetails.tagId && l.add_trend && l.add_trend === "YES") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_trend")
                                        .classList.toggle(
                                            "show_external_trend_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_trend"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                } else if (l.elementDetails.tagId && l.elementDetails.tagId !== "") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_detail")
                                        .classList.toggle(
                                            "show_external_detail_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId2"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName2"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_detail"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                }
                            }}

                            style={{
                                border: "1px solid rgb(100,100,100)",
                                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px",
                                backgroundColor: l.bgColor ? l.bgColor : "transparent",
                                borderRadius: l.elementDetails.borderRadius ? l.elementDetails.borderRadius + "px" : "8px",
                                minWidth: "100px", minHeight: "100px",
                                zIndex: "1",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                borderColor: l.borderColor ? l.borderColor : "rgb(100,100,100)",
                                overflow: "hidden", // Ebeveyn div taşmasını önler
                            }}
                            key={`${l.id} gauge-${fufg}`}

                            data-id={l.special_type ? "l.special_type" : ""}

                            id={l.id}

                        >

                            <GaugeComponent

                                maxValue={max}
                                minValue={min}
                                className="gauge_widget"
                                arc={{
                                    subArcs:
                                        l.elementDetails.pU ? l.elementDetails.pU === "Percent"
                                            ? arcLimits.map((arc) => ({
                                                limit: ((arc.limit - startValue) / (endValue - startValue)) * 100, // Normalize edilen yüzdelik limitler
                                                color: arc.color,
                                                showTick: true,
                                            }))
                                            : // Eğer "Unit" modundaysa, startValue ve endValue arasında 5 eşit dilim oluştur
                                            arcLimits.map((arc) => {
                                                // Eğer arc.limit startValue'dan küçükse startValue'ya ayarla
                                                let adjustedLimit = arc.limit < startValue ? startValue
                                                    // Eğer arc.limit endValue'dan büyükse endValue'ya ayarla
                                                    : arc.limit > endValue ? endValue
                                                        : arc.limit;

                                                return {
                                                    limit: adjustedLimit, // Normalize edilmiş limit
                                                    color: arc.color,
                                                    showTick: true,
                                                };
                                            }) : arcLimits.map((arc) => ({
                                                limit: ((arc.limit - startValue) / (endValue - startValue)) * 100, // Normalize edilen yüzdelik limitler
                                                color: arc.color,
                                                showTick: true,
                                            })),
                                }}
                                value={
                                    l.elementDetails.pU && l.elementDetails.pU === "Unit"
                                        ? isNumeric ? numericValue.toFixed(2) : "50" // value_tag geçerli sayı mı?
                                        : isNumeric ? (normalizedValue * max) / 100 : 50 // normalizedValue geçerli sayı mı?
                                }
                                style={{
                                    width: "80%",  // Tam genişlik kaplama
                                    height: "80%",
                                    marginLeft: "0%",// Tam yükseklik kaplama,
                                    opacity: "1",

                                }}
                            />
                        </div>
                    );
                }

                else if (l.type === "left_ok") {
                    let rotate_deg = 0;
                    if (l.elementDetails.rotate_deg) {
                        rotate_deg = l.elementDetails.rotate_deg
                    }

                    return (
                        <div

                            style={{ maxHeight: "50px", display: "flex", alignItems: "center", zIndex: "1" }}


                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: l.w,
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            id={l.id}
                            className="left_ok_arrow"
                        >

                            <svg style={l.elementDetails.rotate_deg && { transform: `rotate(${l.elementDetails.rotate_deg}deg)`, transformOrigin: "center" }} width={"100%"} className="sebeke-giris-cizgi">
                                <line
                                    x1="0"
                                    y1="25"
                                    x2="200%"
                                    y2="25"
                                    stroke={l.elementDetails.color}
                                    strokeWidth="8"
                                />
                                <polygon
                                    points="0,25 20,10 20,40"
                                    fill={l.elementDetails.color}
                                />
                                <line

                                    stroke="black"
                                    strokeWidth="14"
                                    markerEnd="url(#arrowhead)"
                                />
                            </svg>

                        </div>
                    )


                } else if (l.type === "right_ok") {

                    let rotate_deg = 0;
                    if (l.elementDetails.rotate_deg) {
                        rotate_deg = l.elementDetails.rotate_deg
                    }

                    return (
                        <div

                            style={{ maxHeight: "50px", display: "flex", alignItems: "center", color: `${l.elementDetails.color}`, zIndex: "1" }}

                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: l.w,
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            id={l.id}
                            className="right_arrow"
                        >

                            <svg width="100%" style={l.elementDetails.rotate_deg && { transform: `rotate(${l.elementDetails.rotate_deg}deg)`, transformOrigin: "center" }} height="50" className="sebeke-giris-cizgi">
                                <defs>
                                    <marker id={`arrowhead${l.id}`} orient="auto" markerWidth="5" markerHeight="5" refX="5" refY="2.5">
                                        <path d="M 0,0 L 5,2.5 L 0,5 Z" fill={`${l.elementDetails.color}`} />
                                    </marker>
                                </defs>

                                <line
                                    x1="0"
                                    y1="25"
                                    x2="calc(100% - 10px)"
                                    y2="25"
                                    stroke={l.elementDetails.color}
                                    strokeWidth="8"
                                />

                                <line
                                    x1="0"
                                    y1="25"
                                    x2="100%"
                                    y2="25"
                                    stroke={l.elementDetails.color}
                                    strokeWidth="8"
                                    marker-end={`url(#arrowhead${l.id})`}
                                />
                            </svg>









                        </div>
                    )

                }
                // return (
                //   <div id='selam34' style={{ display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "rgb(170,170,170)", color: "wheat", fontSize: "35px" }} key={i} className={l.static ? 'static' : ''}>
                //     {l.static ? (
                //       <span className="text" title="This item is static and cannot be removed or resized.">
                //         Static - {i}
                //       </span>
                //     ) : (
                //       <span style={{ padding: "10%", display: "flex", alignItems: "center", justifyContent: "center", width: "90%", height: "90%" }} className="text"><div id='test1' style={{ width: "100%", fontSize: `${Number(l.w) * 15}px`, height: "100%", backgroundColor: "black", display: "flex", alignItems: "center", justifyContent: "center" }}>{i}</div></span>
                //     )}
                //   </div>
                // );
            });

        } else if (currentBreakpoint === "sm") {
            if (!layouts.sm || !Array.isArray(layouts.sm)) {
                return [];
            }
            return _.map(layouts.sm, function (l, i) {
                if (l.type === "text") {

                    return (
                        <div
                            style={{
                                zIndex: "1",
                                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px",
                                borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px",
                                borderColor: l.borderColor ? l.borderColor : "black",
                                backgroundColor: l.bgColor ? l.bgColor : "white",
                                color: l.fontColor ? l.fontColor : "black",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                textAlign: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center",
                                fontSize: l.fontSize ? l.fontSize : `${(Number(l.w)) / 10}px`,
                                overflowWrap: "break-word",
                                wordBreak: "break-word",
                                whiteSpace: "normal",
                            }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: l.w,
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}
                            className={"text_widget" + " " + (l.special_type ? "special_type" : "")}
                        >
                            {l.elementDetails.text !== "" ? (
                                <span
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {l.elementDetails.text}
                                </span>
                            ) : (
                                <span
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    Bu alanda henüz metin yok.
                                </span>
                            )}
                        </div>
                    );

                } else if (l.type === "Alarm") {

                    let value;
                    let stats = alarms_state;

                    console.warn(stats); let seviye_ = l.elementDetails.seviye;
                    if (seviye_ === "1") {
                        value = stats?.high || 0
                    } else if (seviye_ === "2") {
                        value = stats?.warning || 0
                    } else {
                        value = stats?.critical || 0
                    }

                    return (
                        <div



                            style={{
                                zIndex: "1", border: "2px solid black", borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px",
                                borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor || "transparent"
                            }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: l.w,
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            data-id={l.special_type ? "l.special_type" : ""}
                            key={l.i}
                            className="alarm_widget"
                        >
                            <div className="main_alarm_widget">

                                <div style={{ display: "flex", justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center" }} className="showAlarmValueW">{value}</div>
                            </div>


                        </div>
                    );

                } else if (l.type === "gauge_linear") {

                    // tip kontrolü ile uygun tag değerini bul
                    let selectedTag;
                    if (l.elementDetails.tip === "Var") {
                        selectedTag = tag_values_state.find(
                            (item) => item.tip === "Var" && item.tagId === l.elementDetails.tagId
                        );
                    } else {
                        selectedTag = tag_values_state.find((item) => item.tagId === l.elementDetails.tagId);
                        // Sayısal değeri güvenli şekilde al
                        let value_tag = selectedTag ? selectedTag.tagValue : "";
                        console.warn("value_tag", value_tag)
                        const numericValue = parseFloat(value_tag);
                        console.warn(numericValue, "numericValue")
                        const isNumeric = !isNaN(numericValue);

                        // Eğer isNumeric false ise boşluktan sonrasını kes
                        value_tag = isNumeric ? value_tag : value_tag.split(' ')[0];

                        // startValue ve endValue güvenli şekilde belirle
                        const startValue =
                            l.elementDetails.startValue && isNumeric && l.elementDetails.startValue <= numericValue
                                ? l.elementDetails.startValue
                                : 0;

                        const endValue =
                            l.elementDetails.endValue && isNumeric && l.elementDetails.endValue >= numericValue
                                ? l.elementDetails.endValue
                                : isNumeric
                                    ? numericValue.toFixed(2)
                                    : 100;
                        // normalizedValue hesapla
                        const normalizedValue = isNumeric
                            ? ((value_tag - startValue) / (endValue - startValue)) * 100
                            : 0;



                        const linearOptions = {
                            pointer: {
                                value: isNumeric ? numericValue : 50, // Sayıysa kullan, değilse 50
                                shape: "arrow",
                                size: 20,
                                color: "rgb(20,20,20)"// Pointer büyüklüğü artırıldı
                            },
                            scale: {
                                min: startValue,
                                max: endValue,
                                majorUnit: (endValue - startValue) / 5,
                                minorUnit: 2,
                                line: {
                                    width: 5, // Ölçek çizgisi kalınlaştırıldı
                                    color: "black"
                                },
                                labels: {
                                    color: "black",
                                    visible: true,
                                    font: "14px Arial, sans-serif", // Yazı fontu büyütüldü
                                },
                                ranges: [
                                    { from: startValue, to: l.elementDetails.alarmValue ? l.elementDetails.alarmValue : (endValue - startValue) / 2, color: "red" },
                                    { from: l.elementDetails.alarmValue ? l.elementDetails.alarmValue : (endValue - startValue) / 2, to: endValue, color: "blue" },
                                ],
                            },
                        };

                        const alarmValue = l.elementDetails.alarmValue || 0


                        return (
                            <div
                                className="gauge_widgetParentDiv"
                                data-grid={{
                                    x: l.x,
                                    y: l.y,
                                    w: l.w,
                                    h: l.h,
                                    resizeHandles: l.resizeHandles,
                                }}


                                style={{
                                    border: "none",
                                    borderWidth: l.borderWidth ? `${l.borderWidth}px` : "2px",
                                    backgroundColor: "transparent",
                                    borderRadius: l.elementDetails.borderRadius ? `${l.elementDetails.borderRadius}px` : "8px",

                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    borderColor: l.borderColor ? l.borderColor : "rgb(100,100,100)",
                                    overflow: "hidden",
                                }}
                                key={l.i}
                                id={l.id}
                                data-id={l.special_type ? "l.special_type" : ""}

                                onContextMenu={(e) => {
                                    if (l.elementDetails.tagId && l.add_trend && l.add_trend === "YES") {
                                        var tagName = tags
                                            .filter((b) => b.tagId === l.elementDetails.tagId)
                                            .map((c) => c.tagName)[0];

                                        e.preventDefault();
                                        const { clientX, clientY } = e;
                                        let screen_width = window.innerWidth;
                                        console.log(clientX, clientY);
                                        document
                                            .querySelector(".show_external_trend")
                                            .classList.toggle(
                                                "show_external_trend_active"
                                            );
                                        document.querySelector(
                                            ".show_tagId"
                                        ).innerHTML = l.elementDetails.tagId;
                                        document.querySelector(
                                            ".show_tagName"
                                        ).innerHTML = tagName;
                                        var popup = document.querySelector(
                                            ".show_external_trend"
                                        );
                                        const popupRect =
                                            popup.getBoundingClientRect();
                                        const viewportWidth = window.innerWidth;
                                        const viewportHeight = window.innerHeight;

                                        // Calculate the new positions
                                        let newX = clientX;
                                        let newY = clientY;

                                        // Adjust if the popup would overflow the right edge of the viewport
                                        if (
                                            newX + popupRect.width >
                                            viewportWidth
                                        ) {
                                            newX = viewportWidth - popupRect.width;
                                        }

                                        // Adjust if the popup would overflow the bottom edge of the viewport
                                        if (
                                            newY + popupRect.height >
                                            viewportHeight
                                        ) {
                                            newY =
                                                viewportHeight - popupRect.height;
                                        }

                                        // Adjust if the popup would overflow the left edge of the viewport
                                        if (newX < 0) {
                                            newX = 0;
                                        }

                                        // Adjust if the popup would overflow the top edge of the viewport
                                        if (newY < 0) {
                                            newY = 0;
                                        }

                                        if (
                                            screen_width < 2301 &&
                                            screen_width > 1800
                                        ) {
                                            document.querySelector(
                                                ".show_external_trend"
                                            ).style.left = `${String(
                                                newX / 1.2
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_trend"
                                            ).style.top = `${String(newY / 1.2)}px`;
                                        } else if (
                                            screen_width < 2801 &&
                                            screen_width > 2300
                                        ) {
                                            document.querySelector(
                                                ".show_external_trend"
                                            ).style.left = `${String(
                                                newX / 1.5
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_trend"
                                            ).style.top = `${String(newY / 1.5)}px`;
                                        } else if (
                                            screen_width < 3501 &&
                                            screen_width > 2800
                                        ) {
                                            document.querySelector(
                                                ".show_external_trend"
                                            ).style.left = `${String(
                                                newX / 1.8
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_trend"
                                            ).style.top = `${String(newY / 1.8)}px`;
                                        } else if (
                                            screen_width < 5001 &&
                                            screen_width > 3500
                                        ) {
                                            document.querySelector(
                                                ".show_external_trend"
                                            ).style.left = `${String(
                                                newX / 2.5
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_trend"
                                            ).style.top = `${String(newY / 2.5)}px`;
                                        } else if (screen_width <= 1800) {
                                            document.querySelector(
                                                ".show_external_trend"
                                            ).style.left = `${String(newX)}px`;
                                            document.querySelector(
                                                ".show_external_trend"
                                            ).style.top = `${String(newY)}px`;
                                        }
                                    } else if (l.elementDetails.tagId && l.elementDetails.tagId !== "") {
                                        var tagName = tags
                                            .filter((b) => b.tagId === l.elementDetails.tagId)
                                            .map((c) => c.tagName)[0];

                                        e.preventDefault();
                                        const { clientX, clientY } = e;
                                        let screen_width = window.innerWidth;
                                        console.log(clientX, clientY);
                                        document
                                            .querySelector(".show_external_detail")
                                            .classList.toggle(
                                                "show_external_detail_active"
                                            );
                                        document.querySelector(
                                            ".show_tagId2"
                                        ).innerHTML = l.elementDetails.tagId;
                                        document.querySelector(
                                            ".show_tagName2"
                                        ).innerHTML = tagName;
                                        var popup = document.querySelector(
                                            ".show_external_detail"
                                        );
                                        const popupRect =
                                            popup.getBoundingClientRect();
                                        const viewportWidth = window.innerWidth;
                                        const viewportHeight = window.innerHeight;

                                        // Calculate the new positions
                                        let newX = clientX;
                                        let newY = clientY;

                                        // Adjust if the popup would overflow the right edge of the viewport
                                        if (
                                            newX + popupRect.width >
                                            viewportWidth
                                        ) {
                                            newX = viewportWidth - popupRect.width;
                                        }

                                        // Adjust if the popup would overflow the bottom edge of the viewport
                                        if (
                                            newY + popupRect.height >
                                            viewportHeight
                                        ) {
                                            newY =
                                                viewportHeight - popupRect.height;
                                        }

                                        // Adjust if the popup would overflow the left edge of the viewport
                                        if (newX < 0) {
                                            newX = 0;
                                        }

                                        // Adjust if the popup would overflow the top edge of the viewport
                                        if (newY < 0) {
                                            newY = 0;
                                        }

                                        if (
                                            screen_width < 2301 &&
                                            screen_width > 1800
                                        ) {
                                            document.querySelector(
                                                ".show_external_detail"
                                            ).style.left = `${String(
                                                newX / 1.2
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_detail"
                                            ).style.top = `${String(newY / 1.2)}px`;
                                        } else if (
                                            screen_width < 2801 &&
                                            screen_width > 2300
                                        ) {
                                            document.querySelector(
                                                ".show_external_detail"
                                            ).style.left = `${String(
                                                newX / 1.5
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_detail"
                                            ).style.top = `${String(newY / 1.5)}px`;
                                        } else if (
                                            screen_width < 3501 &&
                                            screen_width > 2800
                                        ) {
                                            document.querySelector(
                                                ".show_external_detail"
                                            ).style.left = `${String(
                                                newX / 1.8
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_detail"
                                            ).style.top = `${String(newY / 1.8)}px`;
                                        } else if (
                                            screen_width < 5001 &&
                                            screen_width > 3500
                                        ) {
                                            document.querySelector(
                                                ".show_external_detail"
                                            ).style.left = `${String(
                                                newX / 2.5
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_detail"
                                            ).style.top = `${String(newY / 2.5)}px`;
                                        } else if (screen_width <= 1800) {
                                            document.querySelector(
                                                ".show_external_detail"
                                            ).style.left = `${String(newX)}px`;
                                            document.querySelector(
                                                ".show_external_detail"
                                            ).style.top = `${String(newY)}px`;
                                        }
                                    }
                                }}
                            >
                                <div className="su_tanki_gauge_linear" style={{ borderColor: l.borderColor || "#000" }}>
                                    <div style={{ position: "relative", height: "100%", width: "100%", display: "flex", flexDirection: "column-reverse" }}>
                                        <div style={{ width: "100%", height: alarmValue >= numericValue ? "0%" : numericValue * 100 / endValue + "%", backgroundColor: "blue" }} className="water"></div>
                                        <div style={{ width: "100%", height: alarmValue >= numericValue ? numericValue * 100 / endValue + "%" : "0%", backgroundColor: "red" }} className="alarmWater"></div>

                                        <div
                                            style={{
                                                position: "absolute",
                                                top: "50%",
                                                left: "50%",
                                                transform: "translate(-50%, -50%)", // Bu, öğeyi tam olarak ortalar
                                                backgroundColor: "black", // Hafif şeffaf beyaz arka plan
                                                padding: "4px 8px",
                                                borderRadius: "6px",
                                                fontSize: "16px",
                                                fontWeight: "bold",
                                                zIndex: "3",
                                                color: "#ffffff", // Daha koyu siyah
                                                fontFamily: "'Poppins', sans-serif", // Daha modern ve seksi font
                                                boxShadow: "2px 2px 6px rgba(0, 0, 0, 0.15)", // Hafif gölge efekti
                                            }}
                                        >
                                            {isNumeric ? l.elementDetails.pU && l.elementDetails.pU === "Percent" ? (numericValue * 100 / endValue).toFixed(2) + "%" : numericValue : 50}
                                        </div>
                                    </div>
                                </div>



                            </div>
                        );
                    }
                }
                else if (l.type === "lock") {
                    let value_ = tag_values_state.find(i =>
                        l.elementDetails.tip !== "Var"
                            ? String(i.tagId) === String(l.elementDetails.tagId)
                            : i.tip === "Var" && String(i.tagId) === String(l.elementDetails.tagId)
                    )?.tagValue;
                    if (value_ && isNaN(Number(value_))) {
                        value_ = value_.split(' ')[0]; // ilk boşluktan önceki kısmı al
                        value_ = value_.includes(" ") ? value_.trim() : value_
                    }
                    return (
                        <div


                            onClick={(e) => {
                                let tagValue;
                                (layouts[currentBreakpoint] || []).forEach(x => {
                                    if (String(x.id) === String(l.id)) {
                                        let tagId_ = l.elementDetails.tagId || "";

                                        tagValue = value_ === "1" ? "0" : "1";
                                        setValueFunc({ TagId: tagId_, TagValue: tagValue })
                                        document.querySelectorAll(".react-grid-item").forEach((item) => {
                                            if (item.classList.contains(`${l.elementDetails.tagIdEx}`)) {
                                                item.style.pointerEvents = tagValue === "1" ? "none" : "all";
                                                if (e.target.classList.contains("fa-lock")) {
                                                    item.style.opacity = "1"
                                                } else if (e.target.classList.contains("fa-unlock")) {
                                                    item.style.opacity = "0.55"
                                                }
                                            }
                                        })
                                        if (e.target.classList.contains("fa-lock")) {
                                            e.target.classList.replace("fa-lock", "fa-unlock");
                                        } else if (e.target.classList.contains("fa-unlock")) {
                                            e.target.classList.replace("fa-unlock", "fa-lock");
                                        }
                                    }
                                })
                            }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            data-id={l.special_type ? "l.special_type" : ""}
                            key={l.i}
                            className={`lock_widget`}
                        >
                            <i id="lock_i_dyn" style={{ color: l.fontColor || "gray", width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: `${l.w / 4}px` }} className={value_ === "0" ? "fa fa-lock" : "fa fa-unlock"}></i>



                        </div>
                    );
                } else if (l.type === "i_g") {
                    return (
                        <div

                            onClick={() => {
                                pages.forEach(async x => {
                                    if (Number(x.pageId) === Number(l.elementDetails.pageId)) {
                                        function normalizeURLPath(path) {
                                            const turkishMap = {
                                                'İ': 'I', 'ı': 'i', 'Ş': 'S', 'ş': 's',
                                                'Ğ': 'G', 'ğ': 'g', 'Ü': 'U', 'ü': 'u',
                                                'Ö': 'O', 'ö': 'o', 'Ç': 'C', 'ç': 'c'
                                            };

                                            return path.split('').map(char => turkishMap[char] || char).join('');
                                        }
                                        await Store.dispatch(set_current_dyn_pageName(x.pageName))
                                        history.push(`/pages/${normalizeURLPath(x.pageName).replaceAll(" ", "_")}`)

                                    }
                                })
                            }}

                            style={{
                                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px",
                                border: "2px solid rgb(60,60,60)", borderColor: l.borderColor ? l.borderColor : "black", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black",
                                borderRadius: "4px", zIndex: "1", cursor: "pointer"
                            }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            data-id={l.special_type ? "l.special_type" : ""}
                            key={l.i}
                            className="i_g_widget"
                        >

                            <div style={{ backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black", width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                                {l.elementDetails.text}

                            </div>

                        </div>
                    );
                } else if (l.type === "y_g") {

                    let value_ = tag_values_state.find(i =>
                        l.elementDetails.tip !== "Var"
                            ? String(i.tagId) === String(l.elementDetails.tagId)
                            : i.tip === "Var" && String(i.tagId) === String(l.elementDetails.tagId)
                    )?.tagValue;

                    // Eğer value_ sayısal değilse, boşluktan sonrasını sil
                    if (value_ && isNaN(Number(value_))) {
                        value_ = value_.split(' ')[0];

                    }
                    console.warn("value_", value_, typeof (value_));

                    value_ = value_ && value_.split('.')[0]; // Noktadan sonrasını almaz

                    console.warn("value_", value_, typeof (value_));

                    // 2. value_list oluştur (value1, value2, value3... varsa onları al)
                    let valueList = [];
                    let i = 1;
                    while (l.elementDetails[`value${i}`] !== undefined) {
                        valueList.push(l.elementDetails[`value${i}`]);
                        i++;
                    }


                    // 2. `value_.elementDetailslist` İçinde `valelementDetails.ue_` İndeksini Bul
                    let index_ = l.elementDetails.value_list && l.elementDetails.value_list.indexOf(
                        value_ !== undefined && value_.includes(" ") ? value_.trim() : value_
                    );

                    // 3. Varsayılan Atama
                    if (index_ === -1 || index_ === undefined) { // `indexOf` bulunamazsa -1 döner
                        index_ = 0;
                    }

                    return (
                        <div

                            onContextMenu={(e) => {
                                if (l.elementDetails.tagId && l.add_trend && l.add_trend === "YES") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_trend")
                                        .classList.toggle(
                                            "show_external_trend_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_trend"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                } else if (l.elementDetails.tagId && l.elementDetails.tagId !== "") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_detail")
                                        .classList.toggle(
                                            "show_external_detail_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId2"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName2"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_detail"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                }
                            }}
                            style={{
                                border: "2px solid rgb(60,60,60)",

                                width: l.elementDetails.rad ? l.elementDetails.rad + "px" : "10px", height: l.elementDetails.rad ? l.elementDetails.rad + "px" : "10px", borderRadius: l.elementDetails.rad ? (l.elementDetails.tur ? l.elementDetails.tur === "circle" ? l.elementDetails.rad + "px" : l.elementDetails.borderRadius + "px" : "10px") : "10px", zIndex: "1", borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px",
                                backgroundColor: l.elementDetails.bg_list && l.elementDetails.bg_list[index_] ? l.elementDetails.bg_list[index_] : "white", borderColor: l.elementDetails.border_list && l.elementDetails.border_list[index_] ? l.elementDetails.border_list[index_] : "black"
                            }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: l.elementDetails.rad ? l.elementDetails.rad : l.w,
                                h: l.elementDetails.rad ? l.elementDetails.rad : l.w,
                            }}
                            id={l.id}
                            data-id={l.special_type ? "l.special_type" : ""}
                            key={l.i}
                            className="yuvarlak_gosterge_widget"
                        >


                        </div>
                    );
                }
                else if (l.type === "go_page") {
                    return (
                        <div

                            onClick={() => {
                                if (l.elementDetails.text === "Alarm" && alarm_okuma) {
                                    history.push("/AlarmPanel")
                                } else {
                                    pages.forEach(async x => {
                                        if (Number(x.pageId) === Number(l.elementDetails.pageId)) {
                                            console.warn(l)

                                            function normalizeURLPath(path) {
                                                const turkishMap = {
                                                    'İ': 'I', 'ı': 'i', 'Ş': 'S', 'ş': 's',
                                                    'Ğ': 'G', 'ğ': 'g', 'Ü': 'U', 'ü': 'u',
                                                    'Ö': 'O', 'ö': 'o', 'Ç': 'C', 'ç': 'c'
                                                };

                                                return path.split('').map(char => turkishMap[char] || char).join('');
                                            }
                                            await Store.dispatch(set_current_dyn_pageName(x.pageName))
                                            history.push(`/pages/${normalizeURLPath(x.pageName).replaceAll(" ", "_")}`)

                                        }
                                    })
                                }
                            }
                            }

                            style={{
                                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px",
                                border: "2px solid rgb(60,60,60)", borderColor: l.borderColor ? l.borderColor : "black", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black",
                                borderRadius: "4px", zIndex: "1", cursor: "pointer"
                            }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            data-id={l.special_type ? "l.special_type" : ""}
                            key={l.i}
                            className="go_page_widget"
                        >

                            <div style={{ backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black", width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                                {l.elementDetails.text}

                            </div>

                        </div>
                    );
                }
                else if (l.type === "set") {

                    // 1. `value_` Değerini Bul
                    let value_ = tag_values_state.find(i =>
                        l.elementDetails.tip !== "Var"
                            ? String(i.tagId) === String(l.elementDetails.tagId)
                            : i.tip === "Var" && String(i.tagId) === String(l.elementDetails.tagId)
                    )?.tagValue;

                    // Eğer value_ sayısal değilse, boşluktan sonrasını sil
                    if (value_ && isNaN(Number(value_))) {
                        value_ = value_.split(' ')[0]; // ilk boşluktan önceki kısmı al
                    }

                    // 2. `value_list` İçinde `value_` İndeksini Bul
                    let index_ = l.elementDetails.value_list && l.elementDetails.value_list.indexOf(
                        value_ !== undefined && value_.includes(" ") ? value_.trim() : value_
                    );


                    // 3. Varsayılan Atama
                    if (index_ === -1 || index_ === undefined) { // `indexOf` bulunamazsa -1 döner
                        index_ = 0;
                    }


                    console.warn(value_, l, tag_values_state)

                    return (
                        <div
                            onContextMenu={(e) => {
                                if (l.elementDetails.tagId && l.add_trend && l.add_trend === "YES") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_trend")
                                        .classList.toggle(
                                            "show_external_trend_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_trend"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                } else if (l.elementDetails.tagId && l.elementDetails.tagId !== "") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_detail")
                                        .classList.toggle(
                                            "show_external_detail_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId2"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName2"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_detail"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                }
                            }}

                            onClick={(e) => {
                                if (l.elementDetails.tagId2 && l.elementDetails.tagId2 !== "" && l.elementDetails.tagId2 !== "None" && yazma_control) {
                                    console.log(e.target);
                                    e.preventDefault();
                                    e.stopPropagation();
                                    const { clientX, clientY } = e;
                                    document.querySelector(".Popup-selectbox2").classList.toggle("changeProperties_active")
                                    document.querySelector(".Popup-selectbox2").id = l.id

                                    var popup = document.querySelector(".Popup-selectbox2")
                                    const popupRect = popup.getBoundingClientRect();

                                    // Yeni pozisyonları hesapla
                                    let newX = clientX + window.scrollX;
                                    let newY = clientY + window.scrollY;

                                    console.log(newX, newY);

                                    // Sağ kenardan taşmayı önle
                                    if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                                        newX = window.innerWidth + window.scrollX - popupRect.width;
                                    }

                                    // Alt kenardan taşmayı önle
                                    if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                                        newY = window.innerHeight + window.scrollY - popupRect.height;
                                    }

                                    // Sol kenardan taşmayı önle
                                    if (newX < window.scrollX) {
                                        newX = window.scrollX;
                                    }

                                    // Üst kenardan taşmayı önle
                                    if (newY < window.scrollY) {
                                        newY = window.scrollY;
                                    }

                                    console.log(newX, newY);

                                    // Pop-up'ın pozisyonunu ayarla
                                    popup.style.left = `${newX}px`;
                                    popup.style.top = `${newY}px`;

                                    const parentElement = e.target.closest(".set_widget");
                                    const parentRect = parentElement.getBoundingClientRect();

                                    Set_elem_popup({
                                        width: l.w,
                                        height: l.h,
                                        left: l.x,
                                        top: l.y,

                                        value_list: l.elementDetails.value_list && l.elementDetails.value_list.length === 0 ? l.value_list : l.elementDetails.value_list,
                                        bg_list: l.elementDetails.bg_list && l.elementDetails.bg_list.length === 0 ? l.bg_list : l.elementDetails.bg_list,
                                        border_list: l.elementDetails.border_list && l.elementDetails.border_list.length === 0 ? l.border_list : l.elementDetails.border_list,
                                        font_list: l.elementDetails.font_list && l.elementDetails.font_list.length === 0 ? l.font_list : l.elementDetails.font_list,
                                        type: l.type,
                                        id: l.id,
                                        fontSize: l.fontSize ? l.fontSize : Number(l.w) / 10,
                                        value: l.elementDetails.text
                                    })
                                    setSelectedOptionselectbox(l.elementDetails.text)
                                }

                            }}
                            style={{
                                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px",
                                borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", backgroundColor: "white", border: "2px solid rgb(60,60,60)", borderColor: l.borderColor ? l.borderColor : "black", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black",
                                zIndex: "1",
                            }}

                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            data-id={l.special_type ? "l.special_type" : ""}
                            key={l.i}
                            className={`set_widget ${l.elementDetails.text} ${l.elementDetails.tagId}` + " " + (l.special_type ? "special_type" : "")}
                        >
                            <div style={{ backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black", width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                                {Number(value_).toLocaleString("tr-TR", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                }) || l.elementDetails.text}

                            </div>

                        </div>
                    );
                }
                else if (l.type === "selectbox") {

                    let value_ = tag_values_state.find(i =>
                        l.elementDetails.tip !== "Var"
                            ? String(i.tagId) === String(l.elementDetails.tagId)
                            : i.tip === "Var" && String(i.tagId) === String(l.elementDetails.tagId)
                    )?.tagValue;

                    // Eğer value_ sayısal değilse, boşluktan sonrasını sil
                    if (value_ && isNaN(Number(value_))) {
                        value_ = value_.split(' ')[0];

                    }
                    console.warn("value_", value_, typeof (value_));

                    value_ = value_ && value_.split('.')[0]; // Noktadan sonrasını almaz

                    console.warn("value_", value_, typeof (value_), l);

                    // 2. value_list oluştur (value1, value2, value3... varsa onları al)
                    let valueList = [];
                    let i = 1;
                    while (l.elementDetails[`value${i}`] !== undefined) {
                        valueList.push(l.elementDetails[`value${i}`]);
                        i++;
                    }


                    // 2. `value_list` İçinde `value_` İndeksini Bul
                    let index_ = l.elementDetails.value_list && l.elementDetails.value_list.indexOf(
                        value_ !== undefined && typeof value_ === "string" && value_.includes(" ")
                            ? value_.trim()
                            : value_
                    );

                    // 3. Varsayılan Atama
                    if (index_ === -1 || index_ === undefined) {
                        index_ = 0;
                    }

                    console.warn(value_, l, tag_values_state)
                    let text_list_ = l.elementDetails.text_list;
                    let alarmClassName = "";

                    if (text_list_ && text_list_.length > 0 && text_list_[index_] === "ALARM" && l.special_type) {
                        alarmClassName = "alarmactive_blackBorder";
                        (layouts[currentBreakpoint] || []).forEach((item) => {
                            if (item.id === l.id2 && !item.special_type) {
                                let id = item.id
                                document.querySelector(`#Popup${id}`).style.backgroundColor = "red"
                            }
                        });

                    }




                    return (
                        <div
                            onContextMenu={(e) => {
                                if (l.elementDetails.tagId && l.add_trend && l.add_trend === "YES") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_trend")
                                        .classList.toggle(
                                            "show_external_trend_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_trend"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                } else if (l.elementDetails.tagId && l.elementDetails.tagId !== "") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_detail")
                                        .classList.toggle(
                                            "show_external_detail_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId2"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName2"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_detail"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                }
                            }}
                            onClick={(e) => {
                                if (l.elementDetails.tagId2 && l.elementDetails.tagId2 !== "" && l.elementDetails.tagId2 !== "None" && yazma_control) {
                                    console.log(e.target);
                                    e.preventDefault();
                                    e.stopPropagation();
                                    const { clientX, clientY } = e;
                                    document.querySelector(".Popup-selectbox").classList.toggle("changeProperties_active")
                                    document.querySelector(".Popup-selectbox").id = l.id

                                    var popup = document.querySelector(".Popup-selectbox")
                                    const popupRect = popup.getBoundingClientRect();

                                    // Yeni pozisyonları hesapla
                                    let newX = clientX + window.scrollX;
                                    let newY = clientY + window.scrollY;

                                    console.log(newX, newY);

                                    // Sağ kenardan taşmayı önle
                                    if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                                        newX = window.innerWidth + window.scrollX - popupRect.width;
                                    }

                                    // Alt kenardan taşmayı önle
                                    if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                                        newY = window.innerHeight + window.scrollY - popupRect.height;
                                    }

                                    // Sol kenardan taşmayı önle
                                    if (newX < window.scrollX) {
                                        newX = window.scrollX;
                                    }

                                    // Üst kenardan taşmayı önle
                                    if (newY < window.scrollY) {
                                        newY = window.scrollY;
                                    }

                                    console.log(newX, newY);

                                    // Pop-up'ın pozisyonunu ayarla
                                    popup.style.left = `${newX}px`;
                                    popup.style.top = `${newY}px`;

                                    const parentElement = e.target.closest(".selectbox_widget");
                                    const parentRect = parentElement.getBoundingClientRect();

                                    Set_elem_popup({
                                        width: l.w,
                                        height: l.h,
                                        left: l.x,
                                        top: l.y,
                                        text_list: l.elementDetails.text_list.length === 0 ? l.text_list : l.elementDetails.text_list,
                                        value_list: l.elementDetails.value_list && l.elementDetails.value_list.length === 0 ? l.value_list : l.elementDetails.value_list,
                                        bg_list: l.elementDetails.bg_list && l.elementDetails.bg_list.length === 0 ? l.bg_list : l.elementDetails.bg_list,
                                        border_list: l.elementDetails.border_list && l.elementDetails.border_list.length === 0 ? l.border_list : l.elementDetails.border_list,
                                        font_list: l.elementDetails.font_list && l.elementDetails.font_list.length === 0 ? l.font_list : l.elementDetails.font_list,
                                        type: l.type,
                                        id: l.id,
                                        fontSize: l.fontSize ? l.fontSize : Number(l.w) / 10,
                                        value: l.elementDetails.text
                                    })
                                    setSelectedOptionselectbox(l.elementDetails.text)
                                }

                            }}
                            style={{
                                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px",
                                backgroundColor: "white", border: "2px solid rgb(60,60,60)", borderColor: l.elementDetails.border_list && l.elementDetails.border_list[index_] ? l.elementDetails.border_list[index_] : "black", backgroundColor: l.elementDetails.bg_list && l.elementDetails.bg_list[index_] ? l.elementDetails.bg_list[index_] : "white", color: l.elementDetails.font_list && l.elementDetails.font_list[index_] ? l.elementDetails.font_list[index_] : "black", zIndex: "1",
                            }}

                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            className={`selectbox_widget ${l.elementDetails.text}` + " " + (l.special_type ? ("special_type_ " + alarmClassName) : "")}
                        >
                            <div style={{ backgroundColor: "transparent", color: l.elementDetails.font_list && l.elementDetails.font_list[index_] ? l.elementDetails.font_list[index_] : "black", width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                                {l.elementDetails.text_list[index_]}

                            </div>

                        </div>
                    );
                }
                else if (l.type === "senaryoSelect") {
                    return (
                        <div


                            style={{
                                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px",
                                backgroundColor: "white", border: "2px solid rgb(60,60,60)", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black", borderRadius: "8px", zIndex: "1",
                            }}

                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            className={`senaryo_widget ${l.elementDetails.text}`}
                        >
                            <div style={{ backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black", width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                                {l.elementDetails.text}

                            </div>

                        </div>
                    );
                }
                else if (l.type === "trend") {
                    let data_ = {
                        labels: [],
                        datasets: [{
                            data: [],
                            backgroundColor: "transparent",
                            borderColor: "#f26c6d",
                            pointBorderColor: "#f26c6d",
                            pointBorderWidth: 1
                        }]

                    }
                    if (l.elementDetails.data) {
                        data_ = {
                            labels: (l.elementDetails.data || []).map((item, index) => {
                                return item.date

                            }),
                            datasets: [{
                                data: (l.elementDetails.data || []).map((item, index) => {
                                    return item.value
                                }),
                                backgroundColor: "transparent",
                                borderColor: "#f26c6d",
                                pointBorderColor: "#f26c6d",
                                pointBorderWidth: 1
                            }]

                        }
                    }

                    const datason = data_

                    const optionsSon = {
                        scales: {
                            x: {
                                type: 'time',
                                time: {
                                    unit: 'day',
                                    stepSize: 1,
                                    displayFormats: {
                                        day: 'MMM D'
                                    }
                                },
                                ticks: {
                                    maxTicksLimit: 24
                                }
                            },
                            y: {
                                min: Number(min),
                                max: 0,
                                beginAtZero: true,
                                ticks: {
                                    callback: function (value) {
                                        return Number(value.toFixed(2)); // Etiketlerdeki sıfırları engelle
                                    }
                                }
                            }
                        },
                        plugins: {
                            legend: {
                                display: true,
                                labels: {
                                    filter: function (item, chart) {
                                        return item.text !== undefined;
                                    },
                                    generateLabels: function (chart) {
                                        return [{
                                            text: "",
                                            fillStyle: "crimson",
                                            strokeStyle: chart.ctx.strokeStyle,
                                            lineWidth: chart.ctx.lineWidth,
                                            hidden: false,
                                            index: 0,
                                            datasetIndex: 0
                                        }];
                                    }
                                }
                            },
                            zoom: {
                                pan: {
                                    enabled: true,
                                    mode: 'xy',
                                },
                                zoom: {
                                    wheel: {
                                        enabled: true,
                                    },
                                    pinch: {
                                        enabled: true,
                                    },
                                    mode: 'x',
                                    onZoom: ({ chart }) => {
                                        const xScale = chart.scales.x;
                                        const min = xScale.min;
                                        const max = xScale.max;
                                        const diff = max - min;
                                        let unit = 'second';

                                        // Zoom leveline göre birim seçimi
                                        if (diff > 1000 * 60 * 60 * 24 * 7) {
                                            unit = 'day';
                                        } else if (diff > 1000 * 60 * 60) {
                                            unit = 'hour';
                                        } else if (diff > 1000 * 60) {
                                            unit = 'minute';
                                        }

                                        // Yeniden ayarlama
                                        xScale.options.time.unit = unit;
                                        xScale.options.time.tooltipFormat = unit === 'second' ? 'll HH:mm:ss' : 'll HH:mm';
                                        xScale.options.ticks.callback = (value) => {
                                            return moment(value).format(unit === 'second' ? 'll HH:mm:ss' : 'll HH:mm');
                                        };

                                        chart.update();
                                    },
                                },
                            },
                        },
                    };

                    return (
                        <div


                            style={{ zIndex: "1", marginTop: "-8px" }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            className="trend_widget"
                        >

                            <div style={{ width: "100%", height: "100%" }} className="bottom_sec trend_graph">
                                <Line options={JSON.stringify(real_datas) !== "{}" ? real_datas[String(l.id)] ? createChartOptions(String(l.id)) : optionsSon : optionsSon} data={JSON.stringify(real_datas) !== "{}" ? real_datas[String(l.id)] ? createChartData(String(l.id)) : datason : datason} />
                            </div>
                        </div>
                    )
                }
                else if (l.type === "empty_btn") {
                    return (
                        <div


                            style={{
                                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px",
                                backgroundColor: "white", border: "2px solid rgb(60,60,60)", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black", borderRadius: "8px", zIndex: "1",
                            }}

                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            className={`empty_btn_widget ${l.elementDetails.text}`}
                        >
                            <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                                <input disabled={true} style={{ backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black", backgroundColor: "transparent", width: "100%", outline: "none", appearance: "none", border: "none", textAlign: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w)) / 10}px` }} type="text" value={l.elementDetails.text} />


                            </div>

                        </div>
                    );
                }
                else if (l.type === "t_t") {

                    return (
                        <div

                            onContextMenu={(e) => {
                                if (l.elementDetails.tagId && l.add_trend && l.add_trend === "YES") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_trend")
                                        .classList.toggle(
                                            "show_external_trend_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_trend"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                } else if (l.elementDetails.tagId && l.elementDetails.tagId !== "") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_detail")
                                        .classList.toggle(
                                            "show_external_detail_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId2"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName2"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_detail"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                }
                            }}

                            style={{
                                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px",
                                zIndex: "1", borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", borderColor: l.borderColor ? l.borderColor : "black", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black",
                            }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: l.w,
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            data-id={l.special_type ? "l.special_type" : ""}
                            key={l.i}
                            className="text_tag_widget"
                        >

                            <input
                                type="text"
                                style={{
                                    width: "100%", textAlign: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w)) / 10}px`, position: "relative", backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black"
                                }}
                                disabled={true}

                                value={
                                    (l.elementDetails.text !== "" ? l.elementDetails.text : " ") +
                                    " : " +
                                    (
                                        l.elementDetails.tagId !== ""
                                            ? (() => {
                                                const matchedItem = tag_values_state.find(item =>
                                                    l.elementDetails.tip !== "Var"
                                                        ? item.tagId === l.elementDetails.tagId
                                                        : item.tip === "Var" && item.tagId === l.elementDetails.tagId
                                                );

                                                const tagValue = matchedItem?.tagValue;
                                                const formatted = tagValue != null
                                                    ? Number(tagValue).toLocaleString("tr-TR", {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2,
                                                    })
                                                    : "";

                                                return (
                                                    formatted +
                                                    (l.elementDetails.unit && l.elementDetails.unit !== "None"
                                                        ? " " + l.elementDetails.unit
                                                        : "")
                                                );
                                            })()
                                            : " "
                                    )

                                }


                            />
                            )
                        </div>
                    );
                }

                else if (l.type === "tag") {
                    const matchingTag = tag_values_state.find(item =>
                        l.elementDetails.tip !== "Var"
                            ? item.tagId === l.elementDetails.tagId
                            : item.tip === "Var" && item.tagId === l.elementDetails.tagId
                    );

                    const decimalPlaces = matchingTag && matchingTag.tagDecimal !== null ? Number(matchingTag.tagDecimal) : 2;
                    let formattedValue = "";

                    if (matchingTag) {
                        let value_tag = matchingTag.tagValue;
                        if (value_tag && isNaN(Number(value_tag))) {
                            value_tag = value_tag.split(" ")[0];
                        }

                        console.log(value_tag, 1)

                        if (value_tag && !isNaN(Number(value_tag))) {
                            let numericValue = Number(value_tag);

                            // Eğer birimi kW/h ise 1000'e böl
                            if (l.elementDetails.unit === "kW/h") {
                                numericValue = numericValue / 1000;
                            }

                            console.log(numericValue, 2)

                            formattedValue = numericValue.toLocaleString("tr-TR", {
                                minimumFractionDigits: decimalPlaces,
                                maximumFractionDigits: decimalPlaces,
                            }) + (l.elementDetails.unit && l.elementDetails.unit !== "None" ? " " + l.elementDetails.unit : "");
                        }
                    }




                    return (
                        <div

                            onContextMenu={(e) => {
                                if (l.elementDetails.tagId && l.add_trend && l.add_trend === "YES") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_trend")
                                        .classList.toggle(
                                            "show_external_trend_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_trend"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                } else if (l.elementDetails.tagId && l.elementDetails.tagId !== "") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_detail")
                                        .classList.toggle(
                                            "show_external_detail_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId2"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName2"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_detail"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                }
                            }}

                            style={{ borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", zIndex: "1", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black", }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            className={"tag_widget" + " " + (l.special_type ? "special_type" : "")}
                        >



                            <input
                                id={l.id + "cc"}
                                type="text"
                                disabled={true}
                                style={{
                                    backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black",
                                    fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, textAlign: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center",
                                    width: "100%", backgroundColor: "transparent", outline: "none", border: "none",

                                }}
                                value={
                                    l.elementDetails.tagId !== ""
                                        ? (() => {
                                            const source = tag_values_state.length > 0 ? tag_values_state : tag_values_state;

                                            const matchedItem = source.find(item =>
                                                l.elementDetails.tip !== "Var"
                                                    ? item.tagId === l.elementDetails.tagId
                                                    : item.tip === "Var" && item.tagId === l.elementDetails.tagId
                                            );

                                            let value_tag = matchedItem?.tagValue;

                                            // Sayı değilse boşluktan önceki kısmı al
                                            if (value_tag && isNaN(Number(value_tag))) {
                                                value_tag = value_tag.split(" ")[0];
                                            }

                                            // Formatla
                                            if (value_tag && !isNaN(Number(value_tag))) {
                                                let numericValue = Number(value_tag);

                                                // BURASI EKLENDİ: Eğer birimi kW/h ise 1000'e böl
                                                if (l.elementDetails.unit === "kW/h") {
                                                    numericValue = numericValue / 1000;
                                                }

                                                const decimalPlaces = l.elementDetails.decimal ?? 2;

                                                const formatted = numericValue.toLocaleString("tr-TR", {
                                                    minimumFractionDigits: decimalPlaces,
                                                    maximumFractionDigits: decimalPlaces,
                                                });

                                                const unit = l.elementDetails.unit;
                                                return formatted + (unit && unit !== "None" ? " " + unit : "");
                                            }

                                            return "";
                                        })()
                                        : ""
                                }



                            />

                        </div>
                    );
                }
                else if (l.type === "Popup") {
                    // 1. `value_` Değerini Bul
                    let value_ = tag_values_state.find(i =>
                        l.elementDetails.tip !== "Var"
                            ? String(i.tagId) === String(l.elementDetails.tagId)
                            : i.tip === "Var" && String(i.tagId) === String(l.elementDetails.tagId)
                    )?.tagValue;

                    // Eğer value_ sayısal değilse, boşluktan sonrasını sil
                    if (value_ && isNaN(Number(value_))) {
                        value_ = value_.split(' ')[0]; // ilk boşluktan önceki kısmı al
                    }

                    // 2. `value_list` İçinde `value_` İndeksini Bul
                    let index_ = l.elementDetails.value_list && l.elementDetails.value_list.indexOf(
                        value_ !== undefined && value_.includes(" ") ? value_.trim() : value_
                    );


                    // 3. Varsayılan Atama
                    if (index_ === -1 || index_ === undefined) { // `indexOf` bulunamazsa -1 döner
                        index_ = 0;
                    }

                    // 1. `value_` Değerini Bul
                    let value_2 = tag_values_state.find(i =>
                        l.elementDetails.tip2 !== "Var"
                            ? String(i.tagId) === String(l.elementDetails.tagId2)
                            : i.tip === "Var" && String(i.tagId) === String(l.elementDetails.tagId2)
                    )?.tagValue;

                    // Eğer value_ sayısal değilse, boşluktan sonrasını sil
                    if (value_2 && isNaN(Number(value_2))) {
                        value_2 = value_2.split(' ')[0]; // ilk boşluktan önceki kısmı al
                    }

                    // 2. `value_list` İçinde `value_` İndeksini Bul
                    let index_2 = l.elementDetails.value_list && l.elementDetails.value_list.indexOf(
                        value_2 !== undefined && value_2.includes(" ") ? value_2.trim() : value_2
                    );

                    // 3. Varsayılan Atama
                    if (index_2 === -1 || index_2 === undefined) { // `indexOf` bulunamazsa -1 döner
                        index_2 = 0;
                    }

                    // 1. `value_` Değerini Bul
                    let value_3 = tag_values_state.find(i =>
                        l.elementDetails.tip !== "Var"
                            ? String(i.tagId) === String(l.elementDetails.tagId3)
                            : i.tip === "Var" && String(i.tagId) === String(l.elementDetails.tagId3)
                    )?.tagValue;

                    // Eğer value_ sayısal değilse, boşluktan sonrasını sil
                    if (value_3 && isNaN(Number(value_3))) {
                        value_3 = value_3.split(' ')[0]; // ilk boşluktan önceki kısmı al
                    }

                    // 2. `value_list` İçinde `value_` İndeksini Bul
                    let index_3 = l.elementDetails.value_list && l.elementDetails.value_list.indexOf(
                        value_3 !== undefined && value_3.includes(" ") ? value_3.trim() : value_3
                    );

                    // 3. Varsayılan Atama
                    if (index_3 === -1 || index_3 === undefined) { // `indexOf` bulunamazsa -1 döner
                        index_3 = 0;
                    }

                    return (
                        <div

                            onClick={(e) => {
                                if (yazma_control) {
                                    let active_id = l.id;
                                    let active_items = l.elementDetails.items;
                                    Set_active_popup_id(active_id);
                                    Set_active_popup_items(active_items)
                                    // Hide other elements
                                    document.querySelector(".react-grid-layout").childNodes.forEach((x) => {
                                        x.style.opacity = "0";
                                        x.style.zIndex = "-1";
                                    });

                                    let w__, h__, x__, y__;

                                    setLayouts((prevLayouts) => {
                                        const updatedLayouts = { ...prevLayouts };

                                        if (Array.isArray(updatedLayouts[currentBreakpoint])) {
                                            (updatedLayouts[currentBreakpoint] || []).forEach((item) => {
                                                if (String(item.id) === String(active_id)) {
                                                    if (!item.elementDetails.items) {
                                                        item.elementDetails.items = [];
                                                    }

                                                    item.elementDetails.items.forEach((newItem) => {
                                                        if (newItem.type === "frame") {
                                                            w__ = newItem.w;
                                                            h__ = newItem.h;
                                                            x__ = newItem.x;
                                                            y__ = newItem.y;
                                                        }
                                                        newItem.isDraggable = false;
                                                        newItem.isResizable = false;
                                                        updatedLayouts[currentBreakpoint].push(newItem);
                                                    });
                                                }
                                            });
                                        }

                                        return updatedLayouts;
                                    });

                                    document.querySelector(".main_sec").classList.toggle("main_sec_bg_blur");

                                    setTimeout(() => {
                                        document.querySelector(".react-grid-layout").childNodes.forEach((x) => {
                                            if (window.getComputedStyle(x).zIndex !== "-1") {
                                                x.style.zIndex = "2";
                                            }
                                        });
                                    }, 50);

                                    setTimeout(() => {
                                        let diffX, diffY;
                                        const layoutItems = document.querySelector(".react-grid-layout")
                                            .childNodes;

                                        layoutItems.forEach((x) => {
                                            const id = x.getAttribute("data-id");

                                            if (x.classList.contains("frame_widget")) {

                                                x.style.width = `${w__}px`; // Grid birimlerini px'e çevir
                                                x.style.height = `${h__}px`;

                                                const initialRect = x.getBoundingClientRect();
                                                const mainSec = document.querySelector(".main_sec");
                                                const mainSecRect = mainSec.getBoundingClientRect();

                                                const centerX = (mainSecRect.width) / 2;
                                                const centerY = (mainSecRect.height) / 2 - mainSecRect.top / 10;

                                                console.warn(mainSecRect, "kdoejdıoejoejoe")

                                                const targetX = (centerX - w__ / 2) - mainSecRect.left / 5;
                                                const targetY = (centerY - h__ / 2);

                                                console.log("targetX", targetX)

                                                diffX = targetX;
                                                diffY = targetY;

                                                x.style.transform = `translate(${targetX}px, ${targetY}px)`;
                                            }
                                        });

                                        // Diğer öğeleri frame'e göre taşı
                                        layoutItems.forEach((x) => {
                                            const id = x.getAttribute("data-id");
                                            if (x.classList.contains("frame_widget")) return;


                                            if (!id?.includes("l.special_type")) return;



                                            if (typeof diffX !== "undefined" && typeof diffY !== "undefined") {
                                                const frameWidgetRect = document
                                                    .querySelector(".frame_widget")
                                                    .getBoundingClientRect();
                                                const elementRect = x.getBoundingClientRect();

                                                const relativeX = elementRect.left - frameWidgetRect.left;
                                                const relativeY = elementRect.top - frameWidgetRect.top;

                                                x.style.transform = `translate(${diffX + relativeX}px, ${diffY + relativeY
                                                    }px)`;
                                            }
                                        });
                                    }, 50);
                                }
                            }
                            }


                            style={{ borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", zIndex: "1", border: "2px solid rgb(70,70,70)", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black", borderRadius: "8px", display: "flex", alignItems: "center", borderColor: l.elementDetails.border_list && l.elementDetails.border_list[index_] ? l.elementDetails.border_list[index_] : "black", backgroundColor: l.elementDetails.bg_list && l.elementDetails.bg_list[index_] ? l.elementDetails.bg_list[index_] : "white", color: l.elementDetails.font_list && l.elementDetails.font_list[index_] ? l.elementDetails.font_list[index_] : "black" }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={"Popup" + l.id}
                            data-id={l.special_type ? "l.special_type" : ""}
                            key={l.i}
                            className="popupduz_widget"
                        >



                            <input
                                className="showRoomNumber_popupDYN"
                                placeholder="room number"

                                id={l.id + "cc"}
                                type="text"

                                value={l.elementDetails.text ? l.elementDetails.text : ""}
                                style={{
                                    fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, textAlign: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center",
                                    backgroundColor: "transparent",
                                    color: l.fontColor ? l.fontColor : "black",
                                    width: "100%", outline: "none", backgroundColor: "transparent", border: "none"

                                }}




                            />

                            <div className="dyn_popup_bottom_part">
                                <div><p style={{ fontSize: `${l.w / 17}px` }}>Oda:</p> <input style={{ color: l.elementDetails.font_list && l.elementDetails.font_list[index_] ? l.elementDetails.font_list[index_] : "black", fontSize: `${l.w / 20}px`, backgroundColor: "transparent" }} type="text" value={
                                    l.elementDetails.tagId3 !== ""
                                        ? (() => {
                                            let selectedTag;
                                            if (l.elementDetails.tip3 === "Var") {
                                                selectedTag = tag_values_state.find(
                                                    (item) => item.tip === "Var" && item.tagId === l.elementDetails.tagId3
                                                );
                                            } else {
                                                selectedTag = tag_values_state.find(
                                                    (item) => item.tagId === l.elementDetails.tagId3
                                                );
                                            }

                                            if (!selectedTag) return "";

                                            const numericValue = parseFloat(selectedTag.tagValue);
                                            const isNumeric = !isNaN(numericValue);

                                            return isNumeric
                                                ? numericValue.toFixed(l.elementDetails.decimal ? l.elementDetails.decimal : 2) +
                                                (l.elementDetails.unit && l.elementDetails.unit !== "None" ? " " + l.elementDetails.unit : "")
                                                : selectedTag.tagValue; // Sayıya çevrilemezse olduğu gibi bırak
                                        })()
                                        : ""
                                } className="dyn_popup_show_room_temp" /></div>
                                <div className="span_divPopupW"><span style={{ borderColor: l.elementDetails.border_list2 && l.elementDetails.border_list2[index_] ? l.elementDetails.border_list2[index_] : "black", backgroundColor: l.elementDetails.bg_list2 && l.elementDetails.bg_list2[index_] ? l.elementDetails.bg_list2[index_] : "white", }}></span></div>
                                <div><p style={{ fontSize: `${l.w / 17}px` }}>Set:</p> <input
                                    onClick={(e) => {
                                        if (l.elementDetails.tagId4 && l.elementDetails.tagId4 !== "" && l.elementDetails.tagId4 !== "None" && yazma_control) {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            const { clientX, clientY } = e;

                                            // Set elem_popup with tagId2 as tagId4 for modal to work
                                            Set_elem_popup({ ...l, elementDetails: { ...l.elementDetails, tagId2: l.elementDetails.tagId4 } });

                                            document.querySelector(".Popup-selectbox2").classList.toggle("changeProperties_active");
                                            document.querySelector(".Popup-selectbox2").id = l.id;

                                            var popup = document.querySelector(".Popup-selectbox2");
                                            const popupRect = popup.getBoundingClientRect();

                                            let newX = clientX + window.scrollX;
                                            let newY = clientY + window.scrollY;

                                            if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                                                newX = window.innerWidth + window.scrollX - popupRect.width;
                                            }
                                            if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                                                newY = window.innerHeight + window.scrollY - popupRect.height;
                                            }

                                            popup.style.left = `${newX}px`;
                                            popup.style.top = `${newY}px`;
                                        }
                                    }}
                                    style={{ color: l.elementDetails.font_list && l.elementDetails.font_list[index_] ? l.elementDetails.font_list[index_] : "black", fontSize: `${l.w / 20}px`, backgroundColor: "transparent", cursor: l.elementDetails.tagId4 && l.elementDetails.tagId4 !== "" && l.elementDetails.tagId4 !== "None" && yazma_control ? "pointer" : "default" }}
                                    type="text"
                                    value={
                                    l.elementDetails.tagId4 !== ""
                                        ? (() => {
                                            let selectedTag;
                                            if (l.elementDetails.tip4 === "Var") {
                                                selectedTag = tag_values_state.find(
                                                    (item) => item.tip === "Var" && item.tagId === l.elementDetails.tagId4
                                                );
                                            } else {
                                                selectedTag = tag_values_state.find(
                                                    (item) => item.tagId === l.elementDetails.tagId4
                                                );
                                            }

                                            if (!selectedTag) return "";

                                            const numericValue = parseFloat(selectedTag.tagValue);
                                            const isNumeric = !isNaN(numericValue);

                                            return isNumeric
                                                ? numericValue.toFixed(l.elementDetails.decimal ? l.elementDetails.decimal : 2) +
                                                (l.elementDetails.unit && l.elementDetails.unit !== "None" ? " " + l.elementDetails.unit : "")
                                                : selectedTag.tagValue; // Sayıya çevrilemezse olduğu gibi bırak
                                        })()
                                        : ""
                                } className="dyn_popup_show_room_set_temp" /></div>
                            </div>

                        </div>
                    );
                }
                else if (l.type === "frame") {
                    if (!l.special_type) {
                        return (
                            <div

                                onContextMenu={(e) => {
                                    console.log(l);
                                    if (l.combine_trend && l.combine_trend === true) {
                                        let group_id = l.group_t_id ? l.group_t_id : undefined

                                        let newData = combine_trend_tags;

                                        (layouts[currentBreakpoint] || []).forEach(x => {
                                            if (group_id !== undefined && x.group_t_id && Number(x.group_t_id) === Number(group_id) && l.elementDetails.tagId) {
                                                var tagName = tags
                                                    .filter((b) => b.tagId === l.elementDetails.tagId)
                                                    .map((c) => c.tagName)[0];
                                                newData.push({ tagId: l.elementDetails.tagId, tagName: tagName })
                                            }
                                        })

                                        Set_combine_trend_tags(newData)

                                        e.preventDefault();
                                        const { clientX, clientY } = e;
                                        let screen_width = window.innerWidth;
                                        console.log(clientX, clientY);
                                        document
                                            .querySelector(".show_external_combine_trend")
                                            .classList.toggle(
                                                "show_external_combine_trend_active"
                                            );

                                        var popup = document.querySelector(
                                            ".show_external_combine_trend"
                                        );
                                        const popupRect =
                                            popup.getBoundingClientRect();
                                        const viewportWidth = window.innerWidth;
                                        const viewportHeight = window.innerHeight;

                                        // Calculate the new positions
                                        let newX = clientX;
                                        let newY = clientY;

                                        // Adjust if the popup would overflow the right edge of the viewport
                                        if (
                                            newX + popupRect.width >
                                            viewportWidth
                                        ) {
                                            newX = viewportWidth - popupRect.width;
                                        }

                                        // Adjust if the popup would overflow the bottom edge of the viewport
                                        if (
                                            newY + popupRect.height >
                                            viewportHeight
                                        ) {
                                            newY =
                                                viewportHeight - popupRect.height;
                                        }

                                        // Adjust if the popup would overflow the left edge of the viewport
                                        if (newX < 0) {
                                            newX = 0;
                                        }

                                        // Adjust if the popup would overflow the top edge of the viewport
                                        if (newY < 0) {
                                            newY = 0;
                                        }

                                        if (
                                            screen_width < 2301 &&
                                            screen_width > 1800
                                        ) {
                                            document.querySelector(
                                                ".show_external_combine_trend"
                                            ).style.left = `${String(
                                                newX / 1.2
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_combine_trend"
                                            ).style.top = `${String(newY / 1.2)}px`;
                                        } else if (
                                            screen_width < 2801 &&
                                            screen_width > 2300
                                        ) {
                                            document.querySelector(
                                                ".show_external_combine_trend"
                                            ).style.left = `${String(
                                                newX / 1.5
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_combine_trend"
                                            ).style.top = `${String(newY / 1.5)}px`;
                                        } else if (
                                            screen_width < 3501 &&
                                            screen_width > 2800
                                        ) {
                                            document.querySelector(
                                                ".show_external_combine_trend"
                                            ).style.left = `${String(
                                                newX / 1.8
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_combine_trend"
                                            ).style.top = `${String(newY / 1.8)}px`;
                                        } else if (
                                            screen_width < 5001 &&
                                            screen_width > 3500
                                        ) {
                                            document.querySelector(
                                                ".show_external_combine_trend"
                                            ).style.left = `${String(
                                                newX / 2.5
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_combine_trend"
                                            ).style.top = `${String(newY / 2.5)}px`;
                                        } else if (screen_width <= 1800) {
                                            document.querySelector(
                                                ".show_external_combine_trend"
                                            ).style.left = `${String(newX)}px`;
                                            document.querySelector(
                                                ".show_external_combine_trend"
                                            ).style.top = `${String(newY)}px`;
                                        }
                                    }
                                }}

                                style={{ borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", backgroundColor: "white", borderRadius: l.elementDetails.borderRadius + "px", border: "3px solid rgb(65,65,65)", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black", zIndex: "0" }}
                                data-grid={{
                                    x: l.x,
                                    y: l.y,
                                    w: (l.w),
                                    h: l.h,
                                    resizeHandles: l.resizeHandles,
                                }}
                                id={l.id}
                                data-id={l.special_type ? "l.special_type" : ""}
                                key={l.i}
                                className="frame_widget"
                            >




                            </div>
                        );
                    } else {
                        return (
                            <div


                                style={{ borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", backgroundColor: "white", borderRadius: l.elementDetails.borderRadius + "px", border: "3px solid rgb(65,65,65)", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black", zIndex: "0" }}
                                data-grid={{
                                    x: l.x,
                                    y: l.y,
                                    w: (l.w),
                                    h: l.h,
                                    resizeHandles: l.resizeHandles,
                                }}
                                id={l.id}
                                data-id={l.special_type ? "l.special_type" : ""}
                                key={l.i}
                                className="frame_widget"
                            >
                                <i onClick={(e) => {
                                    if (document.querySelector(".main_sec").classList.contains("main_sec_bg_blur")) {


                                        setLayouts((prevLayouts) => {
                                            const updatedLayouts = { ...prevLayouts };


                                            if (Array.isArray(updatedLayouts[currentBreakpoint])) {
                                                // Filter out items with matching special_type and id2
                                                updatedLayouts[currentBreakpoint] = (updatedLayouts[currentBreakpoint] || []).filter(
                                                    (item) => !(item.special_type && String(item.id2) === String(active_popup_id))
                                                );
                                            }

                                            return updatedLayouts;
                                        });
                                        Set_active_popup_id(null)
                                        Set_active_popup_items([])
                                        document.querySelector(".main_sec").classList.toggle("main_sec_bg_blur");
                                        setTimeout(() => {
                                            document.querySelector(".react-grid-layout").childNodes.forEach(x => {
                                                x.style.opacity = "1"
                                                x.style.zIndex = "1"
                                            })
                                        }, 50)
                                    }

                                }} style={{ position: "relative", left: "95%", top: "-30px", cursor: "pointer", backgroundColor: "red", width: "40px", height: "40px", display: "flex", alignItems: "center", justifyContent: "center", color: "white", borderRadius: "40px", border: "none" }} className="fa fa-times"></i>




                            </div>
                        );
                    }

                }
                else if (l.type === "fan_modu") {
                    return (
                        <div

                            onContextMenu={(e) => {
                                if (l.elementDetails.tagId && l.add_trend && l.add_trend === "YES") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_trend")
                                        .classList.toggle(
                                            "show_external_trend_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_trend"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                } else if (l.elementDetails.tagId && l.elementDetails.tagId !== "") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_detail")
                                        .classList.toggle(
                                            "show_external_detail_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId2"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName2"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_detail"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                }
                            }}

                            onClick={(e) => {
                                if (yazma_control) {
                                    console.log(e.target);
                                    e.preventDefault();
                                    e.stopPropagation();
                                    const { clientX, clientY } = e;
                                    document.querySelector(".Popup-fan").classList.toggle("changeProperties_active")
                                    document.querySelector(".Popup-fan").id = l.id

                                    var popup = document.querySelector(".Popup-fan")
                                    const popupRect = popup.getBoundingClientRect();

                                    // Yeni pozisyonları hesapla
                                    let newX = clientX + window.scrollX;
                                    let newY = clientY + window.scrollY;

                                    console.log(newX, newY);

                                    // Sağ kenardan taşmayı önle
                                    if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                                        newX = window.innerWidth + window.scrollX - popupRect.width;
                                    }

                                    // Alt kenardan taşmayı önle
                                    if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                                        newY = window.innerHeight + window.scrollY - popupRect.height;
                                    }

                                    // Sol kenardan taşmayı önle
                                    if (newX < window.scrollX) {
                                        newX = window.scrollX;
                                    }

                                    // Üst kenardan taşmayı önle
                                    if (newY < window.scrollY) {
                                        newY = window.scrollY;
                                    }

                                    console.log(newX, newY);

                                    // Pop-up'ın pozisyonunu ayarla
                                    popup.style.left = `${newX}px`;
                                    popup.style.top = `${newY}px`;

                                    const parentElement = e.target.closest(".fan_modu_widget");
                                    const parentRect = parentElement.getBoundingClientRect();

                                    Set_elem_popup({
                                        width: l.w,
                                        height: l.h * 10,
                                        left: l.x,
                                        top: l.y,

                                        type: l.type,
                                        id: l.id,
                                        fontSize: l.fontSize ? l.fontSize : Number(l.w) / 10
                                    })

                                    setSelectedOptionfan(l.elementDetails.text)
                                }
                            }
                            }
                            style={{ borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", border: "2px solid rgb(60,60,60)", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black", borderRadius: "4px", zIndex: "1" }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            className={"fan_modu_widget" + " " + (l.special_type ? "special_type" : "")}
                        >

                            <div style={{ backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black", width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                                {l.elementDetails.text}

                            </div>

                        </div>
                    );
                }
                else if (l.type === "calisma_modu") {
                    return (
                        <div
                            onContextMenu={(e) => {
                                if (l.elementDetails.tagId && l.add_trend && l.add_trend === "YES") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_trend")
                                        .classList.toggle(
                                            "show_external_trend_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_trend"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                } else if (l.elementDetails.tagId && l.elementDetails.tagId !== "") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_detail")
                                        .classList.toggle(
                                            "show_external_detail_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId2"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName2"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_detail"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                }
                            }}
                            onClick={(e) => {
                                if (yazma_control) {
                                    console.log(e.target);
                                    e.preventDefault();
                                    e.stopPropagation();
                                    const { clientX, clientY } = e;
                                    document.querySelector(".Popup-calisma").classList.toggle("changeProperties_active")
                                    document.querySelector(".Popup-calisma").id = l.id

                                    var popup = document.querySelector(".Popup-calisma")
                                    const popupRect = popup.getBoundingClientRect();

                                    // Yeni pozisyonları hesapla
                                    let newX = clientX + window.scrollX;
                                    let newY = clientY + window.scrollY;

                                    console.log(newX, newY);

                                    // Sağ kenardan taşmayı önle
                                    if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                                        newX = window.innerWidth + window.scrollX - popupRect.width;
                                    }

                                    // Alt kenardan taşmayı önle
                                    if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                                        newY = window.innerHeight + window.scrollY - popupRect.height;
                                    }

                                    // Sol kenardan taşmayı önle
                                    if (newX < window.scrollX) {
                                        newX = window.scrollX;
                                    }

                                    // Üst kenardan taşmayı önle
                                    if (newY < window.scrollY) {
                                        newY = window.scrollY;
                                    }

                                    console.log(newX, newY);

                                    // Pop-up'ın pozisyonunu ayarla
                                    popup.style.left = `${newX}px`;
                                    popup.style.top = `${newY}px`;

                                    const parentElement = e.target.closest(".calisma_modu_widget");
                                    const parentRect = parentElement.getBoundingClientRect();

                                    Set_elem_popup({
                                        width: l.w,
                                        height: l.h * 10,
                                        left: l.x,
                                        top: l.y,

                                        type: l.type,
                                        id: l.id,
                                        fontSize: l.fontSize ? l.fontSize : Number(l.w) / 10
                                    })

                                    setSelectedOptioncalisma(l.elementDetails.text)
                                }
                            }
                            }
                            style={{ borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", border: "2px solid rgb(60,60,60)", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black", borderRadius: "4px", zIndex: "1" }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}

                            id={l.id}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            className={"calisma_modu_widget" + ` ${l.elementDetails.tagId}` + " " + (l.special_type ? "special_type" : "")}
                        >


                            <div style={{ backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black", width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                                {l.elementDetails.text}

                            </div>



                        </div>
                    );
                }
                else if (l.type === "on/off") {
                    let value_ = tag_values_state.find(i =>
                        l.elementDetails.tip !== "Var"
                            ? String(i.tagId) === String(l.elementDetails.tagId)
                            : i.tip === "Var" && String(i.tagId) === String(l.elementDetails.tagId)
                    )?.tagValue;

                    // Eğer value_ sayısal değilse, boşluktan sonrasını sil
                    if (value_ && isNaN(Number(value_))) {
                        value_ = value_.split(' ')[0];

                    }
                    console.warn("value_", value_, typeof (value_));

                    value_ = value_ && value_.split('.')[0]; // Noktadan sonrasını almaz

                    console.warn("value_", value_, typeof (value_));

                    // 2. value_list oluştur (value1, value2, value3... varsa onları al)
                    let valueList = [];
                    let i = 1;
                    while (l.elementDetails[`value${i}`] !== undefined) {
                        valueList.push(l.elementDetails[`value${i}`]);
                        i++;
                    }

                    // 3. value_ değeri valueList içinde kaçıncı sıradaysa onu al
                    let index_ = valueList.indexOf(
                        value_ !== undefined && value_.includes(" ") ? value_.trim() : value_
                    );

                    // 4. Varsayılan atama
                    if (index_ === -1 || index_ === undefined) {
                        index_ = 0;
                    }
                    return (
                        <div

                            onContextMenu={(e) => {
                                const { clientX, clientY } = e;
                                let screen_width = window.innerWidth;
                                console.log(l);

                                if (l.elementDetails.tagId && l.add_trend && l.add_trend === "YES") {
                                    if (l.elementDetails.text === "ON") {
                                        var tagName = tags
                                            .filter((b) => b.tagId === l.elementDetails.tagId)
                                            .map((c) => c.tagName)[0];

                                        e.preventDefault();

                                        let screen_width = window.innerWidth;
                                        console.log(clientX, clientY);
                                        document
                                            .querySelector(".show_external_trend")
                                            .classList.toggle(
                                                "show_external_trend_active"
                                            );
                                        document.querySelector(
                                            ".show_tagId"
                                        ).innerHTML = l.elementDetails.tagId;
                                        document.querySelector(
                                            ".show_tagName"
                                        ).innerHTML = tagName;
                                        var popup = document.querySelector(
                                            ".show_external_trend"
                                        );
                                    } else {
                                        var tagName = tags
                                            .filter((b) => b.tagId === l.elementDetails.tagId)
                                            .map((c) => c.tagName)[0];

                                        e.preventDefault();

                                        let screen_width = window.innerWidth;
                                        console.log(clientX, clientY);
                                        document
                                            .querySelector(".show_external_trend")
                                            .classList.toggle(
                                                "show_external_trend_active"
                                            );
                                        document.querySelector(
                                            ".show_tagId"
                                        ).innerHTML = l.elementDetails.tagId;
                                        document.querySelector(
                                            ".show_tagName"
                                        ).innerHTML = tagName;
                                        var popup = document.querySelector(
                                            ".show_external_trend"
                                        );
                                    }

                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                } else if (l.elementDetails.tagId && l.elementDetails.tagId !== "") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_detail")
                                        .classList.toggle(
                                            "show_external_detail_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId2"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName2"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_detail"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                }
                            }}

                            onClick={(e) => {
                                if (yazma_control) {


                                    console.log(e.target);
                                    e.preventDefault();
                                    e.stopPropagation();
                                    const { clientX, clientY } = e;
                                    document.querySelector(".Popup-onOff").classList.toggle("changeProperties_active")
                                    document.querySelector(".Popup-onOff").id = l.id

                                    var popup = document.querySelector(".Popup-onOff")
                                    const popupRect = popup.getBoundingClientRect();

                                    // Yeni pozisyonları hesapla
                                    let newX = clientX + window.scrollX;
                                    let newY = clientY + window.scrollY;

                                    console.log(newX, newY);

                                    // Sağ kenardan taşmayı önle
                                    if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                                        newX = window.innerWidth + window.scrollX - popupRect.width;
                                    }

                                    // Alt kenardan taşmayı önle
                                    if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                                        newY = window.innerHeight + window.scrollY - popupRect.height;
                                    }

                                    // Sol kenardan taşmayı önle
                                    if (newX < window.scrollX) {
                                        newX = window.scrollX;
                                    }

                                    // Üst kenardan taşmayı önle
                                    if (newY < window.scrollY) {
                                        newY = window.scrollY;
                                    }

                                    console.log(newX, newY);

                                    // Pop-up'ın pozisyonunu ayarla
                                    popup.style.left = `${newX}px`;
                                    popup.style.top = `${newY}px`;

                                    const parentElement = e.target.closest(".on-off_widget");
                                    const parentRect = parentElement.getBoundingClientRect();

                                    Set_elem_popup({
                                        width: l.w,
                                        height: l.h * 10,
                                        left: l.x,
                                        top: l.y,

                                        type: l.type,
                                        id: l.id,
                                        fontSize: l.fontSize ? l.fontSize : Number(l.w) / 10,
                                        value: value_ !== undefined && value_ === "1" ? "ON" : "OFF"
                                    })
                                }
                            }
                            }
                            style={{
                                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", backgroundColor: "white", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "white", borderRadius: "8px", zIndex: "1",
                            }}

                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            className={`on-off_widget ${value_ !== undefined && value_ === "1" ? "ON" : "OFF"} ${l.elementDetails.tagId}` + " " + (l.special_type ? "special_type" : "")}
                        >
                            <div style={{ backgroundColor: "transparent", color: "white", width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                                {value_ !== undefined && value_ === "1" ? "ON" : "OFF"}

                            </div>

                        </div>
                    );
                }
                else if (l.type === "image") {
                    return (
                        <div


                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: l.w,
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            className="image_widgetParentDiv"
                            style={{ borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", borderColor: "rgb(100,100,100)", zIndex: "1" }}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            id={l.id}
                        >

                            <img
                                style={{ width: "100%", height: "100%" }}
                                className="image_widget"
                                src={l.elementDetails.src !== "" ? l.elementDetails.src : ""}
                                alt=""
                            />
                        </div>
                    );
                } else if (l.type === "bg") {

                    let diffWidth = document.querySelector(".link-group-data-links").getBoundingClientRect().width * 1.05
                    let diffHeigth = document.querySelector("nav").getBoundingClientRect().height * 1.25
                    console.log(diffHeigth)


                    setTimeout(() => {
                        if (document.querySelector(".main_sec")) {
                            document.querySelector(
                                ".main_sec"
                            ).style.backgroundImage = `url("${l.elementDetails.src}")`;
                            document.querySelector(".main_sec").style.backgroundPosition =
                                `${l.elementDetails.left}px ${l.elementDetails.top}px`;
                            document.querySelector(".main_sec").style.backgroundSize = `${l.elementDetails.width}px ${l.elementDetails.height}px`;
                            document.querySelector(".main_sec").style.backgroundRepeat = "no-repeat"
                        }

                    }, 1000)



                } else if (l.type === "gauge") {
                    let value_max = Number(l.elementDetails.maxValue);

                    // tip kontrolü ile uygun tag değerini bul
                    let selectedTag;
                    if (l.elementDetails.tip === "Var") {
                        selectedTag = tag_values_state.find(
                            (item) => item.tip === "Var" && item.tagId === l.elementDetails.tagId
                        );
                    } else {
                        selectedTag = tag_values_state.find((item) => item.tagId === l.elementDetails.tagId);
                    }

                    // Sayısal değeri güvenli şekilde al
                    let value_tag = selectedTag ? selectedTag.tagValue : "";
                    const numericValue = parseFloat(value_tag);
                    const isNumeric = !isNaN(numericValue);

                    // Eğer isNumeric false ise boşluktan sonrasını kes
                    value_tag = isNumeric ? value_tag : value_tag.split(' ')[0];



                    // last_deger hesaplamasını güvenli hale getir
                    let last_deger = isNumeric
                        ? (numericValue / (l.elementDetails.endValue ? l.elementDetails.endValue : value_max).toFixed(2)) * 100
                        : 0;

                    // startValue ve endValue güvenli şekilde belirle
                    const startValue =
                        l.elementDetails.startValue && isNumeric && l.elementDetails.startValue <= numericValue
                            ? l.elementDetails.startValue
                            : 0;

                    const endValue = l.elementDetails.endValue && isNumeric
                        ? l.elementDetails.limitValues && l.elementDetails.limitValues.length > 0 && Number([...l.elementDetails.limitValues]
                            .sort((a, b) => a.value - b.value)
                            .at(-1).value) >= l.elementDetails.endValue
                            ? Math.max(l.elementDetails.endValue, numericValue) +
                            Number([...l.elementDetails.limitValues]
                                .sort((a, b) => a.value - b.value)
                                .at(-1).value)
                            : Math.max(l.elementDetails.endValue, numericValue)
                        : isNumeric
                            ? numericValue.toFixed(2)
                            : 100;
                    // normalizedValue hesapla
                    const normalizedValue = isNumeric
                        ? ((value_tag - startValue) / (endValue - startValue)) * 100
                        : 0;

                    // Arc limitlerini tanımla
                    const arcLimits = l.elementDetails.pU && l.elementDetails.limitValues
                        ? (() => {
                            if (l.elementDetails.pU === "Unit") {
                                // Unit modu için özel mantık
                                const sortedLimits = [...l.elementDetails.limitValues].sort((a, b) => a.value - b.value);
                                const colorLimits = sortedLimits.filter(i => i.color);

                                let lastLimit = startValue;
                                let result = [];

                                colorLimits.forEach(({ value, color }) => {
                                    let newColor = color;
                                    if (l.elementDetails.scaleX === "-1" && color === "#008000") {
                                        newColor = "#ff0000";
                                    } else if (l.elementDetails.scaleX === "-1" && color === "#ff0000") {
                                        newColor = "#008000";
                                    }
                                    result.push({
                                        limit: value,
                                        color: newColor,
                                    });
                                    lastLimit = value;
                                });

                                // Son rengi endValue'ya kadar devam ettir
                                if (colorLimits.length > 2) {
                                    result.push({
                                        limit: endValue,
                                        color: l.elementDetails.scaleX === "-1" ? colorLimits[0].color : colorLimits[colorLimits.length - 1].color,
                                    });
                                } else {
                                    result = [
                                        {
                                            limit: ((20 / 100) * (endValue - startValue)) + startValue,
                                            color: l.elementDetails.scaleX === "-1" ? "#5BE12C" : "#EA4228",
                                        },
                                        {
                                            limit: ((40 / 100) * (endValue - startValue)) + startValue,
                                            color: l.elementDetails.scaleX === "-1" ? "#F5CD19" : "#F58B19",
                                        },
                                        {
                                            limit: ((60 / 100) * (endValue - startValue)) + startValue,
                                            color: l.elementDetails.scaleX === "-1" ? "#F58B19" : "#F5CD19",
                                        },
                                        {
                                            limit: ((80 / 100) * (endValue - startValue)) + startValue,
                                            color: l.elementDetails.scaleX === "-1" ? "#FF5733" : "#33FFCE",
                                        },
                                        {
                                            limit: ((100 / 100) * (endValue - startValue)) + startValue,
                                            color: l.elementDetails.scaleX === "-1" ? "#EA4228" : "#5BE12C",
                                        },
                                    ];
                                }

                                return result;
                            } else if (l.elementDetails.pU === "Percent") {
                                // Percent modu için 5 renkli dizi
                                return [
                                    {
                                        limit: ((20 / 100) * (endValue - startValue)) + startValue,
                                        color: l.elementDetails.scaleX === "-1" ? "#5BE12C" : "#EA4228",
                                    },
                                    {
                                        limit: ((40 / 100) * (endValue - startValue)) + startValue,
                                        color: l.elementDetails.scaleX === "-1" ? "#F5CD19" : "#F58B19",
                                    },
                                    {
                                        limit: ((60 / 100) * (endValue - startValue)) + startValue,
                                        color: l.elementDetails.scaleX === "-1" ? "#F58B19" : "#F5CD19",
                                    },
                                    {
                                        limit: ((80 / 100) * (endValue - startValue)) + startValue,
                                        color: l.elementDetails.scaleX === "-1" ? "#FF5733" : "#33FFCE",
                                    },
                                    {
                                        limit: ((100 / 100) * (endValue - startValue)) + startValue,
                                        color: l.elementDetails.scaleX === "-1" ? "#EA4228" : "#5BE12C",
                                    },
                                ];
                            } else {
                                // Diğer durumlar için varsayılan dizi
                                return [
                                    {
                                        limit: ((20 / 100) * (endValue - startValue)) + startValue,
                                        color: l.elementDetails.scaleX === "-1" ? "#5BE12C" : "#EA4228",
                                    },
                                    {
                                        limit: ((40 / 100) * (endValue - startValue)) + startValue,
                                        color: l.elementDetails.scaleX === "-1" ? "#F5CD19" : "#F58B19",
                                    },
                                    {
                                        limit: ((60 / 100) * (endValue - startValue)) + startValue,
                                        color: l.elementDetails.scaleX === "-1" ? "#F58B19" : "#F5CD19",
                                    },
                                    {
                                        limit: ((80 / 100) * (endValue - startValue)) + startValue,
                                        color: l.elementDetails.scaleX === "-1" ? "#FF5733" : "#33FFCE",
                                    },
                                    {
                                        limit: ((100 / 100) * (endValue - startValue)) + startValue,
                                        color: l.elementDetails.scaleX === "-1" ? "#EA4228" : "#5BE12C",
                                    },
                                ];
                            }
                        })()
                        : [
                            {
                                limit: ((20 / 100) * (endValue - startValue)) + startValue,
                                color: l.elementDetails.scaleX === "-1" ? "#5BE12C" : "#EA4228",
                            },
                            {
                                limit: ((40 / 100) * (endValue - startValue)) + startValue,
                                color: l.elementDetails.scaleX === "-1" ? "#F5CD19" : "#F58B19",
                            },
                            {
                                limit: ((60 / 100) * (endValue - startValue)) + startValue,
                                color: l.elementDetails.scaleX === "-1" ? "#F58B19" : "#F5CD19",
                            },
                            {
                                limit: ((80 / 100) * (endValue - startValue)) + startValue,
                                color: l.elementDetails.scaleX === "-1" ? "#FF5733" : "#33FFCE",
                            },
                            {
                                limit: ((100 / 100) * (endValue - startValue)) + startValue,
                                color: l.elementDetails.scaleX === "-1" ? "#EA4228" : "#5BE12C",
                            },
                        ];
                    ;

                    const textElement = document.querySelector(`.gauge_widgetParentDiv${l.id} .value-text text`);

                    if (textElement && l.fontColor) textElement.style.fill = l.fontColor

                    document.querySelectorAll(`.gauge_widgetParentDiv${l.id} .tick-value text`).forEach(x => {
                        if (l.fontColor) x.style.fill = l.fontColor
                    })

                    // pU kontrolü ile text içeriğini güncelle
                    if (l.elementDetails.pU) {
                        const textElement = document.querySelector(`.gauge_widgetParentDiv${l.id} .value-text text`);
                        if (textElement) {
                            if (l.elementDetails.pU === "Unit") {
                                if (textElement.textContent.includes("%")) {
                                    textElement.textContent = textElement.textContent.slice(0, -1); // "%" karakterini kaldır
                                }
                                textElement.textContent = value_tag;
                            } else {
                                if (!textElement.textContent.includes("%")) {
                                    textElement.textContent = normalizedValue.toFixed(2) + "%";
                                }
                            }
                        }
                    }

                    // Min ve Max değerlerini ayarla
                    const min = l.elementDetails.pU === "Unit" && l.elementDetails.startValue ? startValue : 0;
                    const max = l.elementDetails.pU === "Unit" && l.elementDetails.endValue ? endValue : 100;





                    return (
                        <div
                            className={"gauge_widgetParentDiv" + " gauge_widgetParentDiv" + l.id}

                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: l.w,
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            onContextMenu={(e) => {
                                if (l.elementDetails.tagId && l.add_trend && l.add_trend === "YES") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_trend")
                                        .classList.toggle(
                                            "show_external_trend_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_trend"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                } else if (l.elementDetails.tagId && l.elementDetails.tagId !== "") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_detail")
                                        .classList.toggle(
                                            "show_external_detail_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId2"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName2"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_detail"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                }
                            }}

                            style={{
                                border: "1px solid rgb(100,100,100)",
                                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px",
                                backgroundColor: l.bgColor ? l.bgColor : "transparent",
                                borderRadius: l.elementDetails.borderRadius ? l.elementDetails.borderRadius + "px" : "8px",
                                minWidth: "100px", minHeight: "100px",
                                zIndex: "1",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                borderColor: l.borderColor ? l.borderColor : "rgb(100,100,100)",
                                overflow: "hidden", // Ebeveyn div taşmasını önler
                            }}
                            key={`${l.id} gauge-${fufg}`}

                            data-id={l.special_type ? "l.special_type" : ""}

                            id={l.id}

                        >

                            <GaugeComponent

                                maxValue={max}
                                minValue={min}
                                className="gauge_widget"
                                arc={{
                                    subArcs:
                                        l.elementDetails.pU ? l.elementDetails.pU === "Percent"
                                            ? arcLimits.map((arc) => ({
                                                limit: ((arc.limit - startValue) / (endValue - startValue)) * 100, // Normalize edilen yüzdelik limitler
                                                color: arc.color,
                                                showTick: true,
                                            }))
                                            : // Eğer "Unit" modundaysa, startValue ve endValue arasında 5 eşit dilim oluştur
                                            arcLimits.map((arc) => {
                                                // Eğer arc.limit startValue'dan küçükse startValue'ya ayarla
                                                let adjustedLimit = arc.limit < startValue ? startValue
                                                    // Eğer arc.limit endValue'dan büyükse endValue'ya ayarla
                                                    : arc.limit > endValue ? endValue
                                                        : arc.limit;

                                                return {
                                                    limit: adjustedLimit, // Normalize edilmiş limit
                                                    color: arc.color,
                                                    showTick: true,
                                                };
                                            }) : arcLimits.map((arc) => ({
                                                limit: ((arc.limit - startValue) / (endValue - startValue)) * 100, // Normalize edilen yüzdelik limitler
                                                color: arc.color,
                                                showTick: true,
                                            })),
                                }}
                                value={
                                    l.elementDetails.pU && l.elementDetails.pU === "Unit"
                                        ? isNumeric ? numericValue.toFixed(2) : "50" // value_tag geçerli sayı mı?
                                        : isNumeric ? (normalizedValue * max) / 100 : 50 // normalizedValue geçerli sayı mı?
                                }
                                style={{
                                    width: "80%",  // Tam genişlik kaplama
                                    height: "80%",
                                    marginLeft: "0%",// Tam yükseklik kaplama,
                                    opacity: "1",

                                }}
                            />
                        </div>
                    );
                }

                else if (l.type === "left_ok") {
                    let rotate_deg = 0;
                    if (l.elementDetails.rotate_deg) {
                        rotate_deg = l.elementDetails.rotate_deg
                    }

                    return (
                        <div

                            style={{ maxHeight: "50px", display: "flex", alignItems: "center", zIndex: "1" }}


                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: l.w,
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            id={l.id}
                            className="left_ok_arrow"
                        >

                            <svg style={l.elementDetails.rotate_deg && { transform: `rotate(${l.elementDetails.rotate_deg}deg)`, transformOrigin: "center" }} width={"100%"} className="sebeke-giris-cizgi">
                                <line
                                    x1="0"
                                    y1="25"
                                    x2="200%"
                                    y2="25"
                                    stroke={l.elementDetails.color}
                                    strokeWidth="8"
                                />
                                <polygon
                                    points="0,25 20,10 20,40"
                                    fill={l.elementDetails.color}
                                />
                                <line

                                    stroke="black"
                                    strokeWidth="14"
                                    markerEnd="url(#arrowhead)"
                                />
                            </svg>

                        </div>
                    )


                } else if (l.type === "right_ok") {

                    let rotate_deg = 0;
                    if (l.elementDetails.rotate_deg) {
                        rotate_deg = l.elementDetails.rotate_deg
                    }

                    return (
                        <div

                            style={{ maxHeight: "50px", display: "flex", alignItems: "center", color: `${l.elementDetails.color}`, zIndex: "1" }}

                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: l.w,
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            id={l.id}
                            className="right_arrow"
                        >

                            <svg width="100%" style={l.elementDetails.rotate_deg && { transform: `rotate(${l.elementDetails.rotate_deg}deg)`, transformOrigin: "center" }} height="50" className="sebeke-giris-cizgi">
                                <defs>
                                    <marker id={`arrowhead${l.id}`} orient="auto" markerWidth="5" markerHeight="5" refX="5" refY="2.5">
                                        <path d="M 0,0 L 5,2.5 L 0,5 Z" fill={`${l.elementDetails.color}`} />
                                    </marker>
                                </defs>

                                <line
                                    x1="0"
                                    y1="25"
                                    x2="calc(100% - 10px)"
                                    y2="25"
                                    stroke={l.elementDetails.color}
                                    strokeWidth="8"
                                />

                                <line
                                    x1="0"
                                    y1="25"
                                    x2="100%"
                                    y2="25"
                                    stroke={l.elementDetails.color}
                                    strokeWidth="8"
                                    marker-end={`url(#arrowhead${l.id})`}
                                />
                            </svg>









                        </div>
                    )

                }
                // return (
                //   <div id='selam34' style={{ display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "rgb(170,170,170)", color: "wheat", fontSize: "35px" }} key={i} className={l.static ? 'static' : ''}>
                //     {l.static ? (
                //       <span className="text" title="This item is static and cannot be removed or resized.">
                //         Static - {i}
                //       </span>
                //     ) : (
                //       <span style={{ padding: "10%", display: "flex", alignItems: "center", justifyContent: "center", width: "90%", height: "90%" }} className="text"><div id='test1' style={{ width: "100%", fontSize: `${Number(l.w) * 15}px`, height: "100%", backgroundColor: "black", display: "flex", alignItems: "center", justifyContent: "center" }}>{i}</div></span>
                //     )}
                //   </div>
                // );
            });
        } else if (currentBreakpoint === "xs") {
            if (!layouts.xs || !Array.isArray(layouts.xs)) {
                return [];
            }
            return _.map(layouts.xs, function (l, i) {
                if (l.type === "text") {

                    return (
                        <div
                            style={{
                                zIndex: "1",
                                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px",
                                borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px",
                                borderColor: l.borderColor ? l.borderColor : "black",
                                backgroundColor: l.bgColor ? l.bgColor : "white",
                                color: l.fontColor ? l.fontColor : "black",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                textAlign: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center",
                                fontSize: l.fontSize ? l.fontSize : `${(Number(l.w)) / 10}px`,
                                overflowWrap: "break-word",
                                wordBreak: "break-word",
                                whiteSpace: "normal",
                            }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: l.w,
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}
                            className={"text_widget" + " " + (l.special_type ? "special_type" : "")}
                        >
                            {l.elementDetails.text !== "" ? (
                                <span
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {l.elementDetails.text}
                                </span>
                            ) : (
                                <span
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    Bu alanda henüz metin yok.
                                </span>
                            )}
                        </div>
                    );

                } else if (l.type === "Alarm") {

                    let value;
                    let stats = alarms_state;

                    console.warn(stats); let seviye_ = l.elementDetails.seviye;
                    if (seviye_ === "1") {
                        value = stats?.high || 0
                    } else if (seviye_ === "2") {
                        value = stats?.warning || 0
                    } else {
                        value = stats?.critical || 0
                    }

                    return (
                        <div



                            style={{
                                zIndex: "1", border: "2px solid black", borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px",
                                borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor || "transparent"
                            }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: l.w,
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            data-id={l.special_type ? "l.special_type" : ""}
                            key={l.i}
                            className="alarm_widget"
                        >
                            <div className="main_alarm_widget">

                                <div style={{ display: "flex", justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center" }} className="showAlarmValueW">{value}</div>
                            </div>


                        </div>
                    );

                } else if (l.type === "gauge_linear") {

                    // tip kontrolü ile uygun tag değerini bul
                    let selectedTag;
                    if (l.elementDetails.tip === "Var") {
                        selectedTag = tag_values_state.find(
                            (item) => item.tip === "Var" && item.tagId === l.elementDetails.tagId
                        );
                    } else {
                        selectedTag = tag_values_state.find((item) => item.tagId === l.elementDetails.tagId);
                        // Sayısal değeri güvenli şekilde al
                        let value_tag = selectedTag ? selectedTag.tagValue : "";
                        console.warn("value_tag", value_tag)
                        const numericValue = parseFloat(value_tag);
                        console.warn(numericValue, "numericValue")
                        const isNumeric = !isNaN(numericValue);

                        // Eğer isNumeric false ise boşluktan sonrasını kes
                        value_tag = isNumeric ? value_tag : value_tag.split(' ')[0];

                        // startValue ve endValue güvenli şekilde belirle
                        const startValue =
                            l.elementDetails.startValue && isNumeric && l.elementDetails.startValue <= numericValue
                                ? l.elementDetails.startValue
                                : 0;

                        const endValue =
                            l.elementDetails.endValue && isNumeric && l.elementDetails.endValue >= numericValue
                                ? l.elementDetails.endValue
                                : isNumeric
                                    ? numericValue.toFixed(2)
                                    : 100;
                        // normalizedValue hesapla
                        const normalizedValue = isNumeric
                            ? ((value_tag - startValue) / (endValue - startValue)) * 100
                            : 0;



                        const linearOptions = {
                            pointer: {
                                value: isNumeric ? numericValue : 50, // Sayıysa kullan, değilse 50
                                shape: "arrow",
                                size: 20,
                                color: "rgb(20,20,20)"// Pointer büyüklüğü artırıldı
                            },
                            scale: {
                                min: startValue,
                                max: endValue,
                                majorUnit: (endValue - startValue) / 5,
                                minorUnit: 2,
                                line: {
                                    width: 5, // Ölçek çizgisi kalınlaştırıldı
                                    color: "black"
                                },
                                labels: {
                                    color: "black",
                                    visible: true,
                                    font: "14px Arial, sans-serif", // Yazı fontu büyütüldü
                                },
                                ranges: [
                                    { from: startValue, to: l.elementDetails.alarmValue ? l.elementDetails.alarmValue : (endValue - startValue) / 2, color: "red" },
                                    { from: l.elementDetails.alarmValue ? l.elementDetails.alarmValue : (endValue - startValue) / 2, to: endValue, color: "blue" },
                                ],
                            },
                        };

                        const alarmValue = l.elementDetails.alarmValue || 0


                        return (
                            <div
                                className="gauge_widgetParentDiv"
                                data-grid={{
                                    x: l.x,
                                    y: l.y,
                                    w: l.w,
                                    h: l.h,
                                    resizeHandles: l.resizeHandles,
                                }}


                                style={{
                                    border: "none",
                                    borderWidth: l.borderWidth ? `${l.borderWidth}px` : "2px",
                                    backgroundColor: "transparent",
                                    borderRadius: l.elementDetails.borderRadius ? `${l.elementDetails.borderRadius}px` : "8px",

                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    borderColor: l.borderColor ? l.borderColor : "rgb(100,100,100)",
                                    overflow: "hidden",
                                }}
                                key={l.i}
                                id={l.id}
                                data-id={l.special_type ? "l.special_type" : ""}

                                onContextMenu={(e) => {
                                    if (l.elementDetails.tagId && l.add_trend && l.add_trend === "YES") {
                                        var tagName = tags
                                            .filter((b) => b.tagId === l.elementDetails.tagId)
                                            .map((c) => c.tagName)[0];

                                        e.preventDefault();
                                        const { clientX, clientY } = e;
                                        let screen_width = window.innerWidth;
                                        console.log(clientX, clientY);
                                        document
                                            .querySelector(".show_external_trend")
                                            .classList.toggle(
                                                "show_external_trend_active"
                                            );
                                        document.querySelector(
                                            ".show_tagId"
                                        ).innerHTML = l.elementDetails.tagId;
                                        document.querySelector(
                                            ".show_tagName"
                                        ).innerHTML = tagName;
                                        var popup = document.querySelector(
                                            ".show_external_trend"
                                        );
                                        const popupRect =
                                            popup.getBoundingClientRect();
                                        const viewportWidth = window.innerWidth;
                                        const viewportHeight = window.innerHeight;

                                        // Calculate the new positions
                                        let newX = clientX;
                                        let newY = clientY;

                                        // Adjust if the popup would overflow the right edge of the viewport
                                        if (
                                            newX + popupRect.width >
                                            viewportWidth
                                        ) {
                                            newX = viewportWidth - popupRect.width;
                                        }

                                        // Adjust if the popup would overflow the bottom edge of the viewport
                                        if (
                                            newY + popupRect.height >
                                            viewportHeight
                                        ) {
                                            newY =
                                                viewportHeight - popupRect.height;
                                        }

                                        // Adjust if the popup would overflow the left edge of the viewport
                                        if (newX < 0) {
                                            newX = 0;
                                        }

                                        // Adjust if the popup would overflow the top edge of the viewport
                                        if (newY < 0) {
                                            newY = 0;
                                        }

                                        if (
                                            screen_width < 2301 &&
                                            screen_width > 1800
                                        ) {
                                            document.querySelector(
                                                ".show_external_trend"
                                            ).style.left = `${String(
                                                newX / 1.2
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_trend"
                                            ).style.top = `${String(newY / 1.2)}px`;
                                        } else if (
                                            screen_width < 2801 &&
                                            screen_width > 2300
                                        ) {
                                            document.querySelector(
                                                ".show_external_trend"
                                            ).style.left = `${String(
                                                newX / 1.5
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_trend"
                                            ).style.top = `${String(newY / 1.5)}px`;
                                        } else if (
                                            screen_width < 3501 &&
                                            screen_width > 2800
                                        ) {
                                            document.querySelector(
                                                ".show_external_trend"
                                            ).style.left = `${String(
                                                newX / 1.8
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_trend"
                                            ).style.top = `${String(newY / 1.8)}px`;
                                        } else if (
                                            screen_width < 5001 &&
                                            screen_width > 3500
                                        ) {
                                            document.querySelector(
                                                ".show_external_trend"
                                            ).style.left = `${String(
                                                newX / 2.5
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_trend"
                                            ).style.top = `${String(newY / 2.5)}px`;
                                        } else if (screen_width <= 1800) {
                                            document.querySelector(
                                                ".show_external_trend"
                                            ).style.left = `${String(newX)}px`;
                                            document.querySelector(
                                                ".show_external_trend"
                                            ).style.top = `${String(newY)}px`;
                                        }
                                    } else if (l.elementDetails.tagId && l.elementDetails.tagId !== "") {
                                        var tagName = tags
                                            .filter((b) => b.tagId === l.elementDetails.tagId)
                                            .map((c) => c.tagName)[0];

                                        e.preventDefault();
                                        const { clientX, clientY } = e;
                                        let screen_width = window.innerWidth;
                                        console.log(clientX, clientY);
                                        document
                                            .querySelector(".show_external_detail")
                                            .classList.toggle(
                                                "show_external_detail_active"
                                            );
                                        document.querySelector(
                                            ".show_tagId2"
                                        ).innerHTML = l.elementDetails.tagId;
                                        document.querySelector(
                                            ".show_tagName2"
                                        ).innerHTML = tagName;
                                        var popup = document.querySelector(
                                            ".show_external_detail"
                                        );
                                        const popupRect =
                                            popup.getBoundingClientRect();
                                        const viewportWidth = window.innerWidth;
                                        const viewportHeight = window.innerHeight;

                                        // Calculate the new positions
                                        let newX = clientX;
                                        let newY = clientY;

                                        // Adjust if the popup would overflow the right edge of the viewport
                                        if (
                                            newX + popupRect.width >
                                            viewportWidth
                                        ) {
                                            newX = viewportWidth - popupRect.width;
                                        }

                                        // Adjust if the popup would overflow the bottom edge of the viewport
                                        if (
                                            newY + popupRect.height >
                                            viewportHeight
                                        ) {
                                            newY =
                                                viewportHeight - popupRect.height;
                                        }

                                        // Adjust if the popup would overflow the left edge of the viewport
                                        if (newX < 0) {
                                            newX = 0;
                                        }

                                        // Adjust if the popup would overflow the top edge of the viewport
                                        if (newY < 0) {
                                            newY = 0;
                                        }

                                        if (
                                            screen_width < 2301 &&
                                            screen_width > 1800
                                        ) {
                                            document.querySelector(
                                                ".show_external_detail"
                                            ).style.left = `${String(
                                                newX / 1.2
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_detail"
                                            ).style.top = `${String(newY / 1.2)}px`;
                                        } else if (
                                            screen_width < 2801 &&
                                            screen_width > 2300
                                        ) {
                                            document.querySelector(
                                                ".show_external_detail"
                                            ).style.left = `${String(
                                                newX / 1.5
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_detail"
                                            ).style.top = `${String(newY / 1.5)}px`;
                                        } else if (
                                            screen_width < 3501 &&
                                            screen_width > 2800
                                        ) {
                                            document.querySelector(
                                                ".show_external_detail"
                                            ).style.left = `${String(
                                                newX / 1.8
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_detail"
                                            ).style.top = `${String(newY / 1.8)}px`;
                                        } else if (
                                            screen_width < 5001 &&
                                            screen_width > 3500
                                        ) {
                                            document.querySelector(
                                                ".show_external_detail"
                                            ).style.left = `${String(
                                                newX / 2.5
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_detail"
                                            ).style.top = `${String(newY / 2.5)}px`;
                                        } else if (screen_width <= 1800) {
                                            document.querySelector(
                                                ".show_external_detail"
                                            ).style.left = `${String(newX)}px`;
                                            document.querySelector(
                                                ".show_external_detail"
                                            ).style.top = `${String(newY)}px`;
                                        }
                                    }
                                }}
                            >
                                <div className="su_tanki_gauge_linear" style={{ borderColor: l.borderColor || "#000" }}>
                                    <div style={{ position: "relative", height: "100%", width: "100%", display: "flex", flexDirection: "column-reverse" }}>
                                        <div style={{ width: "100%", height: alarmValue >= numericValue ? "0%" : numericValue * 100 / endValue + "%", backgroundColor: "blue" }} className="water"></div>
                                        <div style={{ width: "100%", height: alarmValue >= numericValue ? numericValue * 100 / endValue + "%" : "0%", backgroundColor: "red" }} className="alarmWater"></div>

                                        <div
                                            style={{
                                                position: "absolute",
                                                top: "50%",
                                                left: "50%",
                                                transform: "translate(-50%, -50%)", // Bu, öğeyi tam olarak ortalar
                                                backgroundColor: "black", // Hafif şeffaf beyaz arka plan
                                                padding: "4px 8px",
                                                borderRadius: "6px",
                                                fontSize: "16px",
                                                fontWeight: "bold",
                                                zIndex: "3",
                                                color: "#ffffff", // Daha koyu siyah
                                                fontFamily: "'Poppins', sans-serif", // Daha modern ve seksi font
                                                boxShadow: "2px 2px 6px rgba(0, 0, 0, 0.15)", // Hafif gölge efekti
                                            }}
                                        >
                                            {isNumeric ? l.elementDetails.pU && l.elementDetails.pU === "Percent" ? (numericValue * 100 / endValue).toFixed(2) + "%" : numericValue : 50}
                                        </div>
                                    </div>
                                </div>



                            </div>
                        );
                    }
                }
                else if (l.type === "lock") {
                    let value_ = tag_values_state.find(i =>
                        l.elementDetails.tip !== "Var"
                            ? String(i.tagId) === String(l.elementDetails.tagId)
                            : i.tip === "Var" && String(i.tagId) === String(l.elementDetails.tagId)
                    )?.tagValue;
                    if (value_ && isNaN(Number(value_))) {
                        value_ = value_.split(' ')[0]; // ilk boşluktan önceki kısmı al
                        value_ = value_.includes(" ") ? value_.trim() : value_
                    }
                    return (
                        <div


                            onClick={(e) => {
                                let tagValue;
                                (layouts[currentBreakpoint] || []).forEach(x => {
                                    if (String(x.id) === String(l.id)) {
                                        let tagId_ = l.elementDetails.tagId || "";

                                        tagValue = value_ === "1" ? "0" : "1";
                                        setValueFunc({ TagId: tagId_, TagValue: tagValue })
                                        document.querySelectorAll(".react-grid-item").forEach((item) => {
                                            if (item.classList.contains(`${l.elementDetails.tagIdEx}`)) {
                                                item.style.pointerEvents = tagValue === "1" ? "none" : "all";
                                                if (e.target.classList.contains("fa-lock")) {
                                                    item.style.opacity = "1"
                                                } else if (e.target.classList.contains("fa-unlock")) {
                                                    item.style.opacity = "0.55"
                                                }
                                            }
                                        })
                                        if (e.target.classList.contains("fa-lock")) {
                                            e.target.classList.replace("fa-lock", "fa-unlock");
                                        } else if (e.target.classList.contains("fa-unlock")) {
                                            e.target.classList.replace("fa-unlock", "fa-lock");
                                        }
                                    }
                                })
                            }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            data-id={l.special_type ? "l.special_type" : ""}
                            key={l.i}
                            className={`lock_widget`}
                        >
                            <i id="lock_i_dyn" style={{ color: l.fontColor || "gray", width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: `${l.w / 4}px` }} className={value_ === "0" ? "fa fa-lock" : "fa fa-unlock"}></i>



                        </div>
                    );
                } else if (l.type === "i_g") {
                    return (
                        <div

                            onClick={() => {
                                pages.forEach(async x => {
                                    if (Number(x.pageId) === Number(l.elementDetails.pageId)) {
                                        function normalizeURLPath(path) {
                                            const turkishMap = {
                                                'İ': 'I', 'ı': 'i', 'Ş': 'S', 'ş': 's',
                                                'Ğ': 'G', 'ğ': 'g', 'Ü': 'U', 'ü': 'u',
                                                'Ö': 'O', 'ö': 'o', 'Ç': 'C', 'ç': 'c'
                                            };

                                            return path.split('').map(char => turkishMap[char] || char).join('');
                                        }
                                        await Store.dispatch(set_current_dyn_pageName(x.pageName))
                                        history.push(`/pages/${normalizeURLPath(x.pageName).replaceAll(" ", "_")}`)

                                    }
                                })
                            }}

                            style={{
                                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px",
                                border: "2px solid rgb(60,60,60)", borderColor: l.borderColor ? l.borderColor : "black", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black",
                                borderRadius: "4px", zIndex: "1", cursor: "pointer"
                            }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            data-id={l.special_type ? "l.special_type" : ""}
                            key={l.i}
                            className="i_g_widget"
                        >

                            <div style={{ backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black", width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                                {l.elementDetails.text}

                            </div>

                        </div>
                    );
                } else if (l.type === "y_g") {

                    let value_ = tag_values_state.find(i =>
                        l.elementDetails.tip !== "Var"
                            ? String(i.tagId) === String(l.elementDetails.tagId)
                            : i.tip === "Var" && String(i.tagId) === String(l.elementDetails.tagId)
                    )?.tagValue;

                    // Eğer value_ sayısal değilse, boşluktan sonrasını sil
                    if (value_ && isNaN(Number(value_))) {
                        value_ = value_.split(' ')[0];

                    }
                    console.warn("value_", value_, typeof (value_));

                    value_ = value_ && value_.split('.')[0]; // Noktadan sonrasını almaz

                    console.warn("value_", value_, typeof (value_));

                    // 2. value_list oluştur (value1, value2, value3... varsa onları al)
                    let valueList = [];
                    let i = 1;
                    while (l.elementDetails[`value${i}`] !== undefined) {
                        valueList.push(l.elementDetails[`value${i}`]);
                        i++;
                    }


                    // 2. `value_.elementDetailslist` İçinde `valelementDetails.ue_` İndeksini Bul
                    let index_ = l.elementDetails.value_list && l.elementDetails.value_list.indexOf(
                        value_ !== undefined && value_.includes(" ") ? value_.trim() : value_
                    );

                    // 3. Varsayılan Atama
                    if (index_ === -1 || index_ === undefined) { // `indexOf` bulunamazsa -1 döner
                        index_ = 0;
                    }

                    return (
                        <div

                            onContextMenu={(e) => {
                                if (l.elementDetails.tagId && l.add_trend && l.add_trend === "YES") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_trend")
                                        .classList.toggle(
                                            "show_external_trend_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_trend"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                } else if (l.elementDetails.tagId && l.elementDetails.tagId !== "") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_detail")
                                        .classList.toggle(
                                            "show_external_detail_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId2"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName2"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_detail"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                }
                            }}
                            style={{
                                border: "2px solid rgb(60,60,60)",

                                width: l.elementDetails.rad ? l.elementDetails.rad + "px" : "10px", height: l.elementDetails.rad ? l.elementDetails.rad + "px" : "10px", borderRadius: l.elementDetails.rad ? (l.elementDetails.tur ? l.elementDetails.tur === "circle" ? l.elementDetails.rad + "px" : l.elementDetails.borderRadius + "px" : "10px") : "10px", zIndex: "1", borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px",
                                backgroundColor: l.elementDetails.bg_list && l.elementDetails.bg_list[index_] ? l.elementDetails.bg_list[index_] : "white", borderColor: l.elementDetails.border_list && l.elementDetails.border_list[index_] ? l.elementDetails.border_list[index_] : "black"
                            }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: l.elementDetails.rad ? l.elementDetails.rad : l.w,
                                h: l.elementDetails.rad ? l.elementDetails.rad : l.w,
                            }}
                            id={l.id}
                            data-id={l.special_type ? "l.special_type" : ""}
                            key={l.i}
                            className="yuvarlak_gosterge_widget"
                        >


                        </div>
                    );
                }
                else if (l.type === "go_page") {
                    return (
                        <div

                            onClick={() => {
                                if (l.elementDetails.text === "Alarm" && alarm_okuma) {
                                    history.push("/AlarmPanel")
                                } else {
                                    pages.forEach(async x => {
                                        if (Number(x.pageId) === Number(l.elementDetails.pageId)) {
                                            console.warn(l)

                                            function normalizeURLPath(path) {
                                                const turkishMap = {
                                                    'İ': 'I', 'ı': 'i', 'Ş': 'S', 'ş': 's',
                                                    'Ğ': 'G', 'ğ': 'g', 'Ü': 'U', 'ü': 'u',
                                                    'Ö': 'O', 'ö': 'o', 'Ç': 'C', 'ç': 'c'
                                                };

                                                return path.split('').map(char => turkishMap[char] || char).join('');
                                            }
                                            await Store.dispatch(set_current_dyn_pageName(x.pageName))
                                            history.push(`/pages/${normalizeURLPath(x.pageName).replaceAll(" ", "_")}`)

                                        }
                                    })
                                }
                            }
                            }

                            style={{
                                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px",
                                border: "2px solid rgb(60,60,60)", borderColor: l.borderColor ? l.borderColor : "black", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black",
                                borderRadius: "4px", zIndex: "1", cursor: "pointer"
                            }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            data-id={l.special_type ? "l.special_type" : ""}
                            key={l.i}
                            className="go_page_widget"
                        >

                            <div style={{ backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black", width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                                {l.elementDetails.text}

                            </div>

                        </div>
                    );
                }
                else if (l.type === "set") {

                    // 1. `value_` Değerini Bul
                    let value_ = tag_values_state.find(i =>
                        l.elementDetails.tip !== "Var"
                            ? String(i.tagId) === String(l.elementDetails.tagId)
                            : i.tip === "Var" && String(i.tagId) === String(l.elementDetails.tagId)
                    )?.tagValue;

                    // Eğer value_ sayısal değilse, boşluktan sonrasını sil
                    if (value_ && isNaN(Number(value_))) {
                        value_ = value_.split(' ')[0]; // ilk boşluktan önceki kısmı al
                    }

                    // 2. `value_list` İçinde `value_` İndeksini Bul
                    let index_ = l.elementDetails.value_list && l.elementDetails.value_list.indexOf(
                        value_ !== undefined && value_.includes(" ") ? value_.trim() : value_
                    );


                    // 3. Varsayılan Atama
                    if (index_ === -1 || index_ === undefined) { // `indexOf` bulunamazsa -1 döner
                        index_ = 0;
                    }


                    console.warn(value_, l, tag_values_state)

                    return (
                        <div
                            onContextMenu={(e) => {
                                if (l.elementDetails.tagId && l.add_trend && l.add_trend === "YES") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_trend")
                                        .classList.toggle(
                                            "show_external_trend_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_trend"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                } else if (l.elementDetails.tagId && l.elementDetails.tagId !== "") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_detail")
                                        .classList.toggle(
                                            "show_external_detail_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId2"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName2"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_detail"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                }
                            }}

                            onClick={(e) => {
                                if (l.elementDetails.tagId2 && l.elementDetails.tagId2 !== "" && l.elementDetails.tagId2 !== "None" && yazma_control) {
                                    console.log(e.target);
                                    e.preventDefault();
                                    e.stopPropagation();
                                    const { clientX, clientY } = e;
                                    document.querySelector(".Popup-selectbox2").classList.toggle("changeProperties_active")
                                    document.querySelector(".Popup-selectbox2").id = l.id

                                    var popup = document.querySelector(".Popup-selectbox2")
                                    const popupRect = popup.getBoundingClientRect();

                                    // Yeni pozisyonları hesapla
                                    let newX = clientX + window.scrollX;
                                    let newY = clientY + window.scrollY;

                                    console.log(newX, newY);

                                    // Sağ kenardan taşmayı önle
                                    if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                                        newX = window.innerWidth + window.scrollX - popupRect.width;
                                    }

                                    // Alt kenardan taşmayı önle
                                    if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                                        newY = window.innerHeight + window.scrollY - popupRect.height;
                                    }

                                    // Sol kenardan taşmayı önle
                                    if (newX < window.scrollX) {
                                        newX = window.scrollX;
                                    }

                                    // Üst kenardan taşmayı önle
                                    if (newY < window.scrollY) {
                                        newY = window.scrollY;
                                    }

                                    console.log(newX, newY);

                                    // Pop-up'ın pozisyonunu ayarla
                                    popup.style.left = `${newX}px`;
                                    popup.style.top = `${newY}px`;

                                    const parentElement = e.target.closest(".set_widget");
                                    const parentRect = parentElement.getBoundingClientRect();

                                    Set_elem_popup({
                                        width: l.w,
                                        height: l.h,
                                        left: l.x,
                                        top: l.y,

                                        value_list: l.elementDetails.value_list && l.elementDetails.value_list.length === 0 ? l.value_list : l.elementDetails.value_list,
                                        bg_list: l.elementDetails.bg_list && l.elementDetails.bg_list.length === 0 ? l.bg_list : l.elementDetails.bg_list,
                                        border_list: l.elementDetails.border_list && l.elementDetails.border_list.length === 0 ? l.border_list : l.elementDetails.border_list,
                                        font_list: l.elementDetails.font_list && l.elementDetails.font_list.length === 0 ? l.font_list : l.elementDetails.font_list,
                                        type: l.type,
                                        id: l.id,
                                        fontSize: l.fontSize ? l.fontSize : Number(l.w) / 10,
                                        value: l.elementDetails.text
                                    })
                                    setSelectedOptionselectbox(l.elementDetails.text)
                                }

                            }}
                            style={{
                                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px",
                                borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", backgroundColor: "white", border: "2px solid rgb(60,60,60)", borderColor: l.borderColor ? l.borderColor : "black", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black",
                                zIndex: "1",
                            }}

                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            data-id={l.special_type ? "l.special_type" : ""}
                            key={l.i}
                            className={`set_widget ${l.elementDetails.text} ${l.elementDetails.tagId}` + " " + (l.special_type ? "special_type" : "")}
                        >
                            <div style={{ backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black", width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                                {Number(value_).toLocaleString("tr-TR", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                }) || l.elementDetails.text}

                            </div>

                        </div>
                    );
                }
                else if (l.type === "selectbox") {

                    let value_ = tag_values_state.find(i =>
                        l.elementDetails.tip !== "Var"
                            ? String(i.tagId) === String(l.elementDetails.tagId)
                            : i.tip === "Var" && String(i.tagId) === String(l.elementDetails.tagId)
                    )?.tagValue;

                    // Eğer value_ sayısal değilse, boşluktan sonrasını sil
                    if (value_ && isNaN(Number(value_))) {
                        value_ = value_.split(' ')[0];

                    }
                    console.warn("value_", value_, typeof (value_));

                    value_ = value_ && value_.split('.')[0]; // Noktadan sonrasını almaz

                    console.warn("value_", value_, typeof (value_), l);

                    // 2. value_list oluştur (value1, value2, value3... varsa onları al)
                    let valueList = [];
                    let i = 1;
                    while (l.elementDetails[`value${i}`] !== undefined) {
                        valueList.push(l.elementDetails[`value${i}`]);
                        i++;
                    }


                    // 2. `value_list` İçinde `value_` İndeksini Bul
                    let index_ = l.elementDetails.value_list && l.elementDetails.value_list.indexOf(
                        value_ !== undefined && typeof value_ === "string" && value_.includes(" ")
                            ? value_.trim()
                            : value_
                    );

                    // 3. Varsayılan Atama
                    if (index_ === -1 || index_ === undefined) {
                        index_ = 0;
                    }

                    console.warn(value_, l, tag_values_state)
                    let text_list_ = l.elementDetails.text_list;
                    let alarmClassName = "";

                    if (text_list_ && text_list_.length > 0 && text_list_[index_] === "ALARM" && l.special_type) {
                        alarmClassName = "alarmactive_blackBorder";
                        (layouts[currentBreakpoint] || []).forEach((item) => {
                            if (item.id === l.id2 && !item.special_type) {
                                let id = item.id
                                document.querySelector(`#Popup${id}`).style.backgroundColor = "red"
                            }
                        });

                    }




                    return (
                        <div
                            onContextMenu={(e) => {
                                if (l.elementDetails.tagId && l.add_trend && l.add_trend === "YES") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_trend")
                                        .classList.toggle(
                                            "show_external_trend_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_trend"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                } else if (l.elementDetails.tagId && l.elementDetails.tagId !== "") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_detail")
                                        .classList.toggle(
                                            "show_external_detail_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId2"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName2"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_detail"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                }
                            }}
                            onClick={(e) => {
                                if (l.elementDetails.tagId2 && l.elementDetails.tagId2 !== "" && l.elementDetails.tagId2 !== "None" && yazma_control) {
                                    console.log(e.target);
                                    e.preventDefault();
                                    e.stopPropagation();
                                    const { clientX, clientY } = e;
                                    document.querySelector(".Popup-selectbox").classList.toggle("changeProperties_active")
                                    document.querySelector(".Popup-selectbox").id = l.id

                                    var popup = document.querySelector(".Popup-selectbox")
                                    const popupRect = popup.getBoundingClientRect();

                                    // Yeni pozisyonları hesapla
                                    let newX = clientX + window.scrollX;
                                    let newY = clientY + window.scrollY;

                                    console.log(newX, newY);

                                    // Sağ kenardan taşmayı önle
                                    if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                                        newX = window.innerWidth + window.scrollX - popupRect.width;
                                    }

                                    // Alt kenardan taşmayı önle
                                    if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                                        newY = window.innerHeight + window.scrollY - popupRect.height;
                                    }

                                    // Sol kenardan taşmayı önle
                                    if (newX < window.scrollX) {
                                        newX = window.scrollX;
                                    }

                                    // Üst kenardan taşmayı önle
                                    if (newY < window.scrollY) {
                                        newY = window.scrollY;
                                    }

                                    console.log(newX, newY);

                                    // Pop-up'ın pozisyonunu ayarla
                                    popup.style.left = `${newX}px`;
                                    popup.style.top = `${newY}px`;

                                    const parentElement = e.target.closest(".selectbox_widget");
                                    const parentRect = parentElement.getBoundingClientRect();

                                    Set_elem_popup({
                                        width: l.w,
                                        height: l.h,
                                        left: l.x,
                                        top: l.y,
                                        text_list: l.elementDetails.text_list.length === 0 ? l.text_list : l.elementDetails.text_list,
                                        value_list: l.elementDetails.value_list && l.elementDetails.value_list.length === 0 ? l.value_list : l.elementDetails.value_list,
                                        bg_list: l.elementDetails.bg_list && l.elementDetails.bg_list.length === 0 ? l.bg_list : l.elementDetails.bg_list,
                                        border_list: l.elementDetails.border_list && l.elementDetails.border_list.length === 0 ? l.border_list : l.elementDetails.border_list,
                                        font_list: l.elementDetails.font_list && l.elementDetails.font_list.length === 0 ? l.font_list : l.elementDetails.font_list,
                                        type: l.type,
                                        id: l.id,
                                        fontSize: l.fontSize ? l.fontSize : Number(l.w) / 10,
                                        value: l.elementDetails.text
                                    })
                                    setSelectedOptionselectbox(l.elementDetails.text)
                                }

                            }}
                            style={{
                                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px",
                                backgroundColor: "white", border: "2px solid rgb(60,60,60)", borderColor: l.elementDetails.border_list && l.elementDetails.border_list[index_] ? l.elementDetails.border_list[index_] : "black", backgroundColor: l.elementDetails.bg_list && l.elementDetails.bg_list[index_] ? l.elementDetails.bg_list[index_] : "white", color: l.elementDetails.font_list && l.elementDetails.font_list[index_] ? l.elementDetails.font_list[index_] : "black", zIndex: "1",
                            }}

                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            className={`selectbox_widget ${l.elementDetails.text}` + " " + (l.special_type ? ("special_type_ " + alarmClassName) : "")}
                        >
                            <div style={{ backgroundColor: "transparent", color: l.elementDetails.font_list && l.elementDetails.font_list[index_] ? l.elementDetails.font_list[index_] : "black", width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                                {l.elementDetails.text_list[index_]}

                            </div>

                        </div>
                    );
                }
                else if (l.type === "senaryoSelect") {
                    return (
                        <div


                            style={{
                                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px",
                                backgroundColor: "white", border: "2px solid rgb(60,60,60)", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black", borderRadius: "8px", zIndex: "1",
                            }}

                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            className={`senaryo_widget ${l.elementDetails.text}`}
                        >
                            <div style={{ backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black", width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                                {l.elementDetails.text}

                            </div>

                        </div>
                    );
                }
                else if (l.type === "trend") {
                    let data_ = {
                        labels: [],
                        datasets: [{
                            data: [],
                            backgroundColor: "transparent",
                            borderColor: "#f26c6d",
                            pointBorderColor: "#f26c6d",
                            pointBorderWidth: 1
                        }]

                    }
                    if (l.elementDetails.data) {
                        data_ = {
                            labels: (l.elementDetails.data || []).map((item, index) => {
                                return item.date

                            }),
                            datasets: [{
                                data: (l.elementDetails.data || []).map((item, index) => {
                                    return item.value
                                }),
                                backgroundColor: "transparent",
                                borderColor: "#f26c6d",
                                pointBorderColor: "#f26c6d",
                                pointBorderWidth: 1
                            }]

                        }
                    }

                    const datason = data_

                    const optionsSon = {
                        scales: {
                            x: {
                                type: 'time',
                                time: {
                                    unit: 'day',
                                    stepSize: 1,
                                    displayFormats: {
                                        day: 'MMM D'
                                    }
                                },
                                ticks: {
                                    maxTicksLimit: 24
                                }
                            },
                            y: {
                                min: Number(min),
                                max: 0,
                                beginAtZero: true,
                                ticks: {
                                    callback: function (value) {
                                        return Number(value.toFixed(2)); // Etiketlerdeki sıfırları engelle
                                    }
                                }
                            }
                        },
                        plugins: {
                            legend: {
                                display: true,
                                labels: {
                                    filter: function (item, chart) {
                                        return item.text !== undefined;
                                    },
                                    generateLabels: function (chart) {
                                        return [{
                                            text: "",
                                            fillStyle: "crimson",
                                            strokeStyle: chart.ctx.strokeStyle,
                                            lineWidth: chart.ctx.lineWidth,
                                            hidden: false,
                                            index: 0,
                                            datasetIndex: 0
                                        }];
                                    }
                                }
                            },
                            zoom: {
                                pan: {
                                    enabled: true,
                                    mode: 'xy',
                                },
                                zoom: {
                                    wheel: {
                                        enabled: true,
                                    },
                                    pinch: {
                                        enabled: true,
                                    },
                                    mode: 'x',
                                    onZoom: ({ chart }) => {
                                        const xScale = chart.scales.x;
                                        const min = xScale.min;
                                        const max = xScale.max;
                                        const diff = max - min;
                                        let unit = 'second';

                                        // Zoom leveline göre birim seçimi
                                        if (diff > 1000 * 60 * 60 * 24 * 7) {
                                            unit = 'day';
                                        } else if (diff > 1000 * 60 * 60) {
                                            unit = 'hour';
                                        } else if (diff > 1000 * 60) {
                                            unit = 'minute';
                                        }

                                        // Yeniden ayarlama
                                        xScale.options.time.unit = unit;
                                        xScale.options.time.tooltipFormat = unit === 'second' ? 'll HH:mm:ss' : 'll HH:mm';
                                        xScale.options.ticks.callback = (value) => {
                                            return moment(value).format(unit === 'second' ? 'll HH:mm:ss' : 'll HH:mm');
                                        };

                                        chart.update();
                                    },
                                },
                            },
                        },
                    };

                    return (
                        <div


                            style={{ zIndex: "1", marginTop: "-8px" }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            className="trend_widget"
                        >

                            <div style={{ width: "100%", height: "100%" }} className="bottom_sec trend_graph">
                                <Line options={JSON.stringify(real_datas) !== "{}" ? real_datas[String(l.id)] ? createChartOptions(String(l.id)) : optionsSon : optionsSon} data={JSON.stringify(real_datas) !== "{}" ? real_datas[String(l.id)] ? createChartData(String(l.id)) : datason : datason} />
                            </div>
                        </div>
                    )
                }
                else if (l.type === "empty_btn") {
                    return (
                        <div


                            style={{
                                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px",
                                backgroundColor: "white", border: "2px solid rgb(60,60,60)", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black", borderRadius: "8px", zIndex: "1",
                            }}

                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            className={`empty_btn_widget ${l.elementDetails.text}`}
                        >
                            <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                                <input disabled={true} style={{ backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black", backgroundColor: "transparent", width: "100%", outline: "none", appearance: "none", border: "none", textAlign: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w)) / 10}px` }} type="text" value={l.elementDetails.text} />


                            </div>

                        </div>
                    );
                }
                else if (l.type === "t_t") {

                    return (
                        <div

                            onContextMenu={(e) => {
                                if (l.elementDetails.tagId && l.add_trend && l.add_trend === "YES") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_trend")
                                        .classList.toggle(
                                            "show_external_trend_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_trend"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                } else if (l.elementDetails.tagId && l.elementDetails.tagId !== "") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_detail")
                                        .classList.toggle(
                                            "show_external_detail_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId2"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName2"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_detail"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                }
                            }}

                            style={{
                                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px",
                                zIndex: "1", borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", borderColor: l.borderColor ? l.borderColor : "black", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black",
                            }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: l.w,
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            data-id={l.special_type ? "l.special_type" : ""}
                            key={l.i}
                            className="text_tag_widget"
                        >

                            <input
                                type="text"
                                style={{
                                    width: "100%", textAlign: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w)) / 10}px`, position: "relative", backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black"
                                }}
                                disabled={true}

                                value={
                                    (l.elementDetails.text !== "" ? l.elementDetails.text : " ") +
                                    " : " +
                                    (
                                        l.elementDetails.tagId !== ""
                                            ? (() => {
                                                const matchedItem = tag_values_state.find(item =>
                                                    l.elementDetails.tip !== "Var"
                                                        ? item.tagId === l.elementDetails.tagId
                                                        : item.tip === "Var" && item.tagId === l.elementDetails.tagId
                                                );

                                                const tagValue = matchedItem?.tagValue;
                                                const formatted = tagValue != null
                                                    ? Number(tagValue).toLocaleString("tr-TR", {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2,
                                                    })
                                                    : "";

                                                return (
                                                    formatted +
                                                    (l.elementDetails.unit && l.elementDetails.unit !== "None"
                                                        ? " " + l.elementDetails.unit
                                                        : "")
                                                );
                                            })()
                                            : " "
                                    )

                                }


                            />
                            )
                        </div>
                    );
                }

                else if (l.type === "tag") {
                    const matchingTag = tag_values_state.find(item =>
                        l.elementDetails.tip !== "Var"
                            ? item.tagId === l.elementDetails.tagId
                            : item.tip === "Var" && item.tagId === l.elementDetails.tagId
                    );

                    const decimalPlaces = matchingTag && matchingTag.tagDecimal !== null ? Number(matchingTag.tagDecimal) : 2;
                    let formattedValue = "";

                    if (matchingTag) {
                        let value_tag = matchingTag.tagValue;
                        if (value_tag && isNaN(Number(value_tag))) {
                            value_tag = value_tag.split(" ")[0];
                        }

                        console.log(value_tag, 1)

                        if (value_tag && !isNaN(Number(value_tag))) {
                            let numericValue = Number(value_tag);

                            // Eğer birimi kW/h ise 1000'e böl
                            if (l.elementDetails.unit === "kW/h") {
                                numericValue = numericValue / 1000;
                            }

                            console.log(numericValue, 2)

                            formattedValue = numericValue.toLocaleString("tr-TR", {
                                minimumFractionDigits: decimalPlaces,
                                maximumFractionDigits: decimalPlaces,
                            }) + (l.elementDetails.unit && l.elementDetails.unit !== "None" ? " " + l.elementDetails.unit : "");
                        }
                    }




                    return (
                        <div

                            onContextMenu={(e) => {
                                if (l.elementDetails.tagId && l.add_trend && l.add_trend === "YES") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_trend")
                                        .classList.toggle(
                                            "show_external_trend_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_trend"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                } else if (l.elementDetails.tagId && l.elementDetails.tagId !== "") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_detail")
                                        .classList.toggle(
                                            "show_external_detail_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId2"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName2"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_detail"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                }
                            }}

                            style={{ borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", zIndex: "1", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black", }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            className={"tag_widget" + " " + (l.special_type ? "special_type" : "")}
                        >



                            <input
                                id={l.id + "cc"}
                                type="text"
                                disabled={true}
                                style={{
                                    backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black",
                                    fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, textAlign: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center",
                                    width: "100%", backgroundColor: "transparent", outline: "none", border: "none",

                                }}
                                value={
                                    l.elementDetails.tagId !== ""
                                        ? (() => {
                                            const source = tag_values_state.length > 0 ? tag_values_state : tag_values_state;

                                            const matchedItem = source.find(item =>
                                                l.elementDetails.tip !== "Var"
                                                    ? item.tagId === l.elementDetails.tagId
                                                    : item.tip === "Var" && item.tagId === l.elementDetails.tagId
                                            );

                                            let value_tag = matchedItem?.tagValue;

                                            // Sayı değilse boşluktan önceki kısmı al
                                            if (value_tag && isNaN(Number(value_tag))) {
                                                value_tag = value_tag.split(" ")[0];
                                            }

                                            // Formatla
                                            if (value_tag && !isNaN(Number(value_tag))) {
                                                let numericValue = Number(value_tag);

                                                // BURASI EKLENDİ: Eğer birimi kW/h ise 1000'e böl
                                                if (l.elementDetails.unit === "kW/h") {
                                                    numericValue = numericValue / 1000;
                                                }

                                                const decimalPlaces = l.elementDetails.decimal ?? 2;

                                                const formatted = numericValue.toLocaleString("tr-TR", {
                                                    minimumFractionDigits: decimalPlaces,
                                                    maximumFractionDigits: decimalPlaces,
                                                });

                                                const unit = l.elementDetails.unit;
                                                return formatted + (unit && unit !== "None" ? " " + unit : "");
                                            }

                                            return "";
                                        })()
                                        : ""
                                }



                            />

                        </div>
                    );
                }
                else if (l.type === "Popup") {
                    // 1. `value_` Değerini Bul
                    let value_ = tag_values_state.find(i =>
                        l.elementDetails.tip !== "Var"
                            ? String(i.tagId) === String(l.elementDetails.tagId)
                            : i.tip === "Var" && String(i.tagId) === String(l.elementDetails.tagId)
                    )?.tagValue;

                    // Eğer value_ sayısal değilse, boşluktan sonrasını sil
                    if (value_ && isNaN(Number(value_))) {
                        value_ = value_.split(' ')[0]; // ilk boşluktan önceki kısmı al
                    }

                    // 2. `value_list` İçinde `value_` İndeksini Bul
                    let index_ = l.elementDetails.value_list && l.elementDetails.value_list.indexOf(
                        value_ !== undefined && value_.includes(" ") ? value_.trim() : value_
                    );


                    // 3. Varsayılan Atama
                    if (index_ === -1 || index_ === undefined) { // `indexOf` bulunamazsa -1 döner
                        index_ = 0;
                    }

                    // 1. `value_` Değerini Bul
                    let value_2 = tag_values_state.find(i =>
                        l.elementDetails.tip2 !== "Var"
                            ? String(i.tagId) === String(l.elementDetails.tagId2)
                            : i.tip === "Var" && String(i.tagId) === String(l.elementDetails.tagId2)
                    )?.tagValue;

                    // Eğer value_ sayısal değilse, boşluktan sonrasını sil
                    if (value_2 && isNaN(Number(value_2))) {
                        value_2 = value_2.split(' ')[0]; // ilk boşluktan önceki kısmı al
                    }

                    // 2. `value_list` İçinde `value_` İndeksini Bul
                    let index_2 = l.elementDetails.value_list && l.elementDetails.value_list.indexOf(
                        value_2 !== undefined && value_2.includes(" ") ? value_2.trim() : value_2
                    );

                    // 3. Varsayılan Atama
                    if (index_2 === -1 || index_2 === undefined) { // `indexOf` bulunamazsa -1 döner
                        index_2 = 0;
                    }

                    // 1. `value_` Değerini Bul
                    let value_3 = tag_values_state.find(i =>
                        l.elementDetails.tip !== "Var"
                            ? String(i.tagId) === String(l.elementDetails.tagId3)
                            : i.tip === "Var" && String(i.tagId) === String(l.elementDetails.tagId3)
                    )?.tagValue;

                    // Eğer value_ sayısal değilse, boşluktan sonrasını sil
                    if (value_3 && isNaN(Number(value_3))) {
                        value_3 = value_3.split(' ')[0]; // ilk boşluktan önceki kısmı al
                    }

                    // 2. `value_list` İçinde `value_` İndeksini Bul
                    let index_3 = l.elementDetails.value_list && l.elementDetails.value_list.indexOf(
                        value_3 !== undefined && value_3.includes(" ") ? value_3.trim() : value_3
                    );

                    // 3. Varsayılan Atama
                    if (index_3 === -1 || index_3 === undefined) { // `indexOf` bulunamazsa -1 döner
                        index_3 = 0;
                    }

                    return (
                        <div

                            onClick={(e) => {
                                if (yazma_control) {
                                    let active_id = l.id;
                                    let active_items = l.elementDetails.items;
                                    Set_active_popup_id(active_id);
                                    Set_active_popup_items(active_items)
                                    // Hide other elements
                                    document.querySelector(".react-grid-layout").childNodes.forEach((x) => {
                                        x.style.opacity = "0";
                                        x.style.zIndex = "-1";
                                    });

                                    let w__, h__, x__, y__;

                                    setLayouts((prevLayouts) => {
                                        const updatedLayouts = { ...prevLayouts };

                                        if (Array.isArray(updatedLayouts[currentBreakpoint])) {
                                            (updatedLayouts[currentBreakpoint] || []).forEach((item) => {
                                                if (String(item.id) === String(active_id)) {
                                                    if (!item.elementDetails.items) {
                                                        item.elementDetails.items = [];
                                                    }

                                                    item.elementDetails.items.forEach((newItem) => {
                                                        if (newItem.type === "frame") {
                                                            w__ = newItem.w;
                                                            h__ = newItem.h;
                                                            x__ = newItem.x;
                                                            y__ = newItem.y;
                                                        }
                                                        newItem.isDraggable = false;
                                                        newItem.isResizable = false;
                                                        updatedLayouts[currentBreakpoint].push(newItem);
                                                    });
                                                }
                                            });
                                        }

                                        return updatedLayouts;
                                    });

                                    document.querySelector(".main_sec").classList.toggle("main_sec_bg_blur");

                                    setTimeout(() => {
                                        document.querySelector(".react-grid-layout").childNodes.forEach((x) => {
                                            if (window.getComputedStyle(x).zIndex !== "-1") {
                                                x.style.zIndex = "2";
                                            }
                                        });
                                    }, 50);

                                    setTimeout(() => {
                                        let diffX, diffY;
                                        const layoutItems = document.querySelector(".react-grid-layout")
                                            .childNodes;

                                        layoutItems.forEach((x) => {
                                            const id = x.getAttribute("data-id");

                                            if (x.classList.contains("frame_widget")) {

                                                x.style.width = `${w__}px`; // Grid birimlerini px'e çevir
                                                x.style.height = `${h__}px`;

                                                const initialRect = x.getBoundingClientRect();
                                                const mainSec = document.querySelector(".main_sec");
                                                const mainSecRect = mainSec.getBoundingClientRect();

                                                const centerX = (mainSecRect.width) / 2;
                                                const centerY = (mainSecRect.height) / 2 - mainSecRect.top / 10;

                                                console.warn(mainSecRect, "kdoejdıoejoejoe")

                                                const targetX = (centerX - w__ / 2) - mainSecRect.left / 5;
                                                const targetY = (centerY - h__ / 2);

                                                console.log("targetX", targetX)

                                                diffX = targetX;
                                                diffY = targetY;

                                                x.style.transform = `translate(${targetX}px, ${targetY}px)`;
                                            }
                                        });

                                        // Diğer öğeleri frame'e göre taşı
                                        layoutItems.forEach((x) => {
                                            const id = x.getAttribute("data-id");
                                            if (x.classList.contains("frame_widget")) return;


                                            if (!id?.includes("l.special_type")) return;



                                            if (typeof diffX !== "undefined" && typeof diffY !== "undefined") {
                                                const frameWidgetRect = document
                                                    .querySelector(".frame_widget")
                                                    .getBoundingClientRect();
                                                const elementRect = x.getBoundingClientRect();

                                                const relativeX = elementRect.left - frameWidgetRect.left;
                                                const relativeY = elementRect.top - frameWidgetRect.top;

                                                x.style.transform = `translate(${diffX + relativeX}px, ${diffY + relativeY
                                                    }px)`;
                                            }
                                        });
                                    }, 50);
                                }
                            }
                            }


                            style={{ borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", zIndex: "1", border: "2px solid rgb(70,70,70)", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black", borderRadius: "8px", display: "flex", alignItems: "center", borderColor: l.elementDetails.border_list && l.elementDetails.border_list[index_] ? l.elementDetails.border_list[index_] : "black", backgroundColor: l.elementDetails.bg_list && l.elementDetails.bg_list[index_] ? l.elementDetails.bg_list[index_] : "white", color: l.elementDetails.font_list && l.elementDetails.font_list[index_] ? l.elementDetails.font_list[index_] : "black" }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={"Popup" + l.id}
                            data-id={l.special_type ? "l.special_type" : ""}
                            key={l.i}
                            className="popupduz_widget"
                        >



                            <input
                                className="showRoomNumber_popupDYN"
                                placeholder="room number"

                                id={l.id + "cc"}
                                type="text"

                                value={l.elementDetails.text ? l.elementDetails.text : ""}
                                style={{
                                    fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, textAlign: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center",
                                    backgroundColor: "transparent",
                                    color: l.fontColor ? l.fontColor : "black",
                                    width: "100%", outline: "none", backgroundColor: "transparent", border: "none"

                                }}




                            />

                            <div className="dyn_popup_bottom_part">
                                <div><p style={{ fontSize: `${l.w / 17}px` }}>Oda:</p> <input style={{ color: l.elementDetails.font_list && l.elementDetails.font_list[index_] ? l.elementDetails.font_list[index_] : "black", fontSize: `${l.w / 20}px`, backgroundColor: "transparent" }} type="text" value={
                                    l.elementDetails.tagId3 !== ""
                                        ? (() => {
                                            let selectedTag;
                                            if (l.elementDetails.tip3 === "Var") {
                                                selectedTag = tag_values_state.find(
                                                    (item) => item.tip === "Var" && item.tagId === l.elementDetails.tagId3
                                                );
                                            } else {
                                                selectedTag = tag_values_state.find(
                                                    (item) => item.tagId === l.elementDetails.tagId3
                                                );
                                            }

                                            if (!selectedTag) return "";

                                            const numericValue = parseFloat(selectedTag.tagValue);
                                            const isNumeric = !isNaN(numericValue);

                                            return isNumeric
                                                ? numericValue.toFixed(l.elementDetails.decimal ? l.elementDetails.decimal : 2) +
                                                (l.elementDetails.unit && l.elementDetails.unit !== "None" ? " " + l.elementDetails.unit : "")
                                                : selectedTag.tagValue; // Sayıya çevrilemezse olduğu gibi bırak
                                        })()
                                        : ""
                                } className="dyn_popup_show_room_temp" /></div>
                                <div className="span_divPopupW"><span style={{ borderColor: l.elementDetails.border_list2 && l.elementDetails.border_list2[index_] ? l.elementDetails.border_list2[index_] : "black", backgroundColor: l.elementDetails.bg_list2 && l.elementDetails.bg_list2[index_] ? l.elementDetails.bg_list2[index_] : "white", }}></span></div>
                                <div><p style={{ fontSize: `${l.w / 17}px` }}>Set:</p> <input
                                    onClick={(e) => {
                                        if (l.elementDetails.tagId4 && l.elementDetails.tagId4 !== "" && l.elementDetails.tagId4 !== "None" && yazma_control) {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            const { clientX, clientY } = e;

                                            // Set elem_popup with tagId2 as tagId4 for modal to work
                                            Set_elem_popup({ ...l, elementDetails: { ...l.elementDetails, tagId2: l.elementDetails.tagId4 } });

                                            document.querySelector(".Popup-selectbox2").classList.toggle("changeProperties_active");
                                            document.querySelector(".Popup-selectbox2").id = l.id;

                                            var popup = document.querySelector(".Popup-selectbox2");
                                            const popupRect = popup.getBoundingClientRect();

                                            let newX = clientX + window.scrollX;
                                            let newY = clientY + window.scrollY;

                                            if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                                                newX = window.innerWidth + window.scrollX - popupRect.width;
                                            }
                                            if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                                                newY = window.innerHeight + window.scrollY - popupRect.height;
                                            }

                                            popup.style.left = `${newX}px`;
                                            popup.style.top = `${newY}px`;
                                        }
                                    }}
                                    style={{ color: l.elementDetails.font_list && l.elementDetails.font_list[index_] ? l.elementDetails.font_list[index_] : "black", fontSize: `${l.w / 20}px`, backgroundColor: "transparent", cursor: l.elementDetails.tagId4 && l.elementDetails.tagId4 !== "" && l.elementDetails.tagId4 !== "None" && yazma_control ? "pointer" : "default" }}
                                    type="text"
                                    value={
                                    l.elementDetails.tagId4 !== ""
                                        ? (() => {
                                            let selectedTag;
                                            if (l.elementDetails.tip4 === "Var") {
                                                selectedTag = tag_values_state.find(
                                                    (item) => item.tip === "Var" && item.tagId === l.elementDetails.tagId4
                                                );
                                            } else {
                                                selectedTag = tag_values_state.find(
                                                    (item) => item.tagId === l.elementDetails.tagId4
                                                );
                                            }

                                            if (!selectedTag) return "";

                                            const numericValue = parseFloat(selectedTag.tagValue);
                                            const isNumeric = !isNaN(numericValue);

                                            return isNumeric
                                                ? numericValue.toFixed(l.elementDetails.decimal ? l.elementDetails.decimal : 2) +
                                                (l.elementDetails.unit && l.elementDetails.unit !== "None" ? " " + l.elementDetails.unit : "")
                                                : selectedTag.tagValue; // Sayıya çevrilemezse olduğu gibi bırak
                                        })()
                                        : ""
                                } className="dyn_popup_show_room_set_temp" /></div>
                            </div>

                        </div>
                    );
                }
                else if (l.type === "frame") {
                    if (!l.special_type) {
                        return (
                            <div

                                onContextMenu={(e) => {
                                    console.log(l);
                                    if (l.combine_trend && l.combine_trend === true) {
                                        let group_id = l.group_t_id ? l.group_t_id : undefined

                                        let newData = combine_trend_tags;

                                        (layouts[currentBreakpoint] || []).forEach(x => {
                                            if (group_id !== undefined && x.group_t_id && Number(x.group_t_id) === Number(group_id) && l.elementDetails.tagId) {
                                                var tagName = tags
                                                    .filter((b) => b.tagId === l.elementDetails.tagId)
                                                    .map((c) => c.tagName)[0];
                                                newData.push({ tagId: l.elementDetails.tagId, tagName: tagName })
                                            }
                                        })

                                        Set_combine_trend_tags(newData)

                                        e.preventDefault();
                                        const { clientX, clientY } = e;
                                        let screen_width = window.innerWidth;
                                        console.log(clientX, clientY);
                                        document
                                            .querySelector(".show_external_combine_trend")
                                            .classList.toggle(
                                                "show_external_combine_trend_active"
                                            );

                                        var popup = document.querySelector(
                                            ".show_external_combine_trend"
                                        );
                                        const popupRect =
                                            popup.getBoundingClientRect();
                                        const viewportWidth = window.innerWidth;
                                        const viewportHeight = window.innerHeight;

                                        // Calculate the new positions
                                        let newX = clientX;
                                        let newY = clientY;

                                        // Adjust if the popup would overflow the right edge of the viewport
                                        if (
                                            newX + popupRect.width >
                                            viewportWidth
                                        ) {
                                            newX = viewportWidth - popupRect.width;
                                        }

                                        // Adjust if the popup would overflow the bottom edge of the viewport
                                        if (
                                            newY + popupRect.height >
                                            viewportHeight
                                        ) {
                                            newY =
                                                viewportHeight - popupRect.height;
                                        }

                                        // Adjust if the popup would overflow the left edge of the viewport
                                        if (newX < 0) {
                                            newX = 0;
                                        }

                                        // Adjust if the popup would overflow the top edge of the viewport
                                        if (newY < 0) {
                                            newY = 0;
                                        }

                                        if (
                                            screen_width < 2301 &&
                                            screen_width > 1800
                                        ) {
                                            document.querySelector(
                                                ".show_external_combine_trend"
                                            ).style.left = `${String(
                                                newX / 1.2
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_combine_trend"
                                            ).style.top = `${String(newY / 1.2)}px`;
                                        } else if (
                                            screen_width < 2801 &&
                                            screen_width > 2300
                                        ) {
                                            document.querySelector(
                                                ".show_external_combine_trend"
                                            ).style.left = `${String(
                                                newX / 1.5
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_combine_trend"
                                            ).style.top = `${String(newY / 1.5)}px`;
                                        } else if (
                                            screen_width < 3501 &&
                                            screen_width > 2800
                                        ) {
                                            document.querySelector(
                                                ".show_external_combine_trend"
                                            ).style.left = `${String(
                                                newX / 1.8
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_combine_trend"
                                            ).style.top = `${String(newY / 1.8)}px`;
                                        } else if (
                                            screen_width < 5001 &&
                                            screen_width > 3500
                                        ) {
                                            document.querySelector(
                                                ".show_external_combine_trend"
                                            ).style.left = `${String(
                                                newX / 2.5
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_combine_trend"
                                            ).style.top = `${String(newY / 2.5)}px`;
                                        } else if (screen_width <= 1800) {
                                            document.querySelector(
                                                ".show_external_combine_trend"
                                            ).style.left = `${String(newX)}px`;
                                            document.querySelector(
                                                ".show_external_combine_trend"
                                            ).style.top = `${String(newY)}px`;
                                        }
                                    }
                                }}

                                style={{ borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", backgroundColor: "white", borderRadius: l.elementDetails.borderRadius + "px", border: "3px solid rgb(65,65,65)", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black", zIndex: "0" }}
                                data-grid={{
                                    x: l.x,
                                    y: l.y,
                                    w: (l.w),
                                    h: l.h,
                                    resizeHandles: l.resizeHandles,
                                }}
                                id={l.id}
                                data-id={l.special_type ? "l.special_type" : ""}
                                key={l.i}
                                className="frame_widget"
                            >




                            </div>
                        );
                    } else {
                        return (
                            <div


                                style={{ borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", backgroundColor: "white", borderRadius: l.elementDetails.borderRadius + "px", border: "3px solid rgb(65,65,65)", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black", zIndex: "0" }}
                                data-grid={{
                                    x: l.x,
                                    y: l.y,
                                    w: (l.w),
                                    h: l.h,
                                    resizeHandles: l.resizeHandles,
                                }}
                                id={l.id}
                                data-id={l.special_type ? "l.special_type" : ""}
                                key={l.i}
                                className="frame_widget"
                            >
                                <i onClick={(e) => {
                                    if (document.querySelector(".main_sec").classList.contains("main_sec_bg_blur")) {


                                        setLayouts((prevLayouts) => {
                                            const updatedLayouts = { ...prevLayouts };


                                            if (Array.isArray(updatedLayouts[currentBreakpoint])) {
                                                // Filter out items with matching special_type and id2
                                                updatedLayouts[currentBreakpoint] = (updatedLayouts[currentBreakpoint] || []).filter(
                                                    (item) => !(item.special_type && String(item.id2) === String(active_popup_id))
                                                );
                                            }

                                            return updatedLayouts;
                                        });
                                        Set_active_popup_id(null)
                                        Set_active_popup_items([])
                                        document.querySelector(".main_sec").classList.toggle("main_sec_bg_blur");
                                        setTimeout(() => {
                                            document.querySelector(".react-grid-layout").childNodes.forEach(x => {
                                                x.style.opacity = "1"
                                                x.style.zIndex = "1"
                                            })
                                        }, 50)
                                    }

                                }} style={{ position: "relative", left: "95%", top: "-30px", cursor: "pointer", backgroundColor: "red", width: "40px", height: "40px", display: "flex", alignItems: "center", justifyContent: "center", color: "white", borderRadius: "40px", border: "none" }} className="fa fa-times"></i>




                            </div>
                        );
                    }

                }
                else if (l.type === "fan_modu") {
                    return (
                        <div

                            onContextMenu={(e) => {
                                if (l.elementDetails.tagId && l.add_trend && l.add_trend === "YES") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_trend")
                                        .classList.toggle(
                                            "show_external_trend_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_trend"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                } else if (l.elementDetails.tagId && l.elementDetails.tagId !== "") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_detail")
                                        .classList.toggle(
                                            "show_external_detail_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId2"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName2"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_detail"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                }
                            }}

                            onClick={(e) => {
                                if (yazma_control) {
                                    console.log(e.target);
                                    e.preventDefault();
                                    e.stopPropagation();
                                    const { clientX, clientY } = e;
                                    document.querySelector(".Popup-fan").classList.toggle("changeProperties_active")
                                    document.querySelector(".Popup-fan").id = l.id

                                    var popup = document.querySelector(".Popup-fan")
                                    const popupRect = popup.getBoundingClientRect();

                                    // Yeni pozisyonları hesapla
                                    let newX = clientX + window.scrollX;
                                    let newY = clientY + window.scrollY;

                                    console.log(newX, newY);

                                    // Sağ kenardan taşmayı önle
                                    if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                                        newX = window.innerWidth + window.scrollX - popupRect.width;
                                    }

                                    // Alt kenardan taşmayı önle
                                    if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                                        newY = window.innerHeight + window.scrollY - popupRect.height;
                                    }

                                    // Sol kenardan taşmayı önle
                                    if (newX < window.scrollX) {
                                        newX = window.scrollX;
                                    }

                                    // Üst kenardan taşmayı önle
                                    if (newY < window.scrollY) {
                                        newY = window.scrollY;
                                    }

                                    console.log(newX, newY);

                                    // Pop-up'ın pozisyonunu ayarla
                                    popup.style.left = `${newX}px`;
                                    popup.style.top = `${newY}px`;

                                    const parentElement = e.target.closest(".fan_modu_widget");
                                    const parentRect = parentElement.getBoundingClientRect();

                                    Set_elem_popup({
                                        width: l.w,
                                        height: l.h * 10,
                                        left: l.x,
                                        top: l.y,

                                        type: l.type,
                                        id: l.id,
                                        fontSize: l.fontSize ? l.fontSize : Number(l.w) / 10
                                    })

                                    setSelectedOptionfan(l.elementDetails.text)
                                }
                            }
                            }
                            style={{ borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", border: "2px solid rgb(60,60,60)", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black", borderRadius: "4px", zIndex: "1" }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            className={"fan_modu_widget" + " " + (l.special_type ? "special_type" : "")}
                        >

                            <div style={{ backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black", width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                                {l.elementDetails.text}

                            </div>

                        </div>
                    );
                }
                else if (l.type === "calisma_modu") {
                    return (
                        <div
                            onContextMenu={(e) => {
                                if (l.elementDetails.tagId && l.add_trend && l.add_trend === "YES") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_trend")
                                        .classList.toggle(
                                            "show_external_trend_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_trend"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                } else if (l.elementDetails.tagId && l.elementDetails.tagId !== "") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_detail")
                                        .classList.toggle(
                                            "show_external_detail_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId2"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName2"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_detail"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                }
                            }}
                            onClick={(e) => {
                                if (yazma_control) {
                                    console.log(e.target);
                                    e.preventDefault();
                                    e.stopPropagation();
                                    const { clientX, clientY } = e;
                                    document.querySelector(".Popup-calisma").classList.toggle("changeProperties_active")
                                    document.querySelector(".Popup-calisma").id = l.id

                                    var popup = document.querySelector(".Popup-calisma")
                                    const popupRect = popup.getBoundingClientRect();

                                    // Yeni pozisyonları hesapla
                                    let newX = clientX + window.scrollX;
                                    let newY = clientY + window.scrollY;

                                    console.log(newX, newY);

                                    // Sağ kenardan taşmayı önle
                                    if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                                        newX = window.innerWidth + window.scrollX - popupRect.width;
                                    }

                                    // Alt kenardan taşmayı önle
                                    if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                                        newY = window.innerHeight + window.scrollY - popupRect.height;
                                    }

                                    // Sol kenardan taşmayı önle
                                    if (newX < window.scrollX) {
                                        newX = window.scrollX;
                                    }

                                    // Üst kenardan taşmayı önle
                                    if (newY < window.scrollY) {
                                        newY = window.scrollY;
                                    }

                                    console.log(newX, newY);

                                    // Pop-up'ın pozisyonunu ayarla
                                    popup.style.left = `${newX}px`;
                                    popup.style.top = `${newY}px`;

                                    const parentElement = e.target.closest(".calisma_modu_widget");
                                    const parentRect = parentElement.getBoundingClientRect();

                                    Set_elem_popup({
                                        width: l.w,
                                        height: l.h * 10,
                                        left: l.x,
                                        top: l.y,

                                        type: l.type,
                                        id: l.id,
                                        fontSize: l.fontSize ? l.fontSize : Number(l.w) / 10
                                    })

                                    setSelectedOptioncalisma(l.elementDetails.text)
                                }
                            }
                            }
                            style={{ borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", border: "2px solid rgb(60,60,60)", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black", borderRadius: "4px", zIndex: "1" }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}

                            id={l.id}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            className={"calisma_modu_widget" + ` ${l.elementDetails.tagId}` + " " + (l.special_type ? "special_type" : "")}
                        >


                            <div style={{ backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black", width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                                {l.elementDetails.text}

                            </div>



                        </div>
                    );
                }
                else if (l.type === "on/off") {
                    let value_ = tag_values_state.find(i =>
                        l.elementDetails.tip !== "Var"
                            ? String(i.tagId) === String(l.elementDetails.tagId)
                            : i.tip === "Var" && String(i.tagId) === String(l.elementDetails.tagId)
                    )?.tagValue;

                    // Eğer value_ sayısal değilse, boşluktan sonrasını sil
                    if (value_ && isNaN(Number(value_))) {
                        value_ = value_.split(' ')[0];

                    }
                    console.warn("value_", value_, typeof (value_));

                    value_ = value_ && value_.split('.')[0]; // Noktadan sonrasını almaz

                    console.warn("value_", value_, typeof (value_));

                    // 2. value_list oluştur (value1, value2, value3... varsa onları al)
                    let valueList = [];
                    let i = 1;
                    while (l.elementDetails[`value${i}`] !== undefined) {
                        valueList.push(l.elementDetails[`value${i}`]);
                        i++;
                    }

                    // 3. value_ değeri valueList içinde kaçıncı sıradaysa onu al
                    let index_ = valueList.indexOf(
                        value_ !== undefined && value_.includes(" ") ? value_.trim() : value_
                    );

                    // 4. Varsayılan atama
                    if (index_ === -1 || index_ === undefined) {
                        index_ = 0;
                    }
                    return (
                        <div

                            onContextMenu={(e) => {
                                const { clientX, clientY } = e;
                                let screen_width = window.innerWidth;
                                if (l.elementDetails.tagId && l.add_trend && l.add_trend === "YES") {
                                    if (l.elementDetails.text === "ON") {
                                        var tagName = tags
                                            .filter((b) => b.tagId === l.elementDetails.tagId)
                                            .map((c) => c.tagName)[0];

                                        e.preventDefault();

                                        let screen_width = window.innerWidth;
                                        console.log(clientX, clientY);
                                        document
                                            .querySelector(".show_external_trend")
                                            .classList.toggle(
                                                "show_external_trend_active"
                                            );
                                        document.querySelector(
                                            ".show_tagId"
                                        ).innerHTML = l.elementDetails.tagId;
                                        document.querySelector(
                                            ".show_tagName"
                                        ).innerHTML = tagName;
                                        var popup = document.querySelector(
                                            ".show_external_trend"
                                        );
                                    } else {
                                        var tagName = tags
                                            .filter((b) => b.tagId === l.elementDetails.tagId)
                                            .map((c) => c.tagName)[0];

                                        e.preventDefault();

                                        let screen_width = window.innerWidth;
                                        console.log(clientX, clientY);
                                        document
                                            .querySelector(".show_external_trend")
                                            .classList.toggle(
                                                "show_external_trend_active"
                                            );
                                        document.querySelector(
                                            ".show_tagId"
                                        ).innerHTML = l.elementDetails.tagId;
                                        document.querySelector(
                                            ".show_tagName"
                                        ).innerHTML = tagName;
                                        var popup = document.querySelector(
                                            ".show_external_trend"
                                        );
                                    }

                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                } else if (l.elementDetails.tagId && l.elementDetails.tagId !== "") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_detail")
                                        .classList.toggle(
                                            "show_external_detail_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId2"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName2"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_detail"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                }
                            }}

                            onClick={(e) => {
                                if (yazma_control) {


                                    console.log(e.target);
                                    e.preventDefault();
                                    e.stopPropagation();
                                    const { clientX, clientY } = e;
                                    document.querySelector(".Popup-onOff").classList.toggle("changeProperties_active")
                                    document.querySelector(".Popup-onOff").id = l.id

                                    var popup = document.querySelector(".Popup-onOff")
                                    const popupRect = popup.getBoundingClientRect();

                                    // Yeni pozisyonları hesapla
                                    let newX = clientX + window.scrollX;
                                    let newY = clientY + window.scrollY;

                                    console.log(newX, newY);

                                    // Sağ kenardan taşmayı önle
                                    if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                                        newX = window.innerWidth + window.scrollX - popupRect.width;
                                    }

                                    // Alt kenardan taşmayı önle
                                    if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                                        newY = window.innerHeight + window.scrollY - popupRect.height;
                                    }

                                    // Sol kenardan taşmayı önle
                                    if (newX < window.scrollX) {
                                        newX = window.scrollX;
                                    }

                                    // Üst kenardan taşmayı önle
                                    if (newY < window.scrollY) {
                                        newY = window.scrollY;
                                    }

                                    console.log(newX, newY);

                                    // Pop-up'ın pozisyonunu ayarla
                                    popup.style.left = `${newX}px`;
                                    popup.style.top = `${newY}px`;

                                    const parentElement = e.target.closest(".on-off_widget");
                                    const parentRect = parentElement.getBoundingClientRect();

                                    Set_elem_popup({
                                        width: l.w,
                                        height: l.h * 10,
                                        left: l.x,
                                        top: l.y,

                                        type: l.type,
                                        id: l.id,
                                        fontSize: l.fontSize ? l.fontSize : Number(l.w) / 10,
                                        value: value_ !== undefined && value_ === "1" ? "ON" : "OFF"
                                    })
                                }
                            }
                            }
                            style={{
                                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", backgroundColor: "white", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "white", borderRadius: "8px", zIndex: "1",
                            }}

                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            className={`on-off_widget ${value_ !== undefined && value_ === "1" ? "ON" : "OFF"} ${l.elementDetails.tagId}` + " " + (l.special_type ? "special_type" : "")}
                        >
                            <div style={{ backgroundColor: "transparent", color: "white", width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                                {value_ !== undefined && value_ === "1" ? "ON" : "OFF"}

                            </div>

                        </div>
                    );
                }
                else if (l.type === "image") {
                    return (
                        <div


                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: l.w,
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            className="image_widgetParentDiv"
                            style={{ borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", borderColor: "rgb(100,100,100)", zIndex: "1" }}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            id={l.id}
                        >

                            <img
                                style={{ width: "100%", height: "100%" }}
                                className="image_widget"
                                src={l.elementDetails.src !== "" ? l.elementDetails.src : ""}
                                alt=""
                            />
                        </div>
                    );
                } else if (l.type === "bg") {

                    let diffWidth = document.querySelector(".link-group-data-links").getBoundingClientRect().width * 1.05
                    let diffHeigth = document.querySelector("nav").getBoundingClientRect().height * 1.25
                    console.log(diffHeigth)


                    setTimeout(() => {
                        if (document.querySelector(".main_sec")) {
                            document.querySelector(
                                ".main_sec"
                            ).style.backgroundImage = `url("${l.elementDetails.src}")`;
                            document.querySelector(".main_sec").style.backgroundPosition =
                                `${l.elementDetails.left}px ${l.elementDetails.top}px`;
                            document.querySelector(".main_sec").style.backgroundSize = `${l.elementDetails.width}px ${l.elementDetails.height}px`;
                            document.querySelector(".main_sec").style.backgroundRepeat = "no-repeat"
                        }

                    }, 1000)



                } else if (l.type === "gauge") {
                    let value_max = Number(l.elementDetails.maxValue);

                    // tip kontrolü ile uygun tag değerini bul
                    let selectedTag;
                    if (l.elementDetails.tip === "Var") {
                        selectedTag = tag_values_state.find(
                            (item) => item.tip === "Var" && item.tagId === l.elementDetails.tagId
                        );
                    } else {
                        selectedTag = tag_values_state.find((item) => item.tagId === l.elementDetails.tagId);
                    }

                    // Sayısal değeri güvenli şekilde al
                    let value_tag = selectedTag ? selectedTag.tagValue : "";
                    const numericValue = parseFloat(value_tag);
                    const isNumeric = !isNaN(numericValue);

                    // Eğer isNumeric false ise boşluktan sonrasını kes
                    value_tag = isNumeric ? value_tag : value_tag.split(' ')[0];



                    // last_deger hesaplamasını güvenli hale getir
                    let last_deger = isNumeric
                        ? (numericValue / (l.elementDetails.endValue ? l.elementDetails.endValue : value_max).toFixed(2)) * 100
                        : 0;

                    // startValue ve endValue güvenli şekilde belirle
                    const startValue =
                        l.elementDetails.startValue && isNumeric && l.elementDetails.startValue <= numericValue
                            ? l.elementDetails.startValue
                            : 0;

                    const endValue = l.elementDetails.endValue && isNumeric
                        ? l.elementDetails.limitValues && l.elementDetails.limitValues.length > 0 && Number([...l.elementDetails.limitValues]
                            .sort((a, b) => a.value - b.value)
                            .at(-1).value) >= l.elementDetails.endValue
                            ? Math.max(l.elementDetails.endValue, numericValue) +
                            Number([...l.elementDetails.limitValues]
                                .sort((a, b) => a.value - b.value)
                                .at(-1).value)
                            : Math.max(l.elementDetails.endValue, numericValue)
                        : isNumeric
                            ? numericValue.toFixed(2)
                            : 100;
                    // normalizedValue hesapla
                    const normalizedValue = isNumeric
                        ? ((value_tag - startValue) / (endValue - startValue)) * 100
                        : 0;

                    // Arc limitlerini tanımla
                    const arcLimits = l.elementDetails.pU && l.elementDetails.limitValues
                        ? (() => {
                            if (l.elementDetails.pU === "Unit") {
                                // Unit modu için özel mantık
                                const sortedLimits = [...l.elementDetails.limitValues].sort((a, b) => a.value - b.value);
                                const colorLimits = sortedLimits.filter(i => i.color);

                                let lastLimit = startValue;
                                let result = [];

                                colorLimits.forEach(({ value, color }) => {
                                    let newColor = color;
                                    if (l.elementDetails.scaleX === "-1" && color === "#008000") {
                                        newColor = "#ff0000";
                                    } else if (l.elementDetails.scaleX === "-1" && color === "#ff0000") {
                                        newColor = "#008000";
                                    }
                                    result.push({
                                        limit: value,
                                        color: newColor,
                                    });
                                    lastLimit = value;
                                });

                                // Son rengi endValue'ya kadar devam ettir
                                if (colorLimits.length > 2) {
                                    result.push({
                                        limit: endValue,
                                        color: l.elementDetails.scaleX === "-1" ? colorLimits[0].color : colorLimits[colorLimits.length - 1].color,
                                    });
                                } else {
                                    result = [
                                        {
                                            limit: ((20 / 100) * (endValue - startValue)) + startValue,
                                            color: l.elementDetails.scaleX === "-1" ? "#5BE12C" : "#EA4228",
                                        },
                                        {
                                            limit: ((40 / 100) * (endValue - startValue)) + startValue,
                                            color: l.elementDetails.scaleX === "-1" ? "#F5CD19" : "#F58B19",
                                        },
                                        {
                                            limit: ((60 / 100) * (endValue - startValue)) + startValue,
                                            color: l.elementDetails.scaleX === "-1" ? "#F58B19" : "#F5CD19",
                                        },
                                        {
                                            limit: ((80 / 100) * (endValue - startValue)) + startValue,
                                            color: l.elementDetails.scaleX === "-1" ? "#FF5733" : "#33FFCE",
                                        },
                                        {
                                            limit: ((100 / 100) * (endValue - startValue)) + startValue,
                                            color: l.elementDetails.scaleX === "-1" ? "#EA4228" : "#5BE12C",
                                        },
                                    ];
                                }

                                return result;
                            } else if (l.elementDetails.pU === "Percent") {
                                // Percent modu için 5 renkli dizi
                                return [
                                    {
                                        limit: ((20 / 100) * (endValue - startValue)) + startValue,
                                        color: l.elementDetails.scaleX === "-1" ? "#5BE12C" : "#EA4228",
                                    },
                                    {
                                        limit: ((40 / 100) * (endValue - startValue)) + startValue,
                                        color: l.elementDetails.scaleX === "-1" ? "#F5CD19" : "#F58B19",
                                    },
                                    {
                                        limit: ((60 / 100) * (endValue - startValue)) + startValue,
                                        color: l.elementDetails.scaleX === "-1" ? "#F58B19" : "#F5CD19",
                                    },
                                    {
                                        limit: ((80 / 100) * (endValue - startValue)) + startValue,
                                        color: l.elementDetails.scaleX === "-1" ? "#FF5733" : "#33FFCE",
                                    },
                                    {
                                        limit: ((100 / 100) * (endValue - startValue)) + startValue,
                                        color: l.elementDetails.scaleX === "-1" ? "#EA4228" : "#5BE12C",
                                    },
                                ];
                            } else {
                                // Diğer durumlar için varsayılan dizi
                                return [
                                    {
                                        limit: ((20 / 100) * (endValue - startValue)) + startValue,
                                        color: l.elementDetails.scaleX === "-1" ? "#5BE12C" : "#EA4228",
                                    },
                                    {
                                        limit: ((40 / 100) * (endValue - startValue)) + startValue,
                                        color: l.elementDetails.scaleX === "-1" ? "#F5CD19" : "#F58B19",
                                    },
                                    {
                                        limit: ((60 / 100) * (endValue - startValue)) + startValue,
                                        color: l.elementDetails.scaleX === "-1" ? "#F58B19" : "#F5CD19",
                                    },
                                    {
                                        limit: ((80 / 100) * (endValue - startValue)) + startValue,
                                        color: l.elementDetails.scaleX === "-1" ? "#FF5733" : "#33FFCE",
                                    },
                                    {
                                        limit: ((100 / 100) * (endValue - startValue)) + startValue,
                                        color: l.elementDetails.scaleX === "-1" ? "#EA4228" : "#5BE12C",
                                    },
                                ];
                            }
                        })()
                        : [
                            {
                                limit: ((20 / 100) * (endValue - startValue)) + startValue,
                                color: l.elementDetails.scaleX === "-1" ? "#5BE12C" : "#EA4228",
                            },
                            {
                                limit: ((40 / 100) * (endValue - startValue)) + startValue,
                                color: l.elementDetails.scaleX === "-1" ? "#F5CD19" : "#F58B19",
                            },
                            {
                                limit: ((60 / 100) * (endValue - startValue)) + startValue,
                                color: l.elementDetails.scaleX === "-1" ? "#F58B19" : "#F5CD19",
                            },
                            {
                                limit: ((80 / 100) * (endValue - startValue)) + startValue,
                                color: l.elementDetails.scaleX === "-1" ? "#FF5733" : "#33FFCE",
                            },
                            {
                                limit: ((100 / 100) * (endValue - startValue)) + startValue,
                                color: l.elementDetails.scaleX === "-1" ? "#EA4228" : "#5BE12C",
                            },
                        ];
                    ;

                    const textElement = document.querySelector(`.gauge_widgetParentDiv${l.id} .value-text text`);

                    if (textElement && l.fontColor) textElement.style.fill = l.fontColor

                    document.querySelectorAll(`.gauge_widgetParentDiv${l.id} .tick-value text`).forEach(x => {
                        if (l.fontColor) x.style.fill = l.fontColor
                    })

                    // pU kontrolü ile text içeriğini güncelle
                    if (l.elementDetails.pU) {
                        const textElement = document.querySelector(`.gauge_widgetParentDiv${l.id} .value-text text`);
                        if (textElement) {
                            if (l.elementDetails.pU === "Unit") {
                                if (textElement.textContent.includes("%")) {
                                    textElement.textContent = textElement.textContent.slice(0, -1); // "%" karakterini kaldır
                                }
                                textElement.textContent = value_tag;
                            } else {
                                if (!textElement.textContent.includes("%")) {
                                    textElement.textContent = normalizedValue.toFixed(2) + "%";
                                }
                            }
                        }
                    }

                    // Min ve Max değerlerini ayarla
                    const min = l.elementDetails.pU === "Unit" && l.elementDetails.startValue ? startValue : 0;
                    const max = l.elementDetails.pU === "Unit" && l.elementDetails.endValue ? endValue : 100;





                    return (
                        <div
                            className={"gauge_widgetParentDiv" + " gauge_widgetParentDiv" + l.id}

                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: l.w,
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            onContextMenu={(e) => {
                                if (l.elementDetails.tagId && l.add_trend && l.add_trend === "YES") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_trend")
                                        .classList.toggle(
                                            "show_external_trend_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_trend"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                } else if (l.elementDetails.tagId && l.elementDetails.tagId !== "") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_detail")
                                        .classList.toggle(
                                            "show_external_detail_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId2"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName2"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_detail"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                }
                            }}

                            style={{
                                border: "1px solid rgb(100,100,100)",
                                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px",
                                backgroundColor: l.bgColor ? l.bgColor : "transparent",
                                borderRadius: l.elementDetails.borderRadius ? l.elementDetails.borderRadius + "px" : "8px",
                                minWidth: "100px", minHeight: "100px",
                                zIndex: "1",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                borderColor: l.borderColor ? l.borderColor : "rgb(100,100,100)",
                                overflow: "hidden", // Ebeveyn div taşmasını önler
                            }}
                            key={`${l.id} gauge-${fufg}`}

                            data-id={l.special_type ? "l.special_type" : ""}

                            id={l.id}

                        >

                            <GaugeComponent

                                maxValue={max}
                                minValue={min}
                                className="gauge_widget"
                                arc={{
                                    subArcs:
                                        l.elementDetails.pU ? l.elementDetails.pU === "Percent"
                                            ? arcLimits.map((arc) => ({
                                                limit: ((arc.limit - startValue) / (endValue - startValue)) * 100, // Normalize edilen yüzdelik limitler
                                                color: arc.color,
                                                showTick: true,
                                            }))
                                            : // Eğer "Unit" modundaysa, startValue ve endValue arasında 5 eşit dilim oluştur
                                            arcLimits.map((arc) => {
                                                // Eğer arc.limit startValue'dan küçükse startValue'ya ayarla
                                                let adjustedLimit = arc.limit < startValue ? startValue
                                                    // Eğer arc.limit endValue'dan büyükse endValue'ya ayarla
                                                    : arc.limit > endValue ? endValue
                                                        : arc.limit;

                                                return {
                                                    limit: adjustedLimit, // Normalize edilmiş limit
                                                    color: arc.color,
                                                    showTick: true,
                                                };
                                            }) : arcLimits.map((arc) => ({
                                                limit: ((arc.limit - startValue) / (endValue - startValue)) * 100, // Normalize edilen yüzdelik limitler
                                                color: arc.color,
                                                showTick: true,
                                            })),
                                }}
                                value={
                                    l.elementDetails.pU && l.elementDetails.pU === "Unit"
                                        ? isNumeric ? numericValue.toFixed(2) : "50" // value_tag geçerli sayı mı?
                                        : isNumeric ? (normalizedValue * max) / 100 : 50 // normalizedValue geçerli sayı mı?
                                }
                                style={{
                                    width: "80%",  // Tam genişlik kaplama
                                    height: "80%",
                                    marginLeft: "0%",// Tam yükseklik kaplama,
                                    opacity: "1",

                                }}
                            />
                        </div>
                    );
                }

                else if (l.type === "left_ok") {
                    let rotate_deg = 0;
                    if (l.elementDetails.rotate_deg) {
                        rotate_deg = l.elementDetails.rotate_deg
                    }

                    return (
                        <div

                            style={{ maxHeight: "50px", display: "flex", alignItems: "center", zIndex: "1" }}


                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: l.w,
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            id={l.id}
                            className="left_ok_arrow"
                        >

                            <svg style={l.elementDetails.rotate_deg && { transform: `rotate(${l.elementDetails.rotate_deg}deg)`, transformOrigin: "center" }} width={"100%"} className="sebeke-giris-cizgi">
                                <line
                                    x1="0"
                                    y1="25"
                                    x2="200%"
                                    y2="25"
                                    stroke={l.elementDetails.color}
                                    strokeWidth="8"
                                />
                                <polygon
                                    points="0,25 20,10 20,40"
                                    fill={l.elementDetails.color}
                                />
                                <line

                                    stroke="black"
                                    strokeWidth="14"
                                    markerEnd="url(#arrowhead)"
                                />
                            </svg>

                        </div>
                    )


                } else if (l.type === "right_ok") {

                    let rotate_deg = 0;
                    if (l.elementDetails.rotate_deg) {
                        rotate_deg = l.elementDetails.rotate_deg
                    }

                    return (
                        <div

                            style={{ maxHeight: "50px", display: "flex", alignItems: "center", color: `${l.elementDetails.color}`, zIndex: "1" }}

                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: l.w,
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            id={l.id}
                            className="right_arrow"
                        >

                            <svg width="100%" style={l.elementDetails.rotate_deg && { transform: `rotate(${l.elementDetails.rotate_deg}deg)`, transformOrigin: "center" }} height="50" className="sebeke-giris-cizgi">
                                <defs>
                                    <marker id={`arrowhead${l.id}`} orient="auto" markerWidth="5" markerHeight="5" refX="5" refY="2.5">
                                        <path d="M 0,0 L 5,2.5 L 0,5 Z" fill={`${l.elementDetails.color}`} />
                                    </marker>
                                </defs>

                                <line
                                    x1="0"
                                    y1="25"
                                    x2="calc(100% - 10px)"
                                    y2="25"
                                    stroke={l.elementDetails.color}
                                    strokeWidth="8"
                                />

                                <line
                                    x1="0"
                                    y1="25"
                                    x2="100%"
                                    y2="25"
                                    stroke={l.elementDetails.color}
                                    strokeWidth="8"
                                    marker-end={`url(#arrowhead${l.id})`}
                                />
                            </svg>









                        </div>
                    )

                }
                // return (
                //   <div id='selam34' style={{ display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "rgb(170,170,170)", color: "wheat", fontSize: "35px" }} key={i} className={l.static ? 'static' : ''}>
                //     {l.static ? (
                //       <span className="text" title="This item is static and cannot be removed or resized.">
                //         Static - {i}
                //       </span>
                //     ) : (
                //       <span style={{ padding: "10%", display: "flex", alignItems: "center", justifyContent: "center", width: "90%", height: "90%" }} className="text"><div id='test1' style={{ width: "100%", fontSize: `${Number(l.w) * 15}px`, height: "100%", backgroundColor: "black", display: "flex", alignItems: "center", justifyContent: "center" }}>{i}</div></span>
                //     )}
                //   </div>
                // );
            });

        } else if (currentBreakpoint === "xxs") {
            if (!layouts.xss || !Array.isArray(layouts.xss)) {
                return [];
            }
            return _.map(layouts.xss, function (l, i) {
                if (l.type === "text") {

                    return (
                        <div
                            style={{
                                zIndex: "1",
                                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px",
                                borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px",
                                borderColor: l.borderColor ? l.borderColor : "black",
                                backgroundColor: l.bgColor ? l.bgColor : "white",
                                color: l.fontColor ? l.fontColor : "black",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                textAlign: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center",
                                fontSize: l.fontSize ? l.fontSize : `${(Number(l.w)) / 10}px`,
                                overflowWrap: "break-word",
                                wordBreak: "break-word",
                                whiteSpace: "normal",
                            }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: l.w,
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}
                            className={"text_widget" + " " + (l.special_type ? "special_type" : "")}
                        >
                            {l.elementDetails.text !== "" ? (
                                <span
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {l.elementDetails.text}
                                </span>
                            ) : (
                                <span
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    Bu alanda henüz metin yok.
                                </span>
                            )}
                        </div>
                    );

                } else if (l.type === "Alarm") {

                    let value;
                    let stats = alarms_state;

                    console.warn(stats); let seviye_ = l.elementDetails.seviye;
                    if (seviye_ === "1") {
                        value = stats?.high || 0
                    } else if (seviye_ === "2") {
                        value = stats?.warning || 0
                    } else {
                        value = stats?.critical || 0
                    }

                    return (
                        <div



                            style={{
                                zIndex: "1", border: "2px solid black", borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px",
                                borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor || "transparent"
                            }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: l.w,
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            data-id={l.special_type ? "l.special_type" : ""}
                            key={l.i}
                            className="alarm_widget"
                        >
                            <div className="main_alarm_widget">

                                <div style={{ display: "flex", justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center" }} className="showAlarmValueW">{value}</div>
                            </div>


                        </div>
                    );

                } else if (l.type === "gauge_linear") {

                    // tip kontrolü ile uygun tag değerini bul
                    let selectedTag;
                    if (l.elementDetails.tip === "Var") {
                        selectedTag = tag_values_state.find(
                            (item) => item.tip === "Var" && item.tagId === l.elementDetails.tagId
                        );
                    } else {
                        selectedTag = tag_values_state.find((item) => item.tagId === l.elementDetails.tagId);
                        // Sayısal değeri güvenli şekilde al
                        let value_tag = selectedTag ? selectedTag.tagValue : "";
                        console.warn("value_tag", value_tag)
                        const numericValue = parseFloat(value_tag);
                        console.warn(numericValue, "numericValue")
                        const isNumeric = !isNaN(numericValue);

                        // Eğer isNumeric false ise boşluktan sonrasını kes
                        value_tag = isNumeric ? value_tag : value_tag.split(' ')[0];

                        // startValue ve endValue güvenli şekilde belirle
                        const startValue =
                            l.elementDetails.startValue && isNumeric && l.elementDetails.startValue <= numericValue
                                ? l.elementDetails.startValue
                                : 0;

                        const endValue =
                            l.elementDetails.endValue && isNumeric && l.elementDetails.endValue >= numericValue
                                ? l.elementDetails.endValue
                                : isNumeric
                                    ? numericValue.toFixed(2)
                                    : 100;
                        // normalizedValue hesapla
                        const normalizedValue = isNumeric
                            ? ((value_tag - startValue) / (endValue - startValue)) * 100
                            : 0;



                        const linearOptions = {
                            pointer: {
                                value: isNumeric ? numericValue : 50, // Sayıysa kullan, değilse 50
                                shape: "arrow",
                                size: 20,
                                color: "rgb(20,20,20)"// Pointer büyüklüğü artırıldı
                            },
                            scale: {
                                min: startValue,
                                max: endValue,
                                majorUnit: (endValue - startValue) / 5,
                                minorUnit: 2,
                                line: {
                                    width: 5, // Ölçek çizgisi kalınlaştırıldı
                                    color: "black"
                                },
                                labels: {
                                    color: "black",
                                    visible: true,
                                    font: "14px Arial, sans-serif", // Yazı fontu büyütüldü
                                },
                                ranges: [
                                    { from: startValue, to: l.elementDetails.alarmValue ? l.elementDetails.alarmValue : (endValue - startValue) / 2, color: "red" },
                                    { from: l.elementDetails.alarmValue ? l.elementDetails.alarmValue : (endValue - startValue) / 2, to: endValue, color: "blue" },
                                ],
                            },
                        };

                        const alarmValue = l.elementDetails.alarmValue || 0


                        return (
                            <div
                                className="gauge_widgetParentDiv"
                                data-grid={{
                                    x: l.x,
                                    y: l.y,
                                    w: l.w,
                                    h: l.h,
                                    resizeHandles: l.resizeHandles,
                                }}


                                style={{
                                    border: "none",
                                    borderWidth: l.borderWidth ? `${l.borderWidth}px` : "2px",
                                    backgroundColor: "transparent",
                                    borderRadius: l.elementDetails.borderRadius ? `${l.elementDetails.borderRadius}px` : "8px",

                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    borderColor: l.borderColor ? l.borderColor : "rgb(100,100,100)",
                                    overflow: "hidden",
                                }}
                                key={l.i}
                                id={l.id}
                                data-id={l.special_type ? "l.special_type" : ""}

                                onContextMenu={(e) => {
                                    if (l.elementDetails.tagId && l.add_trend && l.add_trend === "YES") {
                                        var tagName = tags
                                            .filter((b) => b.tagId === l.elementDetails.tagId)
                                            .map((c) => c.tagName)[0];

                                        e.preventDefault();
                                        const { clientX, clientY } = e;
                                        let screen_width = window.innerWidth;
                                        console.log(clientX, clientY);
                                        document
                                            .querySelector(".show_external_trend")
                                            .classList.toggle(
                                                "show_external_trend_active"
                                            );
                                        document.querySelector(
                                            ".show_tagId"
                                        ).innerHTML = l.elementDetails.tagId;
                                        document.querySelector(
                                            ".show_tagName"
                                        ).innerHTML = tagName;
                                        var popup = document.querySelector(
                                            ".show_external_trend"
                                        );
                                        const popupRect =
                                            popup.getBoundingClientRect();
                                        const viewportWidth = window.innerWidth;
                                        const viewportHeight = window.innerHeight;

                                        // Calculate the new positions
                                        let newX = clientX;
                                        let newY = clientY;

                                        // Adjust if the popup would overflow the right edge of the viewport
                                        if (
                                            newX + popupRect.width >
                                            viewportWidth
                                        ) {
                                            newX = viewportWidth - popupRect.width;
                                        }

                                        // Adjust if the popup would overflow the bottom edge of the viewport
                                        if (
                                            newY + popupRect.height >
                                            viewportHeight
                                        ) {
                                            newY =
                                                viewportHeight - popupRect.height;
                                        }

                                        // Adjust if the popup would overflow the left edge of the viewport
                                        if (newX < 0) {
                                            newX = 0;
                                        }

                                        // Adjust if the popup would overflow the top edge of the viewport
                                        if (newY < 0) {
                                            newY = 0;
                                        }

                                        if (
                                            screen_width < 2301 &&
                                            screen_width > 1800
                                        ) {
                                            document.querySelector(
                                                ".show_external_trend"
                                            ).style.left = `${String(
                                                newX / 1.2
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_trend"
                                            ).style.top = `${String(newY / 1.2)}px`;
                                        } else if (
                                            screen_width < 2801 &&
                                            screen_width > 2300
                                        ) {
                                            document.querySelector(
                                                ".show_external_trend"
                                            ).style.left = `${String(
                                                newX / 1.5
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_trend"
                                            ).style.top = `${String(newY / 1.5)}px`;
                                        } else if (
                                            screen_width < 3501 &&
                                            screen_width > 2800
                                        ) {
                                            document.querySelector(
                                                ".show_external_trend"
                                            ).style.left = `${String(
                                                newX / 1.8
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_trend"
                                            ).style.top = `${String(newY / 1.8)}px`;
                                        } else if (
                                            screen_width < 5001 &&
                                            screen_width > 3500
                                        ) {
                                            document.querySelector(
                                                ".show_external_trend"
                                            ).style.left = `${String(
                                                newX / 2.5
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_trend"
                                            ).style.top = `${String(newY / 2.5)}px`;
                                        } else if (screen_width <= 1800) {
                                            document.querySelector(
                                                ".show_external_trend"
                                            ).style.left = `${String(newX)}px`;
                                            document.querySelector(
                                                ".show_external_trend"
                                            ).style.top = `${String(newY)}px`;
                                        }
                                    } else if (l.elementDetails.tagId && l.elementDetails.tagId !== "") {
                                        var tagName = tags
                                            .filter((b) => b.tagId === l.elementDetails.tagId)
                                            .map((c) => c.tagName)[0];

                                        e.preventDefault();
                                        const { clientX, clientY } = e;
                                        let screen_width = window.innerWidth;
                                        console.log(clientX, clientY);
                                        document
                                            .querySelector(".show_external_detail")
                                            .classList.toggle(
                                                "show_external_detail_active"
                                            );
                                        document.querySelector(
                                            ".show_tagId2"
                                        ).innerHTML = l.elementDetails.tagId;
                                        document.querySelector(
                                            ".show_tagName2"
                                        ).innerHTML = tagName;
                                        var popup = document.querySelector(
                                            ".show_external_detail"
                                        );
                                        const popupRect =
                                            popup.getBoundingClientRect();
                                        const viewportWidth = window.innerWidth;
                                        const viewportHeight = window.innerHeight;

                                        // Calculate the new positions
                                        let newX = clientX;
                                        let newY = clientY;

                                        // Adjust if the popup would overflow the right edge of the viewport
                                        if (
                                            newX + popupRect.width >
                                            viewportWidth
                                        ) {
                                            newX = viewportWidth - popupRect.width;
                                        }

                                        // Adjust if the popup would overflow the bottom edge of the viewport
                                        if (
                                            newY + popupRect.height >
                                            viewportHeight
                                        ) {
                                            newY =
                                                viewportHeight - popupRect.height;
                                        }

                                        // Adjust if the popup would overflow the left edge of the viewport
                                        if (newX < 0) {
                                            newX = 0;
                                        }

                                        // Adjust if the popup would overflow the top edge of the viewport
                                        if (newY < 0) {
                                            newY = 0;
                                        }

                                        if (
                                            screen_width < 2301 &&
                                            screen_width > 1800
                                        ) {
                                            document.querySelector(
                                                ".show_external_detail"
                                            ).style.left = `${String(
                                                newX / 1.2
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_detail"
                                            ).style.top = `${String(newY / 1.2)}px`;
                                        } else if (
                                            screen_width < 2801 &&
                                            screen_width > 2300
                                        ) {
                                            document.querySelector(
                                                ".show_external_detail"
                                            ).style.left = `${String(
                                                newX / 1.5
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_detail"
                                            ).style.top = `${String(newY / 1.5)}px`;
                                        } else if (
                                            screen_width < 3501 &&
                                            screen_width > 2800
                                        ) {
                                            document.querySelector(
                                                ".show_external_detail"
                                            ).style.left = `${String(
                                                newX / 1.8
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_detail"
                                            ).style.top = `${String(newY / 1.8)}px`;
                                        } else if (
                                            screen_width < 5001 &&
                                            screen_width > 3500
                                        ) {
                                            document.querySelector(
                                                ".show_external_detail"
                                            ).style.left = `${String(
                                                newX / 2.5
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_detail"
                                            ).style.top = `${String(newY / 2.5)}px`;
                                        } else if (screen_width <= 1800) {
                                            document.querySelector(
                                                ".show_external_detail"
                                            ).style.left = `${String(newX)}px`;
                                            document.querySelector(
                                                ".show_external_detail"
                                            ).style.top = `${String(newY)}px`;
                                        }
                                    }
                                }}
                            >
                                <div className="su_tanki_gauge_linear" style={{ borderColor: l.borderColor || "#000" }}>
                                    <div style={{ position: "relative", height: "100%", width: "100%", display: "flex", flexDirection: "column-reverse" }}>
                                        <div style={{ width: "100%", height: alarmValue >= numericValue ? "0%" : numericValue * 100 / endValue + "%", backgroundColor: "blue" }} className="water"></div>
                                        <div style={{ width: "100%", height: alarmValue >= numericValue ? numericValue * 100 / endValue + "%" : "0%", backgroundColor: "red" }} className="alarmWater"></div>

                                        <div
                                            style={{
                                                position: "absolute",
                                                top: "50%",
                                                left: "50%",
                                                transform: "translate(-50%, -50%)", // Bu, öğeyi tam olarak ortalar
                                                backgroundColor: "black", // Hafif şeffaf beyaz arka plan
                                                padding: "4px 8px",
                                                borderRadius: "6px",
                                                fontSize: "16px",
                                                fontWeight: "bold",
                                                zIndex: "3",
                                                color: "#ffffff", // Daha koyu siyah
                                                fontFamily: "'Poppins', sans-serif", // Daha modern ve seksi font
                                                boxShadow: "2px 2px 6px rgba(0, 0, 0, 0.15)", // Hafif gölge efekti
                                            }}
                                        >
                                            {isNumeric ? l.elementDetails.pU && l.elementDetails.pU === "Percent" ? (numericValue * 100 / endValue).toFixed(2) + "%" : numericValue : 50}
                                        </div>
                                    </div>
                                </div>



                            </div>
                        );
                    }
                }
                else if (l.type === "lock") {
                    let value_ = tag_values_state.find(i =>
                        l.elementDetails.tip !== "Var"
                            ? String(i.tagId) === String(l.elementDetails.tagId)
                            : i.tip === "Var" && String(i.tagId) === String(l.elementDetails.tagId)
                    )?.tagValue;
                    if (value_ && isNaN(Number(value_))) {
                        value_ = value_.split(' ')[0]; // ilk boşluktan önceki kısmı al
                        value_ = value_.includes(" ") ? value_.trim() : value_
                    }
                    return (
                        <div


                            onClick={(e) => {
                                let tagValue;
                                (layouts[currentBreakpoint] || []).forEach(x => {
                                    if (String(x.id) === String(l.id)) {
                                        let tagId_ = l.elementDetails.tagId || "";

                                        tagValue = value_ === "1" ? "0" : "1";
                                        setValueFunc({ TagId: tagId_, TagValue: tagValue })
                                        document.querySelectorAll(".react-grid-item").forEach((item) => {
                                            if (item.classList.contains(`${l.elementDetails.tagIdEx}`)) {
                                                item.style.pointerEvents = tagValue === "1" ? "none" : "all";
                                                if (e.target.classList.contains("fa-lock")) {
                                                    item.style.opacity = "1"
                                                } else if (e.target.classList.contains("fa-unlock")) {
                                                    item.style.opacity = "0.55"
                                                }
                                            }
                                        })
                                        if (e.target.classList.contains("fa-lock")) {
                                            e.target.classList.replace("fa-lock", "fa-unlock");
                                        } else if (e.target.classList.contains("fa-unlock")) {
                                            e.target.classList.replace("fa-unlock", "fa-lock");
                                        }
                                    }
                                })
                            }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            data-id={l.special_type ? "l.special_type" : ""}
                            key={l.i}
                            className={`lock_widget`}
                        >
                            <i id="lock_i_dyn" style={{ color: l.fontColor || "gray", width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: `${l.w / 4}px` }} className={value_ === "0" ? "fa fa-lock" : "fa fa-unlock"}></i>



                        </div>
                    );
                } else if (l.type === "i_g") {
                    return (
                        <div

                            onClick={() => {
                                pages.forEach(async x => {
                                    if (Number(x.pageId) === Number(l.elementDetails.pageId)) {
                                        function normalizeURLPath(path) {
                                            const turkishMap = {
                                                'İ': 'I', 'ı': 'i', 'Ş': 'S', 'ş': 's',
                                                'Ğ': 'G', 'ğ': 'g', 'Ü': 'U', 'ü': 'u',
                                                'Ö': 'O', 'ö': 'o', 'Ç': 'C', 'ç': 'c'
                                            };

                                            return path.split('').map(char => turkishMap[char] || char).join('');
                                        }
                                        await Store.dispatch(set_current_dyn_pageName(x.pageName))
                                        history.push(`/pages/${normalizeURLPath(x.pageName).replaceAll(" ", "_")}`)

                                    }
                                })
                            }}

                            style={{
                                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px",
                                border: "2px solid rgb(60,60,60)", borderColor: l.borderColor ? l.borderColor : "black", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black",
                                borderRadius: "4px", zIndex: "1", cursor: "pointer"
                            }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            data-id={l.special_type ? "l.special_type" : ""}
                            key={l.i}
                            className="i_g_widget"
                        >

                            <div style={{ backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black", width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                                {l.elementDetails.text}

                            </div>

                        </div>
                    );
                } else if (l.type === "y_g") {

                    let value_ = tag_values_state.find(i =>
                        l.elementDetails.tip !== "Var"
                            ? String(i.tagId) === String(l.elementDetails.tagId)
                            : i.tip === "Var" && String(i.tagId) === String(l.elementDetails.tagId)
                    )?.tagValue;

                    // Eğer value_ sayısal değilse, boşluktan sonrasını sil
                    if (value_ && isNaN(Number(value_))) {
                        value_ = value_.split(' ')[0];

                    }
                    console.warn("value_", value_, typeof (value_));

                    value_ = value_ && value_.split('.')[0]; // Noktadan sonrasını almaz

                    console.warn("value_", value_, typeof (value_));

                    // 2. value_list oluştur (value1, value2, value3... varsa onları al)
                    let valueList = [];
                    let i = 1;
                    while (l.elementDetails[`value${i}`] !== undefined) {
                        valueList.push(l.elementDetails[`value${i}`]);
                        i++;
                    }


                    // 2. `value_.elementDetailslist` İçinde `valelementDetails.ue_` İndeksini Bul
                    let index_ = l.elementDetails.value_list && l.elementDetails.value_list.indexOf(
                        value_ !== undefined && value_.includes(" ") ? value_.trim() : value_
                    );

                    // 3. Varsayılan Atama
                    if (index_ === -1 || index_ === undefined) { // `indexOf` bulunamazsa -1 döner
                        index_ = 0;
                    }

                    return (
                        <div

                            onContextMenu={(e) => {
                                if (l.elementDetails.tagId && l.add_trend && l.add_trend === "YES") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_trend")
                                        .classList.toggle(
                                            "show_external_trend_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_trend"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                } else if (l.elementDetails.tagId && l.elementDetails.tagId !== "") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_detail")
                                        .classList.toggle(
                                            "show_external_detail_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId2"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName2"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_detail"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                }
                            }}
                            style={{
                                border: "2px solid rgb(60,60,60)",

                                width: l.elementDetails.rad ? l.elementDetails.rad + "px" : "10px", height: l.elementDetails.rad ? l.elementDetails.rad + "px" : "10px", borderRadius: l.elementDetails.rad ? (l.elementDetails.tur ? l.elementDetails.tur === "circle" ? l.elementDetails.rad + "px" : l.elementDetails.borderRadius + "px" : "10px") : "10px", zIndex: "1", borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px",
                                backgroundColor: l.elementDetails.bg_list && l.elementDetails.bg_list[index_] ? l.elementDetails.bg_list[index_] : "white", borderColor: l.elementDetails.border_list && l.elementDetails.border_list[index_] ? l.elementDetails.border_list[index_] : "black"
                            }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: l.elementDetails.rad ? l.elementDetails.rad : l.w,
                                h: l.elementDetails.rad ? l.elementDetails.rad : l.w,
                            }}
                            id={l.id}
                            data-id={l.special_type ? "l.special_type" : ""}
                            key={l.i}
                            className="yuvarlak_gosterge_widget"
                        >


                        </div>
                    );
                }
                else if (l.type === "go_page") {
                    return (
                        <div

                            onClick={() => {
                                if (l.elementDetails.text === "Alarm" && alarm_okuma) {
                                    history.push("/AlarmPanel")
                                } else {
                                    pages.forEach(async x => {
                                        if (Number(x.pageId) === Number(l.elementDetails.pageId)) {
                                            console.warn(l)

                                            function normalizeURLPath(path) {
                                                const turkishMap = {
                                                    'İ': 'I', 'ı': 'i', 'Ş': 'S', 'ş': 's',
                                                    'Ğ': 'G', 'ğ': 'g', 'Ü': 'U', 'ü': 'u',
                                                    'Ö': 'O', 'ö': 'o', 'Ç': 'C', 'ç': 'c'
                                                };

                                                return path.split('').map(char => turkishMap[char] || char).join('');
                                            }
                                            await Store.dispatch(set_current_dyn_pageName(x.pageName))
                                            history.push(`/pages/${normalizeURLPath(x.pageName).replaceAll(" ", "_")}`)

                                        }
                                    })
                                }
                            }
                            }

                            style={{
                                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px",
                                border: "2px solid rgb(60,60,60)", borderColor: l.borderColor ? l.borderColor : "black", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black",
                                borderRadius: "4px", zIndex: "1", cursor: "pointer"
                            }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            data-id={l.special_type ? "l.special_type" : ""}
                            key={l.i}
                            className="go_page_widget"
                        >

                            <div style={{ backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black", width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                                {l.elementDetails.text}

                            </div>

                        </div>
                    );
                }
                else if (l.type === "set") {

                    // 1. `value_` Değerini Bul
                    let value_ = tag_values_state.find(i =>
                        l.elementDetails.tip !== "Var"
                            ? String(i.tagId) === String(l.elementDetails.tagId)
                            : i.tip === "Var" && String(i.tagId) === String(l.elementDetails.tagId)
                    )?.tagValue;

                    // Eğer value_ sayısal değilse, boşluktan sonrasını sil
                    if (value_ && isNaN(Number(value_))) {
                        value_ = value_.split(' ')[0]; // ilk boşluktan önceki kısmı al
                    }

                    // 2. `value_list` İçinde `value_` İndeksini Bul
                    let index_ = l.elementDetails.value_list && l.elementDetails.value_list.indexOf(
                        value_ !== undefined && value_.includes(" ") ? value_.trim() : value_
                    );


                    // 3. Varsayılan Atama
                    if (index_ === -1 || index_ === undefined) { // `indexOf` bulunamazsa -1 döner
                        index_ = 0;
                    }


                    console.warn(value_, l, tag_values_state)

                    return (
                        <div
                            onContextMenu={(e) => {
                                if (l.elementDetails.tagId && l.add_trend && l.add_trend === "YES") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_trend")
                                        .classList.toggle(
                                            "show_external_trend_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_trend"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                } else if (l.elementDetails.tagId && l.elementDetails.tagId !== "") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_detail")
                                        .classList.toggle(
                                            "show_external_detail_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId2"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName2"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_detail"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                }
                            }}

                            onClick={(e) => {
                                if (l.elementDetails.tagId2 && l.elementDetails.tagId2 !== "" && l.elementDetails.tagId2 !== "None" && yazma_control) {
                                    console.log(e.target);
                                    e.preventDefault();
                                    e.stopPropagation();
                                    const { clientX, clientY } = e;
                                    document.querySelector(".Popup-selectbox2").classList.toggle("changeProperties_active")
                                    document.querySelector(".Popup-selectbox2").id = l.id

                                    var popup = document.querySelector(".Popup-selectbox2")
                                    const popupRect = popup.getBoundingClientRect();

                                    // Yeni pozisyonları hesapla
                                    let newX = clientX + window.scrollX;
                                    let newY = clientY + window.scrollY;

                                    console.log(newX, newY);

                                    // Sağ kenardan taşmayı önle
                                    if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                                        newX = window.innerWidth + window.scrollX - popupRect.width;
                                    }

                                    // Alt kenardan taşmayı önle
                                    if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                                        newY = window.innerHeight + window.scrollY - popupRect.height;
                                    }

                                    // Sol kenardan taşmayı önle
                                    if (newX < window.scrollX) {
                                        newX = window.scrollX;
                                    }

                                    // Üst kenardan taşmayı önle
                                    if (newY < window.scrollY) {
                                        newY = window.scrollY;
                                    }

                                    console.log(newX, newY);

                                    // Pop-up'ın pozisyonunu ayarla
                                    popup.style.left = `${newX}px`;
                                    popup.style.top = `${newY}px`;

                                    const parentElement = e.target.closest(".set_widget");
                                    const parentRect = parentElement.getBoundingClientRect();

                                    Set_elem_popup({
                                        width: l.w,
                                        height: l.h,
                                        left: l.x,
                                        top: l.y,

                                        value_list: l.elementDetails.value_list && l.elementDetails.value_list.length === 0 ? l.value_list : l.elementDetails.value_list,
                                        bg_list: l.elementDetails.bg_list && l.elementDetails.bg_list.length === 0 ? l.bg_list : l.elementDetails.bg_list,
                                        border_list: l.elementDetails.border_list && l.elementDetails.border_list.length === 0 ? l.border_list : l.elementDetails.border_list,
                                        font_list: l.elementDetails.font_list && l.elementDetails.font_list.length === 0 ? l.font_list : l.elementDetails.font_list,
                                        type: l.type,
                                        id: l.id,
                                        fontSize: l.fontSize ? l.fontSize : Number(l.w) / 10,
                                        value: l.elementDetails.text
                                    })
                                    setSelectedOptionselectbox(l.elementDetails.text)
                                }

                            }}
                            style={{
                                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px",
                                borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", backgroundColor: "white", border: "2px solid rgb(60,60,60)", borderColor: l.borderColor ? l.borderColor : "black", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black",
                                zIndex: "1",
                            }}

                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            data-id={l.special_type ? "l.special_type" : ""}
                            key={l.i}
                            className={`set_widget ${l.elementDetails.text} ${l.elementDetails.tagId}` + " " + (l.special_type ? "special_type" : "")}
                        >
                            <div style={{ backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black", width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                                {Number(value_).toLocaleString("tr-TR", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                }) || l.elementDetails.text}

                            </div>

                        </div>
                    );
                }
                else if (l.type === "selectbox") {

                    let value_ = tag_values_state.find(i =>
                        l.elementDetails.tip !== "Var"
                            ? String(i.tagId) === String(l.elementDetails.tagId)
                            : i.tip === "Var" && String(i.tagId) === String(l.elementDetails.tagId)
                    )?.tagValue;

                    // Eğer value_ sayısal değilse, boşluktan sonrasını sil
                    if (value_ && isNaN(Number(value_))) {
                        value_ = value_.split(' ')[0];

                    }
                    console.warn("value_", value_, typeof (value_));

                    value_ = value_ && value_.split('.')[0]; // Noktadan sonrasını almaz

                    console.warn("value_", value_, typeof (value_), l);

                    // 2. value_list oluştur (value1, value2, value3... varsa onları al)
                    let valueList = [];
                    let i = 1;
                    while (l.elementDetails[`value${i}`] !== undefined) {
                        valueList.push(l.elementDetails[`value${i}`]);
                        i++;
                    }


                    // 2. `value_list` İçinde `value_` İndeksini Bul
                    let index_ = l.elementDetails.value_list && l.elementDetails.value_list.indexOf(
                        value_ !== undefined && typeof value_ === "string" && value_.includes(" ")
                            ? value_.trim()
                            : value_
                    );

                    // 3. Varsayılan Atama
                    if (index_ === -1 || index_ === undefined) {
                        index_ = 0;
                    }

                    console.warn(value_, l, tag_values_state)
                    let text_list_ = l.elementDetails.text_list;
                    let alarmClassName = "";

                    if (text_list_ && text_list_.length > 0 && text_list_[index_] === "ALARM" && l.special_type) {
                        alarmClassName = "alarmactive_blackBorder";
                        (layouts[currentBreakpoint] || []).forEach((item) => {
                            if (item.id === l.id2 && !item.special_type) {
                                let id = item.id
                                document.querySelector(`#Popup${id}`).style.backgroundColor = "red"
                            }
                        });

                    }




                    return (
                        <div
                            onContextMenu={(e) => {
                                if (l.elementDetails.tagId && l.add_trend && l.add_trend === "YES") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_trend")
                                        .classList.toggle(
                                            "show_external_trend_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_trend"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                } else if (l.elementDetails.tagId && l.elementDetails.tagId !== "") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_detail")
                                        .classList.toggle(
                                            "show_external_detail_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId2"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName2"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_detail"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                }
                            }}
                            onClick={(e) => {
                                if (l.elementDetails.tagId2 && l.elementDetails.tagId2 !== "" && l.elementDetails.tagId2 !== "None" && yazma_control) {
                                    console.log(e.target);
                                    e.preventDefault();
                                    e.stopPropagation();
                                    const { clientX, clientY } = e;
                                    document.querySelector(".Popup-selectbox").classList.toggle("changeProperties_active")
                                    document.querySelector(".Popup-selectbox").id = l.id

                                    var popup = document.querySelector(".Popup-selectbox")
                                    const popupRect = popup.getBoundingClientRect();

                                    // Yeni pozisyonları hesapla
                                    let newX = clientX + window.scrollX;
                                    let newY = clientY + window.scrollY;

                                    console.log(newX, newY);

                                    // Sağ kenardan taşmayı önle
                                    if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                                        newX = window.innerWidth + window.scrollX - popupRect.width;
                                    }

                                    // Alt kenardan taşmayı önle
                                    if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                                        newY = window.innerHeight + window.scrollY - popupRect.height;
                                    }

                                    // Sol kenardan taşmayı önle
                                    if (newX < window.scrollX) {
                                        newX = window.scrollX;
                                    }

                                    // Üst kenardan taşmayı önle
                                    if (newY < window.scrollY) {
                                        newY = window.scrollY;
                                    }

                                    console.log(newX, newY);

                                    // Pop-up'ın pozisyonunu ayarla
                                    popup.style.left = `${newX}px`;
                                    popup.style.top = `${newY}px`;

                                    const parentElement = e.target.closest(".selectbox_widget");
                                    const parentRect = parentElement.getBoundingClientRect();

                                    Set_elem_popup({
                                        width: l.w,
                                        height: l.h,
                                        left: l.x,
                                        top: l.y,
                                        text_list: l.elementDetails.text_list.length === 0 ? l.text_list : l.elementDetails.text_list,
                                        value_list: l.elementDetails.value_list && l.elementDetails.value_list.length === 0 ? l.value_list : l.elementDetails.value_list,
                                        bg_list: l.elementDetails.bg_list && l.elementDetails.bg_list.length === 0 ? l.bg_list : l.elementDetails.bg_list,
                                        border_list: l.elementDetails.border_list && l.elementDetails.border_list.length === 0 ? l.border_list : l.elementDetails.border_list,
                                        font_list: l.elementDetails.font_list && l.elementDetails.font_list.length === 0 ? l.font_list : l.elementDetails.font_list,
                                        type: l.type,
                                        id: l.id,
                                        fontSize: l.fontSize ? l.fontSize : Number(l.w) / 10,
                                        value: l.elementDetails.text
                                    })
                                    setSelectedOptionselectbox(l.elementDetails.text)
                                }

                            }}
                            style={{
                                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px",
                                backgroundColor: "white", border: "2px solid rgb(60,60,60)", borderColor: l.elementDetails.border_list && l.elementDetails.border_list[index_] ? l.elementDetails.border_list[index_] : "black", backgroundColor: l.elementDetails.bg_list && l.elementDetails.bg_list[index_] ? l.elementDetails.bg_list[index_] : "white", color: l.elementDetails.font_list && l.elementDetails.font_list[index_] ? l.elementDetails.font_list[index_] : "black", zIndex: "1",
                            }}

                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            className={`selectbox_widget ${l.elementDetails.text}` + " " + (l.special_type ? ("special_type_ " + alarmClassName) : "")}
                        >
                            <div style={{ backgroundColor: "transparent", color: l.elementDetails.font_list && l.elementDetails.font_list[index_] ? l.elementDetails.font_list[index_] : "black", width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                                {l.elementDetails.text_list[index_]}

                            </div>

                        </div>
                    );
                }
                else if (l.type === "senaryoSelect") {
                    return (
                        <div


                            style={{
                                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px",
                                backgroundColor: "white", border: "2px solid rgb(60,60,60)", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black", borderRadius: "8px", zIndex: "1",
                            }}

                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            className={`senaryo_widget ${l.elementDetails.text}`}
                        >
                            <div style={{ backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black", width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                                {l.elementDetails.text}

                            </div>

                        </div>
                    );
                }
                else if (l.type === "trend") {
                    let data_ = {
                        labels: [],
                        datasets: [{
                            data: [],
                            backgroundColor: "transparent",
                            borderColor: "#f26c6d",
                            pointBorderColor: "#f26c6d",
                            pointBorderWidth: 1
                        }]

                    }
                    if (l.elementDetails.data) {
                        data_ = {
                            labels: (l.elementDetails.data || []).map((item, index) => {
                                return item.date

                            }),
                            datasets: [{
                                data: (l.elementDetails.data || []).map((item, index) => {
                                    return item.value
                                }),
                                backgroundColor: "transparent",
                                borderColor: "#f26c6d",
                                pointBorderColor: "#f26c6d",
                                pointBorderWidth: 1
                            }]

                        }
                    }

                    const datason = data_

                    const optionsSon = {
                        scales: {
                            x: {
                                type: 'time',
                                time: {
                                    unit: 'day',
                                    stepSize: 1,
                                    displayFormats: {
                                        day: 'MMM D'
                                    }
                                },
                                ticks: {
                                    maxTicksLimit: 24
                                }
                            },
                            y: {
                                min: Number(min),
                                max: 0,
                                beginAtZero: true,
                                ticks: {
                                    callback: function (value) {
                                        return Number(value.toFixed(2)); // Etiketlerdeki sıfırları engelle
                                    }
                                }
                            }
                        },
                        plugins: {
                            legend: {
                                display: true,
                                labels: {
                                    filter: function (item, chart) {
                                        return item.text !== undefined;
                                    },
                                    generateLabels: function (chart) {
                                        return [{
                                            text: "",
                                            fillStyle: "crimson",
                                            strokeStyle: chart.ctx.strokeStyle,
                                            lineWidth: chart.ctx.lineWidth,
                                            hidden: false,
                                            index: 0,
                                            datasetIndex: 0
                                        }];
                                    }
                                }
                            },
                            zoom: {
                                pan: {
                                    enabled: true,
                                    mode: 'xy',
                                },
                                zoom: {
                                    wheel: {
                                        enabled: true,
                                    },
                                    pinch: {
                                        enabled: true,
                                    },
                                    mode: 'x',
                                    onZoom: ({ chart }) => {
                                        const xScale = chart.scales.x;
                                        const min = xScale.min;
                                        const max = xScale.max;
                                        const diff = max - min;
                                        let unit = 'second';

                                        // Zoom leveline göre birim seçimi
                                        if (diff > 1000 * 60 * 60 * 24 * 7) {
                                            unit = 'day';
                                        } else if (diff > 1000 * 60 * 60) {
                                            unit = 'hour';
                                        } else if (diff > 1000 * 60) {
                                            unit = 'minute';
                                        }

                                        // Yeniden ayarlama
                                        xScale.options.time.unit = unit;
                                        xScale.options.time.tooltipFormat = unit === 'second' ? 'll HH:mm:ss' : 'll HH:mm';
                                        xScale.options.ticks.callback = (value) => {
                                            return moment(value).format(unit === 'second' ? 'll HH:mm:ss' : 'll HH:mm');
                                        };

                                        chart.update();
                                    },
                                },
                            },
                        },
                    };

                    return (
                        <div


                            style={{ zIndex: "1", marginTop: "-8px" }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            className="trend_widget"
                        >

                            <div style={{ width: "100%", height: "100%" }} className="bottom_sec trend_graph">
                                <Line options={JSON.stringify(real_datas) !== "{}" ? real_datas[String(l.id)] ? createChartOptions(String(l.id)) : optionsSon : optionsSon} data={JSON.stringify(real_datas) !== "{}" ? real_datas[String(l.id)] ? createChartData(String(l.id)) : datason : datason} />
                            </div>
                        </div>
                    )
                }
                else if (l.type === "empty_btn") {
                    return (
                        <div


                            style={{
                                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px",
                                backgroundColor: "white", border: "2px solid rgb(60,60,60)", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black", borderRadius: "8px", zIndex: "1",
                            }}

                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            className={`empty_btn_widget ${l.elementDetails.text}`}
                        >
                            <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                                <input disabled={true} style={{ backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black", backgroundColor: "transparent", width: "100%", outline: "none", appearance: "none", border: "none", textAlign: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w)) / 10}px` }} type="text" value={l.elementDetails.text} />


                            </div>

                        </div>
                    );
                }
                else if (l.type === "t_t") {

                    return (
                        <div

                            onContextMenu={(e) => {
                                if (l.elementDetails.tagId && l.add_trend && l.add_trend === "YES") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_trend")
                                        .classList.toggle(
                                            "show_external_trend_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_trend"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                } else if (l.elementDetails.tagId && l.elementDetails.tagId !== "") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_detail")
                                        .classList.toggle(
                                            "show_external_detail_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId2"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName2"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_detail"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                }
                            }}

                            style={{
                                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px",
                                zIndex: "1", borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", borderColor: l.borderColor ? l.borderColor : "black", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black",
                            }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: l.w,
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            data-id={l.special_type ? "l.special_type" : ""}
                            key={l.i}
                            className="text_tag_widget"
                        >

                            <input
                                type="text"
                                style={{
                                    width: "100%", textAlign: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w)) / 10}px`, position: "relative", backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black"
                                }}
                                disabled={true}

                                value={
                                    (l.elementDetails.text !== "" ? l.elementDetails.text : " ") +
                                    " : " +
                                    (
                                        l.elementDetails.tagId !== ""
                                            ? (() => {
                                                const matchedItem = tag_values_state.find(item =>
                                                    l.elementDetails.tip !== "Var"
                                                        ? item.tagId === l.elementDetails.tagId
                                                        : item.tip === "Var" && item.tagId === l.elementDetails.tagId
                                                );

                                                const tagValue = matchedItem?.tagValue;
                                                const formatted = tagValue != null
                                                    ? Number(tagValue).toLocaleString("tr-TR", {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2,
                                                    })
                                                    : "";

                                                return (
                                                    formatted +
                                                    (l.elementDetails.unit && l.elementDetails.unit !== "None"
                                                        ? " " + l.elementDetails.unit
                                                        : "")
                                                );
                                            })()
                                            : " "
                                    )

                                }


                            />
                            )
                        </div>
                    );
                }

                else if (l.type === "tag") {
                    const matchingTag = tag_values_state.find(item =>
                        l.elementDetails.tip !== "Var"
                            ? item.tagId === l.elementDetails.tagId
                            : item.tip === "Var" && item.tagId === l.elementDetails.tagId
                    );

                    const decimalPlaces = matchingTag && matchingTag.tagDecimal !== null ? Number(matchingTag.tagDecimal) : 2;
                    let formattedValue = "";

                    if (matchingTag) {
                        let value_tag = matchingTag.tagValue;
                        if (value_tag && isNaN(Number(value_tag))) {
                            value_tag = value_tag.split(" ")[0];
                        }

                        console.log(value_tag, 1)

                        if (value_tag && !isNaN(Number(value_tag))) {
                            let numericValue = Number(value_tag);

                            // Eğer birimi kW/h ise 1000'e böl
                            if (l.elementDetails.unit === "kW/h") {
                                numericValue = numericValue / 1000;
                            }

                            console.log(numericValue, 2)

                            formattedValue = numericValue.toLocaleString("tr-TR", {
                                minimumFractionDigits: decimalPlaces,
                                maximumFractionDigits: decimalPlaces,
                            }) + (l.elementDetails.unit && l.elementDetails.unit !== "None" ? " " + l.elementDetails.unit : "");
                        }
                    }




                    return (
                        <div

                            onContextMenu={(e) => {
                                if (l.elementDetails.tagId && l.add_trend && l.add_trend === "YES") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_trend")
                                        .classList.toggle(
                                            "show_external_trend_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_trend"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                } else if (l.elementDetails.tagId && l.elementDetails.tagId !== "") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_detail")
                                        .classList.toggle(
                                            "show_external_detail_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId2"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName2"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_detail"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                }
                            }}

                            style={{ borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", zIndex: "1", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black", }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            className={"tag_widget" + " " + (l.special_type ? "special_type" : "")}
                        >



                            <input
                                id={l.id + "cc"}
                                type="text"
                                disabled={true}
                                style={{
                                    backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black",
                                    fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, textAlign: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center",
                                    width: "100%", backgroundColor: "transparent", outline: "none", border: "none",

                                }}
                                value={
                                    l.elementDetails.tagId !== ""
                                        ? (() => {
                                            const source = tag_values_state.length > 0 ? tag_values_state : tag_values_state;

                                            const matchedItem = source.find(item =>
                                                l.elementDetails.tip !== "Var"
                                                    ? item.tagId === l.elementDetails.tagId
                                                    : item.tip === "Var" && item.tagId === l.elementDetails.tagId
                                            );

                                            let value_tag = matchedItem?.tagValue;

                                            // Sayı değilse boşluktan önceki kısmı al
                                            if (value_tag && isNaN(Number(value_tag))) {
                                                value_tag = value_tag.split(" ")[0];
                                            }

                                            // Formatla
                                            if (value_tag && !isNaN(Number(value_tag))) {
                                                let numericValue = Number(value_tag);

                                                // BURASI EKLENDİ: Eğer birimi kW/h ise 1000'e böl
                                                if (l.elementDetails.unit === "kW/h") {
                                                    numericValue = numericValue / 1000;
                                                }

                                                const decimalPlaces = l.elementDetails.decimal ?? 2;

                                                const formatted = numericValue.toLocaleString("tr-TR", {
                                                    minimumFractionDigits: decimalPlaces,
                                                    maximumFractionDigits: decimalPlaces,
                                                });

                                                const unit = l.elementDetails.unit;
                                                return formatted + (unit && unit !== "None" ? " " + unit : "");
                                            }

                                            return "";
                                        })()
                                        : ""
                                }



                            />

                        </div>
                    );
                }
                else if (l.type === "Popup") {
                    // 1. `value_` Değerini Bul
                    let value_ = tag_values_state.find(i =>
                        l.elementDetails.tip !== "Var"
                            ? String(i.tagId) === String(l.elementDetails.tagId)
                            : i.tip === "Var" && String(i.tagId) === String(l.elementDetails.tagId)
                    )?.tagValue;

                    // Eğer value_ sayısal değilse, boşluktan sonrasını sil
                    if (value_ && isNaN(Number(value_))) {
                        value_ = value_.split(' ')[0]; // ilk boşluktan önceki kısmı al
                    }

                    // 2. `value_list` İçinde `value_` İndeksini Bul
                    let index_ = l.elementDetails.value_list && l.elementDetails.value_list.indexOf(
                        value_ !== undefined && value_.includes(" ") ? value_.trim() : value_
                    );


                    // 3. Varsayılan Atama
                    if (index_ === -1 || index_ === undefined) { // `indexOf` bulunamazsa -1 döner
                        index_ = 0;
                    }

                    // 1. `value_` Değerini Bul
                    let value_2 = tag_values_state.find(i =>
                        l.elementDetails.tip2 !== "Var"
                            ? String(i.tagId) === String(l.elementDetails.tagId2)
                            : i.tip === "Var" && String(i.tagId) === String(l.elementDetails.tagId2)
                    )?.tagValue;

                    // Eğer value_ sayısal değilse, boşluktan sonrasını sil
                    if (value_2 && isNaN(Number(value_2))) {
                        value_2 = value_2.split(' ')[0]; // ilk boşluktan önceki kısmı al
                    }

                    // 2. `value_list` İçinde `value_` İndeksini Bul
                    let index_2 = l.elementDetails.value_list && l.elementDetails.value_list.indexOf(
                        value_2 !== undefined && value_2.includes(" ") ? value_2.trim() : value_2
                    );

                    // 3. Varsayılan Atama
                    if (index_2 === -1 || index_2 === undefined) { // `indexOf` bulunamazsa -1 döner
                        index_2 = 0;
                    }

                    // 1. `value_` Değerini Bul
                    let value_3 = tag_values_state.find(i =>
                        l.elementDetails.tip !== "Var"
                            ? String(i.tagId) === String(l.elementDetails.tagId3)
                            : i.tip === "Var" && String(i.tagId) === String(l.elementDetails.tagId3)
                    )?.tagValue;

                    // Eğer value_ sayısal değilse, boşluktan sonrasını sil
                    if (value_3 && isNaN(Number(value_3))) {
                        value_3 = value_3.split(' ')[0]; // ilk boşluktan önceki kısmı al
                    }

                    // 2. `value_list` İçinde `value_` İndeksini Bul
                    let index_3 = l.elementDetails.value_list && l.elementDetails.value_list.indexOf(
                        value_3 !== undefined && value_3.includes(" ") ? value_3.trim() : value_3
                    );

                    // 3. Varsayılan Atama
                    if (index_3 === -1 || index_3 === undefined) { // `indexOf` bulunamazsa -1 döner
                        index_3 = 0;
                    }

                    return (
                        <div

                            onClick={(e) => {
                                if (yazma_control) {
                                    let active_id = l.id;
                                    let active_items = l.elementDetails.items;
                                    Set_active_popup_id(active_id);
                                    Set_active_popup_items(active_items)
                                    // Hide other elements
                                    document.querySelector(".react-grid-layout").childNodes.forEach((x) => {
                                        x.style.opacity = "0";
                                        x.style.zIndex = "-1";
                                    });

                                    let w__, h__, x__, y__;

                                    setLayouts((prevLayouts) => {
                                        const updatedLayouts = { ...prevLayouts };

                                        if (Array.isArray(updatedLayouts[currentBreakpoint])) {
                                            (updatedLayouts[currentBreakpoint] || []).forEach((item) => {
                                                if (String(item.id) === String(active_id)) {
                                                    if (!item.elementDetails.items) {
                                                        item.elementDetails.items = [];
                                                    }

                                                    item.elementDetails.items.forEach((newItem) => {
                                                        if (newItem.type === "frame") {
                                                            w__ = newItem.w;
                                                            h__ = newItem.h;
                                                            x__ = newItem.x;
                                                            y__ = newItem.y;
                                                        }
                                                        newItem.isDraggable = false;
                                                        newItem.isResizable = false;
                                                        updatedLayouts[currentBreakpoint].push(newItem);
                                                    });
                                                }
                                            });
                                        }

                                        return updatedLayouts;
                                    });

                                    document.querySelector(".main_sec").classList.toggle("main_sec_bg_blur");

                                    setTimeout(() => {
                                        document.querySelector(".react-grid-layout").childNodes.forEach((x) => {
                                            if (window.getComputedStyle(x).zIndex !== "-1") {
                                                x.style.zIndex = "2";
                                            }
                                        });
                                    }, 50);

                                    setTimeout(() => {
                                        let diffX, diffY;
                                        const layoutItems = document.querySelector(".react-grid-layout")
                                            .childNodes;

                                        layoutItems.forEach((x) => {
                                            const id = x.getAttribute("data-id");

                                            if (x.classList.contains("frame_widget")) {

                                                x.style.width = `${w__}px`; // Grid birimlerini px'e çevir
                                                x.style.height = `${h__}px`;

                                                const initialRect = x.getBoundingClientRect();
                                                const mainSec = document.querySelector(".main_sec");
                                                const mainSecRect = mainSec.getBoundingClientRect();

                                                const centerX = (mainSecRect.width) / 2;
                                                const centerY = (mainSecRect.height) / 2 - mainSecRect.top / 10;

                                                console.warn(mainSecRect, "kdoejdıoejoejoe")

                                                const targetX = (centerX - w__ / 2) - mainSecRect.left / 5;
                                                const targetY = (centerY - h__ / 2);

                                                console.log("targetX", targetX)

                                                diffX = targetX;
                                                diffY = targetY;

                                                x.style.transform = `translate(${targetX}px, ${targetY}px)`;
                                            }
                                        });

                                        // Diğer öğeleri frame'e göre taşı
                                        layoutItems.forEach((x) => {
                                            const id = x.getAttribute("data-id");
                                            if (x.classList.contains("frame_widget")) return;


                                            if (!id?.includes("l.special_type")) return;



                                            if (typeof diffX !== "undefined" && typeof diffY !== "undefined") {
                                                const frameWidgetRect = document
                                                    .querySelector(".frame_widget")
                                                    .getBoundingClientRect();
                                                const elementRect = x.getBoundingClientRect();

                                                const relativeX = elementRect.left - frameWidgetRect.left;
                                                const relativeY = elementRect.top - frameWidgetRect.top;

                                                x.style.transform = `translate(${diffX + relativeX}px, ${diffY + relativeY
                                                    }px)`;
                                            }
                                        });
                                    }, 50);
                                }
                            }
                            }


                            style={{ borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", zIndex: "1", border: "2px solid rgb(70,70,70)", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black", borderRadius: "8px", display: "flex", alignItems: "center", borderColor: l.elementDetails.border_list && l.elementDetails.border_list[index_] ? l.elementDetails.border_list[index_] : "black", backgroundColor: l.elementDetails.bg_list && l.elementDetails.bg_list[index_] ? l.elementDetails.bg_list[index_] : "white", color: l.elementDetails.font_list && l.elementDetails.font_list[index_] ? l.elementDetails.font_list[index_] : "black" }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={"Popup" + l.id}
                            data-id={l.special_type ? "l.special_type" : ""}
                            key={l.i}
                            className="popupduz_widget"
                        >



                            <input
                                className="showRoomNumber_popupDYN"
                                placeholder="room number"

                                id={l.id + "cc"}
                                type="text"

                                value={l.elementDetails.text ? l.elementDetails.text : ""}
                                style={{
                                    fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, textAlign: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center",
                                    backgroundColor: "transparent",
                                    color: l.fontColor ? l.fontColor : "black",
                                    width: "100%", outline: "none", backgroundColor: "transparent", border: "none"

                                }}




                            />

                            <div className="dyn_popup_bottom_part">
                                <div><p style={{ fontSize: `${l.w / 17}px` }}>Oda:</p> <input style={{ color: l.elementDetails.font_list && l.elementDetails.font_list[index_] ? l.elementDetails.font_list[index_] : "black", fontSize: `${l.w / 20}px`, backgroundColor: "transparent" }} type="text" value={
                                    l.elementDetails.tagId3 !== ""
                                        ? (() => {
                                            let selectedTag;
                                            if (l.elementDetails.tip3 === "Var") {
                                                selectedTag = tag_values_state.find(
                                                    (item) => item.tip === "Var" && item.tagId === l.elementDetails.tagId3
                                                );
                                            } else {
                                                selectedTag = tag_values_state.find(
                                                    (item) => item.tagId === l.elementDetails.tagId3
                                                );
                                            }

                                            if (!selectedTag) return "";

                                            const numericValue = parseFloat(selectedTag.tagValue);
                                            const isNumeric = !isNaN(numericValue);

                                            return isNumeric
                                                ? numericValue.toFixed(l.elementDetails.decimal ? l.elementDetails.decimal : 2) +
                                                (l.elementDetails.unit && l.elementDetails.unit !== "None" ? " " + l.elementDetails.unit : "")
                                                : selectedTag.tagValue; // Sayıya çevrilemezse olduğu gibi bırak
                                        })()
                                        : ""
                                } className="dyn_popup_show_room_temp" /></div>
                                <div className="span_divPopupW"><span style={{ borderColor: l.elementDetails.border_list2 && l.elementDetails.border_list2[index_] ? l.elementDetails.border_list2[index_] : "black", backgroundColor: l.elementDetails.bg_list2 && l.elementDetails.bg_list2[index_] ? l.elementDetails.bg_list2[index_] : "white", }}></span></div>
                                <div><p style={{ fontSize: `${l.w / 17}px` }}>Set:</p> <input
                                    onClick={(e) => {
                                        if (l.elementDetails.tagId4 && l.elementDetails.tagId4 !== "" && l.elementDetails.tagId4 !== "None" && yazma_control) {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            const { clientX, clientY } = e;

                                            // Set elem_popup with tagId2 as tagId4 for modal to work
                                            Set_elem_popup({ ...l, elementDetails: { ...l.elementDetails, tagId2: l.elementDetails.tagId4 } });

                                            document.querySelector(".Popup-selectbox2").classList.toggle("changeProperties_active");
                                            document.querySelector(".Popup-selectbox2").id = l.id;

                                            var popup = document.querySelector(".Popup-selectbox2");
                                            const popupRect = popup.getBoundingClientRect();

                                            let newX = clientX + window.scrollX;
                                            let newY = clientY + window.scrollY;

                                            if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                                                newX = window.innerWidth + window.scrollX - popupRect.width;
                                            }
                                            if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                                                newY = window.innerHeight + window.scrollY - popupRect.height;
                                            }

                                            popup.style.left = `${newX}px`;
                                            popup.style.top = `${newY}px`;
                                        }
                                    }}
                                    style={{ color: l.elementDetails.font_list && l.elementDetails.font_list[index_] ? l.elementDetails.font_list[index_] : "black", fontSize: `${l.w / 20}px`, backgroundColor: "transparent", cursor: l.elementDetails.tagId4 && l.elementDetails.tagId4 !== "" && l.elementDetails.tagId4 !== "None" && yazma_control ? "pointer" : "default" }}
                                    type="text"
                                    value={
                                    l.elementDetails.tagId4 !== ""
                                        ? (() => {
                                            let selectedTag;
                                            if (l.elementDetails.tip4 === "Var") {
                                                selectedTag = tag_values_state.find(
                                                    (item) => item.tip === "Var" && item.tagId === l.elementDetails.tagId4
                                                );
                                            } else {
                                                selectedTag = tag_values_state.find(
                                                    (item) => item.tagId === l.elementDetails.tagId4
                                                );
                                            }

                                            if (!selectedTag) return "";

                                            const numericValue = parseFloat(selectedTag.tagValue);
                                            const isNumeric = !isNaN(numericValue);

                                            return isNumeric
                                                ? numericValue.toFixed(l.elementDetails.decimal ? l.elementDetails.decimal : 2) +
                                                (l.elementDetails.unit && l.elementDetails.unit !== "None" ? " " + l.elementDetails.unit : "")
                                                : selectedTag.tagValue; // Sayıya çevrilemezse olduğu gibi bırak
                                        })()
                                        : ""
                                } className="dyn_popup_show_room_set_temp" /></div>
                            </div>

                        </div>
                    );
                }
                else if (l.type === "frame") {
                    if (!l.special_type) {
                        return (
                            <div

                                onContextMenu={(e) => {
                                    console.log(l);
                                    if (l.combine_trend && l.combine_trend === true) {
                                        let group_id = l.group_t_id ? l.group_t_id : undefined

                                        let newData = combine_trend_tags;

                                        (layouts[currentBreakpoint] || []).forEach(x => {
                                            if (group_id !== undefined && x.group_t_id && Number(x.group_t_id) === Number(group_id) && l.elementDetails.tagId) {
                                                var tagName = tags
                                                    .filter((b) => b.tagId === l.elementDetails.tagId)
                                                    .map((c) => c.tagName)[0];
                                                newData.push({ tagId: l.elementDetails.tagId, tagName: tagName })
                                            }
                                        })

                                        Set_combine_trend_tags(newData)

                                        e.preventDefault();
                                        const { clientX, clientY } = e;
                                        let screen_width = window.innerWidth;
                                        console.log(clientX, clientY);
                                        document
                                            .querySelector(".show_external_combine_trend")
                                            .classList.toggle(
                                                "show_external_combine_trend_active"
                                            );

                                        var popup = document.querySelector(
                                            ".show_external_combine_trend"
                                        );
                                        const popupRect =
                                            popup.getBoundingClientRect();
                                        const viewportWidth = window.innerWidth;
                                        const viewportHeight = window.innerHeight;

                                        // Calculate the new positions
                                        let newX = clientX;
                                        let newY = clientY;

                                        // Adjust if the popup would overflow the right edge of the viewport
                                        if (
                                            newX + popupRect.width >
                                            viewportWidth
                                        ) {
                                            newX = viewportWidth - popupRect.width;
                                        }

                                        // Adjust if the popup would overflow the bottom edge of the viewport
                                        if (
                                            newY + popupRect.height >
                                            viewportHeight
                                        ) {
                                            newY =
                                                viewportHeight - popupRect.height;
                                        }

                                        // Adjust if the popup would overflow the left edge of the viewport
                                        if (newX < 0) {
                                            newX = 0;
                                        }

                                        // Adjust if the popup would overflow the top edge of the viewport
                                        if (newY < 0) {
                                            newY = 0;
                                        }

                                        if (
                                            screen_width < 2301 &&
                                            screen_width > 1800
                                        ) {
                                            document.querySelector(
                                                ".show_external_combine_trend"
                                            ).style.left = `${String(
                                                newX / 1.2
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_combine_trend"
                                            ).style.top = `${String(newY / 1.2)}px`;
                                        } else if (
                                            screen_width < 2801 &&
                                            screen_width > 2300
                                        ) {
                                            document.querySelector(
                                                ".show_external_combine_trend"
                                            ).style.left = `${String(
                                                newX / 1.5
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_combine_trend"
                                            ).style.top = `${String(newY / 1.5)}px`;
                                        } else if (
                                            screen_width < 3501 &&
                                            screen_width > 2800
                                        ) {
                                            document.querySelector(
                                                ".show_external_combine_trend"
                                            ).style.left = `${String(
                                                newX / 1.8
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_combine_trend"
                                            ).style.top = `${String(newY / 1.8)}px`;
                                        } else if (
                                            screen_width < 5001 &&
                                            screen_width > 3500
                                        ) {
                                            document.querySelector(
                                                ".show_external_combine_trend"
                                            ).style.left = `${String(
                                                newX / 2.5
                                            )}px`;
                                            document.querySelector(
                                                ".show_external_combine_trend"
                                            ).style.top = `${String(newY / 2.5)}px`;
                                        } else if (screen_width <= 1800) {
                                            document.querySelector(
                                                ".show_external_combine_trend"
                                            ).style.left = `${String(newX)}px`;
                                            document.querySelector(
                                                ".show_external_combine_trend"
                                            ).style.top = `${String(newY)}px`;
                                        }
                                    }
                                }}

                                style={{ borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", backgroundColor: "white", borderRadius: l.elementDetails.borderRadius + "px", border: "3px solid rgb(65,65,65)", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black", zIndex: "0" }}
                                data-grid={{
                                    x: l.x,
                                    y: l.y,
                                    w: (l.w),
                                    h: l.h,
                                    resizeHandles: l.resizeHandles,
                                }}
                                id={l.id}
                                data-id={l.special_type ? "l.special_type" : ""}
                                key={l.i}
                                className="frame_widget"
                            >




                            </div>
                        );
                    } else {
                        return (
                            <div


                                style={{ borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", backgroundColor: "white", borderRadius: l.elementDetails.borderRadius + "px", border: "3px solid rgb(65,65,65)", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black", zIndex: "0" }}
                                data-grid={{
                                    x: l.x,
                                    y: l.y,
                                    w: (l.w),
                                    h: l.h,
                                    resizeHandles: l.resizeHandles,
                                }}
                                id={l.id}
                                data-id={l.special_type ? "l.special_type" : ""}
                                key={l.i}
                                className="frame_widget"
                            >
                                <i onClick={(e) => {
                                    if (document.querySelector(".main_sec").classList.contains("main_sec_bg_blur")) {


                                        setLayouts((prevLayouts) => {
                                            const updatedLayouts = { ...prevLayouts };


                                            if (Array.isArray(updatedLayouts[currentBreakpoint])) {
                                                // Filter out items with matching special_type and id2
                                                updatedLayouts[currentBreakpoint] = (updatedLayouts[currentBreakpoint] || []).filter(
                                                    (item) => !(item.special_type && String(item.id2) === String(active_popup_id))
                                                );
                                            }

                                            return updatedLayouts;
                                        });
                                        Set_active_popup_id(null)
                                        Set_active_popup_items([])
                                        document.querySelector(".main_sec").classList.toggle("main_sec_bg_blur");
                                        setTimeout(() => {
                                            document.querySelector(".react-grid-layout").childNodes.forEach(x => {
                                                x.style.opacity = "1"
                                                x.style.zIndex = "1"
                                            })
                                        }, 50)
                                    }

                                }} style={{ position: "relative", left: "95%", top: "-30px", cursor: "pointer", backgroundColor: "red", width: "40px", height: "40px", display: "flex", alignItems: "center", justifyContent: "center", color: "white", borderRadius: "40px", border: "none" }} className="fa fa-times"></i>




                            </div>
                        );
                    }

                }
                else if (l.type === "fan_modu") {
                    return (
                        <div

                            onContextMenu={(e) => {
                                if (l.elementDetails.tagId && l.add_trend && l.add_trend === "YES") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_trend")
                                        .classList.toggle(
                                            "show_external_trend_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_trend"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                } else if (l.elementDetails.tagId && l.elementDetails.tagId !== "") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_detail")
                                        .classList.toggle(
                                            "show_external_detail_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId2"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName2"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_detail"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                }
                            }}

                            onClick={(e) => {
                                if (yazma_control) {
                                    console.log(e.target);
                                    e.preventDefault();
                                    e.stopPropagation();
                                    const { clientX, clientY } = e;
                                    document.querySelector(".Popup-fan").classList.toggle("changeProperties_active")
                                    document.querySelector(".Popup-fan").id = l.id

                                    var popup = document.querySelector(".Popup-fan")
                                    const popupRect = popup.getBoundingClientRect();

                                    // Yeni pozisyonları hesapla
                                    let newX = clientX + window.scrollX;
                                    let newY = clientY + window.scrollY;

                                    console.log(newX, newY);

                                    // Sağ kenardan taşmayı önle
                                    if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                                        newX = window.innerWidth + window.scrollX - popupRect.width;
                                    }

                                    // Alt kenardan taşmayı önle
                                    if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                                        newY = window.innerHeight + window.scrollY - popupRect.height;
                                    }

                                    // Sol kenardan taşmayı önle
                                    if (newX < window.scrollX) {
                                        newX = window.scrollX;
                                    }

                                    // Üst kenardan taşmayı önle
                                    if (newY < window.scrollY) {
                                        newY = window.scrollY;
                                    }

                                    console.log(newX, newY);

                                    // Pop-up'ın pozisyonunu ayarla
                                    popup.style.left = `${newX}px`;
                                    popup.style.top = `${newY}px`;

                                    const parentElement = e.target.closest(".fan_modu_widget");
                                    const parentRect = parentElement.getBoundingClientRect();

                                    Set_elem_popup({
                                        width: l.w,
                                        height: l.h * 10,
                                        left: l.x,
                                        top: l.y,

                                        type: l.type,
                                        id: l.id,
                                        fontSize: l.fontSize ? l.fontSize : Number(l.w) / 10
                                    })

                                    setSelectedOptionfan(l.elementDetails.text)
                                }
                            }
                            }
                            style={{ borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", border: "2px solid rgb(60,60,60)", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black", borderRadius: "4px", zIndex: "1" }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            className={"fan_modu_widget" + " " + (l.special_type ? "special_type" : "")}
                        >

                            <div style={{ backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black", width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                                {l.elementDetails.text}

                            </div>

                        </div>
                    );
                }
                else if (l.type === "calisma_modu") {
                    return (
                        <div
                            onContextMenu={(e) => {
                                if (l.elementDetails.tagId && l.add_trend && l.add_trend === "YES") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_trend")
                                        .classList.toggle(
                                            "show_external_trend_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_trend"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                } else if (l.elementDetails.tagId && l.elementDetails.tagId !== "") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_detail")
                                        .classList.toggle(
                                            "show_external_detail_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId2"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName2"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_detail"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                }
                            }}
                            onClick={(e) => {
                                if (yazma_control) {
                                    console.log(e.target);
                                    e.preventDefault();
                                    e.stopPropagation();
                                    const { clientX, clientY } = e;
                                    document.querySelector(".Popup-calisma").classList.toggle("changeProperties_active")
                                    document.querySelector(".Popup-calisma").id = l.id

                                    var popup = document.querySelector(".Popup-calisma")
                                    const popupRect = popup.getBoundingClientRect();

                                    // Yeni pozisyonları hesapla
                                    let newX = clientX + window.scrollX;
                                    let newY = clientY + window.scrollY;

                                    console.log(newX, newY);

                                    // Sağ kenardan taşmayı önle
                                    if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                                        newX = window.innerWidth + window.scrollX - popupRect.width;
                                    }

                                    // Alt kenardan taşmayı önle
                                    if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                                        newY = window.innerHeight + window.scrollY - popupRect.height;
                                    }

                                    // Sol kenardan taşmayı önle
                                    if (newX < window.scrollX) {
                                        newX = window.scrollX;
                                    }

                                    // Üst kenardan taşmayı önle
                                    if (newY < window.scrollY) {
                                        newY = window.scrollY;
                                    }

                                    console.log(newX, newY);

                                    // Pop-up'ın pozisyonunu ayarla
                                    popup.style.left = `${newX}px`;
                                    popup.style.top = `${newY}px`;

                                    const parentElement = e.target.closest(".calisma_modu_widget");
                                    const parentRect = parentElement.getBoundingClientRect();

                                    Set_elem_popup({
                                        width: l.w,
                                        height: l.h * 10,
                                        left: l.x,
                                        top: l.y,

                                        type: l.type,
                                        id: l.id,
                                        fontSize: l.fontSize ? l.fontSize : Number(l.w) / 10
                                    })

                                    setSelectedOptioncalisma(l.elementDetails.text)
                                }
                            }
                            }
                            style={{ borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", border: "2px solid rgb(60,60,60)", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "black", borderRadius: "4px", zIndex: "1" }}
                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}

                            id={l.id}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            className={"calisma_modu_widget" + ` ${l.elementDetails.tagId}` + " " + (l.special_type ? "special_type" : "")}
                        >


                            <div style={{ backgroundColor: "transparent", color: l.fontColor ? l.fontColor : "black", width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                                {l.elementDetails.text}

                            </div>



                        </div>
                    );
                }
                else if (l.type === "on/off") {
                    let value_ = tag_values_state.find(i =>
                        l.elementDetails.tip !== "Var"
                            ? String(i.tagId) === String(l.elementDetails.tagId)
                            : i.tip === "Var" && String(i.tagId) === String(l.elementDetails.tagId)
                    )?.tagValue;

                    // Eğer value_ sayısal değilse, boşluktan sonrasını sil
                    if (value_ && isNaN(Number(value_))) {
                        value_ = value_.split(' ')[0];

                    }
                    console.warn("value_", value_, typeof (value_));

                    value_ = value_ && value_.split('.')[0]; // Noktadan sonrasını almaz

                    console.warn("value_", value_, typeof (value_));

                    // 2. value_list oluştur (value1, value2, value3... varsa onları al)
                    let valueList = [];
                    let i = 1;
                    while (l.elementDetails[`value${i}`] !== undefined) {
                        valueList.push(l.elementDetails[`value${i}`]);
                        i++;
                    }

                    // 3. value_ değeri valueList içinde kaçıncı sıradaysa onu al
                    let index_ = valueList.indexOf(
                        value_ !== undefined && value_.includes(" ") ? value_.trim() : value_
                    );

                    // 4. Varsayılan atama
                    if (index_ === -1 || index_ === undefined) {
                        index_ = 0;
                    }
                    return (
                        <div

                            onContextMenu={(e) => {
                                const { clientX, clientY } = e;
                                let screen_width = window.innerWidth;
                                if (l.elementDetails.tagId && l.add_trend && l.add_trend === "YES") {
                                    if (l.elementDetails.text === "ON") {
                                        var tagName = tags
                                            .filter((b) => b.tagId === l.elementDetails.tagId)
                                            .map((c) => c.tagName)[0];

                                        e.preventDefault();

                                        let screen_width = window.innerWidth;
                                        console.log(clientX, clientY);
                                        document
                                            .querySelector(".show_external_trend")
                                            .classList.toggle(
                                                "show_external_trend_active"
                                            );
                                        document.querySelector(
                                            ".show_tagId"
                                        ).innerHTML = l.elementDetails.tagId;
                                        document.querySelector(
                                            ".show_tagName"
                                        ).innerHTML = tagName;
                                        var popup = document.querySelector(
                                            ".show_external_trend"
                                        );
                                    } else {
                                        var tagName = tags
                                            .filter((b) => b.tagId === l.elementDetails.tagId)
                                            .map((c) => c.tagName)[0];

                                        e.preventDefault();

                                        let screen_width = window.innerWidth;
                                        console.log(clientX, clientY);
                                        document
                                            .querySelector(".show_external_trend")
                                            .classList.toggle(
                                                "show_external_trend_active"
                                            );
                                        document.querySelector(
                                            ".show_tagId"
                                        ).innerHTML = l.elementDetails.tagId;
                                        document.querySelector(
                                            ".show_tagName"
                                        ).innerHTML = tagName;
                                        var popup = document.querySelector(
                                            ".show_external_trend"
                                        );
                                    }

                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                } else if (l.elementDetails.tagId && l.elementDetails.tagId !== "") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_detail")
                                        .classList.toggle(
                                            "show_external_detail_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId2"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName2"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_detail"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                }
                            }}

                            onClick={(e) => {
                                if (yazma_control) {


                                    console.log(e.target);
                                    e.preventDefault();
                                    e.stopPropagation();
                                    const { clientX, clientY } = e;
                                    document.querySelector(".Popup-onOff").classList.toggle("changeProperties_active")
                                    document.querySelector(".Popup-onOff").id = l.id

                                    var popup = document.querySelector(".Popup-onOff")
                                    const popupRect = popup.getBoundingClientRect();

                                    // Yeni pozisyonları hesapla
                                    let newX = clientX + window.scrollX;
                                    let newY = clientY + window.scrollY;

                                    console.log(newX, newY);

                                    // Sağ kenardan taşmayı önle
                                    if (newX + popupRect.width > window.innerWidth + window.scrollX) {
                                        newX = window.innerWidth + window.scrollX - popupRect.width;
                                    }

                                    // Alt kenardan taşmayı önle
                                    if (newY + popupRect.height > window.innerHeight + window.scrollY) {
                                        newY = window.innerHeight + window.scrollY - popupRect.height;
                                    }

                                    // Sol kenardan taşmayı önle
                                    if (newX < window.scrollX) {
                                        newX = window.scrollX;
                                    }

                                    // Üst kenardan taşmayı önle
                                    if (newY < window.scrollY) {
                                        newY = window.scrollY;
                                    }

                                    console.log(newX, newY);

                                    // Pop-up'ın pozisyonunu ayarla
                                    popup.style.left = `${newX}px`;
                                    popup.style.top = `${newY}px`;

                                    const parentElement = e.target.closest(".on-off_widget");
                                    const parentRect = parentElement.getBoundingClientRect();

                                    Set_elem_popup({
                                        width: l.w,
                                        height: l.h * 10,
                                        left: l.x,
                                        top: l.y,

                                        type: l.type,
                                        id: l.id,
                                        fontSize: l.fontSize ? l.fontSize : Number(l.w) / 10,
                                        value: value_ !== undefined && value_ === "1" ? "ON" : "OFF"
                                    })
                                }
                            }
                            }
                            style={{
                                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", backgroundColor: "white", borderColor: l.borderColor ? l.borderColor : "black", backgroundColor: l.bgColor ? l.bgColor : "white", color: l.fontColor ? l.fontColor : "white", borderRadius: "8px", zIndex: "1",
                            }}

                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: (l.w),
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            id={l.id}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            className={`on-off_widget ${value_ !== undefined && value_ === "1" ? "ON" : "OFF"} ${l.elementDetails.tagId}` + " " + (l.special_type ? "special_type" : "")}
                        >
                            <div style={{ backgroundColor: "transparent", color: "white", width: "100%", height: "100%", display: "flex", alignItems: "center", fontSize: l.fontSize ? l.fontSize : `${(Number(l.w) / 8)}px`, justifyContent: l.elementDetails.textAlign ? l.elementDetails.textAlign : "center", }}>
                                {value_ !== undefined && value_ === "1" ? "ON" : "OFF"}

                            </div>

                        </div>
                    );
                }
                else if (l.type === "image") {
                    return (
                        <div


                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: l.w,
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            className="image_widgetParentDiv"
                            style={{ borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px", borderRadius: l.borderRadius ? l.borderRadius + "px" : "8px", borderColor: "rgb(100,100,100)", zIndex: "1" }}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            id={l.id}
                        >

                            <img
                                style={{ width: "100%", height: "100%" }}
                                className="image_widget"
                                src={l.elementDetails.src !== "" ? l.elementDetails.src : ""}
                                alt=""
                            />
                        </div>
                    );
                } else if (l.type === "bg") {

                    let diffWidth = document.querySelector(".link-group-data-links").getBoundingClientRect().width * 1.05
                    let diffHeigth = document.querySelector("nav").getBoundingClientRect().height * 1.25
                    console.log(diffHeigth)


                    setTimeout(() => {
                        if (document.querySelector(".main_sec")) {
                            document.querySelector(
                                ".main_sec"
                            ).style.backgroundImage = `url("${l.elementDetails.src}")`;
                            document.querySelector(".main_sec").style.backgroundPosition =
                                `${l.elementDetails.left}px ${l.elementDetails.top}px`;
                            document.querySelector(".main_sec").style.backgroundSize = `${l.elementDetails.width}px ${l.elementDetails.height}px`;
                            document.querySelector(".main_sec").style.backgroundRepeat = "no-repeat"
                        }

                    }, 1000)



                } else if (l.type === "gauge") {
                    let value_max = Number(l.elementDetails.maxValue);

                    // tip kontrolü ile uygun tag değerini bul
                    let selectedTag;
                    if (l.elementDetails.tip === "Var") {
                        selectedTag = tag_values_state.find(
                            (item) => item.tip === "Var" && item.tagId === l.elementDetails.tagId
                        );
                    } else {
                        selectedTag = tag_values_state.find((item) => item.tagId === l.elementDetails.tagId);
                    }

                    // Sayısal değeri güvenli şekilde al
                    let value_tag = selectedTag ? selectedTag.tagValue : "";
                    const numericValue = parseFloat(value_tag);
                    const isNumeric = !isNaN(numericValue);

                    // Eğer isNumeric false ise boşluktan sonrasını kes
                    value_tag = isNumeric ? value_tag : value_tag.split(' ')[0];



                    // last_deger hesaplamasını güvenli hale getir
                    let last_deger = isNumeric
                        ? (numericValue / (l.elementDetails.endValue ? l.elementDetails.endValue : value_max).toFixed(2)) * 100
                        : 0;

                    // startValue ve endValue güvenli şekilde belirle
                    const startValue =
                        l.elementDetails.startValue && isNumeric && l.elementDetails.startValue <= numericValue
                            ? l.elementDetails.startValue
                            : 0;

                    const endValue = l.elementDetails.endValue && isNumeric
                        ? l.elementDetails.limitValues && l.elementDetails.limitValues.length > 0 && Number([...l.elementDetails.limitValues]
                            .sort((a, b) => a.value - b.value)
                            .at(-1).value) >= l.elementDetails.endValue
                            ? Math.max(l.elementDetails.endValue, numericValue) +
                            Number([...l.elementDetails.limitValues]
                                .sort((a, b) => a.value - b.value)
                                .at(-1).value)
                            : Math.max(l.elementDetails.endValue, numericValue)
                        : isNumeric
                            ? numericValue.toFixed(2)
                            : 100;
                    // normalizedValue hesapla
                    const normalizedValue = isNumeric
                        ? ((value_tag - startValue) / (endValue - startValue)) * 100
                        : 0;

                    // Arc limitlerini tanımla
                    const arcLimits = l.elementDetails.pU && l.elementDetails.limitValues
                        ? (() => {
                            if (l.elementDetails.pU === "Unit") {
                                // Unit modu için özel mantık
                                const sortedLimits = [...l.elementDetails.limitValues].sort((a, b) => a.value - b.value);
                                const colorLimits = sortedLimits.filter(i => i.color);

                                let lastLimit = startValue;
                                let result = [];

                                colorLimits.forEach(({ value, color }) => {
                                    let newColor = color;
                                    if (l.elementDetails.scaleX === "-1" && color === "#008000") {
                                        newColor = "#ff0000";
                                    } else if (l.elementDetails.scaleX === "-1" && color === "#ff0000") {
                                        newColor = "#008000";
                                    }
                                    result.push({
                                        limit: value,
                                        color: newColor,
                                    });
                                    lastLimit = value;
                                });

                                // Son rengi endValue'ya kadar devam ettir
                                if (colorLimits.length > 2) {
                                    result.push({
                                        limit: endValue,
                                        color: l.elementDetails.scaleX === "-1" ? colorLimits[0].color : colorLimits[colorLimits.length - 1].color,
                                    });
                                } else {
                                    result = [
                                        {
                                            limit: ((20 / 100) * (endValue - startValue)) + startValue,
                                            color: l.elementDetails.scaleX === "-1" ? "#5BE12C" : "#EA4228",
                                        },
                                        {
                                            limit: ((40 / 100) * (endValue - startValue)) + startValue,
                                            color: l.elementDetails.scaleX === "-1" ? "#F5CD19" : "#F58B19",
                                        },
                                        {
                                            limit: ((60 / 100) * (endValue - startValue)) + startValue,
                                            color: l.elementDetails.scaleX === "-1" ? "#F58B19" : "#F5CD19",
                                        },
                                        {
                                            limit: ((80 / 100) * (endValue - startValue)) + startValue,
                                            color: l.elementDetails.scaleX === "-1" ? "#FF5733" : "#33FFCE",
                                        },
                                        {
                                            limit: ((100 / 100) * (endValue - startValue)) + startValue,
                                            color: l.elementDetails.scaleX === "-1" ? "#EA4228" : "#5BE12C",
                                        },
                                    ];
                                }

                                return result;
                            } else if (l.elementDetails.pU === "Percent") {
                                // Percent modu için 5 renkli dizi
                                return [
                                    {
                                        limit: ((20 / 100) * (endValue - startValue)) + startValue,
                                        color: l.elementDetails.scaleX === "-1" ? "#5BE12C" : "#EA4228",
                                    },
                                    {
                                        limit: ((40 / 100) * (endValue - startValue)) + startValue,
                                        color: l.elementDetails.scaleX === "-1" ? "#F5CD19" : "#F58B19",
                                    },
                                    {
                                        limit: ((60 / 100) * (endValue - startValue)) + startValue,
                                        color: l.elementDetails.scaleX === "-1" ? "#F58B19" : "#F5CD19",
                                    },
                                    {
                                        limit: ((80 / 100) * (endValue - startValue)) + startValue,
                                        color: l.elementDetails.scaleX === "-1" ? "#FF5733" : "#33FFCE",
                                    },
                                    {
                                        limit: ((100 / 100) * (endValue - startValue)) + startValue,
                                        color: l.elementDetails.scaleX === "-1" ? "#EA4228" : "#5BE12C",
                                    },
                                ];
                            } else {
                                // Diğer durumlar için varsayılan dizi
                                return [
                                    {
                                        limit: ((20 / 100) * (endValue - startValue)) + startValue,
                                        color: l.elementDetails.scaleX === "-1" ? "#5BE12C" : "#EA4228",
                                    },
                                    {
                                        limit: ((40 / 100) * (endValue - startValue)) + startValue,
                                        color: l.elementDetails.scaleX === "-1" ? "#F5CD19" : "#F58B19",
                                    },
                                    {
                                        limit: ((60 / 100) * (endValue - startValue)) + startValue,
                                        color: l.elementDetails.scaleX === "-1" ? "#F58B19" : "#F5CD19",
                                    },
                                    {
                                        limit: ((80 / 100) * (endValue - startValue)) + startValue,
                                        color: l.elementDetails.scaleX === "-1" ? "#FF5733" : "#33FFCE",
                                    },
                                    {
                                        limit: ((100 / 100) * (endValue - startValue)) + startValue,
                                        color: l.elementDetails.scaleX === "-1" ? "#EA4228" : "#5BE12C",
                                    },
                                ];
                            }
                        })()
                        : [
                            {
                                limit: ((20 / 100) * (endValue - startValue)) + startValue,
                                color: l.elementDetails.scaleX === "-1" ? "#5BE12C" : "#EA4228",
                            },
                            {
                                limit: ((40 / 100) * (endValue - startValue)) + startValue,
                                color: l.elementDetails.scaleX === "-1" ? "#F5CD19" : "#F58B19",
                            },
                            {
                                limit: ((60 / 100) * (endValue - startValue)) + startValue,
                                color: l.elementDetails.scaleX === "-1" ? "#F58B19" : "#F5CD19",
                            },
                            {
                                limit: ((80 / 100) * (endValue - startValue)) + startValue,
                                color: l.elementDetails.scaleX === "-1" ? "#FF5733" : "#33FFCE",
                            },
                            {
                                limit: ((100 / 100) * (endValue - startValue)) + startValue,
                                color: l.elementDetails.scaleX === "-1" ? "#EA4228" : "#5BE12C",
                            },
                        ];
                    ;

                    const textElement = document.querySelector(`.gauge_widgetParentDiv${l.id} .value-text text`);

                    if (textElement && l.fontColor) textElement.style.fill = l.fontColor

                    document.querySelectorAll(`.gauge_widgetParentDiv${l.id} .tick-value text`).forEach(x => {
                        if (l.fontColor) x.style.fill = l.fontColor
                    })

                    // pU kontrolü ile text içeriğini güncelle
                    if (l.elementDetails.pU) {
                        const textElement = document.querySelector(`.gauge_widgetParentDiv${l.id} .value-text text`);
                        if (textElement) {
                            if (l.elementDetails.pU === "Unit") {
                                if (textElement.textContent.includes("%")) {
                                    textElement.textContent = textElement.textContent.slice(0, -1); // "%" karakterini kaldır
                                }
                                textElement.textContent = value_tag;
                            } else {
                                if (!textElement.textContent.includes("%")) {
                                    textElement.textContent = normalizedValue.toFixed(2) + "%";
                                }
                            }
                        }
                    }

                    // Min ve Max değerlerini ayarla
                    const min = l.elementDetails.pU === "Unit" && l.elementDetails.startValue ? startValue : 0;
                    const max = l.elementDetails.pU === "Unit" && l.elementDetails.endValue ? endValue : 100;





                    return (
                        <div
                            className={"gauge_widgetParentDiv" + " gauge_widgetParentDiv" + l.id}

                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: l.w,
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            onContextMenu={(e) => {
                                if (l.elementDetails.tagId && l.add_trend && l.add_trend === "YES") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_trend")
                                        .classList.toggle(
                                            "show_external_trend_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_trend"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_trend"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                } else if (l.elementDetails.tagId && l.elementDetails.tagId !== "") {
                                    var tagName = tags
                                        .filter((b) => b.tagId === l.elementDetails.tagId)
                                        .map((c) => c.tagName)[0];

                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    let screen_width = window.innerWidth;
                                    console.log(clientX, clientY);
                                    document
                                        .querySelector(".show_external_detail")
                                        .classList.toggle(
                                            "show_external_detail_active"
                                        );
                                    document.querySelector(
                                        ".show_tagId2"
                                    ).innerHTML = l.elementDetails.tagId;
                                    document.querySelector(
                                        ".show_tagName2"
                                    ).innerHTML = tagName;
                                    var popup = document.querySelector(
                                        ".show_external_detail"
                                    );
                                    const popupRect =
                                        popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                        newX + popupRect.width >
                                        viewportWidth
                                    ) {
                                        newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                        newY + popupRect.height >
                                        viewportHeight
                                    ) {
                                        newY =
                                            viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                        newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                        newY = 0;
                                    }

                                    if (
                                        screen_width < 2301 &&
                                        screen_width > 1800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.2
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.2)}px`;
                                    } else if (
                                        screen_width < 2801 &&
                                        screen_width > 2300
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.5)}px`;
                                    } else if (
                                        screen_width < 3501 &&
                                        screen_width > 2800
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 1.8
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 1.8)}px`;
                                    } else if (
                                        screen_width < 5001 &&
                                        screen_width > 3500
                                    ) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(
                                            newX / 2.5
                                        )}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY / 2.5)}px`;
                                    } else if (screen_width <= 1800) {
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.left = `${String(newX)}px`;
                                        document.querySelector(
                                            ".show_external_detail"
                                        ).style.top = `${String(newY)}px`;
                                    }
                                }
                            }}

                            style={{
                                border: "1px solid rgb(100,100,100)",
                                borderWidth: l.borderWidth ? l.borderWidth + "px" : "2px",
                                backgroundColor: l.bgColor ? l.bgColor : "transparent",
                                borderRadius: l.elementDetails.borderRadius ? l.elementDetails.borderRadius + "px" : "8px",
                                minWidth: "100px", minHeight: "100px",
                                zIndex: "1",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                borderColor: l.borderColor ? l.borderColor : "rgb(100,100,100)",
                                overflow: "hidden", // Ebeveyn div taşmasını önler
                            }}
                            key={`${l.id} gauge-${fufg}`}

                            data-id={l.special_type ? "l.special_type" : ""}

                            id={l.id}

                        >

                            <GaugeComponent

                                maxValue={max}
                                minValue={min}
                                className="gauge_widget"
                                arc={{
                                    subArcs:
                                        l.elementDetails.pU ? l.elementDetails.pU === "Percent"
                                            ? arcLimits.map((arc) => ({
                                                limit: ((arc.limit - startValue) / (endValue - startValue)) * 100, // Normalize edilen yüzdelik limitler
                                                color: arc.color,
                                                showTick: true,
                                            }))
                                            : // Eğer "Unit" modundaysa, startValue ve endValue arasında 5 eşit dilim oluştur
                                            arcLimits.map((arc) => {
                                                // Eğer arc.limit startValue'dan küçükse startValue'ya ayarla
                                                let adjustedLimit = arc.limit < startValue ? startValue
                                                    // Eğer arc.limit endValue'dan büyükse endValue'ya ayarla
                                                    : arc.limit > endValue ? endValue
                                                        : arc.limit;

                                                return {
                                                    limit: adjustedLimit, // Normalize edilmiş limit
                                                    color: arc.color,
                                                    showTick: true,
                                                };
                                            }) : arcLimits.map((arc) => ({
                                                limit: ((arc.limit - startValue) / (endValue - startValue)) * 100, // Normalize edilen yüzdelik limitler
                                                color: arc.color,
                                                showTick: true,
                                            })),
                                }}
                                value={
                                    l.elementDetails.pU && l.elementDetails.pU === "Unit"
                                        ? isNumeric ? numericValue.toFixed(2) : "50" // value_tag geçerli sayı mı?
                                        : isNumeric ? (normalizedValue * max) / 100 : 50 // normalizedValue geçerli sayı mı?
                                }
                                style={{
                                    width: "80%",  // Tam genişlik kaplama
                                    height: "80%",
                                    marginLeft: "0%",// Tam yükseklik kaplama,
                                    opacity: "1",

                                }}
                            />
                        </div>
                    );
                }

                else if (l.type === "left_ok") {
                    let rotate_deg = 0;
                    if (l.elementDetails.rotate_deg) {
                        rotate_deg = l.elementDetails.rotate_deg
                    }

                    return (
                        <div

                            style={{ maxHeight: "50px", display: "flex", alignItems: "center", zIndex: "1" }}


                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: l.w,
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            id={l.id}
                            className="left_ok_arrow"
                        >

                            <svg style={l.elementDetails.rotate_deg && { transform: `rotate(${l.elementDetails.rotate_deg}deg)`, transformOrigin: "center" }} width={"100%"} className="sebeke-giris-cizgi">
                                <line
                                    x1="0"
                                    y1="25"
                                    x2="200%"
                                    y2="25"
                                    stroke={l.elementDetails.color}
                                    strokeWidth="8"
                                />
                                <polygon
                                    points="0,25 20,10 20,40"
                                    fill={l.elementDetails.color}
                                />
                                <line

                                    stroke="black"
                                    strokeWidth="14"
                                    markerEnd="url(#arrowhead)"
                                />
                            </svg>

                        </div>
                    )


                } else if (l.type === "right_ok") {

                    let rotate_deg = 0;
                    if (l.elementDetails.rotate_deg) {
                        rotate_deg = l.elementDetails.rotate_deg
                    }

                    return (
                        <div

                            style={{ maxHeight: "50px", display: "flex", alignItems: "center", color: `${l.elementDetails.color}`, zIndex: "1" }}

                            data-grid={{
                                x: l.x,
                                y: l.y,
                                w: l.w,
                                h: l.h,
                                resizeHandles: l.resizeHandles,
                            }}
                            key={l.i}
                            data-id={l.special_type ? "l.special_type" : ""}

                            id={l.id}
                            className="right_arrow"
                        >

                            <svg width="100%" style={l.elementDetails.rotate_deg && { transform: `rotate(${l.elementDetails.rotate_deg}deg)`, transformOrigin: "center" }} height="50" className="sebeke-giris-cizgi">
                                <defs>
                                    <marker id={`arrowhead${l.id}`} orient="auto" markerWidth="5" markerHeight="5" refX="5" refY="2.5">
                                        <path d="M 0,0 L 5,2.5 L 0,5 Z" fill={`${l.elementDetails.color}`} />
                                    </marker>
                                </defs>

                                <line
                                    x1="0"
                                    y1="25"
                                    x2="calc(100% - 10px)"
                                    y2="25"
                                    stroke={l.elementDetails.color}
                                    strokeWidth="8"
                                />

                                <line
                                    x1="0"
                                    y1="25"
                                    x2="100%"
                                    y2="25"
                                    stroke={l.elementDetails.color}
                                    strokeWidth="8"
                                    marker-end={`url(#arrowhead${l.id})`}
                                />
                            </svg>









                        </div>
                    )

                }
                // return (
                //   <div id='selam34' style={{ display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "rgb(170,170,170)", color: "wheat", fontSize: "35px" }} key={i} className={l.static ? 'static' : ''}>
                //     {l.static ? (
                //       <span className="text" title="This item is static and cannot be removed or resized.">
                //         Static - {i}
                //       </span>
                //     ) : (
                //       <span style={{ padding: "10%", display: "flex", alignItems: "center", justifyContent: "center", width: "90%", height: "90%" }} className="text"><div id='test1' style={{ width: "100%", fontSize: `${Number(l.w) * 15}px`, height: "100%", backgroundColor: "black", display: "flex", alignItems: "center", justifyContent: "center" }}>{i}</div></span>
                //     )}
                //   </div>
                // );
            });

        }
    };

    useEffect(() => {
        let obj_lg = layouts.lg;
        let obj_md = layouts.md;
        let obj_sm = layouts.sm;
        let obj_xs = layouts.xs;
        let obj_xxs = layouts.xxs;
        if (layouts.lg) {

            if (
                obj_lg.length !== 0 ||
                obj_md.length !== 0 ||
                obj_sm.length !== 0 ||
                obj_xs.length !== 0 ||
                obj_xxs.length !== 0
            ) {
                Set_layouts2({
                    "lg": layouts[currentBreakpoint],
                    "md": layouts[currentBreakpoint],
                    "sm": layouts[currentBreakpoint],
                    "xs": layouts[currentBreakpoint],
                    "xxs": layouts[currentBreakpoint],

                })
            }
        }
    }, [layouts]);

    const onBreakpointChange = (breakpoint) => {
        // Geçerli breakpoint'teki layout'u geçici bir değişkende sakla
        // Yeni breakpoint'i ayarla
        setCurrentBreakpoint(breakpoint);
    };

    const onCompactTypeChange = () => {
        setCompactType((oldCompactType) =>
            oldCompactType === "horizontal"
                ? "vertical"
                : oldCompactType === "vertical"
                    ? null
                    : "horizontal"
        );
    };

    const onResizeTypeChange = () => {
        setResizeHandles((currentHandles) =>
            currentHandles === availableHandles ? ["se"] : availableHandles
        );
    };

    useEffect(() => {
        console.log(layouts);
    }, [layouts]);

    const onLayoutChangeHandler = (layout, layouts) => {
        onLayoutChange(layout, layouts);
    };

    const onNewLayout = () => {
        if (currentBreakpoint === "lg") {
            setLayouts((prevLayouts) => {
                return { ...prevLayouts, lg: generateLayout(resizeHandles) };
            });
        } else if (currentBreakpoint === "md") {
            setLayouts((prevLayouts) => {
                return { ...prevLayouts, md: generateLayout(resizeHandles) };
            });
        } else if (currentBreakpoint === "sm") {
            setLayouts((prevLayouts) => {
                return { ...prevLayouts, sm: generateLayout(resizeHandles) };
            });
        } else if (currentBreakpoint === "xs") {
            setLayouts((prevLayouts) => {
                return { ...prevLayouts, xs: generateLayout(resizeHandles) };
            });
        } else if (currentBreakpoint === "xxs") {
            setLayouts((prevLayouts) => {
                return { ...prevLayouts, xxs: generateLayout(resizeHandles) };
            });
        }
    };
    useEffect(() => {
        const updateLayouts = () => {
            setLayouts((prevLayouts) => {
                const updatedLayouts = { ...prevLayouts };



                // Function to check if all breakpoints have the same layout
                const areAllBreakpointsSame = () => {
                    const currentLayoutJSON = JSON.stringify(updatedLayouts[currentBreakpoint]);
                    return Object.keys(updatedLayouts).every((breakpoint) =>
                        JSON.stringify(updatedLayouts[breakpoint]) === currentLayoutJSON
                    );
                };

                // Update all breakpoints if they are not already the same
                if (!areAllBreakpointsSame()) {
                    Object.keys(updatedLayouts).forEach((breakpoint) => {
                        updatedLayouts[breakpoint] = [...updatedLayouts[currentBreakpoint]];
                    });
                }

                return updatedLayouts;
            });
        };
        updateLayouts()
    }, [])
    const onDrop = (elemParams, first, last) => {

        setLayouts((prevLayouts) => {
            return {
                ...prevLayouts,
                [currentBreakpoint]: (prevLayouts[currentBreakpoint] || []).map(
                    (layoutItem) => {
                        if (layoutItem.i === first.i) {
                            return { ...layoutItem, x: last.x, y: last.y };
                        }
                        return { ...layoutItem };
                    }
                ),
            };
        });
    };



    const createWidget = (e) => {
        document.querySelector(".tool_box").classList.toggle("tool_box_active")

        let id_ = e.target.id;
        if (id_ !== "") {
            if (id_ === "text") {
                Set_render_items((prevLayouts) => {
                    return {
                        ...prevLayouts,
                        [currentBreakpoint]: [...prevLayouts[currentBreakpoint], "text"],
                    };
                });
                setLayouts((prevLayouts) => {
                    const newX = Math.round(Math.random() * 5) * 2;
                    const newY = Math.floor(12 / 6) * 2;
                    const newWidget = {
                        x: newX,
                        y: newY,
                        id: render_items[currentBreakpoint].length,
                        w: 102,
                        elementDetails: { text: "" },
                        type: "text",
                        h: 2,
                        i: String(render_items[currentBreakpoint].length),
                        static: Math.random() < 0.05,
                        resizeHandles: resizeHandles,
                    };
                    const updatedLayouts = { ...prevLayouts };
                    if (Array.isArray(updatedLayouts[currentBreakpoint])) {
                        updatedLayouts[currentBreakpoint] = [
                            ...updatedLayouts[currentBreakpoint],
                            newWidget,
                        ];
                    } else {
                        updatedLayouts[currentBreakpoint] = [newWidget];
                    }
                    return updatedLayouts;
                });
            } else if (id_ === "on/off") {
                Set_render_items((prevLayouts) => {
                    return {
                        ...prevLayouts,
                        [currentBreakpoint]: [...prevLayouts[currentBreakpoint], "on/off"],
                    };
                });
                setLayouts((prevLayouts) => {
                    const newX = Math.round(Math.random() * 5) * 2;
                    const newY = Math.floor(12 / 6) * 2;
                    const newWidget = {
                        x: newX,
                        y: newY,
                        id: render_items[currentBreakpoint].length,
                        w: 102,
                        elementDetails: { text: "ON" },
                        type: "on/off",
                        h: 2,
                        i: String(render_items[currentBreakpoint].length),
                        static: Math.random() < 0.05,
                        resizeHandles: resizeHandles,
                    };
                    const updatedLayouts = { ...prevLayouts };
                    if (Array.isArray(updatedLayouts[currentBreakpoint])) {
                        updatedLayouts[currentBreakpoint] = [
                            ...updatedLayouts[currentBreakpoint],
                            newWidget,
                        ];
                    } else {
                        updatedLayouts[currentBreakpoint] = [newWidget];
                    }
                    return updatedLayouts;
                });
            }
            else if (id_ === "frame") {
                Set_render_items((prevLayouts) => {
                    return {
                        ...prevLayouts,
                        [currentBreakpoint]: [...prevLayouts[currentBreakpoint], "frame"],
                    };
                });
                setLayouts((prevLayouts) => {
                    const newX = Math.round(Math.random() * 5) * 2;
                    const newY = Math.floor(12 / 6) * 2;
                    const newWidget = {
                        x: newX,
                        y: newY,
                        id: render_items[currentBreakpoint].length,
                        w: 202,
                        elementDetails: { borderRadius: "8", borderWidth: "3" },
                        type: "frame",
                        h: 3,
                        i: String(render_items[currentBreakpoint].length),
                        static: Math.random() < 0.05,
                        resizeHandles: resizeHandles,
                    };
                    const updatedLayouts = { ...prevLayouts };
                    if (Array.isArray(updatedLayouts[currentBreakpoint])) {
                        updatedLayouts[currentBreakpoint] = [
                            ...updatedLayouts[currentBreakpoint],
                            newWidget,
                        ];
                    } else {
                        updatedLayouts[currentBreakpoint] = [newWidget];
                    }
                    return updatedLayouts;
                });
            }
            else if (id_ === "calisma_modu") {
                Set_render_items((prevLayouts) => {
                    return {
                        ...prevLayouts,
                        [currentBreakpoint]: [...prevLayouts[currentBreakpoint], "calisma_modu"],
                    };
                });
                setLayouts((prevLayouts) => {
                    const newX = Math.round(Math.random() * 5) * 2;
                    const newY = Math.floor(12 / 6) * 2;
                    const newWidget = {
                        x: newX,
                        y: newY,
                        id: render_items[currentBreakpoint].length,
                        w: 102,
                        elementDetails: { text: "SOĞUTMA", value: "1" },
                        type: "calisma_modu",
                        h: 2,
                        i: String(render_items[currentBreakpoint].length),
                        static: Math.random() < 0.05,
                        resizeHandles: resizeHandles,
                    };
                    const updatedLayouts = { ...prevLayouts };
                    if (Array.isArray(updatedLayouts[currentBreakpoint])) {
                        updatedLayouts[currentBreakpoint] = [
                            ...updatedLayouts[currentBreakpoint],
                            newWidget,
                        ];
                    } else {
                        updatedLayouts[currentBreakpoint] = [newWidget];
                    }
                    return updatedLayouts;
                });
            }
            else if (id_ === "fan_modu") {
                Set_render_items((prevLayouts) => {
                    return {
                        ...prevLayouts,
                        [currentBreakpoint]: [...prevLayouts[currentBreakpoint], "fan_modu"],
                    };
                });
                setLayouts((prevLayouts) => {
                    const newX = Math.round(Math.random() * 5) * 2;
                    const newY = Math.floor(12 / 6) * 2;
                    const newWidget = {
                        x: newX,
                        y: newY,
                        id: render_items[currentBreakpoint].length,
                        w: 102,
                        elementDetails: { text: "DÜŞÜK", value: "1" },
                        type: "fan_modu",
                        h: 2,
                        i: String(render_items[currentBreakpoint].length),
                        static: Math.random() < 0.05,
                        resizeHandles: resizeHandles,
                    };
                    const updatedLayouts = { ...prevLayouts };
                    if (Array.isArray(updatedLayouts[currentBreakpoint])) {
                        updatedLayouts[currentBreakpoint] = [
                            ...updatedLayouts[currentBreakpoint],
                            newWidget,
                        ];
                    } else {
                        updatedLayouts[currentBreakpoint] = [newWidget];
                    }
                    return updatedLayouts;
                });
            }
            else if (id_ === "tag") {
                Set_render_items((prevLayouts) => {
                    return {
                        ...prevLayouts,
                        [currentBreakpoint]: [...prevLayouts[currentBreakpoint], "tag"],
                    };
                });
                setLayouts((prevLayouts) => {
                    const newX = Math.round(Math.random() * 5) * 2;
                    const newY = Math.floor(12 / 6) * 2;
                    const newWidget = {
                        x: newX,
                        y: newY,
                        id: render_items[currentBreakpoint].length,
                        w: 102,
                        elementDetails: { tagId: "" },
                        type: "tag",
                        h: 2,
                        i: String(render_items[currentBreakpoint].length),
                        static: Math.random() < 0.05,
                        resizeHandles: resizeHandles,
                    };
                    const updatedLayouts = { ...prevLayouts };
                    if (Array.isArray(updatedLayouts[currentBreakpoint])) {
                        updatedLayouts[currentBreakpoint] = [
                            ...updatedLayouts[currentBreakpoint],
                            newWidget,
                        ];
                    } else {
                        updatedLayouts[currentBreakpoint] = [newWidget];
                    }
                    return updatedLayouts;
                });
            }
            else if (id_ === "left_ok") {
                Set_render_items((prevLayouts) => {
                    return {
                        ...prevLayouts,
                        [currentBreakpoint]: [...prevLayouts[currentBreakpoint], "left_ok"],
                    };
                });
                setLayouts((prevLayouts) => {
                    const newX = Math.round(Math.random() * 5) * 2;
                    const newY = Math.floor(12 / 6) * 2;
                    const newWidget = {
                        x: newX,
                        y: newY,
                        id: render_items[currentBreakpoint].length,
                        elementDetails: { color: "aqua" },
                        w: 102,
                        h: 5,
                        i: String(render_items[currentBreakpoint].length),
                        static: Math.random() < 0.05,
                        type: "left_ok",
                        resizeHandles: resizeHandles,
                    };
                    const updatedLayouts = { ...prevLayouts };
                    if (Array.isArray(updatedLayouts[currentBreakpoint])) {
                        updatedLayouts[currentBreakpoint] = [
                            ...updatedLayouts[currentBreakpoint],
                            newWidget,
                        ];
                    } else {
                        updatedLayouts[currentBreakpoint] = [newWidget];
                    }
                    return updatedLayouts;
                });
            } else if (id_ === "right_ok") {
                Set_render_items((prevLayouts) => {
                    return {
                        ...prevLayouts,
                        [currentBreakpoint]: [...prevLayouts[currentBreakpoint], "right_ok"],
                    };
                });
                setLayouts((prevLayouts) => {
                    const newX = Math.round(Math.random() * 5) * 2;
                    const newY = Math.floor(12 / 6) * 2;
                    const newWidget = {
                        x: newX,
                        y: newY,
                        id: render_items[currentBreakpoint].length,
                        elementDetails: { color: "aqua" },
                        w: 102,
                        h: 5,
                        i: String(render_items[currentBreakpoint].length),
                        static: Math.random() < 0.05,
                        type: "right_ok",
                        resizeHandles: resizeHandles,
                    };
                    const updatedLayouts = { ...prevLayouts };
                    if (Array.isArray(updatedLayouts[currentBreakpoint])) {
                        updatedLayouts[currentBreakpoint] = [
                            ...updatedLayouts[currentBreakpoint],
                            newWidget,
                        ];
                    } else {
                        updatedLayouts[currentBreakpoint] = [newWidget];
                    }
                    return updatedLayouts;
                });
            } else if (id_ === "image") {
            } else if (id_ === "bg") {
                var toplam_control = 0;
                render_items[currentBreakpoint].forEach((i) => {
                    if (i === "bg") {
                        toplam_control++;
                    }
                });
                if (toplam_control < 1) {
                    Set_render_items((prevLayouts) => {
                        return {
                            ...prevLayouts,
                            [currentBreakpoint]: [...prevLayouts[currentBreakpoint], "bg"],
                        };
                    });
                }
            } else if (id_ === "gauge") {
                Set_render_items((prevLayouts) => {
                    return {
                        ...prevLayouts,
                        [currentBreakpoint]: [...prevLayouts[currentBreakpoint], "gauge"],
                    };
                });
                setLayouts((prevLayouts) => {
                    const newX = Math.round(Math.random() * 5) * 2;
                    const newY = Math.floor(12 / 6) * 2;
                    const newWidget = {
                        x: newX,
                        y: newY,
                        id: render_items[currentBreakpoint].length,
                        w: 70,
                        elementDetails: { maxValue: "" },
                        type: "gauge",
                        h: 6,
                        i: String(render_items[currentBreakpoint].length),
                        static: Math.random() < 0.05,
                        resizeHandles: resizeHandles,
                    };
                    const updatedLayouts = { ...prevLayouts };
                    if (Array.isArray(updatedLayouts[currentBreakpoint])) {
                        updatedLayouts[currentBreakpoint] = [
                            ...updatedLayouts[currentBreakpoint],
                            newWidget,
                        ];
                    } else {
                        updatedLayouts[currentBreakpoint] = [newWidget];
                    }
                    return updatedLayouts;
                });
            } else if (id_ === "trend") {
                Set_render_items((prevLayouts) => {
                    return {
                        ...prevLayouts,
                        [currentBreakpoint]: [...prevLayouts[currentBreakpoint], "trend"],
                    };
                });
                setLayouts((prevLayouts) => {
                    const newX = Math.round(Math.random() * 5) * 2;
                    const newY = Math.floor(12 / 6) * 2;
                    const newWidget = {
                        x: newX,
                        y: newY,
                        id: render_items[currentBreakpoint].length,
                        w: 2,
                        elementDetails: { tagId: "", tagName: "" },
                        type: "trend",
                        h: 0.2,
                        i: String(render_items[currentBreakpoint].length),
                        static: Math.random() < 0.05,
                        resizeHandles: resizeHandles,
                    };
                    const updatedLayouts = { ...prevLayouts };
                    if (Array.isArray(updatedLayouts[currentBreakpoint])) {
                        updatedLayouts[currentBreakpoint] = [
                            ...updatedLayouts[currentBreakpoint],
                            newWidget,
                        ];
                    } else {
                        updatedLayouts[currentBreakpoint] = [newWidget];
                    }
                    return updatedLayouts;
                });
            }
            else if (id_ === "white_space") {

                Set_ws_active(!ws_active)

                if (!ws_active) {
                    Set_render_items((prevLayouts) => {
                        return {
                            ...prevLayouts,
                            [currentBreakpoint]: [
                                ...prevLayouts[currentBreakpoint],
                                "white_space",
                            ],
                        };
                    });
                    setLayouts((prevLayouts) => {
                        const newX = Math.round(Math.random() * 5) * 2;
                        const newY = Math.floor(12 / 6) * 2;
                        const newWidget = {
                            x: newX,
                            y: newY,
                            id: render_items[currentBreakpoint].length,
                            w: 6,
                            elementDetails: {},
                            type: "white_spaces",
                            h: 8,
                            i: String(render_items[currentBreakpoint].length),
                            static: Math.random() < 0.05,
                            resizeHandles: resizeHandles,
                        };
                        const updatedLayouts = { ...prevLayouts };
                        if (Array.isArray(updatedLayouts[currentBreakpoint])) {
                            updatedLayouts[currentBreakpoint] = [
                                ...updatedLayouts[currentBreakpoint],
                                newWidget,
                            ];
                        } else {
                            updatedLayouts[currentBreakpoint] = [newWidget];
                        }
                        return updatedLayouts;
                    });
                }



            } else {
                return 0;
            }
        }
    };

    const onResize = (elemParams, first, last) => {
        setLayouts((prevLayouts) => {
            return {
                ...prevLayouts,
                [currentBreakpoint]: (prevLayouts[currentBreakpoint] || []).map(
                    (layoutItem) => {
                        // Mevcut layout'un her bir elemanının resizeHandles özelliğini güncelle

                        if (layoutItem.i === first.i) {
                            return { ...layoutItem, w: last.w, h: last.h };
                        }
                        return { ...layoutItem };
                    }
                ),
            };
        });

        var current_elem_id = first.i;
        (layouts[currentBreakpoint] || []).forEach((i) => {
            if (String(i.id) === current_elem_id && i.type === "white_spaces") {
                adjustFontSizeforWS(current_elem_id);
            }
        });
    };

    const closePopUpGauge = () => {
        document
            .querySelector(".gauge_pop_up")
            .classList.toggle("gauge_pop_up_active");
        document.querySelector(".main_sec").classList.toggle("main_sec_dark");
    };

    const open_gauge_poup = () => {
        document
            .querySelector(".gauge_pop_up")
            .classList.toggle("gauge_pop_up_active");
        document.querySelector(".main_sec").classList.toggle("main_sec_dark");
    };


    const [components, setComponents] = useState([]);

    useEffect(() => {
        localStorage.setItem('components-draggable', JSON.stringify([]));


    }, []);

    useEffect(() => {
        // Save components to localStorage whenever components state changes
        localStorage.setItem('components-draggable', JSON.stringify(components));
    }, [components]);
    const refs = useRef([]);

    const handleDrag = (e, data, id) => {
        Set_dragggableActive(true);

        let elementDetails;

        components.forEach(a => {
            if (String(a.id) === String(id)) {
                elementDetails = a.elementDetails
            }
        })

        if (e.target) {
            const selectedDrag = e.target.getBoundingClientRect();
            console.log(selectedDrag);
            let newData = { x: selectedDrag.x, y: selectedDrag.y, w: selectedDrag.width, h: selectedDrag.height, id: id, type: e.target.id, elementDetails: elementDetails }
            console.log(newData);
            Set_dragggableDetail(newData)
        }
    }

    const handleResize = (e, direction, ref, delta, id) => {
        setComponents(prevComponents =>
            prevComponents.map(component =>
                component.id === id
                    ? { ...component, width: ref.style.width, height: ref.style.height }
                    : component
            )
        );
    };


    const cancelDrag = () => {
        Set_dragggableActive(false)
    }

    const addComponent = (e) => {
        let id_ = e.target.id;
        if (id_ !== "") {
            const commonProperties = {
                id: uuidv4(),
                x: window.innerWidth / 2 - 50,
                y: window.innerHeight / 2 - 50,
                width: 100,
                height: 100,
            };

            let newComponent;

            if (id_ === "text") {
                newComponent = {
                    ...commonProperties,
                    type: "text",
                    elementDetails: { text: "" }
                };
            } else if (id_ === "tag") {
                newComponent = {
                    ...commonProperties,
                    type: "tag",
                    elementDetails: { tagId: "" }
                };
            } else if (id_ === "left_ok") {
                newComponent = {
                    ...commonProperties,
                    type: "left_ok",
                    elementDetails: { color: "aqua" },
                    width: 100,
                    height: 200,
                };
            } else if (id_ === "right_ok") {
                newComponent = {
                    ...commonProperties,
                    type: "right_ok",
                    elementDetails: { color: "aqua" },
                    width: 100,
                    height: 200,
                };
            } else if (id_ === "image") {
                newComponent = {
                    ...commonProperties,
                    type: "image",
                    elementDetails: { src: "" }
                };
            } else if (id_ === "gauge") {
                newComponent = {
                    ...commonProperties,
                    type: "gauge",
                    elementDetails: { maxValue: "" }
                };
            }
            setComponents(prevComponents => [...prevComponents, newComponent]);
        }
    };



    const day_trend = (e) => {
        e.preventDefault();

        function formatDate(date) {
            let year = date.getFullYear();
            let month = padZero(date.getMonth() + 1);
            let day = padZero(date.getDate());
            return `${year}-${month}-${day}`;
        }

        function padZero(value) {
            return value < 10 ? "0" + value : value;
        }

        try {
            let today = new Date();
            let tagId_ = document.querySelector(".show_tagId").textContent;

            let yesterday = new Date(today);
            yesterday.setDate(today.getDate() - 1);
            let todayFormatted = formatDate(today);
            let yesterdayFormatted = formatDate(yesterday);

            let newObj = {
                inital_date: yesterdayFormatted,
                tagId: tagId_,
                last_date: todayFormatted,
            };
            let newarray = [];
            newarray.push(newObj);
            Store.dispatch(set_external_trend_info(newarray));

            history.push("/raporlama");
        } catch (err) {
            console.log(err);
        }
    };

    const month_trend = (e) => {
        e.preventDefault();

        function formatDate(date) {
            let year = date.getFullYear();
            let month = padZero(date.getMonth() + 1);
            let day = padZero(date.getDate());
            return `${year}-${month}-${day}`;
        }

        function padZero(value) {
            return value < 10 ? "0" + value : value;
        }

        try {
            let today = new Date();
            let tagId_ = document.querySelector(".show_tagId").textContent;

            let lastMonth = new Date(today);
            lastMonth.setMonth(today.getMonth() - 1);

            let todayFormatted = formatDate(today);
            let lastMonthFormatted = formatDate(lastMonth);

            console.log(todayFormatted, lastMonthFormatted);
            let newObj = {
                inital_date: lastMonthFormatted,
                tagId: tagId_,
                last_date: todayFormatted,
            };

            let newarray = [];
            newarray.push(newObj);
            Store.dispatch(set_external_trend_info(newarray));

            history.push("/raporlama");
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        document.querySelector("aside").style.minWidth = document.querySelector("aside").getBoundingClientRect().width + "px"
    }, [])


    const [isOpenselectbox, setIsOpenselectbox] = useState(false);
    const [selectedOptionselectbox, setSelectedOptionselectbox] = useState("");

    const toggleDropdownselectbox = () => setIsOpenselectbox(!isOpenselectbox);

    const handleOptionClickselectbox = (option) => {
        setSelectedOptionselectbox(option);
        setIsOpenselectbox(false);
    };

    const [add_option_text, Set_add_option_text] = useState("")
    const [add_option_value, Set_add_option_value] = useState("")



    const onay_okPoup = (e) => {
        if (ok_popup !== null) {
            console.log(ok_popup);

            setLayouts((prevLayouts) => {
                const updatedLayouts = { ...prevLayouts };

                if (Array.isArray(updatedLayouts[currentBreakpoint])) {
                    updatedLayouts[currentBreakpoint] = (updatedLayouts[currentBreakpoint] || []).map((widget) => {
                        if (String(widget.id) === String(ok_popup.id)) {  // Burada targetId, güncellenecek elemanın id'sidir
                            return {
                                ...widget,
                                x: Number(ok_popup.left),
                                y: Number(ok_popup.top),
                                w: Number(ok_popup.width),
                                h: Number(ok_popup.height) / 10,
                            };
                        }
                        return widget;
                    });
                }

                return updatedLayouts;
            });

        }
    }

    const bgDrag = (e, data) => {
        console.log(e, data);
    }

    const onay_elemPoup = (e) => {
        if (elem_popup !== null) {
            console.log(elem_popup);

            setLayouts((prevLayouts) => {
                const updatedLayouts = { ...prevLayouts };

                if (Array.isArray(updatedLayouts[currentBreakpoint])) {
                    updatedLayouts[currentBreakpoint] = (updatedLayouts[currentBreakpoint] || []).map((widget) => {
                        if (String(widget.id) === String(elem_popup.id)) {  // Burada targetId, güncellenecek elemanın id'sidir
                            return {
                                ...widget,
                                x: Number(elem_popup.left),
                                y: Number(elem_popup.top),
                                w: Number(elem_popup.width),
                                h: Number(elem_popup.height) / 10,
                                fontSize: Number(elem_popup.fontSize)
                            };
                        }
                        return widget;
                    });
                }

                return updatedLayouts;
            });

        }
    }

    const [rotate, setRotate] = useState(0); // Açı state'i




    useEffect(() => {
        console.log(canvas_boyutu);
    }, [canvas_boyutu])

    return (
        <>
            <div style={{ maxHeight: "100vh", height: canvas_boyutu.height !== 0 ? canvas_boyutu.height + "px" : "100vh", width: canvas_boyutu.width !== 0 ? canvas_boyutu.width + "px" : "100%" }} onClick={() => {
            }} className="maiN_main-sec" ref={mainRef}>
                {bigger_trend_active && <div className="bigger_trend_pop_up_active">
                    <i onClick={(e) => {
                        Set_bigger_trend_active(false)
                        Set_bigger_trend_id(null)
                    }} id="close-full-s-trend" className="fa fa-times"></i>
                    <div style={{ border: "none" }} className="bottom_sec trend_graph">
                        <Line options={createChartOptions(String(bigger_trend_id))} data={createChartData(String(bigger_trend_id))} />
                    </div>
                </div>}
                <div className="show_pop_up show_external_trend">
                    <i
                        onClick={close_pop_up}
                        style={{ position: "relative", left: "50%" }}
                        className="fa fa-times close_tag_pop_up"
                    ></i>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-around",
                            width: "100%",
                        }}
                        className="top_flex"
                    >
                        <p>
                            {" "}
                            TagId: <span className="pop_up_x pop_up_external show_tagId"></span>
                        </p>
                        <p>
                            {" "}
                            TagName:{" "}
                            <span className="pop_up_x pop_up_external show_tagName"></span>
                        </p>
                    </div>
                    <div className="btn_area_popup_external">
                        <button
                            onClick={(e) => {
                                day_trend(e);
                            }}
                        >
                            Günlük Trend <i className="fa-solid fa-chart-line"></i>
                        </button>
                        <button
                            onClick={(e) => {
                                month_trend(e);
                            }}
                        >
                            Aylık Trend <i className="fa-solid fa-chart-line"></i>
                        </button>
                    </div>
                </div>
                <div className="show_pop_up show_external_detail">
                    <i
                        onClick={close_pop_up3}
                        style={{ position: "relative", left: "50%" }}
                        className="fa fa-times close_tag_pop_up"
                    ></i>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-around",
                            width: "100%",
                        }}
                        className="top_flex"
                    >
                        <p>
                            {" "}
                            TagId: <span className="pop_up_x pop_up_external show_tagId2"></span>
                        </p>
                        <p>
                            {" "}
                            TagName:{" "}
                            <span className="pop_up_x pop_up_external show_tagName2"></span>
                        </p>
                    </div>

                </div>
                <div className="show_pop_up show_external_combine_trend">
                    <i
                        onClick={close_pop_up2}
                        style={{ position: "relative", left: "48.6%", top: "1px", margin: "12px 0" }}
                        className="fa fa-times close_tag_pop_up"
                    ></i>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",

                            width: "100%",
                        }}
                        className="top_flex top_flex_combine_trend"
                    >
                        {combine_trend_tags.map((item, index) => {
                            return (
                                <div className="dh0osas"><p>{item.tagId} {" "}-{" "}{item.tagName}</p> <i onClick={(e) => {
                                    Set_combine_trend_tags((prevLayouts) => {
                                        const arr = prevLayouts.filter(i => {
                                            return i.tagId !== item.tagId
                                        })

                                        return arr
                                    })
                                }} className="fa fa-times"></i></div>
                            )
                        })}

                    </div>
                    <div className="btn_area_popup_external">
                        <button onClick={async () => {
                            let tagidsData = [];
                            combine_trend_tags.forEach((item, index) => {
                                tagidsData.push({ tagName: item.tagName, tagId: item.tagId })
                            })


                            await Store.dispatch(set_combine_trends(tagidsData));
                            history.push("/raporlama");
                        }} className="go_combine_trend_dyn">Kombine Trend <i className="fa fa-arrow-right"></i></button>
                    </div>
                </div>

                {bg_control &&
                    <div id="bg_control_section" style={{
                        border: "6px solid rgb(50,50,50)",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        width: canvas_boyutu.width ? canvas_boyutu.width + "px" : "100%",
                        height: canvas_boyutu.height ? canvas_boyutu.height + "px" : "100vh",
                        paddingTop: "100px"
                    }} className="main_sec">

                        <Draggable onStop={(e, data) => {
                            console.log(e, data);
                        }} style={{ marginTop: "100px" }}>
                            <Resizable>
                                <div>
                                    <img
                                        ref={bgRef}
                                        key={bg_key_current.key}
                                        style={{ width: "100%", height: "100%", border: "1.5px solid rgb(30,30,30)" }}
                                        className="xIMG_bg_resizable"
                                        src={bg_key_current.elementDetails.src !== "" ? bg_key_current.elementDetails.src : ""}
                                        alt=""
                                    />
                                </div>
                            </Resizable>
                        </Draggable>

                        <div className="btn_group_bg_selection">
                            <button onClick={() => {
                                let img_tag = document.querySelector(".xIMG_bg_resizable");
                                let w_ = img_tag.offsetWidth;
                                let h_ = img_tag.offsetHeight;
                                const bgElement = bgRef.current;

                                if (bgElement !== null) {
                                    // Parent elementin konumunu al
                                    const parentRect = document.querySelector("#bg_control_section").getBoundingClientRect();
                                    // Resmin konumunu al
                                    const imgRect = img_tag.getBoundingClientRect();

                                    const imgLeft = imgRect.left - parentRect.left;
                                    const imgTop = imgRect.top - parentRect.top;

                                    console.log(imgLeft, imgTop, imgRect, parentRect)

                                    setLayouts((prevLayouts) => {
                                        const updatedLayouts = {};

                                        Object.keys(prevLayouts).forEach((breakpoint) => {
                                            const currentLayout = prevLayouts[breakpoint] || [];
                                            let bgExists = false;
                                            let screenWidth = window.innerWidth;
                                            let screenHeight = window.innerHeight;

                                            const updatedLayout = currentLayout.map((widget) => {
                                                if (widget.type === "bg") {
                                                    bgExists = true;
                                                    return {
                                                        ...widget,
                                                        elementDetails: {
                                                            ...widget.elementDetails,
                                                            src: bg_item,
                                                            width: w_,
                                                            height: h_,
                                                            left: imgLeft,
                                                            top: imgTop,
                                                            initalWidth: screenWidth,
                                                            initalHeight: screenHeight,
                                                        },
                                                    };
                                                }
                                                return widget;
                                            });

                                            if (!bgExists) {
                                                const newX = Math.round(Math.random() * 5) * 2;
                                                const newY = Math.floor(12 / 6) * 2;
                                                const newWidget = {
                                                    x: newX,
                                                    id: render_items[breakpoint].length,
                                                    y: newY,
                                                    elementDetails: {
                                                        src: bg_item,
                                                        width: w_,
                                                        height: h_,
                                                        left: imgLeft,
                                                        top: imgTop,
                                                        initalWidth: screenWidth,
                                                        initalHeight: screenHeight,
                                                    },
                                                    w: 70,
                                                    h: 1,
                                                    i: String(render_items[breakpoint].length),
                                                    static: Math.random() < 0.05,
                                                    resizeHandles: resizeHandles,
                                                    type: "bg",
                                                };
                                                updatedLayout.push(newWidget);
                                            }

                                            updatedLayouts[breakpoint] = updatedLayout;
                                        });

                                        return {
                                            ...prevLayouts,
                                            ...updatedLayouts,
                                        };
                                    });

                                    Set_bg_control(false);
                                    Set_bg_item("");
                                    Set_bg_key_current("");
                                }
                            }}>Kaydet</button>

                            <button onClick={() => {
                                Set_bg_control(false);
                                Set_bg_item("");
                                Set_bg_key_current("");
                            }}>İptal</button>
                        </div>
                    </div>

                }
                <div className="change_color">




                    <div className="btnpart">
                        <button onClick={(e) => { onay_okPoup(e) }}>Kaydet</button><button onClick={() => {
                            document.querySelector(".change_color").classList.toggle("change_color_active")
                            Set_ok_popup(null)
                        }}>İptal</button>
                    </div>
                </div>
                <div
                    className="readChangeP changeProperties Popup-onOff changePoup"
                    style={{
                        background: "white",
                        border: "1px solid #ccc",
                        borderRadius: "6px",
                        padding: "10px",
                        width: "fit-content",
                        height: "fit-content",
                        minWidth: "120px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                    }}
                >
                    {elem_popup !== null && (
                        <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                            <label
                                style={{
                                    fontSize: "14px",
                                    fontWeight: "500",
                                    marginBottom: "4px",
                                    textAlign: "center",
                                }}
                            >
                                Çalışma Durumu
                            </label>
                            <select
                                value={elem_popup.value}
                                onChange={(e) => {
                                    const newValue = e.target.value;

                                    setLayouts((prevLayouts) => {
                                        const updatedLayouts = { ...prevLayouts };

                                        updatedLayouts[currentBreakpoint] =
                                            (updatedLayouts[currentBreakpoint] || []).map((layout) => {
                                                if (String(layout.id) === String(elem_popup.id)) {
                                                    return {
                                                        ...layout,
                                                        elementDetails: {
                                                            ...layout.elementDetails,
                                                            text: newValue,
                                                        },
                                                    };
                                                }
                                                return layout;
                                            });

                                        return updatedLayouts;
                                    });

                                    (layouts[currentBreakpoint] || []).forEach((x) => {
                                        if (String(x.id) === String(elem_popup.id)) {
                                            const { tagId, value1, value2 } = x.elementDetails;
                                            const tagValue = newValue === "ON" ? value1 : value2;

                                            Set_tag_values_state((prevTagValues) =>
                                                prevTagValues.map((tag) =>
                                                    String(tag.tagId) === String(tagId)
                                                        ? { ...tag, tagValue: tagValue }
                                                        : tag
                                                )
                                            );

                                            setValueFunc({ TagId: tagId, TagValue: tagValue });
                                        }
                                    });

                                    Set_elem_popup(null);
                                    document
                                        .querySelector(".Popup-onOff")
                                        .classList.toggle("changeProperties_active");
                                }}
                                style={{
                                    padding: "6px 10px",
                                    fontSize: "14px",
                                    borderRadius: "4px",
                                    border: "1px solid #aaa",
                                    background: "#f9f9f9",
                                    cursor: "pointer",
                                }}
                            >
                                <option value="ON">ON</option>
                                <option value="OFF">OFF</option>
                            </select>
                        </div>
                    )}
                </div>


                <div className="readChangeP changeProperties Popup changePoup">










                    <div className="btnpart">
                        <button onClick={(e) => {
                            document.querySelector(".Popup").classList.toggle("changeProperties_active")
                            Set_elem_popup(null)
                        }}>Kaydet</button><button onClick={() => {
                            document.querySelector(".Popup").classList.toggle("changeProperties_active")
                            Set_elem_popup(null)
                        }}>İptal</button>
                    </div>
                </div>
                <div className="readChangeP changeProperties Popup-fan changePoup">



                    {elem_popup !== null && <div className="mode_read">

                        <h5 style={{ fontWeight: "600", color: "rgb(70,70,70)", fontSize: "1em" }}>Mod</h5>

                        <div className="select-box">
                            <div className="select-box-header" style={{ borderColor: "rgb(237,188,69)" }} onClick={toggleDropdownfan}>
                                {selectedOptionfan}
                                <span className={`arrow ${isOpenfan ? 'open' : ''}`}>▼</span>
                            </div>
                            {isOpenfan && (
                                <ul className="select-box-dropdown">
                                    {["DÜŞÜK", "YÜKSEK", "MID 1", "MID 2", "AUTO"].map((option, index) => (
                                        <li
                                            id={index + 1}
                                            key={index}
                                            onClick={(e) => {
                                                setLayouts((prevLayouts) => {
                                                    const updatedLayouts = { ...prevLayouts };

                                                    updatedLayouts[currentBreakpoint] = (updatedLayouts[currentBreakpoint] || []).map(layout => {
                                                        if (String(layout.id) === String(elem_popup.id)) {

                                                            e.target.parentElement.parentElement.parentElement.id = e.target.id

                                                            return {
                                                                ...layout,
                                                                elementDetails: {
                                                                    ...layout.elementDetails,
                                                                    text: option,
                                                                    value: index + 1
                                                                }
                                                            };
                                                        }
                                                        return layout;
                                                    });
                                                    return updatedLayouts;
                                                });

                                                handleOptionClickfan(option)
                                            }}
                                            className="select-box-option"
                                        >
                                            {option}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>

                    </div>}






                    <div className="btnpart">
                        <button onClick={(e) => {
                            document.querySelector(".Popup-fan").classList.toggle("changeProperties_active")
                            let tagValue;
                            (layouts[currentBreakpoint] || []).forEach(x => {
                                if (String(x.id) === String(elem_popup.id)) {
                                    tagValue = e.target.parentElement.parentElement.firstElementChild.id
                                    console.log(tagValue);

                                    setValueFunc({ TagId: x.elementDetails.tagId, TagValue: tagValue })
                                }
                            })
                            Set_elem_popup(null)
                        }}>Kaydet</button><button onClick={() => {
                            document.querySelector(".Popup-fan").classList.toggle("changeProperties_active")
                            Set_elem_popup(null)
                        }}>İptal</button>
                    </div>
                </div>
                <div className="readChangeP changeProperties Popup-calisma changePoup">

                    {elem_popup !== null && <div className="mode_read">

                        <h5 style={{ fontWeight: "600", color: "rgb(70,70,70)", fontSize: "1em" }}>Mod</h5>

                        <div className="select-box">
                            <div className="select-box-header" style={{ borderColor: "rgb(237,188,69)" }} onClick={toggleDropdowncalisma}>
                                {selectedOptioncalisma}
                                <span className={`arrow ${isOpencalisma ? 'open' : ''}`}>▼</span>
                            </div>
                            {isOpencalisma && (
                                <ul className="select-box-dropdown">
                                    {["SOĞUTMA", "ISITMA", "FAN", "AUTO", "NEM ALMA", "SETBACK"].map((option, index) => (
                                        <li

                                            id={index + 1}
                                            key={index}
                                            onClick={(e) => {
                                                setLayouts((prevLayouts) => {
                                                    const updatedLayouts = { ...prevLayouts };

                                                    updatedLayouts[currentBreakpoint] = (updatedLayouts[currentBreakpoint] || []).map(layout => {
                                                        if (String(layout.id) === String(elem_popup.id)) {
                                                            e.target.parentElement.parentElement.parentElement.id = e.target.id

                                                            return {
                                                                ...layout,
                                                                elementDetails: {
                                                                    ...layout.elementDetails,
                                                                    text: option,
                                                                    value: index + 1
                                                                }
                                                            };
                                                        }
                                                        return layout;
                                                    });
                                                    return updatedLayouts;
                                                });


                                                handleOptionClickcalisma(option)
                                            }}
                                            className="select-box-option"
                                        >
                                            {option}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>

                    </div>}







                    <div className="btnpart">
                        <button onClick={(e) => {
                            document.querySelector(".Popup-calisma").classList.toggle("changeProperties_active")
                            let tagValue;
                            (layouts[currentBreakpoint] || []).forEach(x => {
                                if (String(x.id) === String(elem_popup.id)) {
                                    tagValue = e.target.parentElement.parentElement.firstElementChild.id
                                    setValueFunc({ TagId: x.elementDetails.tagId, TagValue: tagValue })
                                }
                            })
                            Set_elem_popup(null)
                        }}>Kaydet</button><button onClick={() => {
                            document.querySelector(".Popup-calisma").classList.toggle("changeProperties_active")
                            Set_elem_popup(null)
                        }}>İptal</button>
                    </div>
                </div>


                <div className="readChangeP changeProperties Popup-selectbox2 changePoup">


                    <div className="vvg">
                        <label htmlFor="set">Set Değeri Gir &#40; İsteğe Bağlı &#41;</label>
                        <input placeholder="set value" type="number" value={select_set_box2} className="select-set_box" onChange={(e) => {
                            Set_select_set_box2(e.target.value)
                        }} />
                    </div>

                    <div className="btnpart">
                        <button onClick={(e) => {
                            let tagValue;
                            setLayouts((prevLayouts) => {
                                return {
                                    ...prevLayouts,
                                    [currentBreakpoint]: (prevLayouts[currentBreakpoint] || []).map((x) => {
                                        if (String(x.id) === String(elem_popup.id)) {



                                            Set_tag_values_state((prevTagValues) =>
                                                prevTagValues.map((tag) =>
                                                    String(tag.tagId) === String(x.elementDetails.tagId)
                                                        ? { ...tag, tagValue: select_set_box2 !== "" ? select_set_box2 : x.elementDetails.value }  // Yeni değeri ata
                                                        : tag
                                                )
                                            );


                                            return {
                                                ...x,
                                                elementDetails: {
                                                    ...x.elementDetails,
                                                    tagId2: x.elementDetails.tagId2, // Değişmeden kalacak
                                                    value: select_set_box2 !== "" ? select_set_box2 : x.elementDetails.value,
                                                    text: select_set_box2 !== "" ? select_set_box2 : x.elementDetails.value
                                                }
                                            };
                                        }
                                        return x;
                                    })
                                };
                            });


                            (layouts[currentBreakpoint] || []).forEach(async (x, index) => {
                                if (String(x.id) === String(elem_popup.id)) {

                                    await setValueFunc({ TagId: x.elementDetails.tagId2, TagValue: select_set_box2 !== "" ? select_set_box2 : x.elementDetails.value })
                                }
                            })

                            document.querySelector(".Popup-selectbox2").classList.toggle("changeProperties_active")

                            Set_elem_popup(null)
                            if (select_set_box2 !== "") {
                                Set_select_set_box2("")
                            }
                        }}>Kaydet</button><button onClick={() => {
                            document.querySelector(".Popup-selectbox2").classList.toggle("changeProperties_active")
                            Set_elem_popup(null)
                            if (select_set_box2 !== "") {
                                Set_select_set_box2("")
                            }
                        }}>İptal</button>
                    </div>
                </div>
                <div
                    className="readChangeP changeProperties Popup-selectbox changePoup"
                    style={{
                        background: "white",
                        border: "1px solid #ccc",
                        borderRadius: "6px",
                        padding: "10px",
                        width: "fit-content",
                        height: "fit-content",
                        minWidth: "140px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                    }}
                >
                    {elem_popup !== null && (
                        <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>


                            <select
                                value={elem_popup.elementDetails?.value || ""}
                                onChange={(e) => {
                                    const selectedIndex = e.target.selectedIndex;
                                    const selectedText = (elem_popup.text_list || [])[selectedIndex];
                                    const selectedValue =
                                        (elem_popup.value_list || []).length > 0
                                            ? (elem_popup.value_list || [])[selectedIndex]
                                            : selectedText;

                                    setLayouts((prevLayouts) => {
                                        const updatedLayouts = { ...prevLayouts };
                                        updatedLayouts[currentBreakpoint] =
                                            (updatedLayouts[currentBreakpoint] || []).map((layout) => {
                                                if (String(layout.id) === String(elem_popup.id)) {
                                                    return {
                                                        ...layout,
                                                        bgColor: (elem_popup.bg_list || [])[selectedIndex],
                                                        borderColor: (elem_popup.border_list || [])[selectedIndex],
                                                        fontColor: (elem_popup.font_list || [])[selectedIndex],
                                                        elementDetails: {
                                                            ...layout.elementDetails,
                                                            text: selectedText,
                                                            value: selectedValue,
                                                        },
                                                    };
                                                }
                                                return layout;
                                            });
                                        return updatedLayouts;
                                    });

                                    // Tag güncellemesi
                                    (layouts[currentBreakpoint] || []).forEach((x) => {
                                        if (String(x.id) === String(elem_popup.id)) {
                                            const tagId = x.elementDetails.tagId2;
                                            Set_tag_values_state((prevTagValues) =>
                                                prevTagValues.map((tag) =>
                                                    String(tag.tagId) === String(tagId)
                                                        ? { ...tag, tagValue: selectedValue }
                                                        : tag
                                                )
                                            );
                                            setValueFunc({ TagId: tagId, TagValue: selectedValue });
                                        }
                                    });

                                    // Popup kapat
                                    Set_elem_popup(null);
                                    document
                                        .querySelector(".Popup-selectbox")
                                        .classList.toggle("changeProperties_active");
                                }}
                                style={{
                                    padding: "6px 10px",
                                    fontSize: "14px",
                                    borderRadius: "4px",
                                    border: "1px solid #aaa",
                                    background: "#f9f9f9",
                                    cursor: "pointer",
                                }}
                            >
                                {(elem_popup.text_list || []).map((option, index) => (
                                    <option
                                        key={index}
                                        value={
                                            (elem_popup.value_list || []).length > 0
                                                ? (elem_popup.value_list || [])[index]
                                                : option
                                        }
                                    >
                                        {option}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}
                </div>

                <div className="readChangeP changeProperties Popup-gauge changePoup">


                    <div className="btnpart">
                        <button onClick={(e) => {
                            document.querySelector(".Popup-gauge").classList.toggle("changeProperties_active")
                            Set_elem_popup(null)
                        }}>Kaydet</button><button onClick={() => {
                            document.querySelector(".Popup-gauge").classList.toggle("changeProperties_active")
                            Set_elem_popup(null)
                        }}>İptal</button>
                    </div>
                </div>
                <div className="readChangeP changeProperties Popup-trend changePoup">



                    <div className="btnpart">
                        <button onClick={(e) => {
                            document.querySelector(".Popup-trend").classList.toggle("changeProperties_active")
                            Set_elem_popup(null)
                        }}>Kaydet</button><button onClick={() => {
                            document.querySelector(".Popup-trend").classList.toggle("changeProperties_active")
                            Set_elem_popup(null)
                        }}>İptal</button>
                    </div>
                </div>
                <div className="readChangeP changeProperties Popup-frame changePoup">


                    <div className="btnpart">
                        <button onClick={(e) => {
                            document.querySelector(".Popup-frame").classList.toggle("changeProperties_active")
                            Set_elem_popup(null)
                        }}>Kaydet</button><button onClick={() => {
                            document.querySelector(".Popup-frame").classList.toggle("changeProperties_active")
                            Set_elem_popup(null)
                        }}>İptal</button>
                    </div>
                </div>

                {/* <div className="changeProperties-gauge Popup changePoup">

        <p>Tag Seçin</p>

        {elem_popup !== null && <div className="Size">
          <div className="input-group">
            <label htmlFor="Width">Width</label>
            <input onChange={(e) => {
              console.log(elem_popup);
              if (e.target.value !== "") Set_elem_popup((prevItems) => ({ ...prevItems, width: Number(e.target.value) }));
            }} value={String(elem_popup.width)} type="number" className="adjust_width_pop_up" />
          </div>
          <div className="input-group">
            <label htmlFor="Height">Height</label>
            <input onChange={(e) => {
              if (e.target.value !== "") Set_elem_popup((prevItems) => ({ ...prevItems, height: Number(e.target.value) }));
            }} value={String(elem_popup.height)} type="number" className="adjust_height_pop_up" />
          </div>

        </div>}

        {elem_popup !== null && <div className="Position">

          <div className="input-group">
            <label htmlFor="X">X</label>
            <input onChange={(e) => {
              if (e.target.value !== "") Set_elem_popup((prevItems) => ({ ...prevItems, left: Number(e.target.value) }));
            }} value={String(elem_popup.left)} type="number" className="adjust_X_pop_up" />
          </div>
          <div className="input-group">
            <label htmlFor="Y">Y</label>
            <input onChange={(e) => {
              if (e.target.value !== "") Set_elem_popup((prevItems) => ({ ...prevItems, top: Number(e.target.value) }));
            }} type="number" value={String(elem_popup.top)} className="adjust_Y_pop_up" />
          </div>
        </div>}

        <div className="btnpart">
          <button onClick={(e) => { onay_elemPoup(e) }}>Kaydet</button><button onClick={() => {
            document.querySelector(".Popup").classList.toggle("changeProperties_active")
            Set_elem_popup(null)
          }}>İptal</button>
        </div>
      </div> */}
                <div className="gauge_pop_up">
                    <i
                        onClick={closePopUpGauge}
                        style={{
                            position: "absolute",
                            left: "93%",
                            bottom: "92%",
                            color: "red",
                            scale: "1.2",
                            cursor: "pointer",
                        }}
                        className="fa fa-times"
                    ></i>
                    <div className="fgh">
                        <GaugeChart id="gauge-chart2" nrOfLevels={20} percent={0.86} />
                        <span>This is example</span>
                    </div>

                    <div className="fgh">
                        <p style={{ textAlign: "left", display: "block", width: "100%", marginBottom: "12px" }}>Max Value</p>
                        <input
                            value={temp_gauge_max}
                            onChange={(e) => {
                                Set_temp_gauge_max(e.target.value);
                            }}
                            type="text"
                        />

                        <p style={{ textAlign: "left", display: "block", width: "100%", marginBottom: "12px" }}>Tag Seçin</p>

                        <input
                            type="text"
                            className="searchInputclass"
                            id="searchInput"
                            placeholder="Tag ismine göre ara..."
                            value={searchTerm}
                            onChange={handleSearch}
                        />
                        <div className="tag-list-dyn">
                            {filteredTags.map((tag, index) => (
                                <div onClick={(e) => {

                                    var id__ = e.target.id;


                                    if (id__) {


                                        setLayouts((prevLayouts) => {
                                            const updatedLayouts = { ...prevLayouts };
                                            const targetId = id__.substring(0, id__.length - 1);
                                            updatedLayouts[currentBreakpoint] = (updatedLayouts[currentBreakpoint] || []).map((layout, index, array) => {
                                                if (layout.type === "gauge" && index === array.length - 1) {
                                                    return {
                                                        ...layout,
                                                        elementDetails: {
                                                            ...layout.elementDetails,
                                                            tagId: e.target.id
                                                        }
                                                    };
                                                }
                                                return layout;
                                            });
                                            return updatedLayouts;
                                        });


                                        setSearchTerm("")
                                    }

                                }} className="tag-dyn" id={tag.tagId} key={index}>
                                    {tag.tagName}
                                </div>
                            ))}
                        </div>


                        <button
                            onClick={() => {
                                setLayouts((prevLayouts) => {
                                    const updatedLayouts = { ...prevLayouts };
                                    if (Array.isArray(updatedLayouts[currentBreakpoint])) {
                                        updatedLayouts[currentBreakpoint] = updatedLayouts[
                                            currentBreakpoint
                                        ].map((item, index, array) => {
                                            if (index === array.length - 1) {
                                                // Sadece son elemanı kontrol et

                                                return {
                                                    ...item,
                                                    elementDetails: {
                                                        ...item.elementDetails,
                                                        maxValue: temp_gauge_max, // yeniDeger, yeni maxValue değerini temsil eder
                                                    },
                                                };
                                            }
                                            return item;
                                        });
                                    }
                                    return updatedLayouts;
                                });

                                document
                                    .querySelector(".gauge_pop_up")
                                    .classList.toggle("gauge_pop_up_active");

                                document
                                    .querySelector(".main_sec")
                                    .classList.toggle("main_sec_dark");

                                Set_temp_gauge_max(0);
                            }}
                        >
                            SAVE
                        </button>
                    </div>
                </div>
                <div className="canvas_adjust_popUp">
                    <div className="input-group">
                        <label htmlFor="width">Genişlik (px)</label>
                        <input type="number" onChange={(e) => {
                            Set_canvas_boyutu_gecici((prevItem) => ({
                                ...prevItem,
                                width: e.target.value
                            }))
                        }} value={canvas_boyutu_gecici.width} placeholder="genişlik" />
                    </div>
                    <div className="input-group">
                        <label htmlFor="height">Yükseklik (px)</label>
                        <input onChange={(e) => {
                            Set_canvas_boyutu_gecici((prevItem) => ({
                                ...prevItem,
                                height: e.target.value
                            }))
                        }} type="number" value={canvas_boyutu_gecici.height} placeholder="yükseklik" />
                    </div>
                    <div className="btn-group">
                        <button onClick={(e) => {
                            try {
                                let w, h;
                                w = e.target.parentElement.parentElement.firstElementChild.firstElementChild.nextElementSibling.value;
                                h = e.target.parentElement.parentElement.firstElementChild.nextElementSibling.firstElementChild.nextElementSibling.value

                                Set_canvas_boyutu({ width: w, height: h })
                                Store.dispatch(setCanvasBoyut({ width: w, height: h }))
                                document.querySelector("aside").style.height = String(Number(document.querySelector("header").getBoundingClientRect().height) + Number(h) - 13) + "px"
                                document.querySelector("aside").style.maxHeight = String(Number(document.querySelector("header").getBoundingClientRect().height) + Number(h) - 13) + "px"


                            } catch (err) {
                                console.log(err);
                            } finally {
                                document.querySelector(".canvas_adjust_popUp").classList.toggle("canvas_adjust_popUp_active");
                                document.querySelector(".main_sec").classList.toggle("main_sec_dark")
                            }


                        }}>Kaydet</button><button onClick={() => {
                            document.querySelector(".canvas_adjust_popUp").classList.toggle("canvas_adjust_popUp_active");
                            document.querySelector(".main_sec").classList.toggle("main_sec_dark")

                            Set_canvas_boyutu_gecici({ width: canvas_boyutu.width, height: canvas_boyutu.height })
                        }}>İptal</button>
                    </div>
                </div>
                {!bg_control &&

                    <div className="main_sec" style={{ backgroundColor: page_bgColor !== "" ? page_bgColor : "transparent", border: "6px solid rgb(50,50,50)", width: "100%", height: canvas_boyutu.height !== 0 ? canvas_boyutu.height + "px" : "100%h", }}>
                        {/* {document.querySelector(".main_sec") && <>
                        <input  style={{position:"absolute",top:"10px",left:"100px",maxWidth:"100px"}} placeholder={"main_Sec  "+document.querySelector(".main_sec").getBoundingClientRect().width} />
                        <input  style={{position:"absolute",top:"10px",left:"300px",maxWidth:"100px"}} placeholder={"nnerW   "+(window.innerWidth-document.querySelector("aside").getBoundingClientRect().width)} />
                        <input  style={{position:"absolute",top:"10px",left:"500px",maxWidth:"100px"}} placeholder={"column "+cols[currentBreakpoint]}/>
</>} */}
                        {control_loading === true ? <div
                            style={{
                                height: "100vh",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexDirection: "column"
                            }}
                            className="loading"
                        >
                            <img style={{ width: "15%" }} src={loading_} alt="" />
                            <p style={{ textAlign: "center", marginTop: "16px", fontWeight: "600", color: page_bgColor !== "" ? (page_bgColor === "#000" ? "white" : "rgb(70,70,70") : "rgb(70,70,70)" }}>Sayfa Yükleniyor. Lütfen Bekleyiniz...</p>

                        </div> : !ws_active && <>

                            <div style={{ opacity: "0", pointerEvents: "none" }} onClick={(e) => {
                                document.querySelector(".tool_box").classList.toggle("tool_box_active")
                            }} className="hamburgerDyn">
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                            <div style={{ opacity: "0", pointerEvents: "none" }} className="tool_box">
                                <div className="top">
                                    <h4>Toolbox</h4>
                                    <i onClick={() => {
                                        document.querySelector(".tool_box").classList.toggle("tool_box_active")
                                    }} className="fa fa-times"></i></div>
                                <button onClick={createWidget} id="text">
                                    Text
                                </button>
                                <button onClick={createWidget} id="tag">
                                    Tag
                                </button>
                                <button
                                    id="on/off"
                                    onClick={(e) => {

                                        createWidget(e);
                                    }}
                                >
                                    On/Off
                                </button>
                                <button
                                    id="calisma_modu"
                                    onClick={(e) => {
                                        createWidget(e);
                                    }}
                                >
                                    Çalışma Modu
                                </button>
                                <button
                                    id="fan_modu"
                                    onClick={(e) => {
                                        createWidget(e);
                                    }}
                                >
                                    Fan Modu
                                </button>
                                <button
                                    onClick={(e) => {
                                        if (
                                            e.target.firstElementChild.classList.contains(
                                                "arrow_list_active"
                                            )
                                        ) {

                                            e.target.firstElementChild.classList.remove(
                                                "arrow_list_active"
                                            );
                                        } else {
                                            e.target.firstElementChild.classList.add(
                                                "arrow_list_active"
                                            );
                                        }
                                    }}
                                    id="ok"
                                >
                                    Ok
                                    <ul className="arrow_list">
                                        <li id="left_ok" onClick={(e) => {
                                            e.stopPropagation()
                                            createWidget(e)
                                        }}>
                                            Sol Ok <i className="fa fa-arrow-left"></i>
                                        </li>
                                        <li id="right_ok" onClick={(e) => {
                                            e.stopPropagation();
                                            createWidget(e)

                                        }}>
                                            Sağ Ok <i className="fa fa-arrow-right"></i>
                                        </li>
                                    </ul>
                                </button>
                                <button className="img_btn_dyn" onClick={createWidget} id="image">
                                    Image{" "}
                                    <input
                                        className="img_btn_dyn_inp"
                                        onChange={(e) => {
                                            let file = e.target;
                                            let file_ = file.files[0];
                                            if (file_ && file_.type.startsWith("image/")) {
                                                const reader = new FileReader();

                                                Set_render_items((prevLayouts) => {
                                                    return {
                                                        ...prevLayouts,
                                                        [currentBreakpoint]: [
                                                            ...prevLayouts[currentBreakpoint],
                                                            "image",
                                                        ],
                                                    };
                                                });

                                                reader.onload = function (event) {
                                                    const imageSrc = event.target.result;
                                                    setLayouts((prevLayouts) => {
                                                        const newX = Math.round(Math.random() * 5) * 2;
                                                        const newY = Math.floor(12 / 6) * 2;
                                                        const newWidget = {
                                                            x: newX,
                                                            id: render_items[currentBreakpoint].length,
                                                            y: newY,
                                                            elementDetails: { src: imageSrc },
                                                            w: 52,
                                                            h: 12,
                                                            i: String(render_items[currentBreakpoint].length),
                                                            static: Math.random() < 0.05,
                                                            resizeHandles: [
                                                                "s",
                                                                "w",
                                                                "e",
                                                                "n",
                                                                "sw",
                                                                "nw",
                                                                "se",
                                                                "ne",
                                                            ],
                                                            type: "image",
                                                        };
                                                        const updatedLayouts = { ...prevLayouts };
                                                        if (Array.isArray(updatedLayouts[currentBreakpoint])) {
                                                            updatedLayouts[currentBreakpoint] = [
                                                                ...updatedLayouts[currentBreakpoint],
                                                                newWidget,
                                                            ];
                                                        } else {
                                                            updatedLayouts[currentBreakpoint] = [newWidget];
                                                        }
                                                        return updatedLayouts;
                                                    });
                                                    // Resmin veri URL'sini konsola yazdır
                                                };

                                                reader.readAsDataURL(file_);
                                            }
                                        }}
                                        type="file"
                                        name=""
                                        id=""
                                    />
                                </button>
                                <button className="bg_btn_dyn" onClick={createWidget} id="bg">
                                    Background{" "}
                                    <input
                                        className="bg_btn_dyn_inp"

                                        onChange={(e) => {
                                            let file = e.target;
                                            let file_ = file.files[0];
                                            if (file_ && file_.type.startsWith("image/")) {
                                                const reader = new FileReader();

                                                reader.onload = function (event) {
                                                    const imageSrc = event.target.result;

                                                    var toplam_control = 0;
                                                    render_items[currentBreakpoint].forEach((i) => {
                                                        if (i === "bg") {
                                                            toplam_control++;
                                                        }
                                                    });


                                                    Set_bg_item(imageSrc)
                                                    const newX = Math.round(Math.random() * 5) * 2;
                                                    const newY = Math.floor(12 / 6) * 2;

                                                    if (toplam_control < 1) {

                                                        console.log(imageSrc);

                                                        Set_bg_key_current({
                                                            x: newX,
                                                            id: render_items[currentBreakpoint].length,
                                                            y: newY,
                                                            elementDetails: { src: imageSrc },
                                                            w: 70,
                                                            h: 1,
                                                            i: String(render_items[currentBreakpoint].length),
                                                            static: Math.random() < 0.05,
                                                            resizeHandles: resizeHandles,
                                                            type: "bg",
                                                        })

                                                        setTimeout(() => { Set_bg_control(true) }, 200)

                                                    } else {

                                                        let widget_;
                                                        (layouts[currentBreakpoint] || []).forEach((widget, index) => {
                                                            if (widget.type === "bg") {
                                                                widget_ = { ...widget, elementDetails: { ...widget.elementDetails, src: imageSrc } };
                                                            }
                                                        });

                                                        // Güncellenmiş widget'i console'a yazdır

                                                        Set_bg_key_current(widget_)

                                                        setTimeout(() => { Set_bg_control(true) }, 200)

                                                    }
                                                };
                                                reader.readAsDataURL(file_);
                                            }
                                        }}
                                        type="file"
                                        name=""
                                        id=""
                                    />
                                </button>
                                <button
                                    id="gauge"
                                    onClick={(e) => {
                                        createWidget(e);
                                        open_gauge_poup();
                                    }}
                                >
                                    Gauge
                                </button>

                                <button
                                    id="frame"
                                    onClick={(e) => {
                                        createWidget(e);

                                    }}
                                >
                                    Çerçeve
                                </button>

                                {set_Raporlama && <button
                                    id="trend"
                                    onClick={(e) => {
                                        createWidget(e);
                                    }}
                                >
                                    Trend
                                </button>}
                                <button
                                    onClick={() => {
                                        document.querySelector(".canvas_adjust_popUp").classList.toggle("canvas_adjust_popUp_active");
                                        document.querySelector(".main_sec").classList.toggle("main_sec_dark")
                                    }}
                                    id="white_space"
                                >
                                    Canvas Boyutu
                                </button>
                                <div className="bottom">
                                    <p>Sayfa Adı</p>
                                    <input type="text" value={sayfa_adi} onChange={onChangePageName} id="save_page_name_inp" />
                                </div>
                                <div className="bottom">
                                    <p>Sayfay İkonu</p>
                                    <div style={{ marginTop: "16px", maxHeight: "30%" }} className="select-box">
                                        <div style={{ maxWidth: "60%", minWidth: "200px", borderColor: "rgb(237,188,69)", backgroundColor: "white", borderWidth: "2.5px", borderRadius: "8px", borderColor: "rgb(237,188,69)" }} className="select-box-header" onClick={toggleDropdownİkon}>
                                            {selectedOptionİkon}
                                            <span className={`arrow ${isOpenİkon ? 'open' : ''}`}>▼</span>
                                        </div>
                                        {isOpenİkon && (
                                            <ul style={{ width: "72%", marginLeft: "13.4%" }} className="select-box-dropdown">
                                                {[dashBoard, water, enerjiIcon, heat_system, pumpicon, fansicon, vrf_icon].map((option, index) => {
                                                    if (option.startsWith("fa")) {
                                                        return <li
                                                            id={index + 1}
                                                            key={index}
                                                            onClick={() => {
                                                                Set_sayfa_ikonu_son(option)
                                                                handleOptionClickİkon(<i style={{ color: "rgb(67,67,67)", margin: "0 10%" }} className={`${option}`}></i>)
                                                            }}
                                                            className="select-box-option"
                                                        >
                                                            {<i style={{ color: "rgb(67,67,67)", marginLeft: "4%" }} className={option}></i>}
                                                        </li>
                                                    } else {
                                                        return <li
                                                            id={index + 1}
                                                            key={index}
                                                            onClick={() => {
                                                                Set_sayfa_ikonu_son(option)
                                                                handleOptionClickİkon(<img src={`${option}`} />)

                                                            }}
                                                            className="select-box-option"
                                                        >
                                                            {<img src={option} />}
                                                        </li>
                                                    }

                                                })}
                                            </ul>
                                        )}
                                    </div>
                                </div>
                                <div className="bottom">
                                    <p>Sayfayı Kaydet</p>
                                    <div className="dyn_save_btn_parts">
                                        <button onClick={(e) => {
                                            let items_last = localStorage.getItem("layouts");
                                            if (items_last) {
                                                items_last = JSON.parse(items_last)
                                            }

                                            if (sayfa_adi !== "" && sayfa_ikonu_son !== "" && items_last !== undefined) {
                                                let obj_ilk = {
                                                    companyId: props.com_id,
                                                    userId: props.uid,
                                                    pageName: sayfa_adi,
                                                    pageIcon: sayfa_ikonu_son,
                                                    pageId: 0,
                                                    details: JSON.stringify({ ...items_last, canvas_boyutu })
                                                }

                                                let obj_son = JSON.stringify(obj_ilk);

                                                addPageFunc(obj_son);


                                            }
                                        }}>Kaydet</button>
                                        <button onClick={async (e) => {
                                            localStorage.removeItem("canvas_properties")
                                            await history.push("/");
                                            localStorage.removeItem("layouts")

                                        }}>İptal</button>
                                    </div>
                                </div>

                            </div>

                        </>}
                        {/* Not grid-layout ___> react-draggable */}


                        {/* <div>
          Current Breakpoint: {currentBreakpoint} ({cols[currentBreakpoint]}{" "}
          columns)
        </div>
        <div>
          Compaction type: {_.capitalize(compactType) || "No Compaction"}
        </div>
        <button onClick={onNewLayout}>Generate New Layout</button>
        <button onClick={onCompactTypeChange}>Change Compaction Type</button>
        <button onClick={onResizeTypeChange}>
          Resize{" "}
          {resizeHandles === availableHandles ? "One Corner" : "All Corners"}
        </button> */}
                        <ResponsiveReactGridLayout
                            {...props}
                            rowHeight={1}
                            cols={cols}
                            layouts={layouts}
                            onBreakpointChange={onBreakpointChange}
                            onLayoutChange={onLayoutChangeHandler}
                            onResizeStop={onResize}
                            allowOverlap={true}
                            onDragStop={onDrop}
                            measureBeforeMount={false}
                            useCSSTransforms={mounted}
                            compactType={compactType}
                            margin={[0, 0]}  // Kenar boşluklarını kaldırarak kesin kontrol sağlayın
                            containerPadding={[0, 0]} // İç boşlukları da kaldırın
                            preventCollision={!compactType}
                            isDraggable={false}  // Elemanların sürüklenmesini engelle
                            isResizable={false}
                            style={document.querySelector(".tool_box") ? { maxHeight: (canvas_boyutu.height - document.querySelector(".tool_box").getBoundingClientRect().height) + "px" } : {}}
                        >
                            {generateDOM()}
                        </ResponsiveReactGridLayout>

                        {/* <div
              ref={drop}
              style={{
                width: '100%',
                height: '100vh',
                position: 'relative',
                border: '1px solid black',
                boxSizing: 'border-box'
              }}
            >
              {boxes.map((box) => (
                <DraggableResizableBox key={box.id} {...box} moveBox={moveBox} resizeBox={resizeBox} />
              ))}
            </div> */}



                    </div>}


            </div>

        </>
    );
};

function generateLayout(resizeHandles) {
    return _.map(_.range(0, 5), function (item, i) {
        var y = Math.ceil(Math.random() * 15) + 1;
        return {
            x: Math.round(Math.random() * 5) * 2,
            y: Math.floor(i / 6) * y,
            w: 70,
            h: y,
            i: i.toString(),
            static: Math.random() < 0.05,
            resizeHandles: resizeHandles,
        };
    });
}

const MapStateToProps = (state) => {
    return {
        tag_values: state.project_reducer.tag_values,
        tags: state.project_reducer.tag_list,
        yetkilendirme: state.project_reducer.yetkilendirme_state,
        group_id: state.project_reducer.group_id,
        uid: state.auth_reducer.user_id,
        totalizer_tags: state.project_reducer.totalizer_tags,
        com_id: state.project_reducer.company_id,
        pages: state.project_reducer.pages,
        current_page_setails_reducer: state.project_reducer.current_page_details,
        current_dyn_pageName: state.project_reducer.current_dyn_pageName,
        current_path: state.project_reducer.current_path,
        ucer_id: state.project_reducer.ucer_id,
        users_list: state.project_reducer.users_list,
        temp_com_id: state.project_reducer.temp_com_id,
        widgets_library: state.project_reducer.widget_library,

        alarms2: state.project_reducer.alarms2,



    }
}

export default connect(MapStateToProps)(DynRead);